/**
 * pl-comps v1.6.15 (http://git.centralgest.com/angular1/pl-comps)
 * Copyright 2021 CentralGest - Produção de Software, S.A.
 * Licensed under UNLICENSED
 */
/**
 * Created by pedro on 04/01/17.
 */
(function () {
  'use strict';

  angular.module('pl.edit', []);
  angular.module('pl.alert', []);
  angular.module('pl.filters', []);

})();

(function () {
  'use strict';

  angular.module('pl.affix', [])
    .directive('plAffix', ['$compile', '$parse', function ($compile, $parse) {
      return {
        restrict: 'A',
        terminal: true,
        priority: 1201,
        compile: function (tElement, tAttrs) {
          var attributes = tAttrs.plAffix;
          if (!attributes) {
            return;
          }
          tElement.removeAttr('pl-affix');
          tElement.removeAttr('data-pl-affix');

          return function postLink($scope, $element, $attrs, ctrl, transclude) {
            var affixProperties = [
              {scrollpoint: 'ui-scrollpoint', property: 'scrollpoint'},
              {scrollpoint: 'ui-scrollpoint-enabled', property: 'enabled', default: false},
              {scrollpoint: 'ui-scrollpoint-absolute', property: 'absolute', default: undefined},
              {scrollpoint: 'ui-scrollpoint-action', property: 'action', default: undefined},
              {scrollpoint: 'ui-scrollpoint-class', property: 'class', default: 'affix', evaluated: true},
              {scrollpoint: 'ui-scrollpoint-edge', property: 'edge', evaluated: true}
            ];

            var model = $parse(attributes)($scope);
            if (model) {
              angular.forEach(affixProperties, function (attribute) {
                var value = model[attribute.property];
                var attr = attributes + '.' + attribute.property;

                if (angular.isUndefined(value) || value === null) {
                  model[attribute.property] = attribute.default;
                }
                if (attribute.evaluated) {
                  attr = '{{' + attr + '}}';
                }
                $element.attr(attribute.scrollpoint, attr);
              });
            }

            $compile($element, transclude)($scope);
          };
        }
      };
    }]);
})();

/**
 * Created by pedro on 03/10/16.
 */
(function () {
  /* jshint -W089 */
  'use strict';

  angular.module('pl.aihighlight', [])
    .filter('AIhighlight', function () {
      return function (text, search, shouldHighlight, wordsOnly) {
        if (shouldHighlight === false) {
          return text;
        }
        else if (text && (search || angular.isNumber(search))) {
          text = text.toString();
          search = search.toString().toLowerCase();

          var accentedForms = {
            a: '[a|\xE0-\xE6]',
            e: '[e|\xE8-\xEB]',
            i: '[i|\xEC-\xEF]',
            o: '[o|\xF2-\xF6]',
            u: '[u|\xF9-\xFC]',
            c: '[c|\xE7]',
            n: '[n|\xF1]'
          };


          var words = search.split(' ');
          var pattern = [];

          for (var i = 0; i < words.length; i++) {
            var p = [];
            var l = words[i].split('');

            for (var s in l) {
              var letra = l[s];
              var lp = accentedForms[letra];
              if (lp) {
                p.push(letra.replace(letra, lp));
              } else {
                p.push(letra);
              }
            }

            pattern.push('(' + RegExp.escapeSafe(p.join('')) + ')');
          }
          search = pattern.join('|');

          var toReplace = '<span class="ui-match">$&</span>';
          if (!wordsOnly) {
            return text.replace(new RegExp(search, 'gi'), toReplace);
          }
          else {
            var regexp = new RegExp(search, 'i');
            var segmentedText = text.split(' ');
            for (var j = 0; j < segmentedText.length; j++) {
              segmentedText[j] = segmentedText[j].replace(regexp, toReplace);
            }
            return segmentedText.join(' ');
          }
        }
        else {
          return text;
        }
      };
    });
})();

/**
 * Created by pedro on 17/12/15.
 */
(function () {
  'use strict';

  angular.module('pl.alert')
    .directive('plAlert', function () {
      return {
        scope: {
          type: '@',
          theme: '@?',
          closeable: '<?',
          close: '&?',
          dismissOnTimeout: '@?'
        },
        bindToController: true,
        transclude: true,
        templateUrl: function (element, attrs) {
          return attrs.templateUrl || '../source/pl-alert.html';
        },
        controllerAs: 'ctrl',
        controller: /*@ngInject*/ ['$scope', '$interpolate', '$timeout', 'plLocale', function ($scope, $interpolate, $timeout, plLocale) {
          var ctrl = this;

          ctrl.showing = true;
          ctrl.locales = plLocale.locales;

          ctrl.$onInit = init;
          ctrl.fnClose = fnClose;

          /////////////

          function init() {
            ctrl.closeable = angular.isDefined(ctrl.closeable) && ctrl.closeable !== null ? ctrl.closeable : true;
            var dismissOnTimeout = angular.isDefined(ctrl.dismissOnTimeout) ? $interpolate(ctrl.dismissOnTimeout)($scope.$parent) : null;
            if (dismissOnTimeout) {
              $timeout(function () {
                if (angular.isFunction(ctrl.fnClose)) {
                  ctrl.fnClose();
                }
              }, parseInt(dismissOnTimeout, 10));
            }
          }

          function fnClose() {
            if (angular.isFunction(ctrl.close)) {
              ctrl.close();
            }
            else {
              ctrl.showing = false;
            }
          }
        }]
      };
    });
})();

/**
 * Created by pedro on 17/12/15.
 */
(function () {
  'use strict';

  var msgboxtemplate = '' +
    '<div class="modal-header">' +
    '  <h3 class="modal-title text-danger">' +
    '    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>&nbsp;<span pl-translate="{{$ctrl.title}}"></span>' +
    '  </h3>' +
    '</div>' +
    '<div class="modal-body" pl-translate="{{$ctrl.message}}"></div>' +
    '<div class="modal-footer" pl-navigation selector="pl-button">' +
    '  <pl-button id="btModelOK" class="btn-success" on-click="$ctrl.ok()">' +
    '    <i class="fa fa-check fa-fw"></i>&nbsp;{{$ctrl.locales.btn.ok}}' +
    '  </pl-button>' +
    '</div>';

  var msgboxconfirm = '' +
    '<div class="modal-header">' +
    '  <h3 class="modal-title text-danger">' +
    '    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>&nbsp;<span pl-translate="{{$ctrl.title}}"></span>' +
    '  </h3>' +
    '</div>' +
    '<div class="modal-body" pl-translate="{{$ctrl.message}}"></div>' +
    '<div class="modal-footer" pl-navigation selector="button">' +
    '  <button id="btModelOK" class="btn btn-success" ng-click="$ctrl.ok()">' +
    '    <i class="fa fa-check fa-fw"></i>&nbsp;{{$ctrl.locales.btn.ok}}' +
    '  </button>' +
    '  <button id="btModalCancel" class="btn btn-default" ng-click="$ctrl.cancel()">' +
    '    <i class="fa fa-times fa-fw"></i>&nbsp;{{$ctrl.locales.btn.cancel}}' +
    '  </button>' +
    '</div>';

  angular.module('pl.alert')
    .config(['notificationServiceProvider', function (notificationServiceProvider) {
      notificationServiceProvider.setStack('plAlertStack', '', {
        animation: true,
        dir1: 'down',
        dir2: 'left',
        firstpos1: 36,
        firstpos2: 36,
        modal: false,
        push: 'bottom',
        spacing1: 20,
        spacing2: 20
      });
    }])
    .factory('plAlertService', ['$timeout', '$sce', 'plTranslate', 'notificationService', '$uibModal', function ($timeout, $sce, plTranslate, notificationService, $uibModal) {
      var alerts = [];
      var baseNotification = {
        addclass: 'es-word-break',
        cornerclass: 'alert-white',
        animate: {
          animate: true,
          'in_class': 'slideInRight',
          'out_class': 'slideOutRight'
        },
        title: false,
        icon: true,
        delay: 5000,
        'mouse_reset': true,
        shadow: true,
        styling: 'fontawesome',
        hide: true,
        buttons: {
          closer: false,
          'closer_hover': false,
          sticker: false
        },
        mobile: {
          mobile: true,
          'swipe_dismiss': true,
          styling: false
        },
        'after_close': closeAlert
      };

      function newNotification(notification, options, source) {
        var notice;
        var array = angular.isArray(source) ? source : alerts;
        for (var i = 0; i < array.length; i++) {
          notice = array[i];
          if (notice.options.text === notification.text && notice.options.type === notification.type) {
            notice.attention('pl-animation-shake');
            notice.queueRemove();
            return;
          }
        }

        if (options) {
          notification = _.merge({}, notification, options);
        }

        notice = notificationService.notifyWithDefaults(notification, 'plAlertStack');
        notice.get().click(function () {
          notice.remove();
        });

        if (!source || !angular.isArray(source)) {
          alerts.push(notice);
        }
        else {
          source.push(notice);
        }
      }

      return {
        clear: clear,
        get: get,
        success: success,
        error: error,
        info: info,
        warning: warning,
        closeAlert: closeAlert,
        closeAlertByIndex: closeAlertByIndex,
        msgBox: msgBox,
        msgBoxConfirm: msgBoxConfirm,
        msgBoxError: msgBoxError
      };

      /////////////

      function clear(source) {
        var array = angular.isArray(source) ? source : alerts;
        angular.forEach(array, function (notice) {
          notice.remove();
        });
      }

      function get() {
        return alerts;
      }

      function success(msg, options, source) {
        baseNotification.text = plTranslate.translate(msg);
        baseNotification.type = 'success';
        newNotification(baseNotification, options, source);
      }

      function error(msg, options, source) {
        baseNotification.text = plTranslate.translate(msg);
        baseNotification.type = 'error';
        newNotification(baseNotification, options, source);
      }

      function info(msg, options, source) {
        baseNotification.text = plTranslate.translate(msg);
        baseNotification.type = 'info';
        newNotification(baseNotification, options, source);
      }

      function warning(msg, options, source) {
        baseNotification.text = plTranslate.translate(msg);
        baseNotification.type = 'notice';
        newNotification(baseNotification, options, source);
      }

      function closeAlert(notice, source) {
        var array = angular.isArray(source) ? source : alerts;
        for (var i = 0; i < array.length; i++) {
          var element = array[i];
          if (element === notice) {
            array.splice(i, 1);
          }
        }
      }

      function closeAlertByIndex(index, source) {
        var array = angular.isArray(source) ? source : alerts;
        array.splice(index, 1);
      }

      function msgBox(type, title, message) {
        return $uibModal.open({
          animation: true,
          bindToController: true,
          template: msgboxtemplate,
          controllerAs: '$ctrl',
          controller: /*@ngInject*/ ['$uibModalInstance', 'plLocale', function ($uibModalInstance, plLocale) {
            var ctrl = this;

            ctrl.locales = plLocale.locales;
            ctrl.title = title;
            ctrl.message = message;

            ctrl.ok = ok;

            /////////////

            function ok() {
              $uibModalInstance.close('ok');
            }
          }]
        });
      }

      function msgBoxConfirm(title, message) {
        return $uibModal.open({
          animation: true,
          bindToController: true,
          template: msgboxconfirm,
          controllerAs: '$ctrl',
          controller: /*@ngInject*/ ['$uibModalInstance', 'plLocale', function ($uibModalInstance, plLocale) {
            var ctrl = this;

            ctrl.locales = plLocale.locales;
            ctrl.title = title;
            ctrl.message = message;

            ctrl.ok = ok;
            ctrl.cancel = cancel;

            /////////////

            function ok() {
              $uibModalInstance.close('ok');
            }

            function cancel() {
              $uibModalInstance.close('cancel');
            }
          }]
        });
      }

      function msgBoxError(title, message) {
        return msgBox('error', title, message);
      }
    }]);
})();

(function () {
  'use strict';

  angular.module('pl.animation', ['ngAnimate'])
    .directive('plAnimationRotate', function () {
      return {
        element: 'A',
        scope: {
          flag: '=plAnimationRotate'
        },
        link: function ($scope, $element) {
          var first = true;
          $element.addClass($scope.flag ? 'pl-animation-rotate-on' : 'pl-animation-rotate-off');
          $scope.$watch('flag', function () {
            if (first) {
              first = false;
              return;
            }
            $element.toggleClass('pl-animation-rotate-off pl-animation-rotate-on');
          });
        }
      };
    })
    .directive('plAnimationCollapse', function () {
      return {
        element: 'A',
        scope: {
          flag: '=plAnimationCollapse'
        },
        transclude: true,
        template: '<div ng-if="!flag" class="pl-animation-collapse" ng-transclude></div>'
      };
    })
    .animation('.pl-animation-collapse', ['$animateCss', function ($animateCss) {
      return {
        enter: function (element) {
          var height = element[0].offsetHeight;
          return $animateCss(element, {
            from: {height: '0px', overflow: 'hidden'},
            to: {height: height + 'px'},
            cleanupStyles: true,
            duration: 0.1
          });
        },
        leave: function (element) {
          var height = element[0].offsetHeight;
          return $animateCss(element, {
            to: {height: '0px', overflow: 'hidden'},
            from: {height: height + 'px'},
            cleanupStyles: true,
            duration: 0.1
          });
        }
      };
    }])
    .directive('plAnimation', function () {
      return {
        element: 'A',
        link: function ($scope, $element, $attrs) {
          var c = 'pl-animate-' + (!$attrs.plAnimation ? 'appear' : $attrs.plAnimation);
          $element.addClass(c);
        }
      };
    })
    .directive('plAnimationShake', ['$animate', function ($animate) {
      return {
        element: 'A',
        scope: {
          flag: '=plAnimationShake'
        },
        link: function ($scope, $element) {
          $element.addClass('pl-animation-shake');
          $scope.$watch('flag', function (newValue, oldValue) {
            if (newValue !== oldValue) {
              $animate.removeClass($element, 'pl-animation-shake').then(function () {
                $element.addClass('pl-animation-shake');
              });
            }
          });
        }
      };
    }])
    .directive('plDisableAnimate', ['$animate', function ($animate) {
      return function (scope, element) {
        $animate.enabled(element, false);
      };
    }]);
})();

(function () {
  'use strict';

  angular.module('pl.autocomplete', ['pl.aihighlight', 'pl.animation'])
    .component('plAutocomplete', {
      require: {
        ngModel: 'ngModel',
        plForm: '?^plForm',
        plGroup: '?^plGroup',
        plEdit: '?^plEdit'
      },
      bindings: {
        name: '@?',
        source: '<?',
        sourceKey: '@?',
        rowTemplate: '<?',
        selected: '=?',
        output: '<?',
        config: '<?',
        value: '<?ngModel',
        onValidate: '<?',
        onSelect: '<?',
        placeholder: '@?',
        inputClass: '@?',
        data: '<?',
        onFocus: '<?',
        autoSelectFirst: '<?',
        allowInvalid: '<?',
        filterFields: '<?',
        showFilter: '<?',
        filterModel: '<?',
        properties: '<?'
      },
      templateUrl: '../source/pl-autocomplete.html',
      controller: /*@ngInject*/ ['$scope', '$element', '$attrs', '$q', '$filter', '$compile', '$interpolate', '$log', '$timeout', 'plCompsService', 'KEYCODE', 'plTranslate', 'plLocale', function ($scope, $element, $attrs, $q, $filter, $compile, $interpolate, $log, $timeout, plCompsService, KEYCODE, plTranslate, plLocale) {
        var ctrl = this;
        var defaultOptions = {
          readonly: false,
          disabled: false,
          disallowInput: false,
          raw: false,
          validate: true,
          filterFields: undefined,
          showFilter: false,
          validators: {
            required: {value: false}
          },
          events: {
            blur: undefined,
            focus: undefined,
            change: undefined,
            keydown: undefined,
            keypress: undefined,
            keyup: undefined,
            mousedown: undefined,
            mouseenter: undefined,
            mouseleave: undefined,
            mousemove: undefined,
            mouseover: undefined,
            mouseup: undefined
          }
        };
        var inputField;
        var dropdown;

        ctrl.component = {};
        ctrl.isLocalSource = false;
        ctrl.isFilterCollapsed = true;
        ctrl.promise = null;

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.$onDestroy = onDestroy;
        ctrl.keyDownHandler = keyDownHandler;
        ctrl.keyPressHandler = keyPressHandler;
        ctrl.updateValue = updateValue;
        ctrl.setWidth = setWidth;
        ctrl.onMouseEnter = onMouseEnter;
        ctrl.onMouseLeave = onMouseLeave;
        ctrl.fnBlur = fnBlur;
        ctrl.onChange = onChange;
        ctrl.fnFocus = fnFocus;
        ctrl.getRow = getRow;
        ctrl.onItemClick = onItemClick;
        ctrl.select = select;
        ctrl.cancel = cancel;
        ctrl.open = fnOpen;
        ctrl.doClose = doClose;
        ctrl.toggle = toggle;
        ctrl.updateModel = updateModel;
        ctrl.loadMore = loadMore;
        ctrl.fnFilter = fnFilter;
        ctrl.clearFilter = clearFilter;
        ctrl.updateComponent = updateComponent;

        /////////////

        function doFilter(shouldFilter, force, reset) {
          if (shouldFilter && ctrl.component.inputValue !== ctrl.component.searchStrLast) {
            ctrl.component.page = 1;
            ctrl.component.model = [];
          }
          if (!force && ctrl.component.inputValue === ctrl.component.searchStrLast) {
            return;
          }

          $timeout.cancel(ctrl.component.timer);

          if (angular.isUndefined(ctrl.component.inputValue)) {
            ctrl.component.inputValue = '';
          }
          ctrl.component.search = '';

          if (shouldFilter) {
            ctrl.component.search = ctrl.component.inputValue;
          }
          ctrl.component.searching = true;

          ctrl.component.searchStrLast = ctrl.component.search;

          if (angular.isFunction(ctrl.onLoad)) {
            if (ctrl.component.page === 0) {
              ctrl.component.page++;
            }
            if (!ctrl.promise) {
              plCompsService.debounce(function () {
                ctrl.promise = $q.when(ctrl.onLoad(ctrl.component.search, null, ctrl.component.page, ctrl.component.pageSize, ctrl.filter, ctrl.component));
                ctrl.promise.then(
                  function success(data) {
                    ctrl.component.searching = false;
                    ctrl.component.responseResultSize = angular.isArray(data) ? data.length : data.list.length;

                    if (angular.isArray(data)) {
                      ctrl.updateModel(data, reset);
                    }
                    else {
                      ctrl.updateModel(data.list, reset);
                    }
                  },
                  function error() {
                    ctrl.component.searching = false;
                    ctrl.component.search = ctrl.component.searchStrLast;
                  },
                  function progress() {
                    ctrl.component.searching = true;
                  }
                )['finally'](function () {
                  ctrl.promise = null;
                });
              }, 200, 'plAutoCompleteOnChange_' + ctrl.name);
            }
            return ctrl.promise;
          }
          else {
            ctrl.component.searching = false;
            ctrl.component.currentIndex = 0;
            if (ctrl.component.search) {
              ctrl.component.model = $filter('filter')(ctrl.source, ctrl.component.search);
            }
            else {
              ctrl.component.model = angular.copy(ctrl.source);
            }
          }
        }

        function scrollToView(element, parent) {
          element = angular.element(element)[0];
          parent = angular.element(parent)[0];
          if (!element || !parent) return false;

          var nextOffset = element.offsetTop + element.clientHeight - parent.offsetHeight;
          if (nextOffset > parent.scrollTop) {
            // scroll down
            parent.scrollTop = nextOffset;
            return;
          }

          nextOffset = element.offsetTop;
          if (nextOffset < parent.scrollTop) {
            parent.scrollTop = element.offsetTop;
          }
        }

        function checkVisibility() {
          $timeout(function () {
            var selected = $element.find('.pl-autocomplete-selected-row');
            if (selected.length) {
              scrollToView(selected, dropdown);
            }
          }, 100);
        }

        function init() {
          ctrl.component = {
            page: 0,
            notFound: null,
            original: {
              selected: ctrl.selected,
              inputValue: ctrl.inputValue,
              isValid: false
            },
            inputValue: ctrl.value,
            searchStrLast: ctrl.inputValue,
            isLoading: true,
            isSelecting: false,
            isMouseIn: false,
            isValid: false,
            showDropdown: false,
            currentIndex: -1,
            minlength: 0,
            selected: ctrl.selected,
            name: ctrl.name,
            placeholder: ctrl.placeholder,
            model: [],
            rowTemplate: ctrl.rowTemplate,
            onLoad: null,
            onValidate: ctrl.onValidate,
            inputClass: ctrl.inputClass,
            data: ctrl.data,
            autoSelectFirst: angular.isDefined(ctrl.autoSelectFirst) ? ctrl.autoSelectFirst : false,
            textSearching: plLocale.locales.autocomplete.textSearching,
            textEmpty: plLocale.locales.autocomplete.textEmpty,
            textNotFound: plLocale.locales.autocomplete.textNotFound,
            changedCount: 0,
            pageSize: 20,
            responseResultSize: null,
            config: ctrl.config,
            allowInvalid: ctrl.allowInvalid,
            filterFields: ctrl.filterFields,
            showFilter: ctrl.showFilter
          };

          ctrl.ngModel.$render = function () {
            ctrl.value = ctrl.ngModel.$viewValue;
            ctrl.component.inputValue = ctrl.value;
          };

          // Requires hashKey
          if (ctrl.plEdit) {
            ctrl.plEdit.addComponent(ctrl);
            if (ctrl.plEdit.options) {
              _.merge(defaultOptions, ctrl.plEdit.options);
            }
          }
          ctrl.options = _.merge({}, defaultOptions, ctrl.properties);
          ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
          _.merge(ctrl, ctrl.options);
          _.merge(ctrl.component, ctrl.options);
          inputField = $element.find('input');

          if ('autofocus' in $attrs && $attrs.autofocus) {
            $timeout(function () {
              var el = $element.find('input');
              if (el.length) {
                el[0].focus();
              }
            });
          }

          if (angular.isArray(ctrl.source)) {
            ctrl.component.model = ctrl.source;
            ctrl.onLoad = ctrl.source;
            ctrl.isLocalSource = true;
          } else if (angular.isFunction(ctrl.source)) {
            ctrl.component.model = [];
            ctrl.onLoad = ctrl.source;
          }
          ctrl.component.isLoading = false;
        }

        function onChanges(autocomplete) {
          if (autocomplete) {
            if (autocomplete.value) {
              ctrl.component.inputValue = autocomplete.value.currentValue;
              ctrl.component.notFound = null;
            }
          }
        }

        function onDestroy() {
          $timeout.cancel(ctrl.component.timer);
          if (ctrl.plEdit) {
            ctrl.plEdit.removeComponent(ctrl.name);
          }
        }

        function keyPressHandler(value, event) {
          ctrl.component.notFound = null;
          if (event.which === KEYCODE.ENTER && (!ctrl.component.showDropdown || ctrl.component.model.length === 0)) {
            ctrl.component.inputValue = inputField.val();
            ctrl.component.isValid = ctrl.allowInvalid || ctrl.options.allowInvalid;
            ctrl.doClose();
          }
          if (angular.isFunction(ctrl.options.events.keypress)) {
            ctrl.options.events.keypress(value, event);
          }
        }

        function keyDownHandler(value, event) {
          var which = event.which;
          ctrl.component.enterPressed = false;
          if (which === KEYCODE.ENTER) {
            event.preventDefault();
            ctrl.component.enterPressed = true;
            if (ctrl.component.changedCount || ctrl.component.showDropdown || ctrl.component.model.length > 0) {
              if (ctrl.component.currentIndex >= 0 && ctrl.component.model.length > 0 && ctrl.component.currentIndex < ctrl.component.model.length) {
                ctrl.select(ctrl.component.model[ctrl.component.currentIndex], false);
              }
              else {
                ctrl.component.inputValue = inputField.val();
                if (ctrl.allowInvalid || ctrl.options.allowInvalid) {
                  ctrl.component.isValid = true;
                }
                ctrl.doClose(true);
              }
            }
          }
          else if (which === KEYCODE.ESC) {
            event.preventDefault();
            ctrl.doClose();
          }
          else if (which === KEYCODE.DOWN) {
            if (ctrl.component.showDropdown) {
              event.preventDefault();
              event.stopPropagation();

              var nextIdx = ctrl.component.currentIndex + 1;
              nextIdx = nextIdx < ctrl.component.model.length ? nextIdx : ctrl.component.model.length - 1;
              ctrl.component.currentIndex = nextIdx;
              checkVisibility();
            }
            else if (ctrl.component.inputValue && ctrl.component.inputValue.length >= ctrl.component.minlength) {
              ctrl.component.searching = true;
            }
          }
          else if (which === KEYCODE.UP) {
            if (ctrl.component.showDropdown) {
              event.preventDefault();
              event.stopPropagation();

              var prevIdx = ctrl.component.currentIndex - 1;
              prevIdx = prevIdx < 0 ? 0 : prevIdx;
              ctrl.component.currentIndex = prevIdx;
              checkVisibility();
            }
          }
          else if (which === KEYCODE.LEFT) {
            if (ctrl.component.showDropdown) {
              ctrl.component.search = ctrl.component.inputValue;
              $timeout.cancel(ctrl.component.timer);
              doFilter(true, false);
              ctrl.component.changedCount = ctrl.component.changedCount + 1;
            }
          }
          if (angular.isFunction(ctrl.options.events.keydown)) {
            ctrl.options.events.keydown(value, event);
          }
        }

        function updateValue() {
          ctrl.ngModel.$setViewValue(ctrl.value);
          var inputModel = $element.find('input').controller('ngModel');
          if (inputModel) {
            inputModel.$setPristine();
          }
          if (ctrl.plEdit) {
            ctrl.plEdit.valueChanged(ctrl);
          }
        }

        function setWidth() {
          dropdown = $element.find('.pl-autocomplete-dropdown-wrapper');
          if (dropdown && inputField && dropdown.length && inputField.length) {
            var dd = dropdown[0].scrollWidth;
            var i = inputField[0].clientWidth;
            ctrl.component.dropdownWidth = Math.max(dd, i);
          }
        }

        function onMouseEnter() {
          ctrl.component.isMouseIn = true;
        }

        function onMouseLeave() {
          ctrl.component.isMouseIn = false;
        }

        function fnBlur(event) {
          if (!ctrl.component.isMouseIn) {
            ctrl.doClose();
          }
          // Callback function
          if (angular.isFunction(ctrl.options.events.blur)) {
            ctrl.options.events.blur(ctrl.value, event, ctrl.component, ctrl.data);
          }
        }

        function onChange(event) {
          ctrl.component.changedCount++;
          ctrl.component.inputValue = ctrl.component.inputValue || '';
          if (!ctrl.component.enterPressed && ctrl.component.inputValue.length >= ctrl.component.minlength) {
            if (!ctrl.component.inputValue && ctrl.filterModel) {
              ctrl.clearFilter();
            }
            ctrl.open(true);
          }
          if (angular.isFunction(ctrl.options.events.change)) {
            ctrl.options.events.change(ctrl.component.inputValue, event);
          }
        }

        function fnFocus(event) {
          // Callback function
          if (angular.isFunction(ctrl.onFocus)) {
            ctrl.onFocus(ctrl.data, event);
          }
          else if (angular.isFunction(ctrl.options.events.focus)) {
            ctrl.options.events.focus(ctrl.value, event, ctrl.component, ctrl.data);
          }
        }

        function getRow(item) {
          angular.forEach(item, function (propValue, propName) {
            if (angular.isString(propValue)) {
              item[propName] = plTranslate.translate(item[propName]);
            }
          });
          var rowTemplate = ctrl.component.rowTemplate;
          if (angular.isFunction(rowTemplate)) {
            rowTemplate = rowTemplate(item);
          }
          try {
            return $interpolate(rowTemplate)(item);
          }
          catch (e) {
            throw 'getRow' + e.stack;
          }
        }

        function onItemClick(event, item) {
          event.preventDefault();
          ctrl.select(item);
        }

        function select(item, force) {
          ctrl.component.changedCount = 0;
          ctrl.component.isValid = true;
          ctrl.component.isSelecting = true;
          ctrl.component.selected = item;
          ctrl.component.original.selected = item;
          ctrl.component.original.inputValue = ctrl.component.inputValue;
          ctrl.component.original.isValid = true;
          ctrl.selected = item;

          if (item && angular.isDefined(item) && angular.isDefined(ctrl.output)) {
            if (ctrl.output.indexOf('{{') >= 0) { // se não tiver {{ é porque é o nome no campo.
              try {
                ctrl.component.inputValue = $interpolate(ctrl.output)(item);
              }
              catch (e) {
                throw 'select:' + e.stack;
              }
            }
            else {
              ctrl.component.inputValue = item[ctrl.output];
            }
          }
          ctrl.value = ctrl.component.inputValue;
          ctrl.updateValue();

          ctrl.component.isSelecting = false;
          ctrl.doClose(force);

          if (angular.isFunction(ctrl.onSelect)) {
            ctrl.onSelect(item, ctrl.component, ctrl.plForm);
          }
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.change)) {
            ctrl.options.events.change(ctrl.component.inputValue, item, ctrl.component, ctrl.plForm);
          }
        }

        function cancel() {
          ctrl.component.selected = ctrl.component.original.selected;
          ctrl.component.inputValue = ctrl.component.original.inputValue;
          ctrl.component.isValid = ctrl.component.original.isValid;
          ctrl.select(ctrl.component.selected);
          ctrl.doClose();
        }

        function fnOpen(shouldFilter) {
          ctrl.isFilterCollapsed = !ctrl.filterModel || !ctrl.filterModel.length;
          ctrl.component.showDropdown = true;
          if (!shouldFilter) {
            ctrl.component.searchStrLast = '';
            ctrl.component.page = 1;
            ctrl.component.model = [];
            inputField.focus();
            inputField.select();
          }
          doFilter(shouldFilter, ctrl.component.model.length === 0);
        }

        function doClose(force) {
          if (!ctrl.component.showDropdown) {
            return;
          }
          $timeout.cancel(ctrl.component.timer);

          ctrl.component.searching = false;
          ctrl.component.showDropdown = false;

          if ((force || !ctrl.component.isValid) && angular.isFunction(ctrl.onValidate)) {
            $q.when(ctrl.onValidate(ctrl.component.inputValue, ctrl.component, ctrl.selected)).then(
              function (data) {
                if (data !== 'doRemain') {
                  ctrl.component.notFound = null;
                  ctrl.select(data);
                }
              },
              function (error) {
                if (!ctrl.allowInvalid && !ctrl.options.allowInvalid) {
                  ctrl.component.notFound = ctrl.component.textNotFound;
                  inputField.focus();
                }
                else {
                  ctrl.component.isValid = true;
                }
                ctrl.select(null);
              }
            );
          }
        }

        function toggle(event, doFilter) {
          event.preventDefault();
          if (ctrl.component.showDropdown || ctrl.options.disabled) {
            ctrl.doClose();
          }
          else {
            ctrl.open(doFilter);
          }
          inputField.triggerHandler('focus');
        }

        function updateModel(list, reset) {
          if (reset === true) {
            ctrl.component.model = [];
          }
          if (ctrl.component.model.length > 0 && ctrl.component.currentIndex < 0 && ctrl.component.autoSelectFirst) {
            ctrl.component.currentIndex = 0;
          }
          else {
            ctrl.component.currentIndex = -1;
          }
          list.forEach(function (item) {
            ctrl.component.model.push(item);
          });
          ctrl.component.resultSize = list.length;
        }

        function loadMore() {
          if (ctrl.component.responseResultSize === 0 || ctrl.isLocalSource) {
            return;
          }
          if (!ctrl.promise) {
            ctrl.component.page++;
          }
          return doFilter(!$element.find('input').controller('ngModel').$pristine, true);
        }

        function fnFilter(value, query) {
          ctrl.filter = query;
          ctrl.component.page = 1;
          return doFilter(true, true, true);
        }

        function clearFilter() {
          ctrl.filter = undefined;
          ctrl.filterModel = [];
        }

        function updateComponent(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties, properties);
            ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
            _.merge(ctrl, ctrl.options);
            _.merge(ctrl.component, ctrl.options);
          }
        }
      }]
    });
})();

(function () {
  'use strict';

  angular.module('pl.autofocus', [])
    .directive('plAutoFocus', ['$interpolate', '$timeout', '$interval', function ($interpolate, $timeout, $interval) {
      return {
        restrict: 'A',
        link: function ($scope, $element, $attrs) {
          var interval = null;
          var selector = $element.prop('tagName').toLowerCase();

          /////////////

          function clearInterval() {
            if (interval) {
              $interval.cancel(interval);
              interval = null;
            }
          }

          (function init() {
            /* $attrs is used instead of scope to allow using this directive in combination
             * with other components*/
            var plAutoFocus = $attrs.plAutoFocus;
            if (plAutoFocus) {
              if (plAutoFocus.indexOf('{{') !== -1) {
                plAutoFocus = $interpolate(plAutoFocus)($scope);
              }
              // If plAutoFocus has a 'false' value, then we do nothing
              if (plAutoFocus !== '' && (plAutoFocus === 'false' || Boolean(plAutoFocus) === false)) {
                return;
              }
              // Else we reassign our selector to override the default one
              if (plAutoFocus !== '') {
                selector = $attrs.plAutoFocus;
              }
            }
            if (!$element.is(selector)) {
              $element = $element.closest(selector);
            }
            if (!$element.is(':first-child')) {
              $element = $element.prev(selector + ':first-child');
            }
            $timeout(function () {
              var $input = $element.find('input');
              interval = $interval(function () {
                if (!$input.length) {
                  $input = $element.find('input');
                }
                else {
                  clearInterval();
                  $input.focus();
                }
              }, 50);
            });
          })();

          $scope.$on('$destroy', function () {
            clearInterval();
          });
        }
      };
    }]);
})();

/**
 * Created by serrano on 02/05/16.
 */
(function () {
  /*jslint bitwise: true */
  'use strict';

  angular.module('pl.colorpicker', ['pl.edit'])
    .component('plColorpicker', {
      require: {
        ngModel: '?ngModel',
        plEdit: '?^plEdit',
        plGroup: '?^plGroup'
      },
      bindings: {
        format: '@?',
        placeholder: '@?'
      },
      templateUrl: '../source/pl-colorpicker.html',
      controllerAs: '$ctrl',
      controller: function () {
        var ctrl = this;
        var defaultOptions = {
          readonly: false,
          disabled: false,
          validate: true,
          validators: {
            required: {value: false}
          },
          events: {}
        };

        ctrl.colorOpened = false;
        ctrl.viewValue = null;
        ctrl.colorValue = null;
        ctrl.options = {};

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.$onDestroy = onDestroy;
        ctrl.handleChanges = handleChanges;
        ctrl.valueChange = valueChange;
        ctrl.updateComponent = updateComponent;

        /////////////

        function init() {
          if (ctrl.plEdit) {
            ctrl.plEdit.addComponent(ctrl);
            if (ctrl.plEdit.options) {
              _.merge(defaultOptions, ctrl.plEdit.options);
            }
          }
          ctrl.options = _.merge({}, defaultOptions, ctrl.properties);
          ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;

          ctrl.handleChanges();

          ctrl.ngModel.$render = function () {
            var newValue = ctrl.ngModel.$viewValue;
            if (newValue) {
              ctrl.viewValue = newValue;
              ctrl.colorValue = newValue;
            }
          };
        }

        function onChanges(plColorPicker) {
          if (plColorPicker) {
            ctrl.handleChanges();
          }
        }

        function onDestroy() {
          // Clears binds when scope is destroyed
          ctrl.clearEvents();
          if (ctrl.plGroup) {
            ctrl.plGroup.removeEdit(ctrl.name);
          }
          if (ctrl.plInlineEdit) {
            ctrl.plInlineEdit.removeEdit(ctrl.name);
          }
        }

        function handleChanges() {
          ctrl.format = ctrl.format || ctrl.options.format || undefined;
          ctrl.placeholder = ctrl.placeholder || ctrl.options.placeholder || undefined;
        }

        function valueChange() {
          ctrl.viewValue = ctrl.colorValue;
          ctrl.colorOpened = false;
          ctrl.ngModel.$setViewValue(ctrl.viewValue);
        }

        function updateComponent(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties, properties);
            ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
          }
        }
      }
    })
    .factory('Helper', function () {
      return {
        closestSlider: function (elem) {
          var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
          if (matchesSelector.bind(elem)('I')) {
            return elem.parentNode;
          }
          return elem;
        },
        getOffset: function (elem, fixedPosition) {
          var
            scrollX = 0,
            scrollY = 0,
            rect = elem.getBoundingClientRect();
          while (elem && !isNaN(elem.offsetLeft) && !isNaN(elem.offsetTop)) {
            if (!fixedPosition && elem.tagName === 'BODY') {
              scrollX += document.documentElement.scrollLeft || elem.scrollLeft;
              scrollY += document.documentElement.scrollTop || elem.scrollTop;
            } else {
              scrollX += elem.scrollLeft;
              scrollY += elem.scrollTop;
            }
            elem = elem.offsetParent;
          }
          return {
            top: rect.top + window.pageYOffset,
            left: rect.left + window.pageXOffset,
            scrollX: scrollX,
            scrollY: scrollY
          };
        },
        // a set of RE's that can match strings and generate color tuples. https://github.com/jquery/jquery-color/
        stringParsers: [
          {
            re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
            parse: function (execResult) {
              return [
                execResult[1],
                execResult[2],
                execResult[3],
                execResult[4]
              ];
            }
          },
          {
            re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
            parse: function (execResult) {
              return [
                2.55 * execResult[1],
                2.55 * execResult[2],
                2.55 * execResult[3],
                execResult[4]
              ];
            }
          },
          {
            re: /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,
            parse: function (execResult) {
              return [
                parseInt(execResult[1], 16),
                parseInt(execResult[2], 16),
                parseInt(execResult[3], 16)
              ];
            }
          },
          {
            re: /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/,
            parse: function (execResult) {
              return [
                parseInt(execResult[1] + execResult[1], 16),
                parseInt(execResult[2] + execResult[2], 16),
                parseInt(execResult[3] + execResult[3], 16)
              ];
            }
          }
        ]
      };
    })
    .factory('Color', ['Helper', function (Helper) {
      return {
        value: {
          h: 1,
          s: 1,
          b: 1,
          a: 1
        },
        // translate a format from Color object to a string
        'rgb': function () {
          var rgb = this.toRGB();
          return 'rgb(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ')';
        },
        'rgba': function () {
          var rgb = this.toRGB();
          return 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')';
        },
        'hex': function () {
          return this.toHex();
        },

        // HSBtoRGB from RaphaelJS
        RGBtoHSB: function (r, g, b, a) {
          r /= 255;
          g /= 255;
          b /= 255;

          var H, S, V, C;
          V = Math.max(r, g, b);
          C = V - Math.min(r, g, b);
          H = (C === 0 ? null :
              V === r ? (g - b) / C :
                V === g ? (b - r) / C + 2 :
                  (r - g) / C + 4
          );
          H = ((H + 360) % 6) * 60 / 360;
          S = C === 0 ? 0 : C / V;
          return {h: H || 1, s: S, b: V, a: a || 1};
        },

        //parse a string to HSB
        setColor: function (val) {
          val = (val) ? val.toLowerCase() : val;
          for (var key in Helper.stringParsers) {
            if (Helper.stringParsers.hasOwnProperty(key)) {
              var parser = Helper.stringParsers[key];
              var match = parser.re.exec(val),
                values = match && parser.parse(match);
              if (values) {
                this.value = this.RGBtoHSB.apply(null, values);
                return false;
              }
            }
          }
        },

        setHue: function (h) {
          this.value.h = 1 - h;
        },

        setSaturation: function (s) {
          this.value.s = s;
        },

        setLightness: function (b) {
          this.value.b = 1 - b;
        },

        setAlpha: function (a) {
          this.value.a = parseInt((1 - a) * 100, 10) / 100;
        },

        // HSBtoRGB from RaphaelJS
        // https://github.com/DmitryBaranovskiy/raphael/
        toRGB: function (h, s, b, a) {
          if (!h) {
            h = this.value.h;
            s = this.value.s;
            b = this.value.b;
          }
          h *= 360;
          var R, G, B, X, C;
          h = (h % 360) / 60;
          C = b * s;
          X = C * (1 - Math.abs(h % 2 - 1));
          R = G = B = b - C;

          h = ~~h;
          R += [C, X, 0, 0, X, C][h];
          G += [X, C, C, X, 0, 0][h];
          B += [0, 0, X, C, C, X][h];
          return {
            r: Math.round(R * 255),
            g: Math.round(G * 255),
            b: Math.round(B * 255),
            a: a || this.value.a
          };
        },

        toHex: function (h, s, b, a) {
          var rgb = this.toRGB(h, s, b, a);
          return '#' + ((1 << 24) | (parseInt(rgb.r, 10) << 16) | (parseInt(rgb.g, 10) << 8) | parseInt(rgb.b, 10)).toString(16).substr(1);
        }
      };
    }])
    .factory('Slider', ['Helper', function (Helper) {
      var
        slider = {
          maxLeft: 0,
          maxTop: 0,
          callLeft: null,
          callTop: null,
          knob: {
            top: 0,
            left: 0
          }
        },
        pointer = {};

      return {
        getSlider: function () {
          return slider;
        },
        getLeftPosition: function (event) {
          return Math.max(0, Math.min(slider.maxLeft, slider.left + ((event.pageX || pointer.left) - pointer.left)));
        },
        getTopPosition: function (event) {
          return Math.max(0, Math.min(slider.maxTop, slider.top + ((event.pageY || pointer.top) - pointer.top)));
        },
        setSlider: function (event, fixedPosition) {
          var
            target = Helper.closestSlider(event.target),
            targetOffset = Helper.getOffset(target, fixedPosition),
            rect = target.getBoundingClientRect(),
            offsetX = event.clientX - rect.left,
            offsetY = event.clientY - rect.top;

          slider.knob = target.children[0].style;
          slider.left = event.pageX - targetOffset.left - window.pageXOffset + targetOffset.scrollX;
          slider.top = event.pageY - targetOffset.top - window.pageYOffset + targetOffset.scrollY;

          pointer = {
            left: event.pageX - (offsetX - slider.left),
            top: event.pageY - (offsetY - slider.top)
          };
        },
        setSaturation: function (event, fixedPosition, componentSize) {
          slider = {
            maxLeft: componentSize,
            maxTop: componentSize,
            callLeft: 'setSaturation',
            callTop: 'setLightness'
          };
          this.setSlider(event, fixedPosition);
        },
        setHue: function (event, fixedPosition, componentSize) {
          slider = {
            maxLeft: 0,
            maxTop: componentSize,
            callLeft: false,
            callTop: 'setHue'
          };
          this.setSlider(event, fixedPosition);
        },
        setAlpha: function (event, fixedPosition, componentSize) {
          slider = {
            maxLeft: 0,
            maxTop: componentSize,
            callLeft: false,
            callTop: 'setAlpha'
          };
          this.setSlider(event, fixedPosition);
        },
        setKnob: function (top, left) {
          slider.knob.top = top + 'px';
          slider.knob.left = left + 'px';
        }
      };
    }])
    .directive('colorpicker', ['$document', '$compile', 'Color', 'Slider', 'Helper', function ($document, $compile, Color, Slider, Helper) {
      return {
        require: '?ngModel',
        scope: {
          disabled: '<?',
          readonly: '<?'
        },
        restrict: 'A',
        link: function ($scope, elem, attrs, ngModel) {
          var
            thisFormat = attrs.colorpicker ? attrs.colorpicker : 'hex',
            position = angular.isDefined(attrs.colorpickerPosition) ? attrs.colorpickerPosition : 'bottom',
            inline = angular.isDefined(attrs.colorpickerInline) ? attrs.colorpickerInline : false,
            fixedPosition = angular.isDefined(attrs.colorpickerFixedPosition) ? attrs.colorpickerFixedPosition : false,
            target = angular.isDefined(attrs.colorpickerParent) ? elem.parent() : angular.element(document.body),
            withInput = angular.isDefined(attrs.colorpickerWithInput) ? attrs.colorpickerWithInput : false,
            componentSize = angular.isDefined(attrs.colorpickerSize) ? attrs.colorpickerSize : 100,
            componentSizePx = componentSize + 'px',
            inputTemplate = withInput ? '<input type="text" name="colorpicker-input" spellcheck="false">' : '',
            closeButton = !inline ? '<button type="button" class="close close-colorpicker">&times;</button>' : '',
            template =
              '<div class="colorpicker dropdown">' +
              '<div class="dropdown-menu">' +
              '<colorpicker-saturation><i></i></colorpicker-saturation>' +
              '<colorpicker-hue><i></i></colorpicker-hue>' +
              '<colorpicker-alpha><i></i></colorpicker-alpha>' +
              '<colorpicker-preview></colorpicker-preview>' +
              inputTemplate +
              closeButton +
              '</div>' +
              '</div>',
            colorpickerTemplate = angular.element(template),
            pickerColor = Color,
            colorpickerValue = {
              h: 1,
              s: 0,
              b: 1,
              a: 1
            },
            sliderAlpha,
            sliderHue = colorpickerTemplate.find('colorpicker-hue'),
            sliderSaturation = colorpickerTemplate.find('colorpicker-saturation'),
            colorpickerPreview = colorpickerTemplate.find('colorpicker-preview'),
            pickerColorPointers = colorpickerTemplate.find('i');

          $compile(colorpickerTemplate)($scope);
          colorpickerTemplate.css('min-width', parseInt(componentSize) + 29 + 'px');
          sliderSaturation.css({
            'width': componentSizePx,
            'height': componentSizePx
          });
          sliderHue.css('height', componentSizePx);

          if (withInput) {
            var pickerColorInput = colorpickerTemplate.find('input');
            pickerColorInput.css('width', componentSizePx);
            pickerColorInput
              .on('mousedown', function (event) {
                event.stopPropagation();
              })
              .on('keyup', function () {
                var newColor = this.value;
                elem.val(newColor);
                if (ngModel && ngModel.$modelValue !== newColor) {
                  $scope.$apply(ngModel.$setViewValue(newColor));
                  update(true);
                }
              });
          }

          function bindMouseEvents() {
            $document.on('mousemove', mousemove);
            $document.on('mouseup', mouseup);
          }

          if (thisFormat === 'rgba') {
            colorpickerTemplate.addClass('alpha');
            sliderAlpha = colorpickerTemplate.find('colorpicker-alpha');
            sliderAlpha.css('height', componentSizePx);
            sliderAlpha
              .on('click', function (event) {
                Slider.setAlpha(event, fixedPosition, componentSize);
                mousemove(event);
              })
              .on('mousedown', function (event) {
                Slider.setAlpha(event, fixedPosition, componentSize);
                bindMouseEvents();
              })
              .on('mouseup', function (event) {
                emitEvent('colorpicker-selected-alpha');
              });
          }

          sliderHue
            .on('click', function (event) {
              Slider.setHue(event, fixedPosition, componentSize);
              mousemove(event);
            })
            .on('mousedown', function (event) {
              Slider.setHue(event, fixedPosition, componentSize);
              bindMouseEvents();
            })
            .on('mouseup', function (event) {
              emitEvent('colorpicker-selected-hue');
            });

          sliderSaturation
            .on('click', function (event) {
              Slider.setSaturation(event, fixedPosition, componentSize);
              mousemove(event);
              if (angular.isDefined(attrs.colorpickerCloseOnSelect)) {
                hideColorpickerTemplate();
              }
            })
            .on('mousedown', function (event) {
              Slider.setSaturation(event, fixedPosition, componentSize);
              bindMouseEvents();
            })
            .on('mouseup', function (event) {
              emitEvent('colorpicker-selected-saturation');
            });

          if (fixedPosition) {
            colorpickerTemplate.addClass('colorpicker-fixed-position');
          }

          colorpickerTemplate.addClass('colorpicker-position-' + position);
          if (inline === 'true') {
            colorpickerTemplate.addClass('colorpicker-inline');
          }

          target.append(colorpickerTemplate);

          if (ngModel) {
            ngModel.$render = function () {
              elem.val(ngModel.$viewValue);

              update();
            };
          }

          elem.on('blur keyup change', function () {
            update();
          });

          elem.on('$destroy', function () {
            colorpickerTemplate.remove();
          });

          function previewColor() {
            try {
              colorpickerPreview.css('backgroundColor', pickerColor[thisFormat]());
            } catch (e) {
              colorpickerPreview.css('backgroundColor', pickerColor.toHex());
            }
            sliderSaturation.css('backgroundColor', pickerColor.toHex(pickerColor.value.h, 1, 1, 1));
            if (thisFormat === 'rgba') {
              sliderAlpha.css.backgroundColor = pickerColor.toHex();
            }
          }

          function mousemove(event) {
            var
              left = Slider.getLeftPosition(event),
              top = Slider.getTopPosition(event),
              slider = Slider.getSlider();

            Slider.setKnob(top, left);

            if (slider.callLeft) {
              pickerColor[slider.callLeft].call(pickerColor, left / componentSize);
            }
            if (slider.callTop) {
              pickerColor[slider.callTop].call(pickerColor, top / componentSize);
            }
            previewColor();
            var newColor = pickerColor[thisFormat]();
            elem.val(newColor);
            if (ngModel) {
              $scope.$apply(ngModel.$setViewValue(newColor));
            }
            if (withInput) {
              pickerColorInput.val(newColor);
            }
            return false;
          }

          function mouseup() {
            emitEvent('colorpicker-selected');
            $document.off('mousemove', mousemove);
            $document.off('mouseup', mouseup);
          }

          function update(omitInnerInput) {
            pickerColor.value = colorpickerValue;
            pickerColor.setColor(elem.val());
            if (withInput && !omitInnerInput) {
              pickerColorInput.val(elem.val());
            }
            pickerColorPointers.eq(0).css({
              left: pickerColor.value.s * componentSize + 'px',
              top: componentSize - pickerColor.value.b * componentSize + 'px'
            });
            pickerColorPointers.eq(1).css('top', componentSize * (1 - pickerColor.value.h) + 'px');
            pickerColorPointers.eq(2).css('top', componentSize * (1 - pickerColor.value.a) + 'px');
            colorpickerValue = pickerColor.value;
            previewColor();
          }

          function getColorpickerTemplatePosition() {
            var
              positionValue,
              positionOffset = Helper.getOffset(elem[0]);

            if (angular.isDefined(attrs.colorpickerParent)) {
              positionOffset.left = 0;
              positionOffset.top = 0;
            }

            if (position === 'top') {
              positionValue = {
                'top': positionOffset.top - 147,
                'left': positionOffset.left
              };
            } else if (position === 'right') {
              positionValue = {
                'top': positionOffset.top,
                'left': positionOffset.left + 126
              };
            } else if (position === 'bottom') {
              positionValue = {
                'top': positionOffset.top + elem[0].offsetHeight + 2,
                'left': positionOffset.left
              };
            } else if (position === 'left') {
              positionValue = {
                'top': positionOffset.top,
                'left': positionOffset.left - 150
              };
            }
            return {
              'top': positionValue.top + 'px',
              'left': positionValue.left + 'px'
            };
          }

          function documentMousedownHandler() {
            hideColorpickerTemplate();
          }

          function showColorpickerTemplate() {
            if ($scope.disabled || $scope.readonly) {
              hideColorpickerTemplate();
              return;
            }

            if (!colorpickerTemplate.hasClass('colorpicker-visible')) {
              update();
              colorpickerTemplate
                .addClass('colorpicker-visible')
                .css(getColorpickerTemplatePosition());
              emitEvent('colorpicker-shown');

              if (inline === false) {
                // register global mousedown event to hide the colorpicker
                $document.on('mousedown', documentMousedownHandler);
              }

              if (attrs.colorpickerIsOpen) {
                $scope[attrs.colorpickerIsOpen] = true;
                if (!$scope.$$phase || !$scope.$root.$$phase) {
                  $scope.$digest(); //trigger the watcher to fire
                }
              }
            }
          }

          if (inline === false) {
            elem.on('click', showColorpickerTemplate);
          } else {
            showColorpickerTemplate();
          }

          colorpickerTemplate.on('mousedown', function (event) {
            event.stopPropagation();
            event.preventDefault();
          });

          function emitEvent(name) {
            if (ngModel) {
              $scope.$emit(name, {
                name: attrs.ngModel,
                value: ngModel.$modelValue
              });
            }
          }

          function hideColorpickerTemplate() {
            if (colorpickerTemplate.hasClass('colorpicker-visible')) {
              colorpickerTemplate.removeClass('colorpicker-visible');
              emitEvent('colorpicker-closed');
              // unregister the global mousedown event
              $document.off('mousedown', documentMousedownHandler);

              if (attrs.colorpickerIsOpen) {
                $scope[attrs.colorpickerIsOpen] = false;
                if (!$scope.$$phase || !$scope.$root.$$phase) {
                  $scope.$digest(); //trigger the watcher to fire
                }
              }
            }
          }

          colorpickerTemplate.find('button').on('click', function () {
            hideColorpickerTemplate();
          });

          if (attrs.colorpickerIsOpen) {
            $scope.$watch(attrs.colorpickerIsOpen, function (shouldBeOpen) {

              if (shouldBeOpen === true) {
                showColorpickerTemplate();
              } else if (shouldBeOpen === false) {
                hideColorpickerTemplate();
              }

            });
          }
        }
      };
    }]);
})();

/**
 * Created by pedro on 28/09/16.
 */
(function () {
  'use strict';

  angular.module('pl.comps',
    [
      'ngMessages',
      'ngAnimate',
      'ngSanitize',
      'ngTouch',
      'angularMoment',
      'jlareau.pnotify',
      'ui.scrollpoint',
      'ui.select',
      'ui.sortable',
      'pl.edit',
      'pl.inlineEdit',
      'pl.animation',
      'pl.filterPanel',
      'pl.toolbar',
      'pl.autocomplete',
      'pl.aihighlight',
      'pl.navbar',
      'pl.table',
      'pl.spinners',
      'pl.translate',
      'pl.promises',
      'pl.datepicker',
      'pl.timepicker',
      'pl.textarea',
      'pl.multiselect',
      'pl.objecteditor',
      'pl.input',
      'pl.infinite-scroll',
      'pl.upload',
      'pl.colorpicker',
      'pl.pdf',
      'pl.dashboard',
      'pl.alert',
      'pl.filters',
      'pl.autofocus',
      'pl.affix'
    ])
    .config(['plEditProvider', function (plEditProvider) {
      plEditProvider.register('autocomplete', '<pl-autocomplete edit-class="$ctrl.editClass" pl-auto-class="false" name="{{$ctrl.name}}" ng-model="$ctrl.value"' +
        ' ng-change="$ctrl.read()" properties="$ctrl.options"></pl-autocomplete>');
      plEditProvider.register('checkbox', '<pl-edit-checkbox edit-class="$ctrl.editClass" pl-auto-class="false" name="{{$ctrl.name}}" ng-model="$ctrl.value"' +
        ' ng-change="$ctrl.read()" properties="$ctrl.options"></pl-edit-checkbox>');
      plEditProvider.register('color', '<pl-colorpicker edit-class="$ctrl.editClass" pl-auto-class="false" ng-model="$ctrl.value"' +
        ' ng-change="$ctrl.read()" properties="$ctrl.options"></pl-colorpicker>');
      plEditProvider.register('date', '<pl-datepicker edit-class="$ctrl.editClass" pl-auto-class="false" name="{{$ctrl.name}}" ng-model="$ctrl.value"' +
        ' ng-change="$ctrl.read()" properties="$ctrl.options"></pl-datepicker>');
      plEditProvider.register('email', '<pl-edit-email edit-class="$ctrl.editClass" pl-auto-class="true" name="{{$ctrl.name}}" ng-model="$ctrl.value"' +
        ' ng-change="$ctrl.read()" properties="$ctrl.options"></pl-edit-email>');
      plEditProvider.register('number', '<pl-edit-number edit-class="$ctrl.editClass" pl-auto-class="true" name="{{$ctrl.name}}" ng-model="$ctrl.value"' +
        ' ng-change="$ctrl.read()" properties="$ctrl.options"></pl-edit-number>');
      plEditProvider.register('multiselect', '<pl-multiselect name="{{$ctrl.name}}" ng-model="$ctrl.value" ng-change="$ctrl.read()"' +
        ' properties="$ctrl.options"></pl-multiselect>');
      plEditProvider.register('password', '<pl-edit-password edit-class="$ctrl.editClass" pl-auto-class="true" name="{{$ctrl.name}}" ng-model="$ctrl.value"' +
        ' ng-change="$ctrl.read()" properties="$ctrl.options"></pl-edit-password>');
      plEditProvider.register('phone', '<pl-edit-phone edit-class="$ctrl.editClass" pl-auto-class="true" name="{{$ctrl.name}}" ng-model="$ctrl.value"' +
        ' ng-change="$ctrl.read()" properties="$ctrl.options"></pl-edit-phone>');
      plEditProvider.register('radio', '<pl-edit-radio edit-class="$ctrl.editClass" pl-auto-class="false" name="{{$ctrl.name}}" ng-model="$ctrl.value"' +
        ' ng-change="$ctrl.read()" properties="$ctrl.options"></pl-edit-radio>');
      plEditProvider.register('rowselect', '<pl-row-select edit-class="$ctrl.editClass" pl-auto-class="false" name="{{$ctrl.name}}" ng-model="$ctrl.value"' +
        ' ng-change="$ctrl.read()" start="{{$ctrl.options.start}}" end="{{$ctrl.options.end}}" list="$ctrl.options.list" properties="$ctrl.options"></pl-row-select>');
      plEditProvider.register('select', '<pl-edit-select edit-class="$ctrl.editClass" pl-auto-class="false" name="{{$ctrl.name}}" ng-model="$ctrl.value"' +
        ' ng-change="$ctrl.read()" properties="$ctrl.options"></pl-edit-select>');
      plEditProvider.register('submit', '<pl-button type="submit" properties="$ctrl.options"></pl-button>');
      plEditProvider.register('switch', '<pl-edit-switch edit-class="$ctrl.editClass" pl-auto-class="false" name="{{$ctrl.name}}" ng-model="$ctrl.value"' +
        ' ng-change="$ctrl.read()" label="{{$ctrl.label}}" properties="$ctrl.options"></pl-edit-switch>');
      plEditProvider.register('text', '<pl-edit-text edit-class="$ctrl.editClass" pl-auto-class="true" name="{{$ctrl.name}}" ng-model="$ctrl.value"' +
        ' ng-change="$ctrl.read()" properties="$ctrl.options"></pl-edit-text>');
      plEditProvider.register('textarea', '<pl-edit-textarea edit-class="$ctrl.editClass" pl-auto-class="true" name="{{$ctrl.name}}" ng-model="$ctrl.value"' +
        ' ng-change="$ctrl.read()" properties="$ctrl.options"></pl-edit-textarea>');
      plEditProvider.register('time', '<pl-timepicker edit-class="$ctrl.editClass" pl-auto-class="false" name="{{$ctrl.name}}" ng-model="$ctrl.value"' +
        ' ng-change="$ctrl.read()" properties="$ctrl.options"></pl-timepicker>');
      plEditProvider.register('select2', '<pl-select name="{{$ctrl.name}}" ng-model="$ctrl.value" ng-change="$ctrl.read()" properties="$ctrl.options"></pl-select>');

      plEditProvider.map('text', 'string');
      plEditProvider.map('switch', 'boolean');
      plEditProvider.map('number', 'currency');
      plEditProvider.map('number', 'float');
      plEditProvider.map('number', 'integer', {decimalsLimit: 0});
      plEditProvider.map('date', 'datepicker');
      plEditProvider.map('select2', 'selectMultiple');
      plEditProvider.map('phone', 'phonenumber');
      plEditProvider.map('phone', 'telephone');
    }])
    .run(['plLocale', 'amMoment', function (plLocale, amMoment) {
      var locale = plLocale.locale;
      locale = locale === 'pt-pt' ? 'pt' : locale;
      amMoment.changeLocale(locale);
    }]);
})();
(function(){'use strict';angular.module('pl.comps').run(['$templateCache', function($templateCache) {$templateCache.put('../source/pl-alert.html','<div class="pl-alert-sticky alert" ng-class="[\'alert-\' + (ctrl.type || \'warning\'), ctrl.closeable ? \'alert-dismissible\' : null, ctrl.theme]" role="alert"\r\n     ng-show="ctrl.showing">\r\n  <button ng-show="ctrl.closeable" type="button" class="close" ng-click="ctrl.fnClose()">\r\n    <span aria-hidden="true">&times;</span>\r\n    <span class="sr-only" pl-translate="{{ctrl.locales.text.close}}"></span>\r\n  </button>\r\n  <div ng-transclude></div>\r\n</div>\r\n');
$templateCache.put('../source/pl-autocomplete.html','<div ng-hide="$ctrl.options.readonly" ng-class="{\'input-group pl-input-group\': $ctrl.options.raw === false}" pl-disable-animate>\r\n  <input type="text" class="form-control pl-autocomplete-input" autocapitalize="off" autocorrect="off" autocomplete="off"\r\n         ng-class="[$ctrl.component.inputClass, {\'raw\': $ctrl.options.raw}]"\r\n         ng-focus="$ctrl.fnFocus($event)"\r\n         ng-model="$ctrl.component.inputValue"\r\n         ng-model-options="$ctrl.options.ngModelOptions"\r\n         ng-blur="$ctrl.fnBlur($event)"\r\n         ng-attr-name="{{$ctrl.name}}"\r\n         ng-attr-placeholder="{{($ctrl.options.raw === false ? \'&#xf002;&nbsp;\' : \'\') + $ctrl.component.placeholder | pltranslate}}"\r\n         ng-change="$ctrl.onChange($event)"\r\n         ng-dblclick="$ctrl.open(false)"\r\n         ng-keydown="$ctrl.keyDownHandler($ctrl.value, $event)"\r\n         ng-keypress="$ctrl.keyPressHandler($ctrl.value, $event)"\r\n         ng-keyup="$ctrl.options.events.keyup($ctrl.value, $event)"\r\n         ng-mousedown="$ctrl.options.events.mousedown($ctrl.value, $event)"\r\n         ng-mouseenter="$ctrl.options.events.mouseenter($ctrl.value, $event)"\r\n         ng-mouseleave="$ctrl.options.events.mouseleave($ctrl.value, $event)"\r\n         ng-mousemove="$ctrl.options.events.mousemove($ctrl.value, $event)"\r\n         ng-mouseover="$ctrl.options.events.mouseover($ctrl.value, $event)"\r\n         ng-mouseup="$ctrl.options.events.mouseup($ctrl.value, $event)"\r\n         ng-disabled="$ctrl.options.disabled || $ctrl.options.disallowInput"\r\n         ng-required="$ctrl.options.validate && $ctrl.options.validators.required.value === true">\r\n\r\n  <a href class="input-group-addon cg-dp-btn" ng-click="$ctrl.toggle($event, false)"\r\n     ng-class="{\'disabled\': $ctrl.options.disabled, \'raw\': $ctrl.options.raw}"\r\n     ng-mouseenter="$ctrl.onMouseEnter($event)"\r\n     ng-mouseleave="$ctrl.onMouseLeave($event)"\r\n     ng-hide="$ctrl.options.raw" tabindex="-1">\r\n    <i class="fa fa-caret-down fa-fw"></i>\r\n  </a>\r\n</div>\r\n\r\n<div class="pl-autocomplete-dropdown-wrapper" ng-if="$ctrl.component.showDropdown" ng-init="$ctrl.setWidth()" ng-mouseenter="$ctrl.onMouseEnter($event)"\r\n     ng-mouseleave="$ctrl.onMouseLeave($event)" ng-class="{\'filter-active\': $ctrl.component.filterFields && $ctrl.component.showFilter}"\r\n     ng-style="{\'min-width\': $ctrl.component.dropdownWidth + \'px\'}">\r\n  <div class="pl-autocomplete-dropdown">\r\n    <div pl-infinite-scroll="$ctrl.loadMore()"\r\n         pl-infinite-scroll-distance="2"\r\n         pl-infinite-scroll-parent="true">\r\n      <ul class="list-unstyled" ng-switch="false" pl-promise="$ctrl.promise"\r\n          promise-btn-options="{btnLoadingClass: \'pl-promise-loading-bottom\'}">\r\n        <li ng-if="$ctrl.component.searching">{{$ctrl.component.textSearching}}</li>\r\n        <li ng-repeat="item in $ctrl.component.model track by (item[$ctrl.sourceKey] || $index)"\r\n            ng-click="$ctrl.onItemClick($event,item)"\r\n            ng-class="{\'pl-autocomplete-selected-row\': $index == $ctrl.component.currentIndex}">\r\n          <span ng-attr-id="{{$index}}" ng-bind-html="$ctrl.getRow(item) | AIhighlight : $ctrl.component.search"></span>\r\n        </li>\r\n        <li ng-if="!$ctrl.component.searching && $ctrl.component.model.length === 0">{{$ctrl.component.textEmpty}}</li>\r\n        <li ng-if="$ctrl.promise && $ctrl.component.model.length > 0" pl-promise="$ctrl.promise"></li>\r\n      </ul>\r\n    </div>\r\n  </div>\r\n\r\n  <div class="pl-autocomplete-dropdown-filter" ng-if="$ctrl.component.filterFields && $ctrl.component.showFilter">\r\n    <pl-filter fields="$ctrl.component.filterFields" show-caption="true" is-collapsed="$ctrl.isFilterCollapsed"\r\n               ng-model="$ctrl.filterModel" on-filter="$ctrl.fnFilter(value, query)">\r\n    </pl-filter>\r\n  </div>\r\n</div>\r\n\r\n<div class="error-form">{{$ctrl.component.notFound}}</div>\r\n\r\n<pl-messages target="{{$ctrl.name}}" validate="$ctrl.options.validate" properties="$ctrl.options.validators"></pl-messages>\r\n\r\n<span ng-show="$ctrl.options.readonly" class="form-control-align" pl-disable-animate>{{$ctrl.component.inputValue}}</span>\r\n');
$templateCache.put('../source/pl-colorpicker.html','<div class="pl-edit-colorpicker">\r\n  <div class="pl-edit-colorpicker-edit input-group pl-input-group">\r\n    <div class="pl-colorpicker circle" colorpicker ng-model="$ctrl.colorValue" ng-change="$ctrl.valueChange()" disabled="$ctrl.options.disabled"\r\n         readonly="$ctrl.options.readonly" ng-class="{\'disabled\': $ctrl.options.disabled, \'readonly\': $ctrl.options.readonly}"\r\n         ng-style="{\'background\': $ctrl.viewValue}">\r\n    </div>\r\n  </div>\r\n  <div class="pl-edit-colorpicker-label" pl-translate="{{$ctrl.options.label}}"></div>\r\n</div>\r\n\r\n<pl-messages target="{{$ctrl.name}}" validate="$ctrl.options.validate" properties="$ctrl.options.validators"></pl-messages>\r\n');
$templateCache.put('../source/pl-dashboard.html','<div ng-switch="ctrl.data.dashboard.type" pl-promise="ctrl.source" ng-if="ctrl.data.dashboard.type !== \'tile\'">\r\n  <div class="panel panel-chart">\r\n    <div class="panel-body">\r\n      <div class="chart-container" ng-switch-when="chart">\r\n        <canvas class="chart chart-bar"\r\n                height="150"\r\n                chart-data="ctrl.data.data"\r\n                chart-labels="ctrl.data.labels"\r\n                chart-series="ctrl.data.series"\r\n                chart-colors="ctrl.data.colors"\r\n                chart-options="ctrl.data.options"\r\n                chart-dataset-override="ctrl.data.datasetOverride">\r\n        </canvas>\r\n      </div>\r\n\r\n      <div ng-switch-when="table" class="table-dashboard">\r\n        <div class="panel panel-primary">\r\n          <div class="panel-heading">\r\n            <h3 class="panel-title">{{ctrl.data.dashboard.title}} </h3>\r\n          </div>\r\n\r\n          <div class="table-responsive">\r\n            <table class="table table-bordered table-hover">\r\n              <thead>\r\n              <tr class="table-header" ng-repeat="item in ctrl.data.data| limitTo: 1">\r\n                <td ng-repeat="(key, name) in item" ng-class="{\'text-right\': ctrl.formatRight(name)}">{{key}}</td>\r\n              </tr>\r\n              </thead>\r\n\r\n              <tbody>\r\n              <tr ng-if="!ctrl.data.data.length">\r\n                <td class="text-center" style="padding: 30px 0">N\xE3o existem dados para mostrar</td>\r\n              </tr>\r\n              <tr ng-repeat="item in ctrl.data.data">\r\n                <td ng-repeat="(key, name) in item " ng-class="{\'text-right\': ctrl.formatRight(name)}">\r\n                  <div uib-tooltip="{{ctrl.getTooltip(name)}}">\r\n                    <div ng-show="ctrl.windowWidth <= 1440">{{ctrl.getValue(name) | limitTo: 50}}</div>\r\n                    <div ng-show="ctrl.windowWidth > 1440">{{ctrl.getValue(name) | limitTo: 90}}</div>\r\n                  </div>\r\n                </td>\r\n              </tr>\r\n              </tbody>\r\n            </table>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div ng-if="ctrl.data.dashboard.type === \'tile\'" pl-promise="ctrl.source">\r\n  <div class="pl-dashboards">\r\n    <div class="panel panel-tile" ng-class="ctrl.data.data.style">\r\n      <div class="panel-heading">\r\n        <div class="row">\r\n          <div class="col-xs-3">\r\n            <span class="fa fa-2x" ng-class="ctrl.data.data.icon"></span>\r\n          </div>\r\n\r\n          <div class="col-xs-9 text-right">\r\n            <span pl-translate="{{ctrl.data.data.title}}"></span><br>\r\n            <small>{{ctrl.data.data.subtitle}}</small>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class="panel-footer clearfix">\r\n        <h4 class="pull-right">{{ctrl.data.data.value}}</h4>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n');
$templateCache.put('../source/pl-datepicker.html','<div class="input-group pl-input-group" ng-class="$ctrl.editClass" ng-hide="$ctrl.options.readonly" pl-disable-animate>\r\n  <input type="text" class="form-control pl-datepicker-input" autocapitalize="off" autocorrect="off" autocomplete="off"\r\n         ng-class="$ctrl.options.inputClass"\r\n         ng-attr-name="{{$ctrl.name}}"\r\n         ng-model="$ctrl.viewValue"\r\n         ng-model-options="$ctrl.options.ngModelOptions"\r\n         ng-change="$ctrl.valueChange($ctrl.viewValue, $event)"\r\n         ng-focus="$ctrl.options.events.focus($ctrl.viewValue, $event)"\r\n         ng-blur="$ctrl.onBlur($event)"\r\n         ng-keypress="$ctrl.options.events.keypress($ctrl.viewValue, $event)"\r\n         ng-keyup="$ctrl.options.events.keyup($ctrl.viewValue, $event)"\r\n         ng-mousedown="$ctrl.options.events.mousedown($ctrl.viewValue, $event)"\r\n         ng-mouseenter="$ctrl.onMouseEnter($event)"\r\n         ng-mouseleave="$ctrl.onMouseLeave($event)"\r\n         ng-mousemove="$ctrl.options.events.mousemove($ctrl.viewValue, $event)"\r\n         ng-mouseover="$ctrl.options.events.mouseover($ctrl.viewValue, $event)"\r\n         ng-mouseup="$ctrl.options.events.mouseup($ctrl.viewValue, $event)"\r\n         ng-dblclick="$ctrl.showCalendar()"\r\n         ng-keydown="$ctrl.keydown($event)"\r\n         ng-disabled="$ctrl.options.disabled || $ctrl.options.disallowInput"\r\n         ng-required="$ctrl.options.validate && $ctrl.options.validators.required.value"\r\n         ng-attr-placeholder="{{$ctrl.options.placeholder | pltranslate}}">\r\n  <a href class="input-group-addon cg-dp-btn btnShowDatePicker" ng-class="{\'disabled\': $ctrl.options.disabled}" ng-click="$ctrl.showCalendar()">\r\n    <i class="fa fa-calendar fa-fw"></i>\r\n  </a>\r\n</div>\r\n\r\n<div class="pl-datepicker" ng-show="$ctrl.calendarOpened" tabindex="-1" ng-mouseenter="$ctrl.onMouseEnter($event)" ng-mouseleave="$ctrl.onMouseLeave($event)">\r\n  <div class="controls">\r\n    <div class="left">\r\n      <i class="fa fa-angle-double-left prev-year-btn" ng-click="$ctrl.prevYear()"></i>\r\n      <i class="fa fa-angle-left prev-month-btn" ng-click="$ctrl.prevMonth()"></i>\r\n    </div>\r\n    <span class="date">{{$ctrl.dateValue}}</span>\r\n    <div class="right">\r\n      <i class="fa fa-angle-right next-month-btn" ng-click="$ctrl.nextMonth()"></i>\r\n      <i class="fa fa-angle-double-right next-year-btn" ng-click="$ctrl.nextYear()"></i>\r\n    </div>\r\n  </div>\r\n\r\n  <div class="day-names">\r\n    <span ng-repeat="dn in $ctrl.dayNames">\r\n      <span>{{ dn }}</span>\r\n    </span>\r\n  </div>\r\n\r\n  <div class="calendar">\r\n    <span ng-repeat="d in $ctrl.days">\r\n      <span class="day" ng-click="$ctrl.selectDate(d, $event, $ctrl.isDayDisabled(d))"\r\n            ng-class="{disabled: d.disabled, current: d.isToday, selected: d.selectedDay, marked: d.marked}">{{ d.day }}</span>\r\n    </span>\r\n  </div>\r\n\r\n  <br>\r\n\r\n  <div class="pl-datepicker-button-wrapper">\r\n    <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.goToday()" ng-disabled="$ctrl.isTodayDisabled()">\r\n      <i class="fa fa-clock-o" aria-hidden="true"></i>&nbsp;<span>Hoje</span>\r\n    </button>\r\n  </div>\r\n</div>\r\n\r\n<pl-messages target="{{$ctrl.name}}" validate="$ctrl.options.validate" properties="$ctrl.options.validators"></pl-messages>\r\n\r\n<span ng-show="$ctrl.options.readonly" class="form-control-align" pl-disable-animate>{{$ctrl.viewValue}}</span>\r\n');
$templateCache.put('../source/pl-edit-button.html','<button ng-attr-type="{{ctrl.type}}" class="btn" ng-class="ctrl.class" ng-attr-name="{{ctrl.name}}" ng-click="ctrl.onClick()"\r\n        ng-disabled="ctrl.ngDisabled" pl-tooltip="ctrl.tooltip" click-on-enter pl-promise ng-transclude>\r\n  <span pl-translate="{{ctrl.text}}"></span>\r\n</button>\r\n');
$templateCache.put('../source/pl-edit-checkbox.html','<div class="pl-checkbox" ng-click="$ctrl.toggleValue()" ng-class="{\'readonly\': $ctrl.options.readonly, \'disabled\': $ctrl.options.disabled}">\r\n  <div class="pl-checkbox-edit" ng-switch="$ctrl.value" pl-disable-animate>\r\n    <span class="pl-checkbox-true" ng-switch-when="true">\r\n      <i class="pl-icon-check-square" aria-hidden="true"></i>\r\n    </span>\r\n    <span class="pl-checkbox-false" ng-switch-when="false">\r\n      <i class="pl-icon-square" aria-hidden="true"></i>\r\n    </span>\r\n  </div>\r\n  <div class="pl-checkbox-label" pl-translate="{{$ctrl.options.label}}"></div>\r\n</div>\r\n\r\n<pl-messages target="{{$ctrl.name}}" validate="$ctrl.options.validate" properties="$ctrl.options.validators"></pl-messages>\r\n');
$templateCache.put('../source/pl-edit-email.html','<div ng-hide="$ctrl.options.readonly" ng-class="{\'input-group pl-input-group\': $ctrl.options.raw === false && $ctrl.hasGroup}" pl-disable-animate>\r\n  <input type="email" class="form-control pl-inline" pl-disable-animate\r\n         ng-hide="$ctrl.options.readonly"\r\n         ng-class="$ctrl.editClass"\r\n         ng-attr-name="{{$ctrl.name}}"\r\n         ng-model="$ctrl.value"\r\n         ng-model-options="$ctrl.options.ngModelOptions"\r\n         ng-change="$ctrl.render()"\r\n         ng-focus="$ctrl.options.events.focus($ctrl.value, $event)"\r\n         ng-blur="$ctrl.options.events.blur($ctrl.value, $event)"\r\n         ng-keydown="$ctrl.options.events.keydown($ctrl.value, $event)"\r\n         ng-keypress="$ctrl.options.events.keypress($ctrl.value, $event)"\r\n         ng-keyup="$ctrl.options.events.keyup($ctrl.value, $event)"\r\n         ng-mousedown="$ctrl.options.events.mousedown($ctrl.value, $event)"\r\n         ng-mouseenter="$ctrl.options.events.mouseenter($ctrl.value, $event)"\r\n         ng-mouseleave="$ctrl.options.events.mouseleave($ctrl.value, $event)"\r\n         ng-mousemove="$ctrl.options.events.mousemove($ctrl.value, $event)"\r\n         ng-mouseover="$ctrl.options.events.mouseover($ctrl.value, $event)"\r\n         ng-mouseup="$ctrl.options.events.mouseup($ctrl.value, $event)"\r\n         ng-disabled="$ctrl.options.disabled || $ctrl.options.disallowInput"\r\n         ng-required="$ctrl.options.validate && $ctrl.options.validators.required.value"\r\n         ng-minlength="$ctrl.options.validate ? $ctrl.options.validators.minlength.value : null"\r\n         ng-maxlength="$ctrl.options.validate ? $ctrl.options.validators.maxlength.value : null"\r\n         ng-pattern="$ctrl.options.validate ? $ctrl.options.validators.pattern.value : null"\r\n         ng-attr-placeholder="{{$ctrl.options.placeholder | pltranslate}}">\r\n  <a href class="input-group-addon cg-dp-btn" ng-class="{\'disabled\': $ctrl.options.disabled, \'raw\': $ctrl.options.raw}"\r\n     ng-hide="$ctrl.options.raw || !$ctrl.hasGroup" tabindex="-1" ng-transclude="inputGroup"\r\n     ng-click="$ctrl.options.events.inputGroup($ctrl.value, $event)">\r\n    <div ng-bind-html="$ctrl.options.inputGroup"></div>\r\n  </a>\r\n</div>\r\n\r\n<pl-messages target="{{$ctrl.name}}" validate="$ctrl.options.validate" properties="$ctrl.options.validators"></pl-messages>\r\n\r\n<a ng-attr-href="{{\'mailto:\' + $ctrl.value}}" ng-show="$ctrl.options.readonly" class="form-control-align" pl-disable-animate>{{$ctrl.value}}</a>\r\n');
$templateCache.put('../source/pl-edit-form-builder.html','<div ng-repeat="builtField in ctrl.builtFields track by $index" ng-switch="builtField.type" ng-init="rootIndex = $index">\r\n  <div ng-switch-default>\r\n    <pl-group ng-class="builtField.field.class" properties="builtField.field.properties">\r\n      <label>{{builtField.field.caption}}</label>\r\n      <edit ng-include="\'plEditFormBuilderPlEdit.html\'"></edit>\r\n      <actions ng-bind-html="builtField.field.actions"></actions>\r\n    </pl-group>\r\n  </div>\r\n\r\n  <div ng-switch-when="group">\r\n    <pl-group properties="builtField.properties">\r\n      <pl-group ng-repeat="builtField in builtField.fields" ng-init="groupIndex = $index" ng-class="builtField.field.class"\r\n                properties="builtField.field.properties">\r\n        <label>{{builtField.field.caption}}</label>\r\n        <edit ng-include="\'plEditFormBuilderPlEdit.html\'"></edit>\r\n        <actions ng-bind-html="builtField.field.actions"></actions>\r\n      </pl-group>\r\n    </pl-group>\r\n  </div>\r\n</div>\r\n\r\n<script type="text/ng-template" id="plEditFormBuilderPlEdit.html">\r\n  <pl-edit type="{{item.field.type}}" ng-repeat="item in builtField.field.repeat"\r\n           ng-model="ctrl.getModelValue(item.field.name)[item.field.modelName]" name="{{item.field.formName}}"\r\n           properties="item.field.properties"\r\n           pl-auto-focus="{{rootIndex === 0 && (!groupIndex || groupIndex === 0) ? \'pl-edit\' : \'false\'}}"\r\n           ng-attr-debug-properties="{{ctrl.debugEnabled ? item.field.properties : \'\'}}">\r\n  </pl-edit>\r\n</script>\r\n');
$templateCache.put('../source/pl-edit-form.html','<form ng-class="ctrl.class" name="ctrl.name" ng-submit="ctrl.submit($event)" ng-if="!ctrl.isNested" pl-form-navigation pl-form-error-navigation novalidate>\r\n  <ng-transclude ng-if="!ctrl.isNested">\r\n    <div ng-include="\'../source/pl-edit-form-builder.html\'"></div>\r\n  </ng-transclude>\r\n</form>\r\n\r\n<ng-form ng-class="ctrl.class" name="ctrl.name" novalidate ng-transclude ng-if="ctrl.isNested" pl-form-navigation pl-form-error-navigation>\r\n  <div ng-include="\'../source/pl-edit-form-builder.html\'"></div>\r\n</ng-form>\r\n');
$templateCache.put('../source/pl-edit-group.html','<div class="pl-edit-group" ng-attr-name="{{$ctrl.name}}" ng-if="$ctrl.options.visible" ng-transclude="plGroup" ng-class="$ctrl.getGroupClass()">\r\n  <label class="pl-group-label control-label" ng-class="[$ctrl.options.labelClass, {\'text-primary\': $ctrl.options.collapse}]"\r\n         ng-click="$ctrl.toggleCollapse()" ng-transclude="label" pl-disable-animate="" tabindex="-1"></label>\r\n\r\n  <div class="pl-group-edit" ng-class="!$ctrl.options.hasParent ? $ctrl.options.editClass : $ctrl.options.doubledEditClass"\r\n       ng-style="{\'width\': $ctrl.options.width ? $ctrl.options.width : null}" pl-animation-collapse="$ctrl.options.isCollapsed">\r\n    <div ng-transclude="edit"></div>\r\n  </div>\r\n\r\n  <div class="pl-group-actions" ng-class="$ctrl.options.actionsClass" ng-if="!$ctrl.options.hideActions" pl-animation-collapse="$ctrl.options.isCollapsed">\r\n    <div ng-transclude="actions"></div>\r\n  </div>\r\n</div>\r\n');
$templateCache.put('../source/pl-edit-number.html','<div ng-hide="$ctrl.options.readonly" ng-class="{\'input-group pl-input-group\': $ctrl.options.raw === false && $ctrl.hasGroup}" pl-disable-animate>\r\n  <input type="text" class="form-control pl-inline" inputmode="numeric" pl-disable-animate\r\n         ng-class="[$ctrl.editClass, {\'text-right\': !$ctrl.options.alignLeft && !$ctrl.isEditing}]"\r\n         ng-attr-name="{{$ctrl.name}}"\r\n         ng-model="$ctrl.value"\r\n         ng-model-options="$ctrl.options.ngModelOptions"\r\n         ng-change="$ctrl.render()"\r\n         ng-focus="$ctrl.onFocus($event)"\r\n         ng-blur="$ctrl.onBlur($event)"\r\n         ng-keydown="$ctrl.options.events.keydown($ctrl.value, $event)"\r\n         ng-keypress="$ctrl.options.events.keypress($ctrl.value, $event)"\r\n         ng-keyup="$ctrl.options.events.keyup($ctrl.value, $event)"\r\n         ng-mousedown="$ctrl.options.events.mousedown($ctrl.value, $event)"\r\n         ng-mouseenter="$ctrl.options.events.mouseenter($ctrl.value, $event)"\r\n         ng-mouseleave="$ctrl.options.events.mouseleave($ctrl.value, $event)"\r\n         ng-mousemove="$ctrl.options.events.mousemove($ctrl.value, $event)"\r\n         ng-mouseover="$ctrl.options.events.mouseover($ctrl.value, $event)"\r\n         ng-mouseup="$ctrl.options.events.mouseup($ctrl.value, $event)"\r\n         ng-attr-placeholder="{{$ctrl.options.placeholder | pltranslate}}"\r\n         ng-disabled="$ctrl.options.disabled || $ctrl.options.disallowInput"\r\n         ng-required="$ctrl.options.validate && $ctrl.options.validators.required.value"\r\n         ng-minlength="$ctrl.options.validate ? $ctrl.options.validators.minlength.value : null"\r\n         ng-maxlength="$ctrl.options.validate ? $ctrl.options.validators.maxlength.value : null"\r\n         ng-pattern="$ctrl.options.validate ? $ctrl.options.validators.pattern.value : null">\r\n\r\n  <a href class="input-group-addon cg-dp-btn" ng-class="{\'disabled\': $ctrl.options.disabled, \'raw\': $ctrl.options.raw}"\r\n     ng-click="$ctrl.options.events.inputGroup($ctrl.value, $event)"\r\n     ng-hide="$ctrl.options.raw || !$ctrl.hasGroup" tabindex="0" ng-transclude="inputGroup">\r\n    <div ng-bind-html="$ctrl.options.inputGroup"></div>\r\n  </a>\r\n</div>\r\n\r\n<pl-messages target="{{$ctrl.name}}" validate="$ctrl.options.validate" properties="$ctrl.options.validators"></pl-messages>\r\n\r\n<span ng-show="$ctrl.options.readonly" class="form-control-align" pl-disable-animate>{{$ctrl.value}}</span>\r\n');
$templateCache.put('../source/pl-edit-password.html','<div ng-hide="$ctrl.options.readonly" ng-class="{\'input-group pl-input-group\': $ctrl.options.raw === false && $ctrl.hasGroup}" pl-disable-animate>\r\n  <input type="password" class="form-control pl-inline" pl-disable-animate\r\n         ng-hide="$ctrl.options.readonly"\r\n         ng-class="$ctrl.editClass"\r\n         ng-attr-name="{{$ctrl.name}}"\r\n         ng-model="$ctrl.value"\r\n         ng-model-options="$ctrl.options.ngModelOptions"\r\n         ng-change="$ctrl.render()"\r\n         ng-focus="$ctrl.options.events.focus($ctrl.value, $event)"\r\n         ng-blur="$ctrl.options.events.blur($ctrl.value, $event)"\r\n         ng-keydown="$ctrl.options.events.keydown($ctrl.value, $event)"\r\n         ng-keypress="$ctrl.options.events.keypress($ctrl.value, $event)"\r\n         ng-keyup="$ctrl.options.events.keyup($ctrl.value, $event)"\r\n         ng-mousedown="$ctrl.options.events.mousedown($ctrl.value, $event)"\r\n         ng-mouseenter="$ctrl.options.events.mouseenter($ctrl.value, $event)"\r\n         ng-mouseleave="$ctrl.options.events.mouseleave($ctrl.value, $event)"\r\n         ng-mousemove="$ctrl.options.events.mousemove($ctrl.value, $event)"\r\n         ng-mouseover="$ctrl.options.events.mouseover($ctrl.value, $event)"\r\n         ng-mouseup="$ctrl.options.events.mouseup($ctrl.value, $event)"\r\n         ng-disabled="$ctrl.options.disabled || $ctrl.options.disallowInput"\r\n         ng-required="$ctrl.options.validate && $ctrl.options.validators.required.value"\r\n         ng-minlength="$ctrl.options.validate ? $ctrl.options.validators.minlength.value : null"\r\n         ng-maxlength="$ctrl.options.validate ? $ctrl.options.validators.maxlength.value : null"\r\n         ng-pattern="$ctrl.options.validate ? $ctrl.options.validators.pattern.value : null"\r\n         ng-attr-placeholder="{{$ctrl.options.placeholder | pltranslate}}">\r\n  <a href class="input-group-addon cg-dp-btn" ng-class="{\'disabled\': $ctrl.options.disabled, \'raw\': $ctrl.options.raw}"\r\n     ng-hide="$ctrl.options.raw || !$ctrl.hasGroup" tabindex="-1" ng-transclude="inputGroup"\r\n     ng-click="$ctrl.options.events.inputGroup($ctrl.value, $event)">\r\n    <div ng-bind-html="$ctrl.options.inputGroup"></div>\r\n  </a>\r\n</div>\r\n\r\n<pl-messages target="{{$ctrl.name}}" validate="$ctrl.options.validate" properties="$ctrl.options.validators"></pl-messages>\r\n\r\n<span ng-show="$ctrl.options.readonly" class="form-control-align" pl-disable-animate>{{$ctrl.value}}</span>\r\n');
$templateCache.put('../source/pl-edit-phone.html','<div ng-hide="$ctrl.options.readonly" ng-class="{\'input-group pl-input-group\': $ctrl.options.raw === false && $ctrl.hasGroup}" pl-disable-animate>\r\n  <input type="text" class="form-control pl-inline" pl-disable-animate\r\n       ng-hide="$ctrl.options.readonly"\r\n       ng-class="$ctrl.editClass"\r\n       ng-attr-name="{{$ctrl.name}}"\r\n       ng-model="$ctrl.value"\r\n       ng-change="$ctrl.render()"\r\n       ng-focus="$ctrl.options.events.focus($ctrl.value, $event)"\r\n       ng-blur="$ctrl.options.events.blur($ctrl.value, $event)"\r\n       ng-keydown="$ctrl.options.events.keydown($ctrl.value, $event)"\r\n       ng-keypress="$ctrl.options.events.keypress($ctrl.value, $event)"\r\n       ng-keyup="$ctrl.options.events.keyup($ctrl.value, $event)"\r\n       ng-mousedown="$ctrl.options.events.mousedown($ctrl.value, $event)"\r\n       ng-mouseenter="$ctrl.options.events.mouseenter($ctrl.value, $event)"\r\n       ng-mouseleave="$ctrl.options.events.mouseleave($ctrl.value, $event)"\r\n       ng-mousemove="$ctrl.options.events.mousemove($ctrl.value, $event)"\r\n       ng-mouseover="$ctrl.options.events.mouseover($ctrl.value, $event)"\r\n       ng-mouseup="$ctrl.options.events.mouseup($ctrl.value, $event)"\r\n       ng-disabled="$ctrl.options.disabled || $ctrl.options.disallowInput"\r\n       ng-required="$ctrl.options.validate && $ctrl.options.validators.required.value"\r\n       ng-minlength="$ctrl.options.validate ? $ctrl.options.validators.minlength.value : null"\r\n       ng-maxlength="$ctrl.options.validate ? $ctrl.options.validators.maxlength.value : null"\r\n       ng-pattern="$ctrl.options.validate ? $ctrl.options.validators.pattern.value : null"\r\n       ng-attr-placeholder="{{$ctrl.options.placeholder | pltranslate}}">\r\n  <a href class="input-group-addon cg-dp-btn" ng-class="{\'disabled\': $ctrl.options.disabled, \'raw\': $ctrl.options.raw}"\r\n     ng-hide="$ctrl.options.raw || !$ctrl.hasGroup" tabindex="-1" ng-transclude="inputGroup"\r\n     ng-click="$ctrl.options.events.inputGroup($ctrl.value, $event)">\r\n    <div ng-bind-html="$ctrl.options.inputGroup"></div>\r\n  </a>\r\n</div>\r\n\r\n<pl-messages target="{{$ctrl.name}}" validate="$ctrl.options.validate" properties="$ctrl.options.validators"></pl-messages>\r\n\r\n<a ng-attr-href="{{\'tel:+\' + $ctrl.value}}" ng-show="$ctrl.options.readonly" class="form-control-align" pl-disable-animate>{{$ctrl.getReadableValue($ctrl.value)}}</a>\r\n');
$templateCache.put('../source/pl-edit-radio.html','<div class="pl-radio" ng-click="$ctrl.toggleValue()" ng-class="{\'readonly\': $ctrl.options.readonly, \'disabled\': $ctrl.options.disabled}">\r\n  <div class="pl-radio-edit" ng-switch="$ctrl.val" pl-disable-animate>\r\n    <span class="pl-checkbox-true" ng-switch-when="true">\r\n      <i class="pl-icon-dot-circle" aria-hidden="true"></i>\r\n    </span>\r\n    <span class="pl-checkbox-false" ng-switch-when="false">\r\n      <i class="fa fa-circle-thin fa-fw" aria-hidden="true"></i>\r\n    </span>\r\n  </div>\r\n  <div class="pl-radio-label" pl-translate="{{$ctrl.options.label}}"></div>\r\n</div>\r\n\r\n<pl-messages target="{{$ctrl.name}}" validate="$ctrl.options.validate" properties="$ctrl.options.validators"></pl-messages>\r\n');
$templateCache.put('../source/pl-edit-select.html','<div ng-hide="$ctrl.options.readonly" ng-class="{\'input-group pl-input-group\': $ctrl.options.raw === false && $ctrl.hasGroup}" pl-disable-animate>\r\n  <select ng-hide="$ctrl.options.readonly" pl-disable-animate\r\n        ng-class="$ctrl.editClass"\r\n        ng-attr-name="{{$ctrl.name}}"\r\n        ng-model="$ctrl.value"\r\n        ng-options="{{$ctrl.list}}"\r\n        ng-change="$ctrl.render()"\r\n        ng-blur="$ctrl.options.blur($ctrl.value, $event)"\r\n        class="form-control pl-inline"\r\n        ng-attr-placeholder="{{$ctrl.options.placeholder | pltranslate}}"\r\n        ng-attr-size="{{$ctrl.options.size}}"\r\n        ng-disabled="$ctrl.options.disabled"\r\n        ng-required="$ctrl.options.validate && $ctrl.options.validators.required.value">\r\n</select>\r\n  <a href class="input-group-addon cg-dp-btn" ng-class="{\'disabled\': $ctrl.options.disabled, \'raw\': $ctrl.options.raw}"\r\n     ng-hide="$ctrl.options.raw || !$ctrl.hasGroup" tabindex="-1" ng-transclude="inputGroup"\r\n     ng-click="$ctrl.options.events.inputGroup($ctrl.value, $event)">\r\n    <div ng-bind-html="$ctrl.options.inputGroup"></div>\r\n  </a>\r\n</div>\r\n\r\n<pl-messages target="{{$ctrl.name}}" validate="$ctrl.options.validate" properties="$ctrl.options.validators"></pl-messages>\r\n\r\n<span ng-show="$ctrl.options.readonly" class="form-control-align" pl-disable-animate>{{$ctrl.value}}</span>\r\n');
$templateCache.put('../source/pl-edit-switch.html','<div class="pl-switch-align">\r\n  <div class="pl-switch-label" ng-if="$ctrl.options.switchPos == \'right\'" pl-translate="{{$ctrl.options.label}}"></div>\r\n  <div class="pl-switch-edit">\r\n    <span class="pl-switch" ng-click="$ctrl.toggleValue()" pl-disable-animate\r\n          ng-class="{\'readonly\': $ctrl.options.readonly, \'disabled\': $ctrl.options.disabled, \'checked\': $ctrl.value}">\r\n      <span class="pl-slider round"></span>\r\n    </span>\r\n  </div>\r\n  <div class="pl-switch-label" ng-if="!$ctrl.options.switchPos || $ctrl.options.switchPos == \'left\'" pl-translate="{{$ctrl.options.label}}"></div>\r\n</div>\r\n\r\n<pl-messages target="{{$ctrl.name}}" ng-if="$ctrl.options.validate" properties="$ctrl.options.validators"></pl-messages>\r\n');
$templateCache.put('../source/pl-edit-text.html','<div ng-hide="$ctrl.options.readonly" ng-class="{\'input-group pl-input-group\': $ctrl.options.raw === false && $ctrl.hasGroup}" pl-disable-animate>\r\n  <input type="text" class="form-control pl-inline" pl-disable-animate\r\n         ng-hide="$ctrl.options.readonly"\r\n         ng-class="$ctrl.editClass"\r\n         ng-attr-name="{{$ctrl.name}}"\r\n         ng-model="$ctrl.value"\r\n         ng-model-options="$ctrl.options.ngModelOptions"\r\n         ng-change="$ctrl.render()"\r\n         ng-focus="$ctrl.options.events.focus($ctrl.value, $event)"\r\n         ng-blur="$ctrl.options.events.blur($ctrl.value, $event)"\r\n         ng-keydown="$ctrl.options.events.keydown($ctrl.value, $event)"\r\n         ng-keypress="$ctrl.options.events.keypress($ctrl.value, $event)"\r\n         ng-keyup="$ctrl.options.events.keyup($ctrl.value, $event)"\r\n         ng-mousedown="$ctrl.options.events.mousedown($ctrl.value, $event)"\r\n         ng-mouseenter="$ctrl.options.events.mouseenter($ctrl.value, $event)"\r\n         ng-mouseleave="$ctrl.options.events.mouseleave($ctrl.value, $event)"\r\n         ng-mousemove="$ctrl.options.events.mousemove($ctrl.value, $event)"\r\n         ng-mouseover="$ctrl.options.events.mouseover($ctrl.value, $event)"\r\n         ng-mouseup="$ctrl.options.events.mouseup($ctrl.value, $event)"\r\n         ng-disabled="$ctrl.options.disabled || $ctrl.options.disallowInput"\r\n         ng-required="$ctrl.options.validate && $ctrl.options.validators.required.value"\r\n         ng-minlength="$ctrl.options.validate ? $ctrl.options.validators.minlength.value : null"\r\n         ng-maxlength="$ctrl.options.validate ? $ctrl.options.validators.maxlength.value : null"\r\n         ng-pattern="$ctrl.options.validate ? $ctrl.options.validators.pattern.value : null"\r\n         ng-attr-placeholder="{{$ctrl.options.placeholder | pltranslate}}">\r\n  <a href class="input-group-addon cg-dp-btn" ng-class="{\'disabled\': $ctrl.options.disabled, \'raw\': $ctrl.options.raw}"\r\n     ng-click="$ctrl.options.events.inputGroup($ctrl.value, $event)"\r\n     ng-hide="$ctrl.options.raw || !$ctrl.hasGroup" tabindex="-1" ng-transclude="inputGroup">\r\n    <div ng-bind-html="$ctrl.options.inputGroup"></div>\r\n  </a>\r\n</div>\r\n\r\n<pl-messages target="{{$ctrl.name}}" validate="$ctrl.options.validate" properties="$ctrl.options.validators"></pl-messages>\r\n\r\n<span ng-show="$ctrl.options.readonly" class="form-control-align" pl-disable-animate>{{$ctrl.value}}</span>\r\n');
$templateCache.put('../source/pl-edit-textarea.html','<textarea class="form-control pl-inline" pl-disable-animate\r\n          ng-hide="$ctrl.options.readonly"\r\n          ng-class="$ctrl.editClass"\r\n          ng-attr-name="{{$ctrl.name}}"\r\n          ng-model="$ctrl.value"\r\n          ng-change="$ctrl.render()"\r\n          ng-focus="$ctrl.options.events.focus($ctrl.value, $event)"\r\n          ng-blur="$ctrl.options.events.blur($ctrl.value, $event)"\r\n          ng-keydown="$ctrl.options.events.keydown($ctrl.value, $event)"\r\n          ng-keypress="$ctrl.options.events.keypress($ctrl.value, $event)"\r\n          ng-keyup="$ctrl.options.events.keyup($ctrl.value, $event)"\r\n          ng-mousedown="$ctrl.options.events.mousedown($ctrl.value, $event)"\r\n          ng-mouseenter="$ctrl.options.events.mouseenter($ctrl.value, $event)"\r\n          ng-mouseleave="$ctrl.options.events.mouseleave($ctrl.value, $event)"\r\n          ng-mousemove="$ctrl.options.events.mousemove($ctrl.value, $event)"\r\n          ng-mouseover="$ctrl.options.events.mouseover($ctrl.value, $event)"\r\n          ng-mouseup="$ctrl.options.events.mouseup($ctrl.value, $event)"\r\n          ng-disabled="$ctrl.options.disabled || $ctrl.options.disallowInput"\r\n          ng-required="$ctrl.options.validate && $ctrl.options.validators.required.value"\r\n          ng-minlength="$ctrl.options.validate ? $ctrl.options.validators.minlength.value : null"\r\n          ng-maxlength="$ctrl.options.validate ? $ctrl.options.validators.maxlength.value : null"\r\n          ng-pattern="$ctrl.options.validate ? $ctrl.options.validators.pattern.value : null"\r\n          ng-trim="$ctrl.options.trim"\r\n          ng-attr-placeholder="{{$ctrl.options.placeholder | pltranslate}}">\r\n</textarea>\r\n<span ng-show="$ctrl.options.readonly" class="form-control-align" pl-disable-animate>{{$ctrl.value}}</span>\r\n\r\n<pl-messages target="{{$ctrl.name}}" validate="$ctrl.options.validate" properties="$ctrl.options.validators"></pl-messages>\r\n');
$templateCache.put('../source/pl-filter-panel.html','<div ng-cloak>\r\n  <a href ng-click="$ctrl.toggleFilter()" ng-show="$ctrl.showCaption">\r\n    <span ng-hide="$ctrl.filterOnCaption" ng-bind-html="$ctrl.config.showLabel"></span>\r\n    <span ng-show="$ctrl.filterOnCaption">{{$ctrl.filter}}</span>\r\n    <span ng-switch="$ctrl.isCollapsed">\r\n      <i ng-class="$ctrl.config.iconClass" aria-hidden="true" pl-animation-rotate="!$ctrl.isCollapsed"></i>\r\n    </span>\r\n  </a>\r\n\r\n  <div pl-animation-collapse="$ctrl.isCollapsed">\r\n    <div class="pl-filter">\r\n      <div class="input-group pl-filter-form">\r\n        <div class="input-group-btn" uib-dropdown>\r\n          <button type="button" class="btn btn-dropdown-toggle" uib-dropdown-toggle ng-disabled="!$ctrl.selectedFilter">\r\n            <span>{{$ctrl.getSelectedFilterText()}}</span>&nbsp;<span class="caret"></span>\r\n          </button>\r\n\r\n          <ul class="dropdown-menu" uib-dropdown-menu>\r\n            <li ng-repeat="field in $ctrl.fields track by $index" ng-show="!$ctrl.isInUse(field)">\r\n              <a href ng-click="$ctrl.selectFilter(field)" pl-translate="{{field.caption}}"></a>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n        <pl-edit type="{{$ctrl.getSelectedFilterType($ctrl.selectedFilter)}}" ng-model="$ctrl.filterValue"\r\n                 properties="$ctrl.getSelectedFilterProperties($ctrl.selectedFilter)">\r\n        </pl-edit>\r\n      </div>\r\n\r\n      <div ng-if="$ctrl.value.length">\r\n        <hr class="pl-filter-separator"/>\r\n        <ul class="pl-filter-items list-inline">\r\n          <li>{{$ctrl.locales.text.activeFilters}}:</li>\r\n          <li class="pl-filter-item" ng-repeat="row in $ctrl.value track by $index">\r\n          <span class="label label-primary">\r\n            <span>{{$ctrl.getCaption(row.name)}}</span>:&nbsp;<strong>{{$ctrl.getRowValue(row)}}</strong>\r\n          </span>\r\n            <div class="close">\r\n              <span aria-hidden="true" ng-click="$ctrl.remove(row)">\xD7</span>\r\n            </div>\r\n          </li>\r\n          <li ng-if="$ctrl.value.length">\r\n            <a href class="text-primary" ng-click="$ctrl.removeAll()">{{$ctrl.locales.text.clearFilters}}</a>\r\n          </li>\r\n        </ul>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n');
$templateCache.put('../source/pl-inline-edit.html','<span class="pl-inline-edit" ng-switch="$ctrl.editMode" ng-class="$ctrl.class" ng-cloak="">\r\n  <span class="clearfix" ng-switch-when="true">\r\n    <pl-edit class="pl-inline-edit"\r\n             edit-class="$ctrl.editClass"\r\n             pl-auto-class="false"\r\n             type="{{$ctrl.type}}"\r\n             ng-model="$ctrl.value"\r\n             ng-change="$ctrl.updateValue()"\r\n             properties="$ctrl.options"\r\n             ng-readonly="$ctrl.options.readonly">\r\n    </pl-edit>\r\n    <a href class="pl-inline-edit-close" ng-click="$ctrl.handleModeChange()"><span ng-bind-html="$ctrl.config.labelset"></span></a>\r\n  </span>\r\n\r\n  <span class="pl-inline-edit-label" ng-switch-default ng-class="$ctrl.editClass" ng-if="!$ctrl.showMask($ctrl.value)">\r\n    <a href class="pl-inline-edit-open" ng-if="!$ctrl.options.readonly" ng-click="$ctrl.handleModeChange()">{{$ctrl.getValue()}} </a>\r\n    <span ng-if="$ctrl.options.readonly">{{$ctrl.getValue()}}</span>\r\n  </span>\r\n\r\n  <a href class="pl-inline-edit-open" ng-if="!$ctrl.editMode && $ctrl.showMask($ctrl.value)" ng-click="$ctrl.handleModeChange()">\r\n    <span ng-if="$ctrl.options.placeholder">(<span pl-translate="{{$ctrl.options.placeholder}}"></span>)</span>\r\n    <span ng-if="!$ctrl.options.placeholder">_____</span>\r\n  </a>\r\n</span>\r\n');
$templateCache.put('../source/pl-messages.html','<div ng-messages="$ctrl.form[$ctrl.target].$error"\r\n     ng-if="$ctrl.validate && ($ctrl.form.$submitted || $ctrl.form[$ctrl.target].$touched || !$ctrl.form[$ctrl.target].$pristine)">\r\n  <div class="pl-messages-error" ng-repeat="(name, validation) in $ctrl.options track by name" ng-message="{{name}}" pl-translate="{{validation.error}}" pl-disable-animate></div>\r\n</div>\r\n');
$templateCache.put('../source/pl-multiselect.html','<div>\r\n  <ng-transclude></ng-transclude>\r\n  <table class="table table-responsive table-no-borders">\r\n    <thead>\r\n    <tr>\r\n      <td>{{$ctrl.getLeftCaption()}}</td>\r\n      <td></td>\r\n      <td>{{$ctrl.getRightCaption()}}</td>\r\n    </tr>\r\n    </thead>\r\n\r\n    <tbody>\r\n    <tr>\r\n      <td width="50%">\r\n        <select class="form-control" multiple ng-model="$ctrl.rights">\r\n          <option ng-repeat="item in $ctrl.source|filter:$ctrl.leftSearch|orderBy:$ctrl.key"\r\n                  value="{{$ctrl.getKey(item)}}" ng-dblclick="$ctrl.selectedRight(item[$ctrl.key])"\r\n                  ng-hide="item.hidden || item.visible === false">\r\n            {{$ctrl.getRow(item)}}\r\n          </option>\r\n        </select>\r\n      </td>\r\n      <td>\r\n        <div class="select-controls">\r\n          <button type="button" class="btn btn-primary btn-sm btn-block" ng-click="$ctrl.allRight()"><i\r\n            class="fa fa-angle-double-right fa-fw"></i></button>\r\n          <button type="button" class="btn btn-primary btn-sm btn-block" ng-click="$ctrl.selectedRight()"><i\r\n            class="fa fa-angle-right fa-fw"></i></button>\r\n          <button type="button" class="btn btn-primary btn-sm btn-block" ng-click="$ctrl.selectedLeft()"><i\r\n            class="fa fa-angle-left fa-fw"></i></button>\r\n          <button type="button" class="btn btn-primary btn-sm btn-block" ng-click="$ctrl.allLeft()"><i\r\n            class="fa fa-angle-double-left fa-fw"></i></button>\r\n        </div>\r\n      </td>\r\n      <td width="50%">\r\n        <select class="form-control" multiple ng-model="$ctrl.lefts">\r\n          <option ng-repeat="item in $ctrl.value|filter:$ctrl.rigthSearch|orderBy:$ctrl.key"\r\n                  value="{{$ctrl.getKey(item)}}" ng-dblclick="$ctrl.selectedLeft(item[$ctrl.key])"\r\n                  ng-hide="item.hidden || item.visible === false">\r\n            {{$ctrl.getRow(item)}}\r\n          </option>\r\n        </select>\r\n      </td>\r\n    </tr>\r\n\r\n    <tr>\r\n      <td><input class="form-control pl-multiselect-input" ng-model="$ctrl.leftSearch"\r\n                 ng-attr-placeholder="{{\'&#xf002;&nbsp;\' + $ctrl.search + \' \' + ($ctrl.getLeftCaption() | lowercase)}}">\r\n      </td>\r\n      <td></td>\r\n      <td><input class="form-control pl-multiselect-input" ng-model="$ctrl.rigthSearch"\r\n                 ng-attr-placeholder="{{\'&#xf002;&nbsp;\' + $ctrl.search + \' \' + ($ctrl.getRightCaption() | lowercase)}}">\r\n      </td>\r\n    </tr>\r\n    </tbody>\r\n  </table>\r\n\r\n  <div class="pl-multiselect-validators">\r\n    <select class="invisible pl-multiselect-validator"\r\n            ng-attr-name="{{$ctrl.name}}"\r\n            ng-model="$ctrl.value"\r\n            ng-model-options="{allowInvalid: true}"\r\n            ng-required="$ctrl.options.validate && $ctrl.options.validators.required.value"\r\n            multiple pl-disable-animate>\r\n    </select>\r\n\r\n    <pl-messages target="{{$ctrl.name}}" validate="$ctrl.options.validate" properties="$ctrl.options.validators"></pl-messages>\r\n  </div>\r\n</div>\r\n');
$templateCache.put('../source/pl-nav-wizard-step.html','<div class="tab-pane nav-wizard-item-content-wrapper" ng-show="$ctrl.active" ng-class="{\'active in\': $ctrl.active}" data-item-id="{{$ctrl.id}}"\r\n     pl-disable-animate>\r\n  <div class="nav-wizard-item-content" ng-show="$ctrl.active" pl-disable-animate ng-transclude></div>\r\n  <div class="nav-wizard-item-footer" ng-hide="$ctrl.hideFooter || $ctrl.options.hideFooter || $ctrl.plNavWizard.hideFooter">\r\n    <div class="row">\r\n      <div class="col-xs-12">\r\n        <div class="separator"></div>\r\n        <div class="nav-wizard-item-footer-offset" ng-class="$ctrl.footerOffset">\r\n          <button type="button" class="btn btn-default btn-sm" ng-click="$ctrl.plNavWizard.previousStep()" pl-promise\r\n                  ng-disabled="$ctrl.evaluateFooter(\'previous\') || $ctrl.options.disableNavigation || $ctrl.options.disablePrevious"\r\n                  ng-hide="$ctrl.hidePrevious || $ctrl.options.hidePrevious"\r\n                  promise-btn-options="{disableSpin: true}">\r\n            <i class="fa fa-angle-left fa-fw"></i> <span pl-translate="{{$ctrl.locale.btn.goBack}}"></span>\r\n          </button>\r\n\r\n          <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.plNavWizard.nextStep()" pl-promise ng-if="!$ctrl.evaluateFooter(\'next\')"\r\n                  ng-disabled="$ctrl.options.disableNavigation || $ctrl.options.disableNext" ng-hide="$ctrl.hideNext || $ctrl.options.hideNext"\r\n                  promise-btn-options="{disableSpin: true}">\r\n            <span pl-translate="{{$ctrl.locale.btn.goForward}}"></span> <i class="fa fa-angle-right fa-fw"></i>\r\n          </button>\r\n\r\n          <button type="button" class="btn btn-sm" ng-repeat="action in $ctrl.actions track by action.id | orderBy : action.order"\r\n                  ng-class="action.class" ng-click="action.click(action)" ng-hide="action.visible === false" pl-promise\r\n                  ng-disabled="action.disabled" pl-tooltip="action.tooltip"\r\n                  promise-btn-options="{disableSpin: true}">\r\n            <span ng-if="action.icon"><i class="fa fa-fw" ng-class="action.icon"></i>&nbsp;</span><span pl-translate="{{action.caption}}"></span>\r\n          </button>\r\n\r\n          <button type="button" class="btn btn-success btn-sm" ng-click="$ctrl.plNavWizard.nextStep()" pl-promise ng-if="$ctrl.evaluateFooter(\'next\')"\r\n                  ng-disabled="$ctrl.options.disableFinalize" ng-hide="$ctrl.hideFinalize || $ctrl.options.hideFinalize"\r\n                  promise-btn-options="{disableSpin: true}">\r\n            <i class="fa fa-check fa-fw"></i> <span pl-translate="{{$ctrl.locale.btn.finalize}}"></span>\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n');
$templateCache.put('../source/pl-nav-wizard.html','<div class="pl-nav-wizard-wrapper" ng-class="$ctrl.definition.type">\r\n  <div class="pl-nav-wizard" pl-affix="$ctrl.affix">\r\n    <div class="pl-nav-wizard-caption" ng-if="$ctrl.definition.vertical && $ctrl.definition.caption">\r\n      <h3 pl-translate="{{$ctrl.definition.caption}}"></h3>\r\n    </div>\r\n\r\n    <div class="pl-nav-wizard-steps" ng-if="!$ctrl.definition.vertical">\r\n      <div class="pl-nav-wizard-progress">\r\n        <div class="pl-nav-wizard-progress-line" ng-style="{\'width\': $ctrl.calcSeparatorSize() + \'px\'}"></div>\r\n      </div>\r\n\r\n      <div class="pl-nav-wizard-step" ng-repeat="item in $ctrl.definition.items" ng-click="$ctrl.setStep(item)" ng-show="item.visible"\r\n           ng-class="[{\'active\': item.active, \'invalid\': !item.valid, \'complete\': item.complete, \'disabled\': $ctrl.isStepDisabled(item)}, $ctrl.definition.type]"\r\n           ng-style="{\'width\': $ctrl.getItemSize()}">\r\n        <div class="pl-nav-wizard-step-icon">\r\n          <i class="fa" aria-hidden="true" ng-class="item.icon"></i>\r\n        </div>\r\n        <p class="pl-nav-wizard-step-content pl-nav-wizard-step-content-simple" ng-if="!item.content || !item.content.length">{{$ctrl.getItemContent(item)}}</p>\r\n        <p class="pl-nav-wizard-step-content pl-nav-wizard-step-content-complex" ng-if="item.content && item.content.length"\r\n           ng-repeat="itemContent in item.content" ng-class="itemContent.responsive">{{$ctrl.getItemContent(itemContent)}}</p>\r\n      </div>\r\n    </div>\r\n\r\n    <ul class="nav nav-wizard" ng-if="$ctrl.definition.vertical">\r\n      <li class="nav-wizard-item" ng-repeat="item in $ctrl.definition.items" ng-click="$ctrl.setStep(item)" ng-show="item.visible"\r\n          ng-class="[{\'active\': item.active, \'invalid\': !item.valid, \'complete\': item.complete, \'disabled\': $ctrl.isStepDisabled(item)}, $ctrl.definition.type]">\r\n        <a href pl-translate="{{item.caption}}"></a>\r\n      </li>\r\n    </ul>\r\n  </div>\r\n\r\n  <div class="nav-wizard-content" pl-promise="$ctrl.promise">\r\n    <div class="tab-content" ng-transclude>\r\n      <pl-nav-wizard-step title="{{$ctrl.getTitle(item.caption)}}" name="{{item.id}}" selected="item.active" properties="item.properties"\r\n                          ng-repeat="item in $ctrl.definition.items" should-add="false">\r\n        <div class="nav-wizard-item-content-template" ng-if="item.template" data-item-id="{{item.id}}" ng-bind-html="item.template"></div>\r\n        <div class="nav-wizard-item-content-template" ng-if="item.templateUrl" data-item-id="{{item.id}}" ng-include="item.templateUrl"></div>\r\n      </pl-nav-wizard-step>\r\n    </div>\r\n  </div>\r\n</div>\r\n');
$templateCache.put('../source/pl-navbar.html','<div class="pl-navbar">\r\n  <nav class="navbar navbar-default navbar-fixed-top" role="navigation">\r\n    <div class="navbar-header">\r\n      <ul class="list-inline logo-wrapper">\r\n        <li>\r\n          <button class="pl-hamburger pl-hamburger--htx" ng-click="vm.toggleSidebar()" ng-class="{\'is-active\':vm.isToogled()}">\r\n            <span>toggle menu</span>\r\n          </button>\r\n        </li>\r\n\r\n        <li class="hidden-xs brand-slot-wrapper">\r\n          <div ng-transclude="brandSlot">\r\n            <span ng-bind-html="vm.brand"></span>\r\n          </div>\r\n        </li>\r\n      </ul>\r\n\r\n      <button type="button" class="navbar-toggle" ng-click="vm.collapsed = !vm.collapsed" ng-class="{\'collapsed\':vm.collapsed}">\r\n        <span class="glyphicon glyphicon-option-vertical"></span>\r\n      </button>\r\n    </div>\r\n\r\n    <div class="nav navbar-nav navbar-sub-brand" ng-transclude="subBrandSlot">\r\n      <p ng-bind-html="vm.subBrand"></p>\r\n    </div>\r\n\r\n    <div class="navbar-collapse" uib-collapse="!vm.collapsed">\r\n      <div class="nav-ul nav navbar-nav navbar-right">\r\n        <div class="nav-li dropdown" uib-dropdown ng-repeat="menu in vm.menus track by $index">\r\n          <a href ng-if="!vm.hasDropdownMenu(menu)" ng-click="vm.navAction(menu)" class="dropdown-toggle"\r\n             uib-dropdown-toggle>\r\n            <i ng-class="menu.icon"></i>\r\n          </a>\r\n\r\n          <a href ng-if="vm.hasDropdownMenu(menu)" class="dropdown-toggle" uib-dropdown-toggle>\r\n            <i ng-class="menu.icon"></i>\r\n            <span class="item-title-menu-right" ng-bind-html="menu.title | pltranslate"></span>\r\n            <b class="caret"></b>\r\n          </a>\r\n\r\n          <div ng-if="vm.hasDropdownMenu(menu)" class="nav-ul-dropdown dropdown-menu dropdown-menu-right">\r\n            <div class="nav-li-dropdown pl-animate-appear" ng-repeat="item in menu.menu track by $index">\r\n              <a href ng-show="!vm.isDivider(item)" ng-click="vm.navAction(item, menu)">\r\n                <i ng-class="item.icon"></i>\r\n                <span ng-bind-html="item.title | pltranslate"></span>\r\n              </a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </nav>\r\n</div>\r\n');
$templateCache.put('../source/pl-navpill-panel.html','<div class="tab-pane" ng-if="!$ctrl.lazyLoad || $ctrl.selected" ng-show="$ctrl.selected" role="tabpanel" ng-transclude></div>\r\n');
$templateCache.put('../source/pl-navpill.html','<div class="pl-navpill-nav">\r\n  <ul class="nav nav-pills nav-stacked pl-navpill-nav-pills">\r\n    <li class="pl-navpill-nav-pill" ng-repeat="pill in $ctrl.panels track by pill.id" ng-class="[{\'active\': pill.selected}, pill.captionClass]">\r\n      <a class="pl-navpill-nav-pills-link" href ng-click="$ctrl.selectPanel(pill.id)" ng-bind-html="$ctrl.getCaption(pill.caption)"></a>\r\n    </li>\r\n  </ul>\r\n</div>\r\n\r\n<div class="tab-content pl-navpill-content" ng-transclude></div>\r\n');
$templateCache.put('../source/pl-page-wrapper.html','<div id="page-wrapper" ng-class="{\'open\': $ctrl.toggle}" ng-cloak>\r\n  <div ng-transclude="sidebar"></div>\r\n  <div id="content-wrapper">\r\n    <div class="page-content">\r\n      <div ng-transclude="navbar"></div>\r\n      <div ng-transclude="container"></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n');
$templateCache.put('../source/pl-pagination.html','<div class="pl-pagination">\r\n  <ul class="pagination pl-pagination-items" ng-if="$ctrl.options.showPagination || $ctrl.pages.length > 1">\r\n    <li ng-if="$ctrl.options.boundaryLinks" ng-class="{\'disabled\': $ctrl.page === 1}">\r\n      <a href ng-click="$ctrl.setCurrent(1)">\r\n        <i class="fa fa-angle-double-left" aria-hidden="true"></i>\r\n      </a>\r\n    </li>\r\n\r\n    <li ng-if="$ctrl.options.directionLinks" ng-class="{\'disabled\': $ctrl.page === 1}">\r\n      <a href ng-click="$ctrl.setCurrent($ctrl.page - 1)">\r\n        <i class="fa fa-angle-left" aria-hidden="true"></i>\r\n      </a>\r\n    </li>\r\n\r\n    <li ng-repeat="pageNumber in $ctrl.pages track by $index" ng-class="{\'active\': $ctrl.page === pageNumber, \'disabled\': pageNumber === \'...\'}">\r\n      <a href ng-click="$ctrl.setCurrent(pageNumber)">{{pageNumber}}</a>\r\n    </li>\r\n\r\n    <li class="pagination-seguinte" ng-if="$ctrl.options.directionLinks" ng-class="{\'disabled\': $ctrl.page === $ctrl.totalPages}">\r\n      <a href ng-click="$ctrl.setCurrent($ctrl.page + 1)">\r\n        <i class="fa fa-angle-right" aria-hidden="true"></i>\r\n      </a>\r\n    </li>\r\n\r\n    <li class="pagination-ultimo" ng-if="$ctrl.options.boundaryLinks" ng-class="{\'disabled\': $ctrl.page === $ctrl.totalPages}">\r\n      <a href ng-click="$ctrl.setCurrent(totalPages)">\r\n        <i class="fa fa-angle-double-right" aria-hidden="true"></i>\r\n      </a>\r\n    </li>\r\n\r\n  </ul>\r\n\r\n  <ul class="pl-pagination-lines">\r\n    <li class="pagination-registos">\r\n      <span>{{$ctrl.locales.text.lines}}:</span>\r\n      <select class="form-control pl-pagination-select" ng-model="$ctrl.options.perPage"\r\n              ng-options="option for option in $ctrl.options.lines"\r\n              ng-change="$ctrl.perPageChanged()">\r\n      </select>\r\n    </li>\r\n  </ul>\r\n</div>\r\n\r\n');
$templateCache.put('../source/pl-pdf.html','<div class="pl-pdf">\r\n\r\n  <pl-alert ng-show="error" type="danger" closeable="false"><i class="fa fa-exclamation-triangle"></i>&nbsp;{{errorMessage}}</pl-alert>\r\n\r\n  <div ng-if="pdfUrl===\'\'">\r\n    <pl-alert type="info"><i class="fa fa-exclamation-circle"></i>&nbsp;<span pl-translate="{{locales.messages.pdfJsNoDocument}}"></span></pl-alert>\r\n  </div>\r\n\r\n  <div id="pdf-wrapper" pl-promise="isLoading()">\r\n    <canvas id="pdf-canvas" class="pdf-canvas"></canvas>\r\n\r\n    <!--<span ng-show="loading">-->\r\n    <!--<pl-spinner type="round">A transferir documento </pl-spinner>-->\r\n    <!--</span>-->\r\n\r\n  </div>\r\n\r\n</div>\r\n');
$templateCache.put('../source/pl-progress.html','<div class="progress">\r\n  <div class="progress-bar"\r\n       role="progressbar"\r\n       aria-valuenow="{{$ctrl.value}}"\r\n       aria-valuemin="{{$ctrl.min}}"\r\n       aria-valuemax="{{$ctrl.max}}"\r\n       ng-style="{\'width\': $ctrl.value + \'%\'}">\r\n    {{$ctrl.value}}%\r\n  </div>\r\n</div>\r\n');
$templateCache.put('../source/pl-rowselect.html','<div class="pl-row-select" ng-switch="$ctrl.isArray()"\r\n     ng-class="[$ctrl.editClass, {\'disabled\': $ctrl.options.disabled, \'readonly\': $ctrl.options.readonly}]">\r\n  <div ng-switch-when="true">\r\n    <span ng-repeat="item in $ctrl.list" class="btn btn-default btn-sm" ng-class="{\'active\' : item === $ctrl.value, \'spaced\': $ctrl.options.spaced}"\r\n          ng-click="$ctrl.select(item)">{{item}}\r\n    </span>\r\n  </div>\r\n\r\n  <div ng-switch-when="false">\r\n    <span ng-repeat="(key,value) in $ctrl.list" class="btn btn-default btn-sm" ng-class="{\'active\' : key === $ctrl.value, \'spaced\': $ctrl.options.spaced}"\r\n          ng-click="$ctrl.select(key)">{{key}}\r\n    </span>\r\n  </div>\r\n</div>\r\n');
$templateCache.put('../source/pl-select.html','<div class="pl-select input-group pl-input-group" ng-hide="$ctrl.readonly || $ctrl.options.readonly"\r\n     ng-class="{\'input-group pl-input-group\': $ctrl.options.raw === false}"\r\n     ng-click="$ctrl.doFocus(null, !$ctrl.options.forceFixEvents)">\r\n  <ui-select name="{{$ctrl.name}}" ng-model="$ctrl.value" ng-change="$ctrl.fnOnChange($item || $select.selected, $model)"\r\n             ng-disabled="$ctrl.ngDisabled || $ctrl.options.disabled"\r\n             on-select="$ctrl.fnOnSelect($item || $select.selected, $model)" theme="bootstrap" multiple-checker\r\n             ng-required="$ctrl.options.validate && $ctrl.options.validators.required.value">\r\n    <ui-select-match ng-attr-placeholder="{{$ctrl.placeholder}}">{{$ctrl.getOutput($item || $select.selected)}}</ui-select-match>\r\n    <ui-select-choices repeat="item in $ctrl.source | filter : $ctrl.getFilter($select.search)" group-by="$ctrl.groupBy">\r\n      <div ng-bind-html="$ctrl.getRow(item) | AIhighlight: $select.search"></div>\r\n    </ui-select-choices>\r\n  </ui-select>\r\n\r\n  <a href class="input-group-addon cg-dp-btn" ng-click="$ctrl.fnOpen($event)"\r\n     ng-class="{\'disabled\': $ctrl.options.disabled, \'raw\': $ctrl.options.raw}"\r\n     ng-mouseenter="$ctrl.onMouseEnter($event)"\r\n     ng-mouseleave="$ctrl.onMouseLeave($event)"\r\n     ng-hide="$ctrl.options.raw" tabindex="-1">\r\n    <i class="fa fa-caret-down fa-fw"></i>\r\n  </a>\r\n</div>\r\n<span class="form-control-align" ng-show="$ctrl.readonly || $ctrl.options.readonly" pl-disable-animate>{{$ctrl.getOutput($ctrl.value)}}</span>\r\n\r\n<pl-messages target="{{$ctrl.name}}" validate="$ctrl.options.validate" properties="$ctrl.options.validators"></pl-messages>\r\n');
$templateCache.put('../source/pl-sidebar.html','<div id="pl-sidebar-wrapper" class="pl-sidebar">\r\n  <div class="pl-sidebar-base">\r\n    <div class="pl-sidebar-main visible-xs-block">\r\n      <a ng-click="ctrl.toggleSidebar()">\r\n        <span class="menu-title" ng-transclude="titleSlot"></span>\r\n        <span class="menu-close glyphicon glyphicon-remove hidden-md hidden-lg"></span>\r\n      </a>\r\n    </div>\r\n\r\n    <div class="pl-sidebar-list-wrapper">\r\n      <div class="pl-sidebar-list" ng-repeat="item in ctrl.menu" ng-class="{\'active\': ctrl.isActive(item), \'active-sub\': item.menu && item.isOpened}"\r\n           ng-hide="ctrl.isFiltered(item)">\r\n        <a href ng-click="ctrl.go(item)" ng-class="{\'active-sub\': item.menu && item.isOpened}" ng-attr-title="{{item.title}}">\r\n          <button class="btn btn-arrow btn-sm" ng-show="item.menu">\r\n            <i class="fa fa-angle-right" pl-animation-rotate="item.isOpened"></i>\r\n          </button>\r\n          <span class="menu-title"\r\n                ng-bind-html="item.title | AIhighlight : ctrl.filterValue : ctrl.filterActive && (!item.menu || !item.menu.length) : true"></span>\r\n          <span class="menu-icon" ng-class="ctrl.getIcon(item)"></span>\r\n        </a>\r\n\r\n        <div class="pl-animation-collapse pl-sidebar-second-level" ng-if="item.isOpened">\r\n          <div class="pl-sidebar-list" ng-repeat="sub in item.menu" ng-class="{\'active\': ctrl.isActive(sub)}" ng-hide="ctrl.isFiltered(sub, item)">\r\n            <a ng-click="ctrl.go(sub)" href ng-attr-title="{{sub.title}}">\r\n              <span class="menu-title">\r\n                <span ng-bind-html="sub.title | AIhighlight : ctrl.filterValue : ctrl.filterActive : true"></span>&nbsp;<span\r\n                ng-bind-html="sub.suffix | AIhighlight : ctrl.filterValue : ctrl.filterActive : true"></span>\r\n              </span>\r\n              <span class="menu-icon" ng-class="ctrl.getIcon(sub, item)"></span>\r\n            </a>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class="pl-sidebar-list-search">\r\n      <div class="input-group input-group-sm input-group-toggle" ng-class="{\'inactive\': !ctrl.filterActive}">\r\n        <input type="text" class="form-control" ng-model="ctrl.filterValue" ng-change="ctrl.doFilter()" ng-keyup="ctrl.filterKeyUp($event)"\r\n               ng-attr-placeholder="{{ctrl.placeholder}}">\r\n        <span class="input-group-btn">\r\n          <button type="button" class="btn btn-primary" ng-click="ctrl.clearFilter()" ng-disabled="ctrl.filterValue === \'\'">\r\n            <i class="fa fa-times" aria-hidden="true"></i>\r\n          </button>\r\n        </span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n');
$templateCache.put('../source/pl-tab.html','<div class="tab-pane" ng-if="!$ctrl.lazyLoad || $ctrl.selected" ng-show="$ctrl.selected" ng-transclude></div>\r\n');
$templateCache.put('../source/pl-table.html','<div class="pl-table" ng-cloak>\r\n  <pl-spinner></pl-spinner>\r\n  <div class="table-responsive">\r\n    <table ng-class="[$ctrl.tableClass, {\'table-bordered\': $ctrl.options.border}, $ctrl.theme]">\r\n      <thead ng-hide="$ctrl.hideHeader || $ctrl.options.hideHeader">\r\n      <tr>\r\n        <th class="actionDetail" ng-if="$ctrl.hasDetail"></th>\r\n\r\n        <th class="actions" ng-if="$ctrl.hasActions && $ctrl.actionsAlign !== \'right\'" ng-hide="$ctrl.options.hideActions" nowrap>\r\n          <div ng-transclude-type="child" ng-transclude="headerActions">\r\n            <span pl-translate="{{$ctrl.options.actionCaption}}"></span>\r\n          </div>\r\n        </th>\r\n\r\n        <th class="table-header-item" ng-repeat="field in $ctrl.definition.fields | orderBy: \'order\'" ng-class="$ctrl.getTdClass(undefined, field, $index)"\r\n            ng-attr-width="{{field.width ? field.width: \'auto\'}}" ng-hide="field.visible === false">\r\n          <a href ng-if="$ctrl.canSort(field)" ng-click="$ctrl.sort(field)">\r\n            <span pl-translate="{{$ctrl.getCaption(field)}}"></span>\r\n            <i class="fa fa-sort-alpha-asc" ng-if="$ctrl.isOrderAsc(field)"></i>\r\n            <i class="fa fa-sort-alpha-desc" ng-if="$ctrl.isOrderDesc(field)"></i>\r\n          </a>\r\n          <span ng-if="!$ctrl.canSort(field)" pl-translate="{{$ctrl.getCaption(field)}}"></span>\r\n        </th>\r\n\r\n        <th class="actions" ng-if="$ctrl.hasActions && $ctrl.actionsAlign === \'right\'" ng-hide="$ctrl.options.hideActions" nowrap>\r\n          <div ng-transclude-type="child" ng-transclude="headerActions">\r\n            <span pl-translate="{{$ctrl.options.actionCaption}}"></span>\r\n          </div>\r\n        </th>\r\n      </tr>\r\n      </thead>\r\n\r\n      <tfoot class="pl-table-footer" ng-if="$ctrl.footerSource.length > 0">\r\n      <tr ng-repeat="item in $ctrl.footerSource">\r\n        <td ng-if="$ctrl.hasDetail" ng-hide="$ctrl.options.hideDetail"></td>\r\n\r\n        <td class="actions" ng-if="$ctrl.hasActions && $ctrl.actionsAlign !== \'right\'" ng-hide="$ctrl.options.hideActions" nowrap>\r\n          <div ng-if="!item.empty" ng-transclude-type="child" ng-transclude="itemActions"></div>\r\n        </td>\r\n\r\n        <td ng-repeat="td in $ctrl.definition.fields | orderBy : \'order\'" ng-hide="td.visible === false" ng-class="$ctrl.getTdClass(item, td, $index)"\r\n            ng-attr-colspan="{{td.colspan}}">\r\n          <div ng-if="!td.empty" ng-switch="td.type">\r\n            <span ng-switch-when="boolean" ng-switch="summary[item.name]">\r\n              <i ng-switch-when="true" class="fa fa-check-square-o" aria-hidden="true"></i>\r\n              <i ng-switch-when="false" class="fa fa-square-o" aria-hidden="true"></i>\r\n            </span>\r\n            <span ng-switch-when="date" ng-bind-html="item[td.name] | date : \'dd-MM-yyyy\' : \'UTC\' "></span>\r\n            <span ng-switch-when="datetime" ng-bind-html="item[td.name] | date : \'dd-MM-yyyy HH:mm:ss\' : \'UTC\'"></span>\r\n            <span ng-switch-when="time" ng-bind-html="item[td.name] | date : \'HH:mm:ss\': \'UTC\'"></span>\r\n            <span ng-switch-when="currency" ng-bind-html="item[td.name] | currency : (td.validators.symbol || \'\u20AC\') : (td.validators.decimals || 2)"></span>\r\n            <span ng-switch-when="tax" ng-bind-html="item[td.name] | tax : item[td.name].properties"></span>\r\n            <span ng-switch-when="number|float" ng-switch-when-separator="|" ng-bind-html="item[td.name] | number : (td.validators.decimals || 2)"></span>\r\n            <span ng-switch-when="color" class="circle" ng-switch="summary[item.name]" ng-style="{\'background\': item[td.name] }"></span>\r\n            <span ng-switch-default ng-bind-html="item[td.name]"></span>\r\n          </div>\r\n        </td>\r\n\r\n        <td class="actions" nowrap></td>\r\n      </tr>\r\n      </tfoot>\r\n\r\n      <tbody ng-if="$ctrl.data.total > 0" ng-repeat="item in $ctrl.data.list" ng-class="$ctrl.getRowClass(item, $index)">\r\n      <tr ng-class="$ctrl.getRowClass(item, $index)">\r\n        <td ng-class="{\'actionDetail\': !item.empty}" ng-click="$ctrl.fnOnDetail(item, (item._hasDetail === false), $event)" ng-hide="$ctrl.options.hideDetail"\r\n            ng-if="$ctrl.hasDetail">\r\n          <i ng-if="!item.empty && item._hasDetail !== false" class="fa fa-angle-right" aria-hidden="true" pl-animation-rotate="item._detailOpen"></i>\r\n        </td>\r\n\r\n        <td class="actions" ng-if="!item.empty && $ctrl.hasActions && $ctrl.actionsAlign !== \'right\'" ng-hide="$ctrl.options.hideActions" nowrap>\r\n          <div ng-transclude-type="child" ng-transclude="itemActions"></div>\r\n        </td>\r\n\r\n        <td ng-repeat="td in $ctrl.definition.fields | orderBy : \'order\'" ng-click="$ctrl.doSelected(item, td, (item._hasDetail === false), $event)"\r\n            ng-hide="td.visible === false" ng-class="[{\'pl-table-onselect\': !item.empty}, $ctrl.getTdClass(item, td, $index)]" ng-attr-colspan="{{td.colspan}}">\r\n          <div ng-if="!item.empty" ng-switch="td.type">\r\n            <span ng-switch-when="boolean" ng-switch="$ctrl.getValue(item,td)" ng-class="$ctrl.getTdValSpanClass(item, td)">\r\n              <i ng-switch-when="true" class="fa fa-check-square-o" aria-hidden="true"></i>\r\n              <i ng-switch-when="false" class="fa fa-square-o" aria-hidden="true"></i>\r\n            </span>\r\n\r\n            <span ng-switch-when="date"\r\n                  ng-bind-html="$ctrl.getValue(item,td) | date : $ctrl.format.date : \'UTC\' | AIhighlight : $ctrl.search : td.hightlight"\r\n                  ng-class="$ctrl.getTdValSpanClass(item, td)">\r\n            </span>\r\n\r\n            <span ng-switch-when="datetime"\r\n                  ng-bind-html="$ctrl.getValue(item,td) | date : $ctrl.format.datetime : \'UTC\' | AIhighlight : $ctrl.search : td.hightlight"\r\n                  ng-class="$ctrl.getTdValSpanClass(item, td)">\r\n            </span>\r\n\r\n            <span ng-switch-when="time"\r\n                  ng-bind-html="$ctrl.getValue(item,td) | date : $ctrl.format.time : \'UTC\' | AIhighlight : $ctrl.search : td.hightlight"\r\n                  ng-class="$ctrl.getTdValSpanClass(item, td)">\r\n            </span>\r\n\r\n            <span ng-switch-when="currency"\r\n                  ng-bind-html="$ctrl.getValue(item,td) | currency : (td.validators.symbol || \'\u20AC\') : (td.validators.decimals || 2) | AIhighlight : $ctrl.search : td.hightlight"\r\n                  ng-class="$ctrl.getTdValSpanClass(item, td)">\r\n              <span>&nbsp;\u20AC</span>\r\n            </span>\r\n\r\n            <span ng-switch-when="tax"\r\n                  ng-bind-html="$ctrl.getValue(item,td) | tax : item.properties | AIhighlight : $ctrl.search : td.hightlight"\r\n                  ng-class="$ctrl.getTdValSpanClass(item, td)">\r\n              <span>&nbsp;\u20AC</span>\r\n            </span>\r\n\r\n            <span ng-switch-when="number|float"\r\n                  ng-switch-when-separator="|"\r\n                  ng-bind-html="$ctrl.getValue(item,td) | number : (td.validators.decimals || 2) | AIhighlight : $ctrl.search : td.hightlight"\r\n                  ng-class="$ctrl.getTdValSpanClass(item, td)">\r\n              <span>&nbsp;\u20AC</span>\r\n            </span>\r\n\r\n            <span ng-switch-default ng-bind-html="$ctrl.getValue(item,td) | AIhighlight : $ctrl.search : td.hightlight"\r\n                  ng-class="$ctrl.getTdValSpanClass(item, td)"></span>\r\n\r\n            <span class="circle" ng-switch-when="color" ng-switch="$ctrl.getValue(item,td)" ng-style="{\'background\': $ctrl.getValue(item,td)}"\r\n                  ng-class="$ctrl.getTdValSpanClass(item, td)"></span>\r\n          </div>\r\n          <span ng-if="item.empty">&nbsp;</span>\r\n        </td>\r\n\r\n        <td class="actions" ng-if="!item.empty && $ctrl.hasActions && $ctrl.actionsAlign === \'right\'" ng-hide="$ctrl.options.hideActions" nowrap>\r\n          <div ng-transclude-type="child" ng-transclude="itemActions"></div>\r\n        </td>\r\n      </tr>\r\n\r\n      <tr class="detail">\r\n        <td class="detail" ng-attr-colspan="{{$ctrl.definition.fields.length + 2}}">\r\n          <div class="pl-animation-collapse detail" ng-if="$ctrl.hasDetail && item._hasDetail !== false && item._detailOpen">\r\n            <div ng-transclude="itemDetail" ng-transclude-type="child"></div>\r\n          </div>\r\n        </td>\r\n      </tr>\r\n      </tbody>\r\n    </table>\r\n  </div>\r\n\r\n  <pl-pagination class="pl-table-pagination" instance-id="{{$ctrl.instanceId}}" total="$ctrl.data.total" on-page-change="$ctrl.loadPage(page, perPage)"\r\n                 page="$ctrl.page" ng-hide="$ctrl.options.hidePagination" properties="$ctrl.options">\r\n  </pl-pagination>\r\n</div>\r\n');
$templateCache.put('../source/pl-tabs.html','<div class="pl-tabs" ng-class="$ctrl.theme">\r\n  <ul class="nav" ng-class="[{\'nav-justified\': $ctrl.justified, \'nav-stacked\': $ctrl.stacked}, $ctrl.getTabsClass()]">\r\n    <li ng-repeat="tab in $ctrl.tabs" ng-class="{\'active\': tab.selected}">\r\n      <a href ng-click="$ctrl.selectTab(tab.id)">\r\n        <span ng-bind-html="$ctrl.getCaption(tab.caption)"></span>\r\n      </a>\r\n    </li>\r\n  </ul>\r\n  <div class="tab-content" ng-transclude></div>\r\n</div>\r\n');
$templateCache.put('../source/pl-timepicker.html','<div class="input-group pl-input-group" ng-class="$ctrl.editClass" ng-hide="$ctrl.options.readonly" pl-disable-animate>\r\n  <input type="text" class="form-control pl-timepicker-input" autocapitalize="off" autocomplete="off"\r\n         ng-model="$ctrl.viewValue"\r\n         ng-change="$ctrl.viewChange($ctrl.viewValue)"\r\n         ng-dblclick="$ctrl.showTimer()"\r\n         ng-focus="$ctrl.options.events.focus($ctrl.viewValue, $event)"\r\n         ng-blur="$ctrl.onBlur($event)"\r\n         ng-attr-name="{{$ctrl.name}}"\r\n         ng-attr-placeholder="{{$ctrl.options.placeholder | pltranslate}}"\r\n         ng-keydown="$ctrl.options.events.keydown($ctrl.value, $event)"\r\n         ng-keypress="$ctrl.options.events.keypress($ctrl.value, $event)"\r\n         ng-keyup="$ctrl.options.events.keyup($ctrl.value, $event)"\r\n         ng-mousedown="$ctrl.options.events.mousedown($ctrl.viewValue, $event)"\r\n         ng-mouseenter="$ctrl.onMouseEnter($event)"\r\n         ng-mouseleave="$ctrl.onMouseLeave($event)"\r\n         ng-mousemove="$ctrl.options.events.mousemove($ctrl.viewValue, $event)"\r\n         ng-mouseover="$ctrl.options.events.mouseover($ctrl.viewValue, $event)"\r\n         ng-mouseup="$ctrl.options.events.mouseup($ctrl.viewValue, $event)"\r\n         ng-disabled="$ctrl.options.disabled || $ctrl.options.disallowInput"\r\n         ng-required="$ctrl.options.validate && $ctrl.options.validators.required.value">\r\n  <a href class="input-group-addon cg-dp-btn btnShowTimer" ng-class="{\'disabled\': $ctrl.options.disabled}" ng-click="$ctrl.toggleTimer()">\r\n    <i class="fa fa-clock-o fa-fw"></i>\r\n  </a>\r\n</div>\r\n\r\n<div class="pl-timepicker" ng-show="$ctrl.timerOpened" tabindex="-1" ng-mouseenter="$ctrl.onMouseEnter($event)" ng-mouseleave="$ctrl.onMouseLeave($event)"\r\n     ng-blur="$ctrl.onBlur()">\r\n  <div class="controls">\r\n    <div class="uib-timepicker" uib-timepicker ng-model="$ctrl.timeValue" ng-change="$ctrl.valueChange()" show-meridian="false" show-seconds="true"></div>\r\n\r\n    <div class="btn-group">\r\n      <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.nowClick()" pl-translate="{{$ctrl.locales.text.now}}"></button>\r\n      <button type="button" class="btn btn-danger btn-sm" ng-click="$ctrl.clearClick()" pl-translate="{{$ctrl.locales.text.clear}}"></button>\r\n    </div>\r\n\r\n    <button type="button" class="btn btn-default btn-sm pull-right pl-timepicker-close" ng-click="$ctrl.closeTimer()"\r\n            pl-translate="{{$ctrl.locales.text.close}}"></button>\r\n  </div>\r\n</div>\r\n\r\n<pl-messages target="{{$ctrl.name}}" validate="$ctrl.options.validate" properties="$ctrl.options.validators"></pl-messages>\r\n\r\n<span ng-show="$ctrl.options.readonly" class="form-control-align" pl-disable-animate>{{$ctrl.viewValue | date : $ctrl.format.time : \'UTC\'}}</span>\r\n');
$templateCache.put('../source/pl-toolbar.html','<div class="toolbar" ng-class="$ctrl.config.toolbarClass">\r\n  <ng-transclude></ng-transclude>\r\n  <ul class="list-inline toolbar-list clearfix">\r\n    <li class="toolbar-list-item" ng-repeat="item in $ctrl.config.items | orderBy:\'order\' track by item.id" ng-if="$ctrl.isVisible(item)"\r\n        ng-class="{\'pull-right\': item.align === \'right\'}" ng-attr-data-group-id="{{item.groupId}}" ng-attr-data-item-id="{{item.id}}"\r\n        pl-animation-collapse="!$ctrl.isCollapsed && $ctrl.isCollapseVisible() && !$ctrl.isTypeExcluded(item.type)">\r\n      <div ng-if="item.type === \'button\'">\r\n        <button type="button" class="btn btn-sm" ng-class="item.class" ng-click="$ctrl.doClick(item, $event)" ng-disabled="item.disabled"\r\n                pl-tooltip="item.tooltip" pl-promise>\r\n          <span ng-bind-html="item.iconLeft"></span>\r\n          <span ng-bind-html="item.caption| pltranslate "></span>\r\n        </button>\r\n      </div>\r\n\r\n      <div class="btn-group btn-group-sm" role="group" ng-if="item.type === \'button-group\'" pl-tooltip="item.tooltip">\r\n        <div class="btn-group-item" ng-repeat="button in item.items | orderBy : \'order\' track by button.id">\r\n          <div pl-tooltip="button.tooltip">\r\n            <button type="button" class="btn btn-sm" ng-class="button.class" ng-click="$ctrl.doClick(button, $event)"\r\n                    ng-disabled="button.disabled" pl-promise>\r\n              <span ng-bind-html="button.iconLeft"></span>\r\n              <span ng-bind-html="button.caption | pltranslate"></span>\r\n            </button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <!-- Force download popup only works on same domain origin href\'s -->\r\n      <div ng-if="item.type === \'download\'">\r\n        <a class="btn btn-sm" ng-class="item.class" ng-click="$ctrl.doClick(item, $event)" ng-attr-href="{{item.download.url}}" ng-disabled="item.disabled"\r\n           download="{{item.download.filename}}" target="_blank" pl-tooltip="item.tooltip">\r\n          <span ng-bind-html="item.iconLeft"></span>\r\n          <span ng-bind-html="item.caption| pltranslate "></span>\r\n        </a>\r\n      </div>\r\n\r\n      <div ng-if="item.type === \'page\'">\r\n        <span ng-bind-html="item.iconLeft"></span>\r\n        <span ng-bind-html="item.caption| pltranslate "></span>\r\n        <pl-inline-edit type="number" ng-model="item.page.num" properties="{decimalsLimit: 0}"></pl-inline-edit>\r\n        <span>/{{item.page.total}}</span>\r\n      </div>\r\n\r\n      <div ng-if="item.type === \'dropdown\'" uib-dropdown keyboard-nav ng-class="$ctrl.getPopupOrientationClass()">\r\n        <button type="button" class="btn btn-sm" ng-attr-id="{{\'dropdown.\' + item.id + \'.\' + $index}}" ng-class="item.class"\r\n                ng-click="$ctrl.doClick(item, $event)"\r\n                ng-disabled="item.disabled" pl-tooltip="item.tooltip" uib-dropdown-toggle>\r\n          <span ng-bind-html="item.iconLeft"></span>\r\n          <span ng-bind-html="item.caption | pltranslate"></span>\r\n          <span class="caret"></span>\r\n        </button>\r\n        <ul class="dropdown-menu" role="menu" ng-attr-aria-labelledby="{{\'dropdown.\' + item.id + \'.\' + $index}}" uib-dropdown-menu>\r\n          <li ng-repeat="mnu in item.menu">\r\n            <a href ng-click="$ctrl.doClick(mnu, $event)" pl-tooltip="mnu.tooltip" ng-attr-tabindex="{{$ctrl.getTabIndex(item)}}"\r\n               ng-disabled="mnu.disabled">\r\n              <span ng-bind-html="mnu.iconLeft"></span>\r\n              <span ng-bind-html="mnu.caption | pltranslate"></span>\r\n            </a>\r\n          </li>\r\n        </ul>\r\n      </div>\r\n\r\n      <div ng-if="item.type === \'dropdown-split\'" uib-dropdown keyboard-nav ng-class="$ctrl.getPopupOrientationClass()">\r\n        <div class="btn-group" pl-tooltip="item.tooltip">\r\n          <button type="button" class="btn btn-sm" ng-attr-id="{{\'dropdown.\' + item.id + \'.\' + $index}}" ng-class="item.class"\r\n                  ng-click="$ctrl.doClick(item, $event)"\r\n                  ng-disabled="item.disabled">\r\n            <span ng-bind-html="item.iconLeft"></span>\r\n            <span ng-bind-html="item.caption | pltranslate"></span>\r\n          </button>\r\n          <button type="button" class="btn btn-sm" ng-class="item.class" ng-disabled="item.disabled" uib-dropdown-toggle>\r\n            <span class="caret"></span>\r\n          </button>\r\n        </div>\r\n        <ul class="dropdown-menu" role="menu" ng-attr-aria-labelledby="{{\'dropdown.\' + item.id + \'.\' + $index}}" uib-dropdown-menu>\r\n          <li ng-class="[mnu.class, {\'divider\': mnu.type === \'divider\' || mnu.role === \'separator\'}]" ng-repeat="mnu in item.menu">\r\n            <a href ng-click="$ctrl.doClick(mnu, $event)" ng-attr-tabindex="{{$ctrl.getTabIndex(mnu)}}" ng-disabled="mnu.disabled"\r\n               pl-tooltip="mnu.tooltip">\r\n              <span ng-bind-html="mnu.iconLeft"></span>\r\n              <span ng-bind-html="mnu.caption | pltranslate"></span>\r\n            </a>\r\n          </li>\r\n        </ul>\r\n      </div>\r\n\r\n      <div class="form-group" ng-if="item.type === \'html\'" ng-bind-html="item.caption"></div>\r\n\r\n      <h4 ng-if="item.type === \'title\'">{{item.caption | pltranslate}}</h4>\r\n\r\n      <ng-form class="navbar-form pl-toolbar-form cg-search" ng-if="item.type === \'search\' && $ctrl.config.search.active"\r\n               ng-attr-name="{{item.groupId + \'-searchForm-\' + item.id}}" role="search">\r\n        <div class="form-group">\r\n          <div class="input-group">\r\n            <input type="text" class="form-control input-sm" ng-attr-placeholder="{{$ctrl.config.search.placeholder| pltranslate }}"\r\n                   ng-model="$ctrl.config.search.text" ng-model-options="{ updateOn: \'default blur\', debounce: {\'default\': 500, \'blur\': 0}}"/>\r\n            <span class="input-group-btn">\r\n                <button class="btn btn-primary btn-sm" type="button" ng-click="$ctrl.config.search.text=\'\'" ng-show="$ctrl.config.search.text.length>0">\r\n                  <i class="fa fa-times"></i>\r\n                </button>\r\n                <button ng-show="$ctrl.config.search.button" class="btn btn-primary btn-sm" type="submit"\r\n                        ng-click="$ctrl.dosearchfn()" pl-promise>\r\n                  <i class="fa fa-search"></i>\r\n                </button>\r\n            </span>\r\n          </div>\r\n        </div>\r\n      </ng-form>\r\n    </li>\r\n    <li class="pl-toolbar-collapse" ng-if="$ctrl.isCollapseVisible()">\r\n      <button class="btn btn-sm btn-primary btn-circle" ng-click="$ctrl.isCollapsed = !$ctrl.isCollapsed">\r\n        <i class="fa fa-cog"></i>\r\n      </button>\r\n    </li>\r\n  </ul>\r\n</div>\r\n');
$templateCache.put('../source/pl-upload.html','<div class="pl-upload">\r\n  <div class="file-input">\r\n    <div class="file-preview disable-select">\r\n      <div class="close fileinput-remove" ng-if="$ctrl.files.length" ng-click="$ctrl.removeAll()">\xD7</div>\r\n\r\n      <div class="file-drop-zone" ngf-drop="$ctrl.uploadFiles($files)" ngf-drag-over-class="\'file-highlighted\'"\r\n           ng-if="$ctrl.options.dragdrop && ((!$ctrl.options.multiple && !$ctrl.files.length) || $ctrl.options.multiple)"\r\n           ngf-multiple="{{$ctrl.options.multiple}}" ngf-pattern="$ctrl.pattern">\r\n        <div class="file-drop-zone-title" ng-if="!$ctrl.files.length">{{$ctrl.placeHolder}} \u2026</div>\r\n      </div>\r\n\r\n      <div class="file-preview-thumbnails clearfix">\r\n        <div class="file-preview-frame krajee-default kv-preview-thumb" data-fileindex="0" data-template="image" ng-repeat="file in $ctrl.files">\r\n          <div class="kv-file-content child-elements">\r\n            <img class="file-preview-image kv-preview-data child-elements"\r\n                 ng-if="$ctrl.isImage(file)"\r\n                 ngf-src="file"\r\n                 ngf-pattern="$ctrl.pattern"\r\n                 ngf-multiple="false"\r\n                 ng-disabled="disabled" style="width:auto;height:120px;">\r\n\r\n            <img ng-if="!$ctrl.isImage(file)" class="child-elements"\r\n                 ng-src="{{$ctrl.getImageFor(file)}}" style="width:auto;height:120px;"/>\r\n          </div>\r\n\r\n          <div class="file-thumbnail-footer">\r\n            <div class="file-footer-caption child-elements" title="{{file.name}}">{{file.name}}</div>\r\n\r\n            <div class="file-thumb-progress hide child-elements">\r\n              <div class="progress">\r\n                <div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar"\r\n                     aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width:0%;">\r\n                  {{$ctrl.locales.text.initialize}}...\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class="file-actions">\r\n              <div class="file-footer-buttons">\r\n                <button type="button" class="kv-file-upload btn btn-xs btn-default" title="Upload file" ng-click="$ctrl.send()">\r\n                  <i class="fa fa-upload fa-fw text-info"></i>\r\n                </button>\r\n                <button type="button" class="kv-file-remove btn btn-xs btn-default" title="Remove file" ng-click="$ctrl.remove($index)">\r\n                  <i class="fa fa-trash-o fa-fw text-danger"></i>\r\n                </button>\r\n              </div>\r\n              <div class="clearfix"></div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class="file-preview-status text-center text-success"></div>\r\n      <div class="kv-fileinput-error file-error-message" ng-if="false"></div>\r\n    </div>\r\n\r\n    <div class="kv-upload-progress hide">\r\n      <div class="progress">\r\n        <div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" aria-valuenow="0"\r\n             aria-valuemin="0" aria-valuemax="100" style="width: 0;">0%\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <pl-progress ng-if="$ctrl.isUploading" value="$ctrl.progress"></pl-progress>\r\n\r\n    <div class="btn-group file-caption-main" role="group">\r\n      <a href tabindex="500" class="btn btn-default fileinput-upload fileinput-upload-button" title="Upload selected files"\r\n         ng-if="$ctrl.files.length" ng-click="$ctrl.send()" ng-hide="$ctrl.options.hideSend">\r\n        <i class="fa fa-upload fa-fw"></i>\r\n        <span class="hidden-xs">Enviar</span>\r\n      </a>\r\n\r\n      <button class="btn btn-primary"\r\n              ngf-select="$ctrl.uploadFiles($files, $file)"\r\n              ngf-multiple="{{$ctrl.options.multiple}}"\r\n              ngf-pattern="$ctrl.pattern"><i class="fa fa-folder-open fa-fw"></i>&nbsp;<span ng-bind="$ctrl.locales.text.open"></span>\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n');}]);})();
/**
 * Created by pedro on 28/09/16.
 */
(function () {
  'use strict';

  angular.module('pl.comps')
    .config(function () {
      // Read https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find#Polyfill
      if (!Array.prototype.find) {
        Object.defineProperty(Array.prototype, 'find', {
          value: function (predicate) {
            if (this === null) {
              throw new TypeError('"this" is null or not defined');
            }
            var o = Object(this);
            var len = o.length >>> 0; // jshint ignore:line
            if (!angular.isFunction(predicate)) {
              throw new TypeError('predicate must be a function');
            }
            var thisArg = arguments[1];
            var k = 0;
            while (k < len) {
              var kValue = o[k];
              if (predicate.call(thisArg, kValue, k, o)) {
                return kValue;
              }
              k++;
            }
            return undefined;
          }
        });
      }
      if (!RegExp.escape) {
        RegExp.escape = function (s) {
          return String(s).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
        };
        RegExp.escapeSafe = function (s) {
          return String(s).replace(/[\\^$*+?.()|{}]/g, '\\$&');
        };
      }

      // PivotTable missing locales
      (function () {
        var callWithJQuery;

        callWithJQuery = function (pivotModule) {
          if (typeof exports === 'object' && typeof module === 'object') {
            return pivotModule(require('jquery'));
          }
          else {
            return pivotModule(angular.element);
          }
        };

        callWithJQuery(function ($) {
          var renderersExport, renderersPlotly;
          renderersExport = angular.element.pivotUtilities.export_renderers; // jshint ignore:line
          renderersPlotly = angular.element.pivotUtilities.plotly_renderers; // jshint ignore:line
          if (renderersExport) {
            angular.element.pivotUtilities.locales.pt.export_renderers = { // jshint ignore:line
              'Exportar para TSV': renderersExport['TSV Export']
            };
          }
          if (renderersPlotly) {
            angular.element.pivotUtilities.locales.pt.plotly_renderers = { // jshint ignore:line
              'Gráfico de Barras Horizontal': renderersPlotly['Horizontal Bar Chart'],
              'Gráfico de Barras Gorizontais Empilhadas': renderersPlotly['Horizontal Stacked Bar Chart'],
              'Gráfico de Barras': renderersPlotly['Bar Chart'],
              'Gráfico de Barras Empilhadas': renderersPlotly['Stacked Bar Chart'],
              'Gráfico de Linhas': renderersPlotly['Line Chart'],
              'Gráfico de Dispersão': renderersPlotly['Scatter Chart']
            };
          }
          return angular.element.pivotUtilities.locales.pt;
        });
      }).call(this);

      // jQuery extensions
      (function ($) {
        $.fn.animateWith = function (animationClass, callback) {
          $(this).removeClass(animationClass + ' animated')
            .addClass(animationClass + ' animated')
            .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
              $(this).removeClass(animationClass);
              if (callback) {
                callback.call(this, animationClass);
              }
            });
        };
      })(angular.element);
    });
})();

(function () {
  'use strict';

  angular.module('pl.comps')
    .provider('plCompsService', /*@ngInject*/ ['SCREENSIZES', 'plFormatProvider', function (SCREENSIZES, plFormatProvider) {
      get.$inject = ['$window', '$timeout', '$filter', 'plFormat', 'plLocale', 'plTranslate', 'moment'];
      var timers = {};
      var configurations = {
        plEditForm: {
          orientation: 'horizontal'
        }
      };
      var provider = {
        config: function () {
          return configurations;
        },
        setConfig: setConfig,
        generateName: generateName,
        generateUniqueID: generateUniqueID,
        toCamelCase: toCamelCase,
        stripCharacters: stripCharacters,
        removeAllNotLast: removeAllNotLast,
        parseNumber: parseNumber,
        getNodePath: getNodePath,
        parseExpressionToString: parseExpressionToString,
        compareTo: compareTo,
        getPathValue: getPathValue,
        stringToArray: stringToArray,
        normalizeAccents: normalizeAccents,
        $get: /*@ngInject*/ get
      };
      return provider;

      function parseExpressionToStr(value, previous, args) {
        previous = previous || '';
        if (angular.isString(value)) {
          previous += ',' + value;
        }
        else if (angular.isArray(value)) {
          angular.forEach(value, function (element) {
            previous = parseExpressionToStr(element, previous);
          });
        }
        else if (angular.isObject(value)) {
          angular.forEach(value, function (value, property) {
            if (angular.isFunction(value) && value.apply(this, args) || value === true) {
              previous = parseExpressionToStr(property, previous);
            }
          });
        }
        return previous;
      }

      /////////////

      function setConfig(object) {
        _.merge(configurations, object);
      }

      function generateName(original, name) {
        if (angular.isUndefined(original) || !original || original.toString().trim() === '') {
          return name + provider.generateUniqueID();
        }
        return original;
      }

      function generateUniqueID() {
        return '_' + Math.random().toString(36).substr(2, 9);
      }

      function toCamelCase(string) {
        return string.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
          return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
        }).replace(/\s+/g, '');
      }

      function stripCharacters(value) {
        // Removing all characters but 0-9 numbers or decimals separator (if using decimals)
        value = value.toString().replace(/\./g, plFormatProvider.format.decimalsSeparator);
        return value.replace(plFormatProvider.format.notNumberRegex, '');
      }

      function removeAllNotLast(string, token) {
        var parts = string.split(token);
        if (angular.isUndefined(parts[1])) {
          return string;
        }
        return parts.slice(0, -1).join('') + token + parts.slice(-1);
      }

      function parseNumber(value) {
        value = provider.stripCharacters(value);
        value = value.replace(new RegExp('\\' + plFormatProvider.format.decimalsSeparator, 'g'), '.');
        value = parseFloat(value);
        return value;
      }

      function getNodePath(element) {
        if (!element) {
          return element;
        }
        else if (angular.isDefined(element.length)) {
          if (!element.length) {
            return;
          }
          element = element[0];
        }
        var stack = [];
        while (element.parentNode !== null) {
          var sibCount = 0;
          var sibIndex = 0;
          for (var i = 0; i < element.parentNode.childNodes.length; i++) {
            var sib = element.parentNode.childNodes[i];
            if (sib.nodeName === element.nodeName) {
              if (sib === element) {
                sibIndex = sibCount;
              }
              sibCount++;
            }
          }
          if (element.hasAttribute('id') && element.id !== '') {
            stack.unshift(element.nodeName.toLowerCase() + '#' + element.id);
          }
          else if (sibCount > 1) {
            stack.unshift(element.nodeName.toLowerCase() + ':eq(' + sibIndex + ')');
          }
          else {
            stack.unshift(element.nodeName.toLowerCase());
          }
          element = element.parentNode;
        }
        return stack.slice(1).join('>');
      }

      function parseExpressionToString(value, args) {
        value = parseExpressionToStr(value, null, args);
        if (value[0] === ',') {
          value = value.substr(1);
        }
        return value;
      }

      /**
       * @return {number}  the value ``0`` if the argument string is equal to
       *          this string; a value less than ``0`` if this string
       *          is lexicographically less than the string argument; and a
       *          value greater than ``0`` if this string is
       *          lexicographically greater than the string argument.
       */
      function compareTo(string, toCompare) {
        var len1 = string.length;
        var len2 = toCompare.length;
        var lim = Math.min(len1, len2);
        var v1 = string;
        var v2 = toCompare;
        var k = 0;
        while (k < lim) {
          var c1 = v1[k];
          var c2 = v2[k];
          if (c1 !== c2) {
            return c1 - c2;
          }
          k++;
        }
        return len1 - len2;
      }

      function getPathValue(root, path) {
        var segments = path.split('.');
        while (segments.length > 1) {
          var pathStep = segments.shift();
          if (angular.isUndefined(root[pathStep]) || root[pathStep] === null) {
            root[pathStep] = {};
          }
          root = root[pathStep];
        }
        return root;
      }

      function stringToArray(string, alternativeContent, separator) {
        separator = separator || ',';
        if (!string) {
          string = alternativeContent || [];
        }
        else if (angular.isString(string) && string.indexOf(separator) !== -1) {
          string = string.split(separator);
        }
        else {
          string = [string];
        }
        return string;
      }

      function normalizeAccents(string) {
        return string.toString().trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      }

      function get($window, $timeout, $filter, plFormat, plLocale, plTranslate, moment) {
        var factory = angular.extend({}, provider, {
          debounce: debounce,
          getScreenWidth: getScreenWidth,
          isMobile: isMobile,
          prettyPrintValue: prettyPrintValue,
          normalizeDate: normalizeDate
        });
        return factory;

        /////////////

        function debounce(callback, ms, id) {
          if (!id) {
            return new Error('Debounce requires an unique ID to avoid timer collisions.');
          }
          if (timers[id]) {
            $timeout.cancel(timers[id]);
          }
          timers[id] = $timeout(callback, ms);
          return timers[id];
        }

        function getScreenWidth() {
          return $window.innerWidth;
        }

        function isMobile() {
          return factory.getScreenWidth() < SCREENSIZES.SM;
        }

        function prettyPrintValue(value, type, format, properties) {
          type = type || 'text';
          format = format || plFormat.format;
          if (angular.isObject(value)) {
            if (value.description) {
              value = value.description;
            }
            else {
              value = value.value;
            }
            return value;
          }
          else {
            if (type === 'date' && value) {
              return factory.normalizeDate(value).format(format.momentDate);
            }
            else if (type === 'datetime' && value) {
              return factory.normalizeDate(value).format(format.momentDatetime);
            }
            else if (type === 'time' && value) {
              return factory.normalizeDate(value).format(format.time);
            }
            else if (type === 'boolean') {
              return value ? plTranslate.translate(plLocale.locales.text.true) : plTranslate.translate(plLocale.locales.text.false);
            }
            else if (type === 'number') {
              return $filter('plNumber')(value, properties);
            }
            else if (type === 'radio' && properties && properties.radio && properties.radio.list) {
              return plTranslate.translate(properties.radio.list.find(function (item) {
                return item[properties.radio.valueProp || 'value'] === value;
              })[properties.radio.labelProp || 'label']);
            }
            else if (type === 'select' && properties && properties.select && properties.select.list) {
              return plTranslate.translate(properties.select.list.find(function (item) {
                return item[properties.select.valueProp || 'value'] === value;
              })[properties.select.labelProp || 'name']);
            }
            return value;
          }
        }

        function normalizeDate(date) {
          if (!date) {
            date = moment.utc();
          }
          else if (angular.isString(date)) {
            date = moment.utc(date);
          }
          var isMoment = moment.isMoment(date);
          var year = isMoment ? date.year() : date.getFullYear();
          var month = isMoment ? date.month() : date.getMonth();
          var day = isMoment ? date.date() : date.getDate();
          var hours = isMoment ? date.hours() : date.getHours();
          var minutes = isMoment ? date.minutes() : date.getMinutes();
          var seconds = isMoment ? date.seconds() : date.getSeconds();
          var milliseconds = isMoment ? date.milliseconds() : date.getMilliseconds();
          return moment.utc(Date.UTC(year, month, day, hours, minutes, seconds, milliseconds));
        }
      }
    }]);
})();

(function () {
  'use strict';

  angular.module('pl.comps')
    .constant('KEYCODE', {
      BACKSPACE: 8,
      TAB: 9,
      ENTER: 13,
      SHIFT: 16,
      CONTROL: 17,
      ALT: 18,
      PAUSE_BREAK: 19,
      CAPS_LOCK: 20,
      ESC: 27,
      SPACEBAR: 32,
      PAGE_UP: 33,
      PAGE_DOWN: 34,
      END: 35,
      HOME: 36,
      LEFT: 37,
      UP: 38,
      RIGHT: 39,
      DOWN: 40,
      INSERT: 45,
      DELETE: 46,
      _0: 48,
      _1: 49,
      _2: 50,
      _3: 51,
      _4: 52,
      _5: 53,
      _6: 54,
      _7: 55,
      _8: 56,
      _9: 57,
      A: 65,
      B: 66,
      C: 67,
      D: 68,
      E: 69,
      F: 70,
      G: 71,
      H: 72,
      I: 73,
      J: 74,
      K: 75,
      L: 76,
      M: 77,
      N: 78,
      O: 79,
      P: 80,
      Q: 81,
      R: 82,
      S: 83,
      T: 84,
      U: 85,
      V: 86,
      W: 87,
      X: 88,
      Y: 89,
      Z: 90,
      LEFT_WINDOW_KEY: 91,
      RIGHT_WINDOW_KEY: 92,
      SELECT_KEY: 93,
      NUMPAD_0: 96,
      NUMPAD_1: 97,
      NUMPAD_2: 98,
      NUMPAD_3: 99,
      NUMPAD_4: 100,
      NUMPAD_5: 101,
      NUMPAD_6: 102,
      NUMPAD_7: 103,
      NUMPAD_8: 104,
      NUMPAD_9: 105,
      MULTIPLY: 106,
      ADD: 107,
      SUBTRACT: 109,
      DECIMAL_POINT: 110,
      DIVIDE: 111,
      F1: 112,
      F2: 113,
      F3: 114,
      F4: 115,
      F5: 116,
      F6: 117,
      F7: 118,
      F8: 119,
      F9: 120,
      F10: 121,
      F11: 122,
      F12: 123,
      F13: 124,
      F14: 125,
      F15: 126,
      NUM_LOCK: 144,
      SCROLL_LOCK: 145,
      SEMI_COLON: 186,
      EQUAL_SIGN: 187,
      COMMA: 188,
      DASH: 189,
      PERIOD: 190,
      FORWARD_SLASH: 191,
      GRAVE_ACCENT: 192,
      OPEN_BRACKET: 219,
      BACK_SLASH: 220,
      CLOSE_BRAKET: 221,
      SINGLE_QUOTE: 222
    })
    .constant('SCREENSIZES', {
      XS: 480,
      SM: 768,
      MD: 992,
      LG: 1200
    });
})();

/**
 * Created by pedro on 13/04/16.
 */
(function () {
  'use strict';

  angular.module('pl.dashboard', ['chart.js'])
    .directive('plDashboard', function () {
      return {
        restrict: 'E',
        scope: {
          source: '='
        },
        bindToController: true,
        templateUrl: '../source/pl-dashboard.html',
        controllerAs: 'ctrl',
        controller: /*@ngInject*/ ['$scope', '$q', '$filter', '$window', 'plCompsService', function ($scope, $q, $filter, $window, plCompsService) {
          var ctrl = this;
          var element = angular.element($window);

          ctrl.windowWidth = element.outerWidth();
          ctrl.data = {};

          ctrl.init = init;
          ctrl.load = load;
          ctrl.formatChart = formatChart;
          ctrl.formatData = formatData;
          ctrl.formatRight = formatRight;
          ctrl.getValue = getValue;
          ctrl.getTooltip = getTooltip;

          ctrl.init();

          /////////////

          function init() {
            ctrl.load();

            element.on('resize', function () {
              plCompsService.debounce(function () {
                ctrl.windowWidth = element.outerWidth();
              }, 500, 'plDashboard');
            });
          }

          function load() {
            if (ctrl.source) {
              $q.when(ctrl.source).then(function (data) {
                formatData(data);
              });
            }
          }

          function formatData(data) {
            var obj = {};
            if (data && !data.dashboard && data.data) {
              obj = data.data;
            }
            else {
              obj = data;
            }

            if (angular.isString(ctrl.data)) {
              obj = JSON.parse(obj);
            }

            if (obj.dashboard.type === 'chart') {
              obj = formatChart(obj);
            }

            ctrl.data = obj;
            return obj;
          }

          function formatChart(dataset) {
            var obj = {
              labels: [],
              series: [],
              data: [],
              options: {
                title: {
                  display: true,
                  text: dataset.dashboard.title,
                  fontSize: 16,
                  fontColor: '#333333'
                },
                /*legend: {
                  display: false,
                  labels: {}
                },*/
                scales: {
                  yAxes: [
                    {
                      type: 'linear',
                      display: true,
                      gridLines: {
                        display: true,
                        offsetGridLines: true
                      },
                      ticks: {
                        scaleBeginAtZero: false
                      }
                    }
                  ],
                  xAxes: [
                    {
                      //id: 'x-axis-0',
                      display: true,
                      gridLines: {
                        display: false,
                        offsetGridLines: true
                      },
                      barPercentage: 0.7
                    }
                  ]
                }
              },
              datasetOverride: [
                {
                  fill: true,
                  borderWidth: 1,
                  borderColor: '#62a8ea',
                  backgroundColor: '#62a8ea',
                  fontColor: '#000000',
                  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
                },
                {
                  fill: true,
                  borderWidth: 1,
                  borderColor: '#46be8a',
                  backgroundColor: '#46be8a',
                  fontColor: '#000000',
                  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
                }
              ]
            };

            var i;
            var data;
            var lastSerie = -1;
            for (i = 0; i < dataset.data.length; i++) {
              var item = dataset.data[i];
              if (item.serie !== 0) {
                if (lastSerie !== item.serie) {
                  data = [];
                  obj.data.push(data);
                  var serie = {type: item.type, label: item.title};
                  obj.datasetOverride.push(serie);
                  obj.series.push(item.title);
                }

                data.push(item.value ? item.value : 0);
                if (item.serie === 1) {
                  obj.labels.push(item.label);
                }
              }
              lastSerie = item.serie;
            }
            obj.dashboard = dataset.dashboard;
            return obj;
          }

          function formatRight(value) {
            return angular.isNumber(value);
          }

          function getValue(value) {
            if (angular.isNumber(value)) {
              return $filter('number')(value, 2);
            }
            return value;
          }

          function getTooltip(value) {
            if (!value || angular.isNumber(value)) {
              return '';
            }
            if (ctrl.windowWidth <= 1440 && value.length > 50) {
              return value;
            }
            else if (ctrl.windowWidth > 1440 && value.length > 90) {
              return value;
            }
            return '';
          }

          /////////////

          $scope.$watch(angular.bind(this, function () {
            return ctrl.source;
          }), function () {
            ctrl.load();
          });

          $scope.$on('$destroy', function () {
            element.off('resize');
          });
        }]
      };
    });
})();

/**
 * Created by pedro on 02/05/16.
 */
(function () {
  'use strict';

  var NUM_WEEK_DAYS = 7;
  var HOUR_NOON = 12;

  angular.module('pl.datepicker', ['pl.edit'])
    .component('plDatepicker', {
      require: {
        ngModel: 'ngModel',
        plEdit: '?^plEdit',
        plGroup: '?^plGroup'
      },
      bindings: {
        name: '@?',
        editClass: '<?',
        properties: '<?',
        disabledDates: '<?',
        markedDates: '<?',
        isDateDisabled: '<?',
        isDateMarked: '<?'
      },
      templateUrl: '../source/pl-datepicker.html',
      controller: ['$parse', '$document', '$attrs', '$element', '$timeout', 'plCompsService', 'plFormat', 'KEYCODE', function ($parse, $document, $attrs, $element, $timeout, plCompsService, plFormat, KEYCODE) { // jshint ignore:line
        var ctrl = this;
        var defaultOptions = {
          readonly: false,
          disabled: false,
          disallowInput: false,
          validate: true,
          todayEnabled: undefined,
          dayEnabled: undefined,
          validators: {
            required: {value: false}
          },
          events: {
            blur: undefined,
            focus: undefined,
            change: undefined,
            keydown: undefined,
            keypress: undefined,
            keyup: undefined,
            mousedown: undefined,
            mouseenter: undefined,
            mouseleave: undefined,
            mousemove: undefined,
            mouseover: undefined,
            mouseup: undefined
          }
        };

        ctrl.calendarOpened = false;
        ctrl.date = plCompsService.normalizeDate();
        ctrl.days = [];
        ctrl.dayNames = [];
        ctrl.viewValue = null;
        ctrl.dateValue = null;
        ctrl.options = {};
        ctrl.disabledDates = undefined;
        ctrl.markedDates = undefined;

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.$onDestroy = onDestroy;
        ctrl.handleChanges = handleChanges;
        ctrl.changedDisabledDates = changedDisabledDates;
        ctrl.changedMarkedDates = changedMarkedDates;
        ctrl.changedIsDateDisabled = changedIsDateDisabled;
        ctrl.changedIsDateMarked = changedIsDateMarked;
        ctrl.showCalendar = showCalendar;
        ctrl.closeCalendar = closeCalendar;
        ctrl.prevYear = prevYear;
        ctrl.prevMonth = prevMonth;
        ctrl.nextMonth = nextMonth;
        ctrl.nextYear = nextYear;
        ctrl.goToday = goToday;
        ctrl.selectDate = selectDate;
        ctrl.valueChange = valueChange;
        ctrl.onMouseEnter = onMouseEnter;
        ctrl.onMouseLeave = onMouseLeave;
        ctrl.onBlur = onBlur;
        ctrl.keydown = keydown;
        ctrl.updateComponent = updateComponent;
        ctrl.fnClickDocument = fnClickDocument;
        ctrl.fnClickElement = fnClickElement;
        ctrl.isTodayDisabled = isTodayDisabled;
        ctrl.dayToDate = dayToDate;
        ctrl.evaluateDay = evaluateDay;
        ctrl.isDayDisabled = isDayDisabled;
        ctrl.handleEvents = handleEvents;
        ctrl.clearEvents = clearEvents;
        ctrl.parseDateValue = parseDateValue;
        ctrl.setViewValue = setViewValue;
        ctrl.parseEvaluatedDates = parseEvaluatedDates;
        ctrl.fnIsDateDisabled = fnIsDateDisabled;
        ctrl.fnIsDateMarked = fnIsDateMarked;

        /////////////

        function setScopeValues() {
          ctrl.format = $attrs.format;
          ctrl.viewFormat = $attrs.viewFormat || plFormat.format.momentDate;
          ctrl.dateMask = ctrl.viewFormat;
          ctrl.firstWeekDaySunday = $parse($attrs.firstWeekDaySunday)(ctrl) || false;
          ctrl.placeholder = $attrs.placeholder || ctrl.viewFormat;
          if (!ctrl.editClass) {
            ctrl.editClass = {};
          }
        }

        function generateCalendar(momDate) {
          var date = momDate.clone();
          var lastDayOfMonth = date.endOf('month').date();
          var month = date.month();
          var year = date.year();
          var n = 1;
          var todayDay = plCompsService.normalizeDate();
          var todayDecoded = {
            day: todayDay.date(),
            month: todayDay.month(),
            year: todayDay.year()
          };
          var selectedDecoded;

          if (ctrl.viewValue) {
            var selMom = ctrl.parseDateValue(ctrl.viewValue);
            selectedDecoded = {
              day: selMom.date(),
              month: selMom.month(),
              year: selMom.year()
            };
          }

          var firstWeekDay = ctrl.firstWeekDaySunday === true ? date.set('date', 2).day() : date.set('date', 1).day();
          if (firstWeekDay !== 1) {
            n -= firstWeekDay - 1;
          }

          // Code to fix date issue
          if (n === 2) {
            n = -5;
          }

          ctrl.dateValue = date.format('MMMM YYYY');
          ctrl.days = [];
          var sameMonthAndYear = (todayDecoded.month === month && todayDecoded.year === year);
          for (var i = n; i <= lastDayOfMonth; i++) {
            var newDay = i > 0 ? {
                day: i,
                month: month + 1,
                year: year,
                isToday: sameMonthAndYear && todayDecoded.day === i,
                selectedDay: selectedDecoded && selectedDecoded.day === i && selectedDecoded.month === month && selectedDecoded.year === year,
                disabled: false,
                marked: false
              }
              : {day: undefined, month: undefined, year: undefined, isToday: false, selectedDay: false, disabled: true, marked: false};
            ctrl.evaluateDay(newDay);
            ctrl.days.push(newDay);
          }
        }

        function generateDayNames() {
          for (var i = 0; i < NUM_WEEK_DAYS; i++) {
            ctrl.dayNames.push(plCompsService.normalizeDate().weekday(i).format('ddd'));
          }
        }

        function init() {
          ctrl.handleChanges();
          setScopeValues(ctrl, $attrs);
          generateDayNames();

          if (ctrl.plEdit) {
            ctrl.plEdit.addComponent(ctrl);
            if (ctrl.plEdit.options) {
              _.merge(defaultOptions, ctrl.plEdit.options);
            }
          }
          ctrl.options = _.merge({}, defaultOptions, ctrl.properties);
          ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;

          ctrl.ngModel.$render = function () {
            var newValue = ctrl.ngModel.$viewValue;
            if (angular.isDefined(newValue) && newValue !== '') {
              ctrl.date = plCompsService.normalizeDate(newValue);
              ctrl.setViewValue(ctrl.date);
              ctrl.dateValue = newValue;
            }
          };
        }

        function onChanges(changes) {
          if (changes.disabledDates && !changes.disabledDates.isFirstChange()) {
            ctrl.changedDisabledDates(changes.disabledDates.currentValue);
          }
          if (changes.markedDates && !changes.markedDates.isFirstChange()) {
            ctrl.changedMarkedDates(changes.markedDates.currentValue);
          }
          if (changes.isDateDisabled && !changes.isDateDisabled.isFirstChange()) {
            ctrl.changedIsDateDisabled(changes.isDateDisabled.currentValue);
          }
          if (changes.isDateMarked && !changes.isDateMarked.isFirstChange()) {
            ctrl.changedIsDateMarked(changes.isDateMarked.currentValue);
          }
        }

        function onDestroy() {
          // Clears binds when scope is destroyed
          ctrl.clearEvents();
          if (ctrl.plGroup) {
            ctrl.plGroup.removeEdit(ctrl.name);
          }
          if (ctrl.plInlineEdit) {
            ctrl.plInlineEdit.removeEdit(ctrl.name);
          }
        }

        function handleChanges() {
          ctrl.changedDisabledDates(ctrl.disabledDates);
          ctrl.changedMarkedDates(ctrl.markedDates);
          ctrl.changedIsDateDisabled(ctrl.isDateDisabled);
          ctrl.changedIsDateMarked(ctrl.isDateMarked);
        }

        function changedDisabledDates(value) {
          ctrl.disabledDates = value || ctrl.options.disabledDates || undefined;
          if (ctrl.disabledDates) {
            ctrl.disabledDates = ctrl.parseEvaluatedDates(ctrl.disabledDates);
          }
        }

        function changedMarkedDates(value) {
          ctrl.markedDates = value || ctrl.options.markedDates || undefined;
          if (ctrl.markedDates) {
            ctrl.markedDates = ctrl.parseEvaluatedDates(ctrl.markedDates);
          }
        }

        function changedIsDateDisabled(value) {
          ctrl.isDateDisabled = value;
          if (!angular.isFunction(ctrl.isDateDisabled)) {
            ctrl.isDateDisabled = ctrl.options.isDateDisabled;
          }
          if (!angular.isFunction(ctrl.isDateDisabled)) {
            ctrl.isDateDisabled = undefined;
          }
        }

        function changedIsDateMarked(value) {
          ctrl.isDateMarked = value;
          if (!angular.isFunction(ctrl.isDateMarked)) {
            ctrl.isDateMarked = ctrl.options.isDateMarked;
          }
          if (!angular.isFunction(ctrl.isDateMarked)) {
            ctrl.isDateMarked = undefined;
          }
        }

        function showCalendar() {
          if (ctrl.calendarOpened || ctrl.options.disabled || ctrl.options.readonly) {
            return;
          }
          ctrl.calendarOpened = true;
          generateCalendar(ctrl.date);
          ctrl.handleEvents();
        }

        function closeCalendar() {
          ctrl.calendarOpened = false;
          ctrl.clearEvents();
        }

        function prevYear() {
          ctrl.date.subtract(1, 'Y');
          generateCalendar(ctrl.date);
        }

        function prevMonth() {
          ctrl.date.subtract(1, 'M');
          generateCalendar(ctrl.date);
        }

        function nextMonth() {
          ctrl.date.add(1, 'M');
          generateCalendar(ctrl.date);
        }

        function nextYear() {
          ctrl.date.add(1, 'Y');
          generateCalendar(ctrl.date);
        }

        function goToday() {
          ctrl.date = plCompsService.normalizeDate();
          generateCalendar(ctrl.date);
          ctrl.selectDate(ctrl.date);
        }

        function selectDate(date, event) {
          if (event) {
            event.preventDefault();
          }
          if (date.disabled) {
            return;
          }
          var selectedDate;
          if (date instanceof moment) {
            selectedDate = date;
            selectedDate.set({hour: 12, minute: 0});
          }
          else {
            selectedDate = plCompsService.normalizeDate(moment.utc(date.day + '.' + date.month + '.' + date.year + ' 12:00', 'DD.MM.YYYY HH:mm'));
          }
          ctrl.ngModel.$setViewValue(selectedDate.toISOString());
          ctrl.setViewValue(selectedDate);
          ctrl.closeCalendar();
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.change)) {
            ctrl.options.events.change(selectedDate.toISOString(), event);
          }
        }

        function valueChange(value, event) {
          var date = ctrl.parseDateValue(value);
          if (date.isValid()) {
            date = plCompsService.normalizeDate(date);
            generateCalendar(date);
            if (ctrl.plEdit) {
              ctrl.plEdit.valueChanged(ctrl);
            }
            if (ctrl.options.events && angular.isFunction(ctrl.options.events.change)) {
              ctrl.options.events.change(date.toISOString(), event);
            }
          }
        }

        function onMouseEnter(event) {
          ctrl.isMouseIn = true;
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.mouseenter)) {
            ctrl.options.events.mouseenter(ctrl.viewValue, event);
          }
        }

        function onMouseLeave() {
          ctrl.isMouseIn = false;
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.mouseleave)) {
            ctrl.options.events.mouseleave(ctrl.viewValue, event);
          }
        }

        function onBlur(event) {
          if (!ctrl.isMouseIn) {
            var date = ctrl.parseDateValue(ctrl.viewValue);
            if (date.isValid()) {
              ctrl.selectDate(date);
            }
            ctrl.closeCalendar();
          }
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.blur)) {
            ctrl.options.events.blur(ctrl.viewValue, event);
          }
        }

        function keydown(event) {
          if (event.which === KEYCODE.ENTER || event.which === KEYCODE.TAB) {
            var date = ctrl.parseDateValue(ctrl.viewValue);
            if (date.isValid()) {
              generateCalendar(date);
              ctrl.selectDate(date);
            }
          }
          if (angular.isFunction(ctrl.options.events.keydown)) {
            ctrl.options.events.keydown(ctrl.viewValue, event);
          }
        }

        function updateComponent(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties, properties);
            ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
          }
        }

        function fnClickDocument() {
          ctrl.closeCalendar();
        }

        function fnClickElement(event) {
          event.stopPropagation();
        }

        function dayToDate(day) {
          return moment(day.day + '.' + day.month + '.' + day.year + ' 00:00:00:000', 'DD.MM.YYYY  HH:mm:ss:SSS');
        }

        function evaluateDay(day) {
          if (!angular.isNumber(day.day) || !angular.isNumber(day.month) || !angular.isNumber(day.year)) {
            return;
          }
          var date = ctrl.dayToDate(day);
          day.disabled = ctrl.fnIsDateDisabled(date);
          day.marked = ctrl.fnIsDateMarked(date);
        }

        function isTodayDisabled() {
          if (ctrl.options && angular.isFunction(ctrl.options.todayEnabled)) {
            return !ctrl.options.todayEnabled(ctrl.date);
          }
          return false;
        }

        function isDayDisabled(date) {
          var enabled = !date.enabled;
          if (ctrl.options && angular.isFunction(ctrl.options.dayEnabled)) {
            var mDate = ctrl.date.clone();
            mDate.set('date', date.day);
            return enabled || !ctrl.options.dayEnabled(mDate, ctrl.ngModel.$viewValue);
          }
          return enabled;
        }

        function handleEvents() {
          $timeout(function () {
            // Click anywhere but the element: closes timer
            angular.element($document).on('click', ctrl.fnClickDocument);

            // Click these elements: timer stays open
            $element.find('div.pl-datepicker, a.btnShowDatePicker').on('click', ctrl.fnClickElement);
          });
        }

        function clearEvents() {
          angular.element($document).off('click', ctrl.fnClickDocument);
          $element.find('div.pl-datepicker, a.btnShowDatePicker').off('click', ctrl.fnClickElement);
        }

        function parseDateValue(value) {
          return moment(value, [
            ctrl.viewFormat,
            'DD-MM-YYYY',
            'DD/MM/YYYY',
            'DDMMYYYY',
            'YYYY-MM-DD',
            'YYYY/MM/DD',
            'YYYYMMDD'
          ]).hours(HOUR_NOON).minutes(0).seconds(0).milliseconds(0);
        }

        function setViewValue(date) {
          if (date) {
            date = plCompsService.normalizeDate(date);
            ctrl.viewValue = date.format(ctrl.viewFormat);
          }
          else {
            ctrl.viewValue = '';
          }
        }

        function parseEvaluatedDates(evaluatedDates) {
          var result = {};
          var myDate;
          if (moment.isMoment(evaluatedDates) && evaluatedDates.isValid()) {
            result[evaluatedDates.toISOString()] = true;
          }
          else if (angular.isArray(evaluatedDates)) {
            for (var i = 0; i < evaluatedDates.length; i++) {
              var date = evaluatedDates[i];
              myDate = moment.isMoment(date) ? date : moment(date);
              if (myDate.isValid()) {
                result[myDate.toISOString()] = true;
              }
            }
          }
          else if (angular.isObject(evaluatedDates)) {
            for (var key in evaluatedDates) {
              if (Object.prototype.hasOwnProperty.call(evaluatedDates, key)) {
                myDate = moment(key);
                if (myDate.isValid()) {
                  var value = evaluatedDates[key];
                  if (typeof value === 'boolean') {
                    result[key] = value;
                  }
                }
              }
            }
          }
          return result;
        }

        function fnIsDateDisabled(date) {
          var myDate = date.clone();
          var normalizedDate = myDate.toISOString();
          var disabled = ctrl.disabledDates ? ctrl.disabledDates[normalizedDate] : false;
          if (typeof disabled !== 'boolean') {
            disabled = false;
          }
          if (angular.isFunction(ctrl.isDateDisabled)) {
            disabled = ctrl.isDateDisabled(myDate, normalizedDate);
          }
          return disabled;
        }

        function fnIsDateMarked(date) {
          var myDate = date.clone();
          var normalizedDate = myDate.toISOString();
          var marked = ctrl.markedDates ? ctrl.markedDates[normalizedDate] : false;
          if (typeof marked !== 'boolean') {
            marked = false;
          }
          if (angular.isFunction(ctrl.isDateMarked)) {
            marked = ctrl.isDateMarked(myDate, normalizedDate);
          }
          return marked;
        }
      }]
    });
})();

(function () {
  'use strict';

  // Adapted from https://github.com/avianey/jqDoubleScroll

  angular.module('pl.comps')
    .directive('cgDoubleScroll', ['$window', '$parse', '$timeout', function ($window, $parse, $timeout) {
      return {
        restrict: 'A',
        link: function ($scope, $element, $attrs) {
          var eventScroll = 'scroll';
          var eventResize = 'resize';
          var TEMPLATES = Object.freeze({
            pltable: {
              contentElement: 'pl-table table.table',
              contentScroll: 'pl-table .table-responsive'
            }
          });

          $scope.cgDoubleScrollTimeout = null;

          function getTopScrollBar($self) {
            return $self.prev($scope.doubleScrollOptions.topScrollBarWrapperSelector);
          }

          function getBottomScrollBar($self) {
            var scrollbar = $self;
            if (angular.isDefined($scope.doubleScrollOptions.contentScroll) && $self.find($scope.doubleScrollOptions.contentScroll).length !== 0) {
              scrollbar = $self.find($scope.doubleScrollOptions.contentScroll);
            }
            return scrollbar;
          }

          function upperToBottomScrollHandler(event) {
            var $self = angular.element(event.target);
            var $bottomScrollBar = getBottomScrollBar($element);
            $bottomScrollBar.scrollLeft($self.scrollLeft());
          }

          function bottomToUpperScrollHandler(event) {
            var $self = angular.element(event.target);
            var $topScrollBar = getTopScrollBar($element);
            $topScrollBar.scrollLeft($self.scrollLeft());
          }

          function parseOptions(properties) {
            var options = $parse(properties)($scope);
            if (properties && (angular.isUndefined(options) && !angular.isObject(properties) || angular.isString(options))) {
              $scope.doubleScrollOptions = parseOptions(TEMPLATES[properties.toLowerCase()]);
            }
            else {
              $scope.doubleScrollOptions = _.merge({}, {
                contentElement: '>:first-child', // Widest element, if not specified first child element will be used
                contentScroll: undefined, // Element to bind scroll to (by default it's the self element itself)
                scrollCss: {
                  'overflow-x': 'auto',
                  'overflow-y': 'hidden'
                },
                contentCss: {
                  'overflow-x': 'auto',
                  'overflow-y': 'hidden'
                },
                onlyIfScroll: false, // top scrollbar is not shown if the bottom one is not present
                resetOnWindowResize: true, // recompute the top ScrollBar requirements when the window is resized
                timeToWaitForResize: 50 // wait for the last update event (usefull when browser fire resize event constantly during ressing)
              }, properties, { // private properties
                topScrollBarMarkup: '<div class="doubleScroll-scroll-wrapper scroll-size">' +
                  '  <div class="doubleScroll-scroll scroll-size"></div>' +
                  '</div>',
                topScrollBarWrapperSelector: '.doubleScroll-scroll-wrapper',
                topScrollBarInnerSelector: '.doubleScroll-scroll'
              });
            }
            return $scope.doubleScrollOptions;
          }

          function showScrollBar($self, options) {
            if (options.onlyIfScroll && $self.get(0).scrollWidth <= $self.width()) {
              // content doesn't scroll
              // remove any existing occurrence...
              $self.prev(options.topScrollBarWrapperSelector).remove();
              return;
            }

            // add div that will act as an upper scroll only if not already added to the DOM
            var $topScrollBar = $self.prev(options.topScrollBarWrapperSelector);
            if ($topScrollBar.length === 0) {
              // creating the scrollbar
              // added before in the DOM
              $topScrollBar = angular.element(options.topScrollBarMarkup);
              $self.before($topScrollBar);

              // apply the css
              $topScrollBar.css(options.scrollCss);
              $self.css(options.contentCss);

              // bind upper scroll to bottom scroll
              $topScrollBar.on(eventScroll, upperToBottomScrollHandler);

              // bind bottom scroll to upper scroll
              var scrollTarget = $self;
              if (angular.isDefined(options.contentScroll) && $self.find(options.contentScroll).length !== 0) {
                scrollTarget = $self.find(options.contentScroll);
              }
              scrollTarget.on(eventScroll, bottomToUpperScrollHandler);
            }

            // find the content element (should be the widest one)
            var $contentElement = $self.find(options.contentElement);

            // set the width of the wrappers
            angular.element(options.topScrollBarInnerSelector, $topScrollBar).width($contentElement.outerWidth());
            $topScrollBar.width($self.width());
            $topScrollBar.scrollLeft($self.scrollLeft());
          }

          function resizeHandler() {
            // adding/removing/replacing the scrollbar might resize the window
            // so the resizing flag will avoid the infinite loop here...
            $timeout.cancel($scope.cgDoubleScrollTimeout);
            $scope.cgDoubleScrollTimeout = $timeout(function () {
              showScrollBar($element, $scope.doubleScrollOptions);
            }, $scope.doubleScrollOptions.timeToWaitForResize);
          }

          function run(properties) {
            parseOptions(properties);
            showScrollBar($element, $scope.doubleScrollOptions);

            // bind the resize handler
            // do it once
            if ($scope.doubleScrollOptions.resetOnWindowResize) {
              angular.element($window).on(eventResize, resizeHandler);
              new ResizeSensor($element.find($scope.doubleScrollOptions.contentElement), resizeHandler);
            }
          }

          // Start directive (inside timeout to wait for template loading)
          $timeout(function () {
            $attrs.$observe('cgDoubleScroll', run);
            $scope.$on('$destroy', function () {
              // unbind resize events
              angular.element($window).off(eventResize, resizeHandler);
              ResizeSensor.detach($element.find($scope.doubleScrollOptions.contentElement));

              // unbind bottom scroll to upper scroll
              $element.off(eventScroll, bottomToUpperScrollHandler);

              // unbind upper scroll to bottom scroll
              getTopScrollBar($element).on(eventScroll, upperToBottomScrollHandler);
            });
          });
        }
      };
    }]);
})();

/**
 * Created by pedro on 04/01/17.
 */
(function () {
  'use strict';

  angular.module('pl.edit')
    .directive('plEdit', function () {
      return {
        require: {
          ngModel: '^ngModel',
          plGroup: '?^plGroup',
          plInlineEdit: '?^plInlineEdit'
        },
        scope: {
          type: '@?',
          name: '@?',
          label: '@?',
          editClass: '<?',
          properties: '<?'
        },
        bindToController: true,
        transclude: true,
        controllerAs: '$ctrl',
        controller: /*@ngInject*/ ['$scope', '$compile', '$element', '$sce', '$transclude', 'plEdit', 'plCompsService', function ($scope, $compile, $element, $sce, $transclude, plEdit, plCompsService) {
          var ctrl = this;
          var lastType;
          var defaultOptions = {
            visible: true
          };

          ctrl.options = {};
          ctrl.components = [];
          ctrl.validator = null;
          ctrl.transcludedContent = null;

          ctrl.$onInit = init;
          ctrl.$onChanges = onChanges;
          ctrl.$doCheck = doCheck;
          ctrl.$onDestroy = onDestroy;
          ctrl.buildTemplate = buildTemplate;
          ctrl.read = read;
          ctrl.addComponent = addComponent;
          ctrl.removeComponent = removeComponent;
          ctrl.addValidator = addValidator;
          ctrl.removeValidator = removeValidator;
          ctrl.updateEdit = updateEdit;
          ctrl.valueChanged = valueChanged;

          /////////////

          function init() {
            if (!ctrl.ngModel) {
              return;
            }

            if (ctrl.plGroup) {
              ctrl.plGroup.addEdit(ctrl);
              if (ctrl.plGroup.options) {
                _.merge(defaultOptions, ctrl.plGroup.options);
              }
            }
            if (ctrl.plInlineEdit) {
              ctrl.plInlineEdit.addEdit(ctrl);
              if (ctrl.plInlineEdit.options) {
                _.merge(defaultOptions, ctrl.plInlineEdit.options);
              }
            }
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties);

            ctrl.ngModel.$render = function () {
              ctrl.value = ctrl.ngModel.$viewValue;
            };
          }

          function onChanges(plEdit) {
            if (plEdit) {
              var plEditOptions = angular.copy(defaultOptions);
              if (ctrl.options) {
                _.merge(plEditOptions, ctrl.options);
              }
              if (plEdit.options) {
                _.merge(plEditOptions, plEdit.options.currentValue);
              }
              if (plEdit.properties) {
                _.merge(plEditOptions, plEdit.properties.currentValue);
              }
              if (ctrl.properties) {
                _.merge(plEditOptions, ctrl.properties);
              }
              ctrl.options = _.merge({}, ctrl.options, plEditOptions);

              for (var i = 0; i < ctrl.components.length; i++) {
                var edit = ctrl.components[i];
                edit.updateComponent(plEditOptions);
              }
              if (ctrl.validator && plEditOptions.validators) {
                ctrl.validator.updateValidator(plEditOptions.validators);
              }

              if (plEdit.type) {
                ctrl.buildTemplate();
              }
              if (plEdit.name) {
                var name = plEdit.name.currentValue;
                if (angular.isUndefined(name) || !name || !name.trim().length) {
                  name = plCompsService.generateName(ctrl.name, 'plEdit');
                }
                ctrl.name = name;
              }
            }
          }

          function doCheck() {
            if (ctrl.validator) {
              ctrl.validator.checkGroupError();
            }
          }

          function onDestroy() {
            if (ctrl.plGroup) {
              ctrl.plGroup.removeEdit(ctrl.name);
            }
            if (ctrl.plInlineEdit) {
              ctrl.plInlineEdit.removeEdit(ctrl.name);
            }
            ctrl.removeValidator();
          }

          function buildTemplate(transcludedContent) {
            if (transcludedContent) {
              ctrl.transcludedContent = angular.element(transcludedContent).clone();
            }
            if (lastType === ctrl.type) {
              return;
            }

            var edit = plEdit.getEdit(ctrl.type);
            var template = angular.element(edit.template);
            if (edit.properties) {
              _.merge(defaultOptions, edit.properties);
            }

            if (!ctrl.plInlineEdit && template.attr('pl-auto-class') === 'true' && !ctrl.editClass && ctrl.plGroup && ctrl.plGroup.innerEditClass) {
              ctrl.editClass = ctrl.plGroup.innerEditClass;
            }

            $element.empty();
            if (ctrl.transcludedContent && ctrl.transcludedContent.length) {
              template.append(ctrl.transcludedContent);
            }
            $element.append(template);
            $compile($element.contents())($scope);

            ctrl.read();
          }

          function read() {
            ctrl.ngModel.$setViewValue(ctrl.value);
            ctrl.ngModel.$commitViewValue();
          }

          function addComponent(component) {
            component.name = plCompsService.generateName(component.name, 'plEdit');
            ctrl.components.push(component);
          }

          function removeComponent(name) {
            for (var i = 0; i < ctrl.components.length; i++) {
              if (ctrl.components[i].name === name) {
                ctrl.components.splice(i, 1);
                break;
              }
            }
          }

          function addValidator(validator) {
            if (validator && validator !== ctrl.validator) {
              ctrl.validator = validator;
            }
          }

          function removeValidator() {
            if (ctrl.validator) {
              ctrl.validator = null;
            }
          }

          function updateEdit(properties) {
            if (properties && properties !== ctrl.options) {
              ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties, properties);
              ctrl.$onChanges({options: {currentValue: ctrl.options}});
            }
          }

          function valueChanged(component) {
            if (ctrl.plGroup) {
              ctrl.plGroup.valueChanged(component);
            }
            if (ctrl.plInlineEdit) {
              ctrl.plInlineEdit.valueChanged(component);
            }
          }
        }],
        link: function ($scope, $element, $attrs, $ctrl, transcludeFn) {
          var ctrl = $scope.$ctrl;
          transcludeFn($scope, function (clone) {
            ctrl.buildTemplate(clone);
          });
        }
      };
    });
})();

/**
 * Created by pedro on 04/01/17.
 */
(function () {
  'use strict';

  angular.module('pl.edit')
    .component('plButton', {
      bindings: {
        type: '@?',
        class: '@?',
        name: '@?',
        text: '@?',
        onClick: '&?',
        tooltip: '<?',
        ngDisabled: '<?',
        properties: '<?'
      },
      transclude: true,
      templateUrl: '../source/pl-edit-button.html',
      controllerAs: 'ctrl',
      controller: /*@ngInject*/ ['plLocale', function (plLocale) {
        var ctrl = this;
        var defaultOptions = {
          type: 'button',
          class: '',
          text: ''
        };

        ctrl.options = {};

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.handleOptions = handleOptions;

        /////////////

        function init() {
          ctrl.type = ctrl.type || 'button';
          ctrl.class = ctrl.class || 'btn-default';
          ctrl.text = ctrl.text || plLocale.locales.btn.submit;
          ctrl.handleOptions();
        }

        function onChanges(button) {
          if (button) {
            if (button.properties && !button.properties.isFirstChange()) {
              ctrl.handleOptions(button.properties.currentValue);
            }
          }
        }

        function handleOptions(options) {
          options = options || ctrl.properties;
          ctrl.options = _.merge({}, defaultOptions, options);
          if (ctrl.options.class && ctrl.options.class !== ctrl.class) {
            ctrl.class = ctrl.options.class;
          }
          if (ctrl.options.type && ctrl.options.type !== ctrl.type) {
            ctrl.type = ctrl.options.type;
          }
          if (ctrl.options.tooltip && !angular.equals(ctrl.options.tooltip, ctrl.tooltip)) {
            ctrl.tooltip = ctrl.options.tooltip;
          }
          if (ctrl.options.text && ctrl.options.text !== ctrl.text) {
            ctrl.text = ctrl.options.text;
          }
        }
      }]
    })
    .directive('clickOnEnter', ['KEYCODE', function (KEYCODE) {
      return {
        restrict: 'A',
        link: function ($scope, $element) {
          function eventHandler(event) {
            if (event.which === KEYCODE.ENTER) {
              $element.triggerHandler('click');
            }
          }

          $element.on('keydown', eventHandler);

          $scope.$on('$destroy', function () {
            $element.off('keydown', eventHandler);
          });
        }
      };
    }]);
})();

/**
 * Created by pedro on 04/01/17.
 */
(function () {
  'use strict';

  angular.module('pl.edit')
    .component('plEditCheckbox', {
      require: {
        ngModel: 'ngModel',
        plForm: '?^plForm',
        plEdit: '?^plEdit'
      },
      bindings: {
        name: '@?',
        label: '@?',
        trueValue: '<?',
        falseValue: '<?',
        properties: '<?'
      },
      templateUrl: '../source/pl-edit-checkbox.html',
      controller: /*@ngInject*/ ['$q', function ($q) {
        var ctrl = this;
        var defaultOptions = {
          label: '',
          trueValue: true,
          falseValue: false,
          readonly: false,
          disabled: false,
          validate: true,
          validators: {
            required: {value: false}
          },
          events: {
            beforeChange: undefined,
            afterChange: undefined
          }
        };

        ctrl.options = {};

        ctrl.$onInit = init;
        ctrl.$onDestroy = onDestroy;
        ctrl.render = render;
        ctrl.toggleValue = toggleValue;
        ctrl.updateComponent = updateComponent;

        /////////////


        function init() {
          if (!ctrl.editClass) {
            ctrl.editClass = {};
          }

          if (ctrl.plEdit) {
            ctrl.plEdit.addComponent(ctrl);
            if (ctrl.plEdit.options) {
              _.merge(defaultOptions, ctrl.plEdit.options);
            }
          }
          ctrl.options = _.merge({}, defaultOptions, ctrl.properties);
          ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;

          if (ctrl.label) {
            ctrl.options.label = ctrl.label;
          }
          if (ctrl.trueValue || ctrl.trueValue === 0) {
            ctrl.options.trueValue = ctrl.trueValue;
          }
          if (ctrl.falseValue || ctrl.falseValue === 0) {
            ctrl.options.falseValue = ctrl.falseValue;
          }

          ctrl.ngModel.$render = function () {
            ctrl.value = !!ctrl.ngModel.$viewValue;
          };

          if (ctrl.options.validate && ctrl.options.validators.required.value === true) {
            ctrl.ngModel.$validators.required = function () {
              return angular.isDefined(ctrl.value) && ctrl.value !== null;
            };
          }
        }

        function onDestroy() {
          if (ctrl.plEdit) {
            ctrl.plEdit.removeComponent(ctrl.name);
          }
        }

        function render() {
          var value = ctrl.value ? ctrl.options.trueValue : ctrl.options.falseValue;
          ctrl.ngModel.$setViewValue(value);
          if (ctrl.plEdit) {
            ctrl.plEdit.valueChanged(ctrl);
          }
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.afterChange)) {
            ctrl.options.events.afterChange(ctrl, ctrl.plForm, value);
          }
        }

        function toggleValue() {
          var promise = null;
          if (angular.isFunction(ctrl.options.events.beforeChange)) {
            promise = ctrl.options.events.beforeChange(ctrl, ctrl.plForm);
          }
          $q.when(promise).then(function () {
            ctrl.value = !ctrl.value;
            ctrl.render();
          });
        }

        function updateComponent(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties, properties);
            ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;

            if (ctrl.label) {
              ctrl.options.label = ctrl.label;
            }
            if (ctrl.trueValue || ctrl.trueValue === 0) {
              ctrl.options.trueValue = ctrl.trueValue;
            }
            if (ctrl.falseValue || ctrl.falseValue === 0) {
              ctrl.options.falseValue = ctrl.falseValue;
            }
          }
        }
      }]
    });
})();

/**
 * Created by pedro on 04/01/17.
 */
(function () {
  'use strict';

  angular.module('pl.edit')
    .component('plEditEmail', {
      templateUrl: '../source/pl-edit-email.html',
      require: {
        ngModel: 'ngModel',
        plForm: '?^plForm',
        plGroup: '?^plGroup',
        plEdit: '?^plEdit'
      },
      bindings: {
        name: '@?',
        editClass: '<?',
        properties: '<?'
      },
      transclude: {
        inputGroup: '?inputGroup'
      },
      controller: /*@ngInject*/ ['$element', '$transclude', '$sce', function ($element, $transclude, $sce) {
        var ctrl = this;
        var defaultOptions = {
          readonly: false,
          disabled: false,
          disallowInput: false,
          validate: true,
          raw: false,
          inputGroup: $sce.trustAsHtml('<i class="fa fa-fw" ng-class="$ctrl.options.inputGroupIcon"></i>'),
          inputGroupIcon: '',
          validators: {
            minlength: {value: null},
            maxlength: {value: null},
            required: {value: false},
            pattern: {value: null}
          },
          events: {
            blur: undefined,
            focus: undefined,
            change: undefined,
            keydown: undefined,
            keypress: undefined,
            keyup: undefined,
            mousedown: undefined,
            mouseenter: undefined,
            mouseleave: undefined,
            mousemove: undefined,
            mouseover: undefined,
            mouseup: undefined,
            inputGroup: undefined
          }
        };

        ctrl.options = {};

        ctrl.$onInit = init;
        ctrl.$onDestroy = onDestroy;
        ctrl.render = render;
        ctrl.updateComponent = updateComponent;

        /////////////

        function init() {
          if (ctrl.plEdit) {
            ctrl.plEdit.addComponent(ctrl);
            if (ctrl.plEdit.options) {
              _.merge(defaultOptions, ctrl.plEdit.options);
            }
          }
          ctrl.options = _.merge({}, defaultOptions, ctrl.properties);
          ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
          ctrl.hasGroup = angular.isDefined(ctrl.options.hasGroup) ? ctrl.options.hasGroup && $transclude.isSlotFilled('inputGroup') : $transclude.isSlotFilled('inputGroup');

          ctrl.ngModel.$render = function () {
            ctrl.value = ctrl.ngModel.$viewValue;
          };
        }

        function onDestroy() {
          if (ctrl.plEdit) {
            ctrl.plEdit.removeComponent(ctrl.name);
          }
        }

        function render() {
          ctrl.ngModel.$setViewValue(ctrl.value);
          if (ctrl.plEdit) {
            ctrl.plEdit.valueChanged(ctrl);
          }
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.change)) {
            ctrl.options.events.change(ctrl, ctrl.plForm, $element);
          }
        }

        function updateComponent(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties, properties);
            ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
            ctrl.hasGroup = angular.isDefined(ctrl.options.hasGroup) ? ctrl.options.hasGroup && $transclude.isSlotFilled('inputGroup') : $transclude.isSlotFilled('inputGroup');
          }
        }
      }]
    });
})();

/**
 * Created by pedro on 04/01/17.
 */
(function () {
  'use strict';

  angular.module('pl.edit')
    .directive('plForm', ['$log', function ($log) {
      return {
        restrict: 'E',
        require: {
          plNavWizardStep: '?^^plNavWizardStep'
        },
        scope: {
          model: '<?',
          class: '@?',
          name: '=?',
          onSubmit: '&?',
          definition: '<?',
          template: '<?',
          parent: '<?',
          properties: '<?'
        },
        bindToController: true,
        transclude: true,
        templateUrl: '../source/pl-edit-form.html',
        controllerAs: 'ctrl',
        controller: /*@ngInject*/ ['$compile', '$scope', '$element', '$timeout', '$filter', '$q', '$parse', 'plTranslate', 'plEdit', 'plCompsService', function ($compile, $scope, $element, $timeout, $filter, $q, $parse, plTranslate, plEdit, plCompsService) {
          var ctrl = this;
          var count = 0;
          var DEFAULTS = {};
          var propertiesToEvaluate = ['visible', 'disabled', 'readonly'];

          ctrl.plCompsConfig = {};
          ctrl.isNested = false;
          ctrl.groups = [];
          ctrl.builtFields = [];
          ctrl.formEvents = null;
          ctrl.plEditVerticalClasses = {};
          ctrl.originalDefinition = null;
          ctrl.debugEnabled = false;

          ctrl.$onInit = init;
          ctrl.$onChanges = onChanges;
          ctrl.addGroup = addGroup;
          ctrl.removeGroup = removeGroup;
          ctrl.buildForm = buildForm;
          ctrl.buildDefinition = buildDefinition;
          ctrl.handleFieldEvents = handleFieldEvents;
          ctrl.initFormNameModel = initFormNameModel;
          ctrl.addField = addField;
          ctrl.buildTemplate = buildTemplate;
          ctrl.handleTemplateItem = handleTemplateItem;
          ctrl.generateTemplateItem = generateTemplateItem;
          ctrl.generateTemplateItemDupes = generateTemplateItemDupes;
          ctrl.filterDefinitionFields = filterDefinitionFields;
          ctrl.orderFieldsList = orderFieldsList;
          ctrl.getModelValue = getModelValue;
          ctrl.submit = submit;
          ctrl.doEvaluate = doEvaluate;
          ctrl.valueChanged = valueChanged;

          /////////////

          function init() {
            ctrl.debugEnabled = plEdit.isDebugEnabled();
            ctrl.properties = ctrl.properties || {};
            ctrl.plCompsConfig = plCompsService.config();
            if (ctrl.plCompsConfig) {
              ctrl.plCompsConfig = ctrl.plCompsConfig.plEditForm;
              if (!ctrl.properties.orientation) {
                ctrl.properties.orientation = ctrl.plCompsConfig.orientation;
              }
            }

            if ($element.parents('form').length) {
              ctrl.isNested = true;
            }

            DEFAULTS.definition = {
              fields: [],
              events: {
                beforeSubmit: undefined,
                afterSubmit: undefined
              }
            };
            DEFAULTS.template = {
              orientation: ctrl.plCompsConfig.orientation || 'horizontal',
              items: [],
              events: {
                beforeSubmit: undefined,
                afterSubmit: undefined
              },
              /* Use this property to render missing template items which are defined in definition */
              addMissingFields: true
            };
            DEFAULTS.definitionField = {
              name: null,
              formName: undefined,
              type: 'text',
              caption: null,
              modelName: null,
              properties: {},
              validators: {},
              events: {
                blur: undefined,
                change: undefined,
                click: undefined,
                focus: undefined
              }
            };
            DEFAULTS.templateField = {
              type: 'field',
              order: null,
              field: {
                formName: undefined,
                order: null,
                caption: null,
                class: '',
                actions: null,
                placeholder: null,
                repeat: [],
                properties: {},
                validators: {},
                events: {
                  blur: undefined,
                  change: undefined,
                  click: undefined,
                  focus: undefined
                }
              },
              parentGroup: undefined
            };
            DEFAULTS.templateGroup = {
              type: 'group',
              fields: [],
              properties: {},
              order: null
            };

            if (ctrl.model || ctrl.definition) {
              if (!ctrl.model || !ctrl.definition) {
                throw new Error('If either model or definition properties are defined, both must be defined');
              }
              ctrl.buildForm();
              ctrl.valueChanged({});
            }
          }

          function onChanges(form) {
            if (form) {
              if (form.class) {
                if (angular.isString(ctrl.class)) {
                  ctrl.class = ctrl.class.split(' ');
                }
                if (!angular.isArray(ctrl.class)) {
                  if (ctrl.class) {
                    ctrl.class = [ctrl.class];
                  }
                  else {
                    ctrl.class = [];
                  }
                }

                if (!ctrl.properties || !ctrl.properties.orientation) {
                  if (!ctrl.properties) {
                    ctrl.properties = {};
                  }
                  ctrl.properties.orientation = plCompsService.config().plEditForm.orientation;
                }
                ctrl.class.push(ctrl.properties.orientation !== 'vertical' ? 'form-horizontal' : 'form-vertical');
              }
              if (form.properties) {
                for (var i = 0; i < ctrl.groups.length; i++) {
                  var group = ctrl.groups[i];
                  group.updateGroup(form.properties.currentValue);
                }
              }
              if (form.definition && !form.definition.isFirstChange()) {
                ctrl.buildDefinition(form.definition.currentValue);
              }
              if (form.template && !form.template.isFirstChange()) {
                ctrl.buildTemplate(form.template.currentValue);
              }
            }
          }

          function addGroup(group) {
            count++;
            group.name = group.name || 'plGroup' + count;
            ctrl.groups.push(group);
          }

          function removeGroup(name) {
            for (var i = 0; i < ctrl.groups.length; i++) {
              if (ctrl.groups[i].name === name) {
                ctrl.groups.splice(i, 1);
                break;
              }
            }
          }

          function buildForm() {
            if (!angular.isObject(ctrl.definition)) {
              throw new TypeError('Definition object must be of type Object');
            }
            var definition = _.merge({}, DEFAULTS.definition, ctrl.definition);
            ctrl.buildDefinition(definition);
          }

          function buildDefinition(definition) {
            if (!angular.isArray(definition.fields)) {
              throw new TypeError('Definition ``fields`` property must be of type Array');
            }

            angular.forEach(definition.fields, function (field, index) {
              field = _.merge({}, angular.copy(DEFAULTS.definitionField), field);
              if (field.validators) {
                field.properties.validators = field.validators;
              }
              if (field.events) {
                field.properties.events = field.events;
              }
              if (field.visible) {
                field.properties.visible = field.visible;
              }
              if (field.width) {
                field.properties.width = field.width;
              }
              if (field.properties.placeholder) {
                field.properties.placeholder = plTranslate.translate(field.properties.placeholder);
              }

              // Add support for parent evaluated event expressions
              ctrl.handleFieldEvents(field);

              // Adding ``modelName`` property for later use in field get ngModel function
              if (!field.modelName) {
                ctrl.initFormNameModel(field);
              }
              definition.fields[index] = field;
            });

            if (!ctrl.template || !ctrl.template.items || !ctrl.template.items.length) {
              if (!ctrl.template) {
                ctrl.template = angular.copy(DEFAULTS.template);
              }
              ctrl.template.addMissingFields = !!ctrl.template.addMissingFields;
              if (!ctrl.template.addMissingFields) {
                $log.warn('No template items are defined but definition rendering is off! Are you sure this is intentional?');
              }
            }

            ctrl.definition = definition;
            ctrl.originalDefinition = angular.copy(ctrl.definition);
            ctrl.buildTemplate(ctrl.template);
          }

          function handleFieldEvents(field) {
            if (!field.properties.events || !ctrl.parent) {
              return;
            }
            for (var event in field.properties.events) {
              if (field.properties.events.hasOwnProperty(event) && angular.isString(field.properties.events[event])) {
                field.properties.events[event] = (function (event) { // jshint ignore:line
                  var parentFn = ctrl.parent[field.properties.events[event]];
                  return function () {
                    return parentFn.apply(this, arguments);
                  };
                })(event); // jshint ignore:line
              }
            }
          }

          function initFormNameModel(field) {
            var index = 0;
            if (!field.name || field.name.trim() === '') {
              throw new TypeError('Invalid field name');
            }
            if (field.name.indexOf('.') !== -1) {
              index = field.name.lastIndexOf('.') + 1;
            }
            field.modelName = field.name.substring(index, field.name.length);
          }

          function addField(definitionField) {
            function findField(fields) {
              for (var i = 0; i < fields.length; i++) {
                var field = fields[i];
                if (field.fields) {
                  var fieldFromGroup = findField(field.fields);
                  if (fieldFromGroup) {
                    return fieldFromGroup;
                  }
                }
                else if (field.field.name === definitionField.name) {
                  return field;
                }
              }
              return undefined;
            }

            var field = findField(ctrl.builtFields);
            if (!field) {
              ctrl.builtFields.push(ctrl.generateTemplateItem({}, definitionField));
            }
          }

          function buildTemplate(template) {
            ctrl.template = _.merge({}, DEFAULTS.template, template);
            ctrl.definition = angular.copy(ctrl.originalDefinition);

            var index;
            if (ctrl.template.orientation === 'vertical') {
              index = ctrl.class.indexOf('form-horizontal');
              if (index !== -1) {
                ctrl.class.splice(ctrl.class.indexOf('form-horizontal'), 1);
              }
            }
            else {
              index = ctrl.class.indexOf('form-vertical');
              if (index !== -1) {
                ctrl.class.splice(ctrl.class.indexOf('form-vertical'), 1);
              }
            }

            // Keeping template events for posterior use
            ctrl.formEvents = angular.copy(ctrl.template.events);

            // Emptying builtFields array in case we're rebuilding our template
            ctrl.builtFields = [];
            var previousLength = ctrl.definition.fields.length;
            var i = -1;
            while (i < ctrl.definition.fields.length) {
              i++;
              var definitionField = ctrl.definition.fields[i];
              if (!definitionField) {
                break;
              }

              // Mapping template items with definition fields
              var returnObject = {
                newItem: {},
                found: false
              };
              for (var j = 0; j < ctrl.template.items.length; j++) {
                angular.extend(returnObject, ctrl.handleTemplateItem(ctrl.template.items[j], definitionField));
                if (returnObject.found) {
                  ctrl.builtFields.push(returnObject.newItem);
                }
              }

              // If no templateItem found and addMissingFields is enabled, we use definition field instead
              if (!returnObject.found && ctrl.template.addMissingFields) {
                ctrl.addField(definitionField);
              }

              if (previousLength !== ctrl.definition.fields.length) {
                i = -1;
                previousLength = ctrl.definition.fields.length;
              }
            }
            ctrl.builtFields = ctrl.orderFieldsList(ctrl.builtFields);
          }

          function handleTemplateItem(templateItem, definitionField) {
            var newItem = {};
            var found = false;
            if (templateItem) {
              // If templateItem isn't a group, treat it as a templateField
              if (templateItem.type !== 'group' && definitionField.name === templateItem.field) {
                found = true;
                ctrl.filterDefinitionFields(templateItem);
                newItem = ctrl.generateTemplateItem(templateItem, definitionField);
              }
              // When templateItem is a group
              else if (templateItem.type === 'group') {
                // Builds group object
                newItem = _.merge({}, angular.copy(DEFAULTS.templateGroup), templateItem);
                for (var i = 0; i < templateItem.fields.length; i++) {
                  var templateField = templateItem.fields[i];

                  // Get corresponding definition field, based on templateField
                  var filteredDefinitionField = ctrl.filterDefinitionFields(templateField);

                  /* Checking for length because when a field is found it gets spliced from the ``definition.fields`` list
                   * thus avoiding adding the same field in the overall fields list + in the group list */
                  if (!filteredDefinitionField.length) {
                    filteredDefinitionField = [definitionField];
                  }

                  // Set templateField's parentGroup
                  templateField.parentGroup = newItem;

                  // Use of recursive method to handle the recently found definition field
                  var returnObject = ctrl.handleTemplateItem(templateField, filteredDefinitionField[0]);

                  // Setting group object fields based on index
                  newItem.fields[i] = angular.copy(returnObject.newItem);
                  if (!found) {
                    found = returnObject.found;
                  }
                }
                newItem.fields = ctrl.orderFieldsList(newItem.fields);
              }
            }

            // returnObject
            return {
              newItem: newItem,
              found: found
            };
          }

          function generateTemplateItem(item, definition) {
            /* This is to avoid template rewriting definition type (such as when template as type: 'field' and thus
             * overwriting definition's type) */
            var fieldType = definition.type;

            /* Builds a templateField object based on defaults and merges any properties defined in both
             * the corresponding definition and template */
            var newItem = _.merge({}, angular.copy(DEFAULTS.templateField), item);
            newItem.field = _.merge({}, angular.copy(DEFAULTS.templateField.field), definition, item);
            newItem.field.properties.validators = newItem.field.validators;
            newItem.field.caption = plTranslate.translate(newItem.field.caption);
            newItem.field.type = fieldType;

            // Assign default formName is it isn't defined
            if (!newItem.field.formName) {
              newItem.field.formName = newItem.field.name;
            }

            // When makes sense, generate duped items (such as radio or checkboxes)
            newItem.field.repeat = ctrl.generateTemplateItemDupes(newItem);

            // Item orientation evaluation
            if (ctrl.template.orientation === 'vertical' || (newItem.parentGroup && newItem.parentGroup.orientation === 'vertical') ||
              newItem.orientation === 'vertical' || newItem.field.orientation === 'vertical') {
              newItem.field.properties.orientation = 'vertical';
              newItem.field.class += ' form-vertical';
            }
            else {
              newItem.field.class += ' form-horizontal';
            }

            return newItem;
          }

          function generateTemplateItemDupes(builtField) {
            var acceptedTypes = ['radio', 'checkbox'];
            var type = acceptedTypes.indexOf(builtField.field.type);
            if (type === -1) {
              return [builtField];
            }
            type = acceptedTypes[type];
            if (!builtField.field.properties[type] || !builtField.field.properties[type].list) {
              return [builtField];
            }

            var repeat = builtField.field.properties[type].list;
            var fields = [];
            for (var i = 0; i < repeat.length; i++) {
              var typeField = {field: {properties: repeat[i]}};
              typeField = _.merge({}, builtField, typeField);
              if (typeField.properties) {
                delete typeField.properties[type];
              }
              if (typeField.field.properties) {
                delete typeField.field.properties[type];
              }
              fields.push(angular.copy(typeField));
            }
            return fields.length ? fields : [builtField];
          }

          function filterDefinitionFields(templateItem) {
            return ctrl.definition.fields.filter(function (field, index, source) {
              if (field.name === templateItem.field) {
                source.splice(index, 1);
              }
              return field.name === templateItem.field;
            });
          }

          function orderFieldsList(fields) {
            return $filter('orderBy')(fields, 'order');
          }

          function getModelValue(path) {
            return plCompsService.getPathValue(ctrl.model, path);
          }

          function submit(event) {
            if (ctrl.name.$invalid) {
              return;
            }
            if (ctrl.formEvents) {
              var events = ctrl.formEvents;
              if (angular.isFunction(events.beforeSubmit)) {
                events.beforeSubmit(ctrl.name, ctrl.model, event);
              }
              $timeout(function () {
                if (angular.isFunction(events.afterSubmit)) {
                  events.afterSubmit(ctrl.name, ctrl.model, event);
                }
              });
            }
            if (angular.isFunction(ctrl.onSubmit)) {
              ctrl.onSubmit(ctrl.name, ctrl.model, event);
            }
          }

          function doEvaluate(fields) {
            function apply(fields, property, index, evaluation) {
              var properties = {field: {properties: {}}};
              properties.field.properties[property] = evaluation;
              fields[index] = _.merge({}, fields[index], properties);
            }

            angular.forEach(fields, function (builtField, index) {
              var field = builtField.field;
              if (builtField.type === 'group') {
                ctrl.doEvaluate(builtField.fields);
              }
              else {
                angular.forEach(propertiesToEvaluate, function (property) {
                  if (angular.isDefined(field[property]) && field[property] !== null) {
                    if (angular.isFunction(field[property])) {
                      $q.when(field[property](ctrl.model, field)).then(
                        function (evaluation) {
                          apply(fields, property, index, evaluation);
                        },
                        function (error) {
                          apply(fields, property, index, error);
                        }
                      );
                    }
                    else {
                      var evaluation = $parse(field.properties[property])(ctrl.model);
                      apply(fields, property, index, evaluation);
                    }
                  }
                });
              }
            });
          }

          function valueChanged(plEdit) {
            if (ctrl.plNavWizardStep) {
              ctrl.plNavWizardStep.setComplete(false);
            }
            if (!plEdit || !ctrl.builtFields.length) {
              return;
            }
            plCompsService.debounce(function () {
              ctrl.doEvaluate(ctrl.builtFields);
            }, 50, 'plEditFormValueChanged');
          }
        }]
      };
    }]);
})();

/**
 * Created by pedro on 04/01/17.
 */
(function () {
  'use strict';

  angular.module('pl.edit')
    .component('plGroup', {
      require: {
        plForm: '?^plForm',
        plGroup: '?^^plGroup'
      },
      bindings: {
        labelClass: '<?',
        editClass: '<?',
        actionsClass: '<?',
        orientation: '@?',
        properties: '<?'
      },
      transclude: {
        label: '?label',
        edit: '?edit',
        actions: '?actions',
        plGroup: '?plGroup'
      },
      templateUrl: '../source/pl-edit-group.html',
      controller: /*@ngInject*/ ['$element', '$timeout', 'plCompsService', function ($element, $timeout, plCompsService) {
        var ctrl = this;
        var defaultOptions = {
          hasError: false,
          collapse: false,
          isCollapsed: false,
          orientation: plCompsService.config().plEditForm.orientation || 'horizontal',
          labelClass: 'col-md-2',
          editClass: 'col-md-8',
          actionsClass: 'col-md-2',
          innerEditClass: 'form-control',
          doubledEditClass: 'col-md-3',
          groupClassVertical: '',
          doubledGroupClassVertical: 'pull-left col-md-6',
          hideActions: false,
          hasParent: false,
          visible: true
        };
        var orientationVertical = {
          labelClass: '',
          editClass: '',
          actionsClass: '',
          doubledEditClass: ''
        };
        ctrl.count = 1;

        ctrl.name = null;
        ctrl.options = {};
        ctrl.groups = [];
        ctrl.edits = [];

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.$onDestroy = onDestroy;
        ctrl.initChild = initChild;
        ctrl.addEdit = addEdit;
        ctrl.removeEdit = removeEdit;
        ctrl.addGroup = addGroup;
        ctrl.removeGroup = removeGroup;
        ctrl.updateGroup = updateGroup;
        ctrl.toggleCollapse = toggleCollapse;
        ctrl.valueChanged = valueChanged;
        ctrl.getGroupClass = getGroupClass;

        /////////////

        function init() {
          if (ctrl.plForm) {
            ctrl.plForm.addGroup(ctrl);
            // If plForm classes/properties use those
            if (ctrl.plForm.properties) {
              _.merge(defaultOptions, ctrl.plForm.properties);
            }
          }
          if (ctrl.plGroup && ctrl.plGroup.properties) {
            _.merge(defaultOptions, ctrl.plGroup.properties);
          }
          ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties);

          // If vertical orientation
          if (ctrl.options.orientation === 'vertical' || ctrl.plForm && ctrl.plForm.properties && ctrl.plForm.properties.orientation === 'vertical') {
            angular.extend(ctrl.options, orientationVertical);
          }

          // If has plGroup parent
          if (ctrl.plGroup) {
            ctrl.initChild();
            ctrl.plGroup.addGroup(ctrl);
          }
        }

        function onChanges(group) {
          if (group) {
            var groupOptions = angular.copy(defaultOptions);
            if (ctrl.options) {
              _.merge(groupOptions, ctrl.options);
            }
            if (group.options) {
              _.merge(groupOptions, group.options.currentValue);

              // If vertical orientation
              if (group.options.currentValue.orientation === 'vertical' || ctrl.plForm && ctrl.plForm.properties && ctrl.plForm.properties.orientation === 'vertical') {
                angular.extend(groupOptions, orientationVertical);
              }
            }
            if (group.properties) {
              _.merge(groupOptions, group.properties.currentValue);
            }
            if (ctrl.properties) {
              _.merge(groupOptions, ctrl.properties);
            }
            ctrl.options = _.merge({}, ctrl.options, groupOptions);

            // Child groups
            for (var i = 0; i < ctrl.groups.length; i++) {
              var childGroup = ctrl.groups[i];
              childGroup.updateGroup(groupOptions);
            }

            // Child plEdit's
            for (i = 0; i < ctrl.edits.length; i++) {
              var plEdit = ctrl.edits[i];
              if (plEdit) {
                plEdit.updateEdit(groupOptions);
              }
            }
          }
        }

        function onDestroy() {
          if (ctrl.plGroup) {
            ctrl.plGroup.removeGroup(ctrl.name);
          }
          if (ctrl.plForm) {
            ctrl.plForm.removeGroup(ctrl.name);
          }
        }

        function initChild() {
          ctrl.options.hasParent = true;
          if (ctrl.plGroup.count % 2 !== 0 || ctrl.plGroup.count % 3 !== 0) {
            ctrl.options.hideActions = true;
          }
        }

        function addEdit(plEdit) {
          plEdit.name = plCompsService.generateName(plEdit.name, 'plEdit');
          ctrl.edits.push(plEdit);
        }

        function removeEdit(name) {
          for (var i = 0; i < ctrl.edits.length; i++) {
            if (ctrl.edits[i].name === name) {
              ctrl.edits.splice(i, 1);
              break;
            }
          }
        }

        function addGroup(group) {
          group.name = group.name || 'plGroup' + ctrl.count;
          ctrl.groups.push(group);
          ctrl.count++;
        }

        function removeGroup(name) {
          for (var i = 0; i < ctrl.groups.length; i++) {
            if (ctrl.groups[i].name === name) {
              ctrl.groups.splice(i, 1);
              break;
            }
          }
        }

        function updateGroup(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties, properties);
            if (ctrl.plGroup) {
              ctrl.initChild();
            }
            ctrl.$onChanges({options: {currentValue: ctrl.options}});
          }
        }

        function toggleCollapse() {
          if (!ctrl.options.collapse) {
            return;
          }
          ctrl.options.isCollapsed = !ctrl.options.isCollapsed;
        }

        function valueChanged(plEdit) {
          if (ctrl.plForm) {
            ctrl.plForm.valueChanged(plEdit);
          }
        }

        function getGroupClass() {
          var classes = [{
            'form-group': !ctrl.options.hasParent,
            'has-parent': ctrl.options.hasParent,
            'has-error': ctrl.options.hasError,
            'active': ctrl.options.collapse,
            'row': ctrl.options.orientation === 'horizontal',
            'clearfix': !ctrl.options.hasParent
          }];
          var classe = '';
          if (ctrl.options.orientation === 'vertical' || ctrl.plForm && ctrl.plForm.properties && ctrl.plForm.properties.orientation === 'vertical') {
            if (!ctrl.hasParent) {
              if (ctrl.groups.length) {
                classe = ctrl.options.groupClassVertical;
              }
            }
            else {
              classe = ctrl.options.doubledGroupClassVertical;
            }
          }
          if (classe) {
            classes.push(classe);
          }
          return classes;
        }
      }]
    });
})();

/**
 * Created by pedro on 04/01/17.
 */
(function () {
  'use strict';

  angular.module('pl.edit')
    .component('plEditNumber', {
      templateUrl: '../source/pl-edit-number.html',
      require: {
        ngModel: 'ngModel',
        plForm: '?^plForm',
        plEdit: '?^plEdit'
      },
      bindings: {
        name: '@?',
        editClass: '<?',
        properties: '<?'
      },
      transclude: {
        inputGroup: '?inputGroup'
      },
      controller: /*@ngInject*/ ['$element', '$window', '$timeout', '$filter', '$transclude', '$sce', 'plKeyboard', 'plFormat', 'plCompsService', function ($element, $window, $timeout, $filter, $transclude, $sce, plKeyboard, plFormat, plCompsService) {
        var ctrl = this;
        var defaultOptions = {
          readonly: false,
          disabled: false,
          disallowInput: false,
          alignLeft: false,
          minlength: null,
          maxlength: null,
          required: false,
          validate: true,
          raw: false,
          inputGroup: $sce.trustAsHtml('<i class="fa fa-fw" ng-class="$ctrl.options.inputGroupIcon"></i>'),
          inputGroupIcon: '',
          validators: {
            min: {value: null},
            max: {value: null},
            minlength: {value: null},
            maxlength: {value: null},
            required: {value: false},
            pattern: {value: null}
          },
          events: {
            blur: undefined,
            focus: undefined,
            change: undefined,
            keydown: undefined,
            keypress: undefined,
            keyup: undefined,
            mousedown: undefined,
            mouseenter: undefined,
            mouseleave: undefined,
            mousemove: undefined,
            mouseover: undefined,
            mouseup: undefined,
            inputGroup: undefined
          }
        };
        var elemInput = null;
        var elemSpan = null;

        ctrl.options = {};
        ctrl.value = '';
        ctrl.previousValue = '';
        ctrl.defaultDecimalsValue = '';
        ctrl.isEditing = false;

        ctrl.$onInit = init;
        ctrl.$onDestroy = onDestroy;
        ctrl.validators = validators;
        ctrl.render = render;
        ctrl.modelHandler = modelHandler;
        ctrl.onFocus = onFocus;
        ctrl.onBlur = onBlur;
        ctrl.defaultDecimals = defaultDecimals;
        ctrl.format = format;
        ctrl.setViewValue = setViewValue;
        ctrl.updateComponent = updateComponent;

        /////////////

        function init() {
          elemInput = $element.find('input');
          elemSpan = $element.find('span');

          if (ctrl.plEdit) {
            ctrl.plEdit.addComponent(ctrl);
            if (ctrl.plEdit.options) {
              _.merge(defaultOptions, ctrl.plEdit.options);
            }
          }
          ctrl.options = _.merge({}, defaultOptions, plFormat.format, ctrl.properties);
          ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
          ctrl.hasGroup = angular.isDefined(ctrl.options.hasGroup) ? ctrl.options.hasGroup && $transclude.isSlotFilled('inputGroup') : $transclude.isSlotFilled('inputGroup');

          ctrl.defaultDecimalsValue = ctrl.defaultDecimals();

          // Set custom validators
          ctrl.ngModel.$render = function () {
            ctrl.validators();
          };

          // Set model handler
          ctrl.modelHandler();

          // Set initial required if necessary
          if (ctrl.options.validate && ctrl.options.validators.required.value) {
            $timeout(function () {
              if (!plCompsService.parseNumber(ctrl.value)) {
                var ngModel = $element.find('input').controller('ngModel');
                if (ngModel) {
                  ngModel.$setValidity('required', false);
                }
              }
            });
          }
        }

        function onDestroy() {
          if (ctrl.plEdit) {
            ctrl.plEdit.removeComponent(ctrl.name);
          }
          $element.off('keydown');
        }

        function validators() {
          var inputModelCtrl = $element.find('input').controller('ngModel');
          if (!inputModelCtrl) {
            return;
          }

          // Min
          if (ctrl.options.validate && ctrl.options.validators.min.value !== null) {
            inputModelCtrl.$validators.min = function (modelValue) {
              var value = parseFloat(ctrl.options.validators.min.value);
              modelValue = modelValue || 0;
              modelValue = plCompsService.parseNumber(modelValue);
              return modelValue >= value;
            };
          }
          else {
            inputModelCtrl.$validators.min = function () {
              return true;
            };
          }

          // Max
          if (ctrl.options.validate && ctrl.options.validators.max.value !== null) {
            inputModelCtrl.$validators.max = function (modelValue) {
              var value = parseFloat(ctrl.options.validators.max.value);
              modelValue = modelValue || 0;
              modelValue = plCompsService.parseNumber(modelValue);
              return modelValue <= value;
            };
          }
          else {
            inputModelCtrl.$validators.max = function () {
              return true;
            };
          }
        }

        function modelHandler() {
          /* Convert data from view format to model format.
           * Also the parsers are called after the ``ctrl.ngModel.$setViewValue()`` call
           * in the ``ctrl.render()`` method. */
          ctrl.ngModel.$parsers.unshift(function (viewValue) {
            if (!viewValue && viewValue !== 0) {
              viewValue = 0;
            }
            var value = plCompsService.parseNumber(viewValue);
            if (!value && value !== 0) {
              value = plCompsService.parseNumber(ctrl.previousValue) || 0;
            }
            ctrl.previousValue = value;
            return value;
          });

          // Called when model is changed programmatically or by other binding
          ctrl.ngModel.$formatters.unshift(function (modelValue) {
            if (!modelValue && modelValue !== 0) {
              modelValue = 0;
            }
            var value = plCompsService.parseNumber(modelValue);
            if (!value && value !== 0) {
              value = plCompsService.parseNumber(ctrl.previousValue) || 0;
            }
            ctrl.value = ctrl.previousValue = $filter('plNumber')(value, ctrl.options);
            return value;
          });
        }

        function render() {
          if (angular.isUndefined(ctrl.value) || ctrl.value === null) {
            return;
          }

          // Clipboard paste + max number fix
          // ^(?!.*ab).*$
          var regex = new RegExp('[^\\d\\' + ctrl.options.decimalsSeparator + '\\-]');
          if (ctrl.value.toString().match(regex) || plCompsService.parseNumber(ctrl.value) > ctrl.options.maxNumber) {
            ctrl.value = ctrl.previousValue;
            ctrl.setViewValue(ctrl.previousValue);
          }

          ctrl.ngModel.$setViewValue(ctrl.value);
          ctrl.ngModel.$commitViewValue();
          if (ctrl.plEdit) {
            ctrl.plEdit.valueChanged(ctrl);
          }
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.change)) {
            ctrl.options.events.change(ctrl, ctrl.plForm, $element);
          }
        }

        function onFocus(event) {
          ctrl.isEditing = true;
          var value = plCompsService.stripCharacters(ctrl.value || elemInput.val());
          value = plCompsService.removeAllNotLast(value, ctrl.options.decimalsSeparator);
          if (ctrl.defaultDecimalsValue !== '' && value.indexOf(ctrl.defaultDecimalsValue) !== -1) {
            value = value.substring(0, value.indexOf(ctrl.defaultDecimalsValue));
          }
          ctrl.setViewValue(value);

          // Select all on focus if enabled
          if (ctrl.options.selectOnFocus) {
            if (!$window.getSelection().toString()) {
              elemInput.get(0).select();
            }
          }

          // Event handlers
          $element.on('keydown', function (event) {
            plKeyboard.numericOnly(event, ctrl.options);
          });

          // Callback function
          if (angular.isFunction(ctrl.options.events.focus)) {
            ctrl.options.events.focus(ctrl, ctrl.plForm, event);
          }
        }

        function onBlur(event) {
          ctrl.isEditing = false;
          ctrl.format();

          // Release event handlers
          $element.off('keydown');

          // Callback function
          if (angular.isFunction(ctrl.options.events.blur)) {
            ctrl.options.events.blur(ctrl, ctrl.plForm, event);
          }
        }

        function defaultDecimals() {
          if (ctrl.options.decimalsLimit > 0) {
            var decimals = '';
            for (var i = 0; i < ctrl.options.decimalsLimit; i++) {
              decimals += 0;
            }
            return ctrl.options.decimalsSeparator + decimals;
          }
          else {
            return '';
          }
        }

        function format(value) {
          if (angular.isUndefined(value) || !value) {
            value = elemInput.val();
          }
          value = $filter('plNumber')(value, ctrl.options);
          ctrl.setViewValue(value);
          return value;
        }

        function setViewValue(value) {
          elemInput.val(value);
          elemSpan.html(value);
        }

        function updateComponent(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties, properties);
            ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
            ctrl.hasGroup = angular.isDefined(ctrl.options.hasGroup) ? ctrl.options.hasGroup && $transclude.isSlotFilled('inputGroup') : $transclude.isSlotFilled('inputGroup');
            ctrl.validators();
            if (!ctrl.isEditing) {
              ctrl.ngModel.$setViewValue(ctrl.format(ctrl.value));
              ctrl.ngModel.$commitViewValue();
            }
          }
        }
      }]
    });
})();

/**
 * Created by pedro on 04/01/17.
 */
(function () {
  'use strict';

  angular.module('pl.filters')
    .filter('plNumber', ['plFormat', 'plCompsService', function (plFormat, plCompsService) {
      var ctrl = {};
      ctrl.options = plFormat.format;

      ctrl.format = format;
      ctrl.checkOverFlow = checkOverFlow;
      ctrl.defaultDecimals = defaultDecimals;
      ctrl.stripLeftZeroes = stripLeftZeroes;
      ctrl.formatThousands = formatThousands;
      ctrl.formatDecimals = formatDecimals;

      function format(value) {
        if (!value || value === '') {
          value = '0';
        }
        else {
          var checkValue = parseFloat(value);
          if (checkValue >= ctrl.options.maxNumber) {
            value = ctrl.options.maxNumber.toString();
          }
          else {
            value = value.toString();
          }
        }
        if (value[0] === ctrl.options.decimalsSeparator) {
          value = '0' + value;
        }
        else if (value[0] === '-' && value[1] === ctrl.options.decimalsSeparator) {
          value = '-0' + value.substring(1, value.length);
        }
        value = ctrl.checkOverFlow(value);
        value = ctrl.stripLeftZeroes(value);
        value = ctrl.formatThousands(value);
        return value;
      }

      function checkOverFlow(value) {
        if (ctrl.options.decimalsLimit > 0) {
          var val = '' + value;
          var index = val.indexOf(ctrl.options.decimalsSeparator);
          if (index !== -1) {
            val = val.substring(index + 1, val.length);
            if (val.length > ctrl.options.decimalsLimit) {
              return value.substring(0, index) + ctrl.options.decimalsSeparator + val.substring(0, ctrl.options.decimalsLimit);
            }
          }
        }
        return value;
      }

      function defaultDecimals() {
        if (ctrl.options.decimalsLimit > 0) {
          var decimals = '';
          for (var i = 0; i < ctrl.options.decimalsLimit; i++) {
            decimals += 0;
          }
          return ctrl.options.decimalsSeparator + decimals;
        }
        else {
          return '';
        }
      }

      function stripLeftZeroes(value) {
        value = plCompsService.stripCharacters(value);
        var decimalsValue = '';

        if (ctrl.options.decimalsLimit > 0) {
          var index = value.indexOf(ctrl.options.decimalsSeparator);
          if (index === -1) {
            index = value.length;
          }
          else {
            decimalsValue = value.substring(value.indexOf(ctrl.options.decimalsSeparator), value.length);
          }
          value = value.substring(0, index);
        }

        if (value === '') {
          return value;
        }

        if (value[0] === '0' && value.length > 1) {
          var count = 0;
          for (var i = 0; i < value.length; i++) {
            if (value[i] === '0') {
              count++;
            }
            else {
              break;
            }
          }
          if (count > 0) {
            value = value.substring(count, value.length);
          }
        }
        return ctrl.formatDecimals(value + decimalsValue);
      }

      function formatThousands(value) {
        value = plCompsService.stripCharacters(value);
        var decimalsValue = '';

        if (ctrl.options.decimalsLimit > 0) {
          var index = value.indexOf(ctrl.options.decimalsSeparator);
          if (index === -1) {
            index = value.length;
          }
          else {
            decimalsValue = value.substring(value.indexOf(ctrl.options.decimalsSeparator), value.length);
          }
          value = value.substring(0, index);
        }

        if (value === '') {
          return value;
        }

        var result = '';
        var thousandsCount = 0;
        for (var i = value.length; i > 0; i--) {
          var char = value[i - 1];
          thousandsCount++;
          if (thousandsCount % 3 === 0) {
            char = ctrl.options.thousandsSeparator + char;
          }
          result = char + result;
        }

        // If result starts with a thousands separator, eg: ',123.99'
        if (result.substring(0, 1) === ctrl.options.thousandsSeparator) {
          result = result.substring(1, result.length);
        }
        // If result starts with a negative sign followed by a thousands separator, eg: '-,123.99'
        if (result.substring(0, 1) === '-' && result.substring(1, 2) === ctrl.options.thousandsSeparator) {
          result = result.substring(0, 1) + result.substring(2, result.length);
        }

        return ctrl.formatDecimals(result + decimalsValue);
      }

      function formatDecimals(value) {
        if (ctrl.options.decimalsLimit > 0) {
          var decimalsValue = '';
          var index = value.indexOf(ctrl.options.decimalsSeparator);
          if (index === -1) {
            return value + ctrl.defaultDecimals();
          }
          else {
            decimalsValue = value.substring(index, value.length);
          }

          // If decimals value is filled
          if (decimalsValue.length > 1) {
            // If decimals has less characters than it is defined in options fills empty chunk with zeroes
            if (decimalsValue.length - 1 !== ctrl.options.decimalsLimit) {
              for (var i = decimalsValue.length - 1; i < ctrl.options.decimalsLimit; i++) {
                value += '0';
              }
            }
            return value;
          }
          // If not simply return default decimals value
          else {
            // If user left nothing but the decimals separator on decimals value
            if (decimalsValue === ctrl.options.decimalsSeparator) {
              value = value.substring(0, value.length - 1);
            }
            return value + ctrl.defaultDecimals();
          }
        }
        else {
          return value;
        }
      }

      /////////////

      return function (value, properties) {
        if (properties && angular.isObject(properties)) {
          ctrl.options = _.merge({}, plFormat.format, ctrl.options, properties);
        }
        if (angular.isUndefined(value) || !value) {
          value = '0';
        }
        if (!angular.isString(value)) {
          value = value.toString();
        }
        return ctrl.format(value.trim());
      };
    }]);
})();

/**
 * Created by pedro on 04/01/17.
 */
(function () {
  'use strict';

  angular.module('pl.edit')
    .component('plEditPassword', {
      templateUrl: '../source/pl-edit-password.html',
      require: {
        ngModel: 'ngModel',
        plForm: '?^plForm',
        plEdit: '?^plEdit'
      },
      bindings: {
        name: '@?',
        editClass: '<?',
        properties: '<?'
      },
      transclude: {
        inputGroup: '?inputGroup'
      },
      controller: /*@ngInject*/ ['$element', '$transclude', '$sce', function ($element, $transclude, $sce) {
        var ctrl = this;
        var defaultOptions = {
          readonly: false,
          disabled: false,
          disallowInput: false,
          validate: true,
          raw: false,
          inputGroup: $sce.trustAsHtml('<i class="fa fa-fw" ng-class="$ctrl.options.inputGroupIcon"></i>'),
          inputGroupIcon: '',
          validators: {
            minlength: {value: null},
            maxlength: {value: null},
            required: {value: false},
            pattern: {value: null}
          },
          events: {
            blur: undefined,
            focus: undefined,
            change: undefined,
            keydown: undefined,
            keypress: undefined,
            keyup: undefined,
            mousedown: undefined,
            mouseenter: undefined,
            mouseleave: undefined,
            mousemove: undefined,
            mouseover: undefined,
            mouseup: undefined,
            inputGroup: undefined

          }
        };

        ctrl.options = {};
        ctrl.validator = {};

        ctrl.$onInit = init;
        ctrl.$onDestroy = onDestroy;
        ctrl.render = render;
        ctrl.updateComponent = updateComponent;

        /////////////

        function init() {
          if (ctrl.plEdit) {
            ctrl.plEdit.addComponent(ctrl);
            if (ctrl.plEdit.options) {
              _.merge(defaultOptions, ctrl.plEdit.options);
            }
          }
          ctrl.options = _.merge({}, defaultOptions, ctrl.properties);
          ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
          ctrl.hasGroup = angular.isDefined(ctrl.options.hasGroup) ? ctrl.options.hasGroup && $transclude.isSlotFilled('inputGroup') : $transclude.isSlotFilled('inputGroup');
          ctrl.ngModel.$render = function () {
            ctrl.value = ctrl.ngModel.$viewValue;
          };
        }

        function onDestroy() {
          if (ctrl.plEdit) {
            ctrl.plEdit.removeComponent(ctrl.name);
          }
        }

        function render() {
          ctrl.ngModel.$setViewValue(ctrl.value);
          if (ctrl.plEdit) {
            ctrl.plEdit.valueChanged(ctrl);
          }
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.change)) {
            ctrl.options.events.change(ctrl, ctrl.plForm, $element);
          }
        }

        function updateComponent(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties, properties);
            ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
            ctrl.hasGroup = angular.isDefined(ctrl.options.hasGroup) ? ctrl.options.hasGroup && $transclude.isSlotFilled('inputGroup') : $transclude.isSlotFilled('inputGroup');
          }
        }
      }]
    });
})();

/**
 * Created by pedro on 04/01/17.
 */
(function () {
  'use strict';

  angular.module('pl.edit')
    .component('plEditPhone', {
      templateUrl: '../source/pl-edit-phone.html',
      require: {
        ngModel: 'ngModel',
        plForm: '?^plForm',
        plEdit: '?^plEdit'
      },
      bindings: {
        name: '@?',
        editClass: '<?',
        properties: '<?'
      },
      transclude: {
        inputGroup: '?inputGroup'
      },
      controller: /*@ngInject*/ ['$element', '$transclude', '$sce', function ($element, $transclude, $sce) {
        var ctrl = this;
        var defaultOptions = {
          readonly: false,
          disabled: false,
          disallowInput: false,
          validate: true,
          raw: false,
          inputGroup: $sce.trustAsHtml('<i class="fa fa-fw" ng-class="$ctrl.options.inputGroupIcon"></i>'),
          inputGroupIcon: '',
          validators: {
            minlength: {value: null},
            maxlength: {value: null},
            required: {value: false},
            pattern: {value: null}
          },
          events: {
            blur: undefined,
            focus: undefined,
            change: undefined,
            keydown: undefined,
            keypress: undefined,
            keyup: undefined,
            mousedown: undefined,
            mouseenter: undefined,
            mouseleave: undefined,
            mousemove: undefined,
            mouseover: undefined,
            mouseup: undefined,
            inputGroup: undefined

          }
        };

        ctrl.options = {};
        ctrl.validator = {};

        ctrl.$onInit = init;
        ctrl.$onDestroy = onDestroy;
        ctrl.render = render;
        ctrl.getReadableValue = getReadableValue;
        ctrl.updateComponent = updateComponent;

        /////////////

        function init() {
          if (ctrl.plEdit) {
            ctrl.plEdit.addComponent(ctrl);
            if (ctrl.plEdit.options) {
              _.merge(defaultOptions, ctrl.plEdit.options);
            }
          }
          ctrl.options = _.merge({}, defaultOptions, ctrl.properties);
          ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
          ctrl.hasGroup = angular.isDefined(ctrl.options.hasGroup) ? ctrl.options.hasGroup && $transclude.isSlotFilled('inputGroup') : $transclude.isSlotFilled('inputGroup');

          ctrl.ngModel.$render = function () {
            ctrl.value = ctrl.ngModel.$viewValue;
          };
        }

        function onDestroy() {
          if (ctrl.plEdit) {
            ctrl.plEdit.removeComponent(ctrl.name);
          }
        }

        function render() {
          ctrl.ngModel.$setViewValue(ctrl.value);
          if (ctrl.plEdit) {
            ctrl.plEdit.valueChanged(ctrl);
          }
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.change)) {
            ctrl.options.events.change(ctrl, ctrl.plForm, $element);
          }
        }

        function getReadableValue(value) {
          if (!value) {
            return value;
          }
          var result = '';
          var count = 0;
          for (var i = value.length; i > 0; i--) {
            var char = value[i - 1];
            count++;
            if (count % 3 === 0) {
              char = ' ' + char;
            }
            result = char + result;
          }
          return result.trim();
        }

        function updateComponent(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties, properties);
            ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
            ctrl.hasGroup = angular.isDefined(ctrl.options.hasGroup) ? ctrl.options.hasGroup && $transclude.isSlotFilled('inputGroup') : $transclude.isSlotFilled('inputGroup');
          }
        }
      }]
    });
})();

/**
 * Created by pedro on 04/01/17.
 */
(function () {
  'use strict';

  angular.module('pl.edit')
    .provider('plEdit', function () {
      var edits = {};
      var maps = {};
      var debugEnabled = false;

      function setDebugEnabled(value) {
        debugEnabled = !!value;
      }

      function register(name, template, properties) {
        edits[name.toLowerCase()] = {
          template: template,
          properties: properties
        };
      }

      function getEdit(name) {
        var normalizedName = name.toLowerCase();
        var edit = edits[normalizedName];
        if (!edit) {
          edit = maps[name];
          if (!edit) {
            edit = edits.text;
          }
          else {
            edit = _.merge({}, edits[edit.type], {properties: edit.properties});
          }
        }
        return edit;
      }

      function getEdits() {
        return edits;
      }

      function map(type, alias, properties) {
        type = type.toLowerCase();
        maps[alias] = {type: type, properties: properties};
      }

      function isDebugEnabled() {
        return debugEnabled;
      }

      return {
        setDebugEnabled: setDebugEnabled,
        register: register,
        map: map,
        $get: function () {
          return {
            register: register,
            map: map,
            getEdit: getEdit,
            getEdits: getEdits,
            isDebugEnabled: isDebugEnabled
          };
        }
      };
    });
})();

/**
 * Created by Bruno Ferreira on 10/10/17.
 */
(function () {
  'use strict';

  angular.module('pl.edit')
    .component('plEditRadio', {
      require: {
        ngModel: 'ngModel',
        plForm: '?^plForm',
        plEdit: '?^plEdit'
      },
      bindings: {
        name: '@?',
        label: '<?',
        value: '<?',
        properties: '<?'
      },
      templateUrl: '../source/pl-edit-radio.html',
      controllerAs: '$ctrl',
      controller: /*@ngInject*/ ['$q', function ($q) {
        var ctrl = this;
        var defaultOptions = {
          readonly: false,
          disabled: false,
          required: true,
          label: '',
          value: null,
          validate: true,
          validators: {
            required: {value: false}
          },
          events: {
            beforeChange: undefined,
            afterChange: undefined
          }
        };

        ctrl.options = {};

        ctrl.$onInit = init;
        ctrl.$onDestroy = onDestroy;
        ctrl.render = render;
        ctrl.toggleValue = toggleValue;
        ctrl.updateComponent = updateComponent;

        /////////////

        function init() {
          if (ctrl.plEdit) {
            ctrl.plEdit.addComponent(ctrl);
            if (ctrl.plEdit.options) {
              _.merge(defaultOptions, ctrl.plEdit.options);
            }
          }
          ctrl.options = _.merge({}, defaultOptions, ctrl.properties);
          ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;

          if (ctrl.value || ctrl.value === 0) {
            ctrl.options.value = ctrl.value;
          }

          ctrl.ngModel.$render = function () {
            if (!ctrl.options.value && ctrl.options.value !== 0) {
              ctrl.val = !!(ctrl.ngModel.$viewValue);
            }
            else {
              ctrl.val = ctrl.ngModel.$viewValue === ctrl.options.value;
            }
          };

          if (ctrl.options.validate && ctrl.options.validators.required.value === true) {
            ctrl.ngModel.$validators.required = function () {
              var val = ctrl.ngModel.$viewValue;
              return angular.isDefined(val) && val !== null;
            };
          }
        }

        function onDestroy() {
          if (ctrl.plEdit) {
            ctrl.plEdit.removeComponent(ctrl.name);
          }
        }

        function render() {
          if (!ctrl.options.value && ctrl.options.value !== 0) {
            ctrl.ngModel.$setViewValue(ctrl.val);
          }
          else {
            if (ctrl.ngModel.$modelValue !== ctrl.options.value) {
              ctrl.ngModel.$setViewValue(ctrl.options.value);
            }
            else if (!ctrl.options.required) {
              ctrl.ngModel.$setViewValue(0);
            }
          }
          if (ctrl.plEdit) {
            ctrl.plEdit.valueChanged(ctrl);
          }
          if (angular.isFunction(ctrl.options.events.afterChange)) {
            ctrl.options.events.afterChange(ctrl, ctrl.plForm);
          }
        }

        function toggleValue() {
          var promise = null;
          if (angular.isFunction(ctrl.options.events.beforeChange)) {
            promise = ctrl.options.events.beforeChange(ctrl, ctrl.plForm);
          }
          $q.when(promise).then(function () {
            ctrl.val = !ctrl.val;
            if ((ctrl.options.required === true || ctrl.options.validators && ctrl.options.validators.required.value === true) && !ctrl.val) {
              ctrl.val = true;
            }
            ctrl.render();
          });
        }

        function updateComponent(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties, properties);
            ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;

            if (ctrl.value || ctrl.value === 0) {
              ctrl.options.value = ctrl.value;
            }
          }
        }
      }]
    });
})();

/**
 * Created by pedro on 04/01/17.
 */
(function () {
  'use strict';

  angular.module('pl.edit')
    .component('plEditSelect', {
      templateUrl: '../source/pl-edit-select.html',
      require: {
        ngModel: 'ngModel',
        plForm: '?^plForm',
        plEdit: '?^plEdit'
      },
      bindings: {
        name: '@?',
        size: '@?',
        ngOptions: '@?',
        onChange: '&?',
        list: '<?',
        source: '<?',
        selected: '=?',
        editClass: '<?',
        properties: '<?'
      },
      transclude: {
        inputGroup: '?inputGroup'
      },
      controller: /*@ngInject*/ ['$q', '$transclude', '$sce', function ($q, $transclude, $sce) {
        var ctrl = this;
        var defaultOptions = {
          readonly: false,
          disabled: false,
          validate: true,
          raw: false,
          inputGroup: $sce.trustAsHtml('<i class="fa fa-fw" ng-class="$ctrl.options.inputGroupIcon"></i>'),
          inputGroupIcon: '',
          validators: {
            required: {value: false}
          },
          events: {
            inputGroup: undefined
          },
          blur: null
        };

        ctrl.key = undefined;
        ctrl.name = undefined;
        ctrl.options = {};
        ctrl.validator = {};
        ctrl.listSource = [];
        ctrl.sourcePromise = undefined;

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.$onDestroy = onDestroy;
        ctrl.updateComponent = updateComponent;
        ctrl.render = render;
        ctrl.handleList = handleList;
        ctrl.handleSource = handleSource;

        /////////////

        function init() {
          if (ctrl.plEdit) {
            ctrl.plEdit.addComponent(ctrl);
            if (ctrl.plEdit.options) {
              _.merge(defaultOptions, ctrl.plEdit.options);
            }
          }
          ctrl.options = _.merge({}, defaultOptions, ctrl.properties);
          ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
          ctrl.hasGroup = angular.isDefined(ctrl.options.hasGroup) ? ctrl.options.hasGroup && $transclude.isSlotFilled('inputGroup') : $transclude.isSlotFilled('inputGroup');
          _.merge(ctrl, ctrl.options);

          ctrl.ngModel.$render = function () {
            ctrl.value = ctrl.ngModel.$viewValue;
            $q.when(ctrl.sourcePromise).then(function (list) {
              if (angular.isDefined(ctrl.value)) {
                var isObjectList = list.length && angular.isObject(list[0]);
                var isObject = angular.isObject(ctrl.value);
                for (var i = 0; i < list.length; i++) {
                  var item = list[i];
                  var found;
                  if (!isObjectList) {
                    found = isObject ? item === ctrl.value[ctrl.key] : ctrl.value;
                  }
                  else {
                    var itemValue = item[ctrl.key];
                    found = isObject ? itemValue === ctrl.value[ctrl.key] : itemValue === ctrl.value;
                  }
                  if (found) {
                    ctrl.value = isObjectList ? item[ctrl.key] : item;
                    break;
                  }
                }
              }
            });
          };

          ctrl.handleList();
        }

        function onChanges(plEditSelect) {
          if (plEditSelect) {
            if (plEditSelect.properties && !plEditSelect.properties.isFirstChange()) {
              ctrl.handleList();
            } else if (plEditSelect.source && !plEditSelect.source.isFirstChange()) {
              ctrl.handleSource();
            }
          }
        }

        function onDestroy() {
          if (ctrl.plEdit) {
            ctrl.plEdit.removeComponent(ctrl.name);
          }
        }

        function updateComponent(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties, properties);
            ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
            if (angular.isDefined(ctrl.options.hasGroup)) {
              ctrl.hasGroup = ctrl.options.hasGroup && $transclude.isSlotFilled('inputGroup');
            } else {
              ctrl.hasGroup = $transclude.isSlotFilled('inputGroup');
            }
            _.merge(ctrl, ctrl.options);
            ctrl.handleList();
          }
        }

        function render() {
          ctrl.ngModel.$setViewValue(ctrl.value);
          if (angular.isArray(ctrl.listSource)) {
            ctrl.selected = angular.isObject(ctrl.value) ? ctrl.value : ctrl.listSource.find(function (item) {
              return item[ctrl.options.select.valueProp || 'value'] === ctrl.value;
            });
            ctrl.options.selected = ctrl.selected;
            if (angular.isObject(ctrl.options.select)) {
              ctrl.options.select.selected = ctrl.selected;
            }
          }
          if (angular.isFunction(ctrl.onChange)) {
            ctrl.onChange(ctrl.value, ctrl.selected);
          }
          if (ctrl.plEdit) {
            ctrl.plEdit.valueChanged(ctrl);
          }
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.change)) {
            ctrl.options.events.change(ctrl, ctrl.plForm, ctrl.value, ctrl.selected);
          }
        }

        function handleList() {
          if (!ctrl.options.select) {
            ctrl.options.select = {};
          }
          ctrl.list = ctrl.options.ngOptions || 'option[$ctrl.options.select.valueProp || \'value\'] as option[$ctrl.options.select.labelProp || \'name\'] | pltranslate' +
            ' group by option[$ctrl.options.select.groupProp || \'group\'] for option in $ctrl.listSource';
          ctrl.key = ctrl.options.select.valueProp || 'value';
          ctrl.name = ctrl.options.select.labelProp || 'name';
          ctrl.handleSource();
        }

        function handleSource() {
          var list = null;
          if (angular.isDefined(ctrl.source) && ctrl.source !== null) {
            list = ctrl.source;
          } else if (angular.isDefined(ctrl.options.select.list) && ctrl.options.select.list !== null) {
            list = ctrl.options.select.list;
          }
          if (list) {
            var promise = null;
            if (angular.isArray(list)) {
              promise = list;
            } else if (angular.isFunction(list)) {
              promise = list();
            }
            var deferred = $q.defer();
            $q.when(promise)
              .then(function (response) {
                ctrl.listSource = response;
                deferred.resolve(ctrl.listSource);
              })
              .catch(function (reason) {
                deferred.reject(reason);
              });
            ctrl.sourcePromise = deferred.promise;
          }
        }
      }]
    });
})();

/**
 * Created by pedro on 04/01/17.
 */
(function () {
  'use strict';

  angular.module('pl.edit')
    .component('plEditSwitch', {
      require: {
        ngModel: 'ngModel',
        plForm: '?^plForm',
        plEdit: '?^plEdit'
      },
      bindings: {
        name: '@?',
        label: '@?',
        trueValue: '<?',
        falseValue: '<?',
        properties: '<?'
      },
      templateUrl: '../source/pl-edit-switch.html',
      controllerAs: '$ctrl',
      controller: /*@ngInject*/ ['$q', 'plAlertService', 'plTranslate', 'plLocale', function ($q, plAlertService, plTranslate, plLocale) {
        var ctrl = this;
        var defaultOptions = {
          readonly: false,
          disabled: false,
          required: false,
          requiredInvalidMessage: plLocale.locales.messages.switchRequiredInvalidMessage,
          labelClass: null,
          round: true,
          label: '',
          value: null,
          trueValue: true,
          falseValue: false,
          validate: true,
          switchPos: 'left',
          validators: {
            required: {value: false}
          },
          events: {
            beforeChange: undefined,
            change: undefined
          }
        };

        ctrl.options = {};

        ctrl.$onInit = init;
        ctrl.$onDestroy = onDestroy;
        ctrl.handleOptions = handleOptions;
        ctrl.toModelValue = toModelValue;
        ctrl.render = render;
        ctrl.toggleValue = toggleValue;
        ctrl.updateComponent = updateComponent;

        /////////////

        function init() {
          if (ctrl.plEdit) {
            ctrl.plEdit.addComponent(ctrl);
            if (ctrl.plEdit.options) {
              _.merge(defaultOptions, ctrl.plEdit.options);
            }
          }
          ctrl.options = _.merge({}, defaultOptions, ctrl.properties);
          ctrl.handleOptions();

          ctrl.ngModel.$render = function () {
            if (!ctrl.options.value) {
              ctrl.value = !!ctrl.ngModel.$viewValue;
            }
            else {
              ctrl.value = ctrl.ngModel.$viewValue === ctrl.options.value;
            }
          };

          if (ctrl.options.validate) {
            if (ctrl.options.validators.required.value === true) {
              ctrl.ngModel.$validators.required = function () {
                return angular.isDefined(ctrl.value) && ctrl.value !== null;
              };
            }
          }
        }

        function onDestroy() {
          if (ctrl.plEdit) {
            ctrl.plEdit.removeComponent(ctrl.name);
          }
        }

        function handleOptions() {
          ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
          if (ctrl.label) {
            ctrl.options.label = ctrl.label;
          }
          if (ctrl.trueValue || ctrl.trueValue === 0) {
            ctrl.options.trueValue = ctrl.trueValue;
          }
          if (ctrl.falseValue || ctrl.falseValue === 0) {
            ctrl.options.falseValue = ctrl.falseValue;
          }
        }

        function toModelValue() {
          return ctrl.value ? ctrl.options.trueValue : ctrl.options.falseValue;
        }

        function render() {
          var value;
          if (!ctrl.options.value && ctrl.options.value !== 0) {
            value = ctrl.toModelValue();
          }
          else {
            if (ctrl.ngModel.$modelValue !== ctrl.options.value) {
              value = ctrl.options.value;
            }
            else if (!ctrl.options.required) {
              value = ctrl.options.falseValue;
            }
          }
          ctrl.ngModel.$setViewValue(value);

          if (ctrl.plEdit) {
            ctrl.plEdit.valueChanged(ctrl);
          }
          if (angular.isFunction(ctrl.options.events.change)) {
            ctrl.options.events.change(value, ctrl, ctrl.plForm);
          }
        }

        function toggleValue() {
          var promise = null;
          if (angular.isFunction(ctrl.options.events.beforeChange)) {
            promise = ctrl.options.events.beforeChange(ctrl, ctrl.plForm);
          }
          $q.when(promise).then(function () {
            ctrl.value = !ctrl.value;
            if (ctrl.options.required && !ctrl.value) {
              ctrl.value = true;
              plAlertService.warning(plTranslate.translate(ctrl.options.requiredInvalidMessage));
            }
            ctrl.render();
          });
        }

        function updateComponent(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties, properties);
            ctrl.handleOptions();
          }
        }
      }]
    });
})();

/**
 * Created by pedro on 04/01/17.
 */
(function () {
  'use strict';

  angular.module('pl.edit')
    .component('plEditText', {
      templateUrl: '../source/pl-edit-text.html',
      require: {
        ngModel: 'ngModel',
        plForm: '?^plForm',
        plEdit: '?^plEdit'
      },
      bindings: {
        name: '@?',
        editClass: '<?',
        properties: '<?'
      },
      transclude: {
        inputGroup: '?inputGroup'
      },
      controller: /*@ngInject*/ ['$element', '$transclude', '$sce', function ($element, $transclude, $sce) {
        var ctrl = this;
        var defaultOptions = {
          readonly: false,
          disabled: false,
          disallowInput: false,
          validate: true,
          raw: false,
          inputGroup: $sce.trustAsHtml('<i class="fa fa-fw" ng-class="$ctrl.options.inputGroupIcon"></i>'),
          inputGroupIcon: '',
          validators: {
            minlength: {value: null},
            maxlength: {value: null},
            required: {value: false},
            pattern: {value: null}
          },
          events: {
            blur: undefined,
            focus: undefined,
            change: undefined,
            keydown: undefined,
            keypress: undefined,
            keyup: undefined,
            mousedown: undefined,
            mouseenter: undefined,
            mouseleave: undefined,
            mousemove: undefined,
            mouseover: undefined,
            mouseup: undefined,
            inputGroup: undefined
          }
        };

        ctrl.options = {};
        ctrl.validator = {};

        ctrl.$onInit = init;
        ctrl.$onDestroy = onDestroy;
        ctrl.render = render;
        ctrl.updateComponent = updateComponent;

        /////////////

        function init() {
          if (ctrl.plEdit) {
            ctrl.plEdit.addComponent(ctrl);
            if (ctrl.plEdit.options) {
              _.merge(defaultOptions, ctrl.plEdit.options);
            }
          }
          ctrl.options = _.merge({}, defaultOptions, ctrl.properties);
          ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
          ctrl.hasGroup = angular.isDefined(ctrl.options.hasGroup) ? ctrl.options.hasGroup && $transclude.isSlotFilled('inputGroup') : $transclude.isSlotFilled('inputGroup');

          ctrl.ngModel.$render = function () {
            ctrl.value = ctrl.ngModel.$viewValue;
          };
        }

        function onDestroy() {
          if (ctrl.plEdit) {
            ctrl.plEdit.removeComponent(ctrl.name);
          }
        }

        function render() {
          ctrl.ngModel.$setViewValue(ctrl.value);
          if (ctrl.plEdit) {
            ctrl.plEdit.valueChanged(ctrl);
          }
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.change)) {
            ctrl.options.events.change(ctrl, ctrl.plForm, $element);
          }
        }

        function updateComponent(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties, properties);
            ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
            ctrl.hasGroup = angular.isDefined(ctrl.options.hasGroup) ? ctrl.options.hasGroup && $transclude.isSlotFilled('inputGroup') : $transclude.isSlotFilled('inputGroup');
          }
        }
      }]
    });
})();

/**
 * Created by pedro on 04/01/17.
 */
(function () {
  'use strict';

  angular.module('pl.edit')
    .component('plEditTextarea', {
      templateUrl: '../source/pl-edit-textarea.html',
      require: {
        ngModel: 'ngModel',
        plForm: '?^plForm',
        plEdit: '?^plEdit'
      },
      bindings: {
        name: '@?',
        editClass: '<?',
        properties: '<?'
      },
      controller: /*@ngInject*/ ['$element', function ($element) {
        var ctrl = this;
        var defaultOptions = {
          readonly: false,
          disabled: false,
          disallowInput: false,
          trim: true,
          validate: true,
          validators: {
            minlength: {value: null},
            maxlength: {value: null},
            required: {value: false},
            pattern: {value: null}
          },
          events: {
            blur: undefined,
            focus: undefined,
            change: undefined,
            keydown: undefined,
            keypress: undefined,
            keyup: undefined,
            mousedown: undefined,
            mouseenter: undefined,
            mouseleave: undefined,
            mousemove: undefined,
            mouseover: undefined,
            mouseup: undefined
          }
        };

        ctrl.options = {};
        ctrl.validator = {};

        ctrl.$onInit = init;
        ctrl.$onDestroy = onDestroy;
        ctrl.render = render;
        ctrl.updateComponent = updateComponent;

        /////////////

        function init() {
          if (ctrl.plEdit) {
            ctrl.plEdit.addComponent(ctrl);
            if (ctrl.plEdit.options) {
              _.merge(defaultOptions, ctrl.plEdit.options);
            }
          }
          ctrl.options = _.merge({}, defaultOptions, ctrl.properties);
          ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;

          ctrl.ngModel.$render = function () {
            ctrl.value = ctrl.ngModel.$viewValue;
          };
        }

        function onDestroy() {
          if (ctrl.plEdit) {
            ctrl.plEdit.removeComponent(ctrl.name);
          }
        }

        function render() {
          ctrl.ngModel.$setViewValue(ctrl.value);
          if (ctrl.plEdit) {
            ctrl.plEdit.valueChanged(ctrl);
          }
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.change)) {
            ctrl.options.events.change(ctrl, ctrl.plForm, $element);
          }
        }

        function updateComponent(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties, properties);
            ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
          }
        }
      }]
    });
})();

/**
 * Created by pedro on 18/11/16.
 */
(function () {
  'use strict';
  angular.module('pl.comps')
    .directive('plFallbackSrc', function () {
      return {
        link: function postLink(scope, iElement, iAttrs) {
          iElement.bind('error', function () {
            angular.element(this).attr('src', iAttrs.plFallbackSrc);
          });
        }
      };
    });

})();

(function () {
  'use strict';

  angular.module('pl.filterPanel', ['ngSanitize', 'ngAnimate', 'pl.inlineEdit', 'pl.animation', 'ui.bootstrap'])
    .factory('plFilterDefault', ['plLocale', function (plLocale) {
      var locales = plLocale.locales;
      var config = {
        showLabel: '<i class="fa fa-filter" aria-hidden="true"></i>&nbsp;' + locales.btn.addFilter,
        iconClass: 'fa fa-angle-right',
        opAnd: 'e',
        opEqual: ' =',
        add: '<i class="fa fa-plus-square-o" aria-hidden="true"></i>',
        remove: '<i class="fa fa-trash-o text-danger" aria-hidden="true"></i>',
        apply: '<i class="fa fa-filter" aria-hidden="true"></i>&nbsp;' + locales.btn.apply
      };
      var factory = {
        config: config,
        setConfig: setConfig
      };
      return factory;

      /////////////

      function setConfig(object) {
        _.merge(config, object);
      }
    }])
    .component('plFilter', {
      require: {
        ngModel: '?ngModel'
      },
      bindings: {
        fields: '=',
        isCollapsed: '=?',
        showCaption: '<?',
        onFilter: '&?',
        properties: '<?'
      },
      replace: true,
      templateUrl: '../source/pl-filter-panel.html',
      controllerAs: '$ctrl',
      controller: ['plFilterDefault', '$element', '$attrs', '$rootScope', '$timeout', '$location', 'plTranslate', 'plLocale', 'plCompsService', function (plFilterDefault, $element, $attrs, $rootScope, $timeout, $location, plTranslate, plLocale, plCompsService) {
        var ctrl = this;

        ctrl.locales = plLocale.locales;
        ctrl.config = plFilterDefault.config;
        ctrl.urlPrefix = '';
        ctrl.useUrl = false;
        ctrl.value = [];
        ctrl.filterValue = '';
        ctrl.selectedFilter = null;

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.updateValue = updateValue;
        ctrl.getField = getField;
        ctrl.getCaption = getCaption;
        ctrl.toggleFilter = toggleFilter;
        ctrl.isInUse = isInUse;
        ctrl.getSelectedFilterType = getSelectedFilterType;
        ctrl.getSelectedFilterText = getSelectedFilterText;
        ctrl.getSelectedFilterProperties = getSelectedFilterProperties;
        ctrl.getRowValue = getRowValue;
        ctrl.selectFilter = selectFilter;
        ctrl.addFilter = addFilter;
        ctrl.remove = remove;
        ctrl.removeAll = removeAll;
        ctrl.buildUrl = buildUrl;
        ctrl.apply = apply;

        /////////////

        function init() {
          ctrl.filterOnCaption = $attrs.showCaption === 'filter';
          ctrl.showCaption = angular.isDefined(ctrl.showCaption) ? ctrl.showCaption : true;
          ctrl.isCollapsed = angular.isDefined(ctrl.isCollapsed) ? ctrl.isCollapsed : false;

          if ($attrs.inurl === 'true') {
            ctrl.useUrl = true;
          }
          else if (angular.isString($attrs.inurl)) {
            ctrl.useUrl = true;
            ctrl.urlPrefix = $attrs.inurl;
          }

          if (ctrl.fields && ctrl.fields.length) {
            ctrl.selectFilter(ctrl.fields[0]);
          }

          if (ctrl.ngModel) {
            ctrl.ngModel.$render = function () {
              var value = ctrl.ngModel.$viewValue;
              if (value) {
                ctrl.value = value;
                $timeout(function () {
                  if (ctrl.useUrl) {
                    var search = $location.search();
                    if (ctrl.value) {
                      search = ctrl.value;
                    }
                    else if ($rootScope.app && $rootScope.app.queryParams) {
                      ctrl.value = $rootScope.app.queryParams;
                    }
                    var query = search[ctrl.urlPrefix + 'filter'];
                    try {
                      query = angular.fromJson(query);
                      if (angular.isArray(query)) {
                        ctrl.value = query;
                        if ($rootScope.app && $rootScope.app.queryParams && $rootScope.app.queryParams.filter) {
                          ctrl.apply();
                          $rootScope.app.queryParams.filter = null;
                        }
                      }
                    } catch (e) {
                      ctrl.value = [];
                    }
                    ctrl.buildUrl();
                  }

                  if (ctrl.selectedFilter && angular.isArray(ctrl.value) && ctrl.value.length) {
                    var value = ctrl.value.find(function (filter) {
                      return filter.name === ctrl.selectedFilter.name;
                    });
                    if (value) {
                      var newFilter = ctrl.fields.find(function (field) {
                        return !ctrl.isInUse(field);
                      });
                      if (newFilter) {
                        ctrl.selectFilter(newFilter);
                      }
                    }
                  }

                  ctrl.apply();
                });
              }
            };
          }
        }

        function onChanges(plFilterPanel) {
          if (plFilterPanel && plFilterPanel.properties) {
            ctrl.config = _.merge({}, plFilterDefault.config, ctrl.config, plFilterPanel.properties.currentValue);
          }
        }

        function updateValue() {
          if (ctrl.ngModel) {
            ctrl.ngModel.$setViewValue(ctrl.value);
          }
        }

        function getField(name) {
          for (var i = 0; i < ctrl.fields.length; i++) {
            if (ctrl.fields[i].name === name) {
              return ctrl.fields[i];
            }
          }
          return '';
        }

        function getCaption(name) {
          var field = ctrl.getField(name);
          return field ? plTranslate.translate(field.caption) : '';
        }

        function toggleFilter() {
          ctrl.isCollapsed = !ctrl.isCollapsed;
        }

        function isInUse(field) {
          for (var i = 0; i < ctrl.value.length; i++) {
            if (field.name === ctrl.value[i].name) {
              return true;
            }
          }
          return false;
        }

        function getSelectedFilterType(field) {
          if (field.type === 'radio') {
            return 'select';
          }
          return field.type;
        }

        function getSelectedFilterText() {
          if (ctrl.selectedFilter) {
            return plTranslate.translate(ctrl.selectedFilter.caption);
          }
          return plLocale.locales.text.noFilters;
        }

        function getSelectedFilterProperties() {
          return _.merge(ctrl.selectedFilter.properties, {
            validate: false,
            disabled: !ctrl.selectedFilter,
            validators: null,
            ngModelOptions: {
              debounce: 200,
              allowInvalid: true
            },
            events: {
              change: ctrl.addFilter
            }
          });
        }

        function getRowValue(row) {
          var type = row.type;
          var properties = row.properties;
          var field = ctrl.fields.find(function (myField) {
            return myField.name === row.name;
          });
          if (angular.isDefined(field)) {
            type = field.type;
            properties = field.properties;
          }
          return plCompsService.prettyPrintValue(row.value, type, null, properties);
        }

        function selectFilter(filter) {
          if (!filter.properties) {
            filter.properties = {};
          }
          ctrl.selectedFilter = filter;
          ctrl.filterValue = '';
        }

        function addFilter(value) {
          value = value.value || value;
          if (angular.isObject(value)) {
            value = ctrl.filterValue;
          }
          var item = ctrl.selectedFilter;
          var found = ctrl.value.find(function (row) {
            return row.name === item.name;
          });
          if (found) {
            if (angular.isUndefined(value) || value === null || value === '') {
              ctrl.remove(found);
              return;
            }
            found.value = value;
          }
          else {
            var obj = {
              name: item.name,
              value: value,
              type: item.type,
              fixed: false,
              properties: item.properties
            };
            ctrl.value.push(obj);
          }
          ctrl.apply();
        }

        function remove(row) {
          var index = ctrl.value.findIndex(function (item) {
            return item === row;
          });
          if (index !== -1) {
            ctrl.value.splice(index, 1);
            ctrl.apply();
          }
        }

        function removeAll() {
          ctrl.value = [];
          ctrl.filterValue = '';
          ctrl.apply();
        }

        function buildUrl() {
          var query = '';
          ctrl.filter = '';
          ctrl.query = '';
          for (var i = 0; i < ctrl.value.length; i++) {
            var row = ctrl.value[i];
            var value = row.value;
            if (angular.isUndefined(value) || value === null || value === '') {
              continue;
            }
            var description = value;
            if (angular.isObject(value)) {
              description = value.description;
              value = value.value;
            }
            if (i > 0) {
              query += '&';
              ctrl.filter += ' ' + ctrl.config.opAnd.trim() + ' ';
            }

            query = query + row.name.trim() + '=' + value;
            ctrl.filter += ctrl.getCaption(row.name).trim() + ' ' + ctrl.config.opEqual.trim() + (' ' + description).trim();

          }
          if (ctrl.useUrl) {
            $location.search(ctrl.urlPrefix + 'filter', angular.toJson(ctrl.value));
          }
          ctrl.query = query;
        }

        function apply() {
          ctrl.buildUrl();
          ctrl.updateValue();
          if (angular.isFunction(ctrl.onFilter)) {
            ctrl.onFilter({value: ctrl.value, query: ctrl.query});
          }
        }
      }]
    });
})();

(function () {
  'use strict';

  angular.module('pl.filters')
    .filter('tax', ['$filter', function ($filter) {
      return function (value, properties) {
        return $filter('plNumber')(value, properties) + ' %';
      };
    }]);
})();

/**
 * Created by pedro on 26/04/16.
 */
(function () {
  'use strict';

  angular.module('pl.comps')
    .directive('plFormErrorNavigation', ['$timeout', function ($timeout) {
      return {
        restrict: 'A',
        scope: {
          topOffset: '@?',
          duration: '@?',
          easing: '@?'
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: ['$scope', '$element', function ($scope, $element) {
          var ctrl = this;

          ctrl.$onInit = init;
          ctrl.$onDestroy = onDestroy;
          ctrl.submit = submit;

          /////////////

          function init() {
            ctrl.topOffset = parseInt(ctrl.topOffset) || 100;
            ctrl.speed = ctrl.speed || 'fast';
            ctrl.easing = ctrl.easing || 'swing';
            $element.on('submit', ctrl.submit);
          }

          function onDestroy() {
            $element.off('submit', ctrl.submit);
          }

          function submit() {
            $timeout(function () {
              var errorGroup = $element.find('.form-group.has-error');
              if (errorGroup.length) {
                var errorElement = errorGroup.first().find('input');
                if (!errorElement.length) {
                  return;
                }

                var $toAnimate = $element.closest('.modal-body');
                if (!$toAnimate.length) {
                  $toAnimate = $element.find('.modal-body').first();
                  if (!$toAnimate.length) {
                    $toAnimate = angular.element('html, body');
                  }
                }
                $toAnimate.animate({
                  scrollTop: errorElement.offset().top - ctrl.topOffset
                }, ctrl.speed, ctrl.easing, function () {
                  errorElement.focus();
                });
              }
            });
          }
        }]
      };
    }]);
})();

/**
 * Created by pedro on 26/04/16.
 */
(function () {
  'use strict';

  angular.module('pl.comps')
    .directive('plFormNavigation', ['$document', 'KEYCODE', function ($document, KEYCODE) {
      return {
        restrict: 'A',
        priority: 3,
        link: function ($scope, $element) {
          $element.on('keydown', function (event) {
            if (event.target.tagName.toUpperCase() === 'TEXTAREA') {
              return true;
            }
            /* PL-SELECT FIX
             *  - when the user is using keyboard navigation while pl-select component is active,
             *    this directive must not interfere with said navigation */
            else if ($element.find('.ui-select-choices-row.active').length) {
              return true;
            }

            if (event.which === KEYCODE.ENTER || event.which === KEYCODE.DOWN) {
              if (event.which === KEYCODE.ENTER && angular.element(event.target).is('button:submit')) {
                return;
              }
              next(event, $element, 1);
            }
            else if (event.which === KEYCODE.UP) {
              next(event, $element, -1);
            }
          });

          $scope.$on('$destroy', function () {
            $element.off('keydown');
          });
        }
      };

      /////////////

      function next(event, element, step) {
        var focusableQuery = 'input, select:not(.pl-pagination-select), textarea, button[focus], button[data-focus], button[type="submit"],' +
          ' pl-button[focus] button, pl-button[data-focus] button';
        var $focusableList = $document.find(element).find(focusableQuery).not('[tabindex=-1], [disabled], :hidden');
        var nextIndex = $focusableList.index(event.target) + step;
        if (nextIndex >= $focusableList.length) {
          nextIndex = 0;
        }
        $focusableList.eq(nextIndex).focus();
        $focusableList.eq(nextIndex).select();
        event.preventDefault();
        event.stopPropagation();
      }
    }]);
})();

/**
 * Created by pedro on 17/01/17.
 */
(function () {
  'use strict';

  angular.module('pl.edit')
    .provider('plFormat', function () {
      var format = {
        date: 'dd-MM-yyyy',
        momentDate: 'DD-MM-YYYY',
        datetime: 'dd-MM-yyyy HH:mm:ss',
        momentDatetime: 'DD-MM-YYYY HH:mm:ss',
        time: 'HH:mm:ss',
        decimalsSeparator: '.',
        decimalsSeparatorCode: 190,
        decimalsLimit: 3,
        thousandsSeparator: ',',
        allowNegative: true,
        selectOnFocus: true,
        maxNumber: 2147483647.0,
        notNumberRegex: null,
        currency: '€',
        pivotTableLocale: 'pt-pt',
        isoRegex: /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/ // jshint ignore:line
      };

      function handleRegex() {
        if (format.decimalsLimit <= 0) {
          format.notNumberRegex = '[^0-9\\-]';
        }
        else {
          format.notNumberRegex = '[^0-9\\' + format.decimalsSeparator + '\\-]';
        }
        format.notNumberRegex = new RegExp(format.notNumberRegex, 'g');
      }

      function setFormat(object) {
        _.merge(format, object);
        handleRegex();
      }

      (function init() {
        handleRegex();
      })();

      return {
        setFormat: setFormat,
        format: format,
        $get: function () {
          return {
            setFormat: setFormat,
            format: format
          };
        }
      };
    });
})();

/**
 * Created by pedro on 30/01/17.
 * based on https://github.com/sroze/ngInfiniteScroll
 */
(function () {
  'use strict';

  angular.module('pl.infinite-scroll', [])
    .value('THROTTLE_MILLISECONDS', null)
    .directive('plInfiniteScroll', ['$rootScope', '$window', '$interval', 'THROTTLE_MILLISECONDS', function ($rootScope, $window, $interval, THROTTLE_MILLISECONDS) {
      return {
        scope: {
          infiniteScroll: '&plInfiniteScroll',
          infiniteScrollContainer: '=plInfiniteScrollContainer',
          infiniteScrollDistance: '=plInfiniteScrollDistance',
          infiniteScrollDisabled: '=plInfiniteScrollDisabled',
          infiniteScrollUseDocumentBottom: '=plInfiniteScrollUseDocumentBottom',
          infiniteScrollListenForEvent: '@plInfiniteScrollListenForEvent'
        },

        link: function link(scope, elem, attrs) {
          var windowElement = angular.element($window);

          var scrollDistance = null;
          var scrollEnabled = null;
          var checkWhenEnabled = null;
          var container = null;
          var immediateCheck = true;
          var useDocumentBottom = false;
          var unregisterEventListener = null;
          var checkInterval = false;

          function height(element) {
            var el = element[0] || element;

            if (isNaN(el.offsetHeight)) {
              return el.document.documentElement.clientHeight;
            }
            return el.offsetHeight;
          }

          function pageYOffset(element) {
            var el = element[0] || element;

            if (isNaN(window.pageYOffset)) {
              return el.document.documentElement.scrollTop;
            }
            return el.ownerDocument.defaultView.pageYOffset;
          }

          function offsetTop(element) {
            if (!(!element[0].getBoundingClientRect || element.css('none'))) {
              return element[0].getBoundingClientRect().top + pageYOffset(element);
            }
            return undefined;
          }

          // infinite-scroll specifies a function to call when the window,
          // or some other container specified by infinite-scroll-container,
          // is scrolled within a certain range from the bottom of the
          // document. It is recommended to use infinite-scroll-disabled
          // with a boolean that is set to true when the function is
          // called in order to throttle the function call.
          function defaultHandler() {
            var containerBottom = void 0;
            var elementBottom = void 0;
            if (container === windowElement) {
              containerBottom = height(container) + pageYOffset(container[0].document.documentElement);
              elementBottom = offsetTop(elem) + height(elem);
            } else {
              containerBottom = height(container);
              var containerTopOffset = 0;
              if (offsetTop(container) !== undefined) {
                containerTopOffset = offsetTop(container);
              }
              elementBottom = offsetTop(elem) - containerTopOffset + height(elem);
            }

            if (useDocumentBottom) {
              elementBottom = height((elem[0].ownerDocument || elem[0].document).documentElement);
            }

            var remaining = elementBottom - containerBottom;
            var shouldScroll = remaining <= height(container) * scrollDistance + 1;

            if (shouldScroll) {
              checkWhenEnabled = true;

              if (scrollEnabled) {
                if (scope.$$phase || $rootScope.$$phase) {
                  scope.infiniteScroll();
                } else {
                  scope.$apply(scope.infiniteScroll);
                }
              }
            } else {
              if (checkInterval) {
                $interval.cancel(checkInterval);
              }
              checkWhenEnabled = false;
            }
          }

          // The optional THROTTLE_MILLISECONDS configuration value specifies
          // a minimum time that should elapse between each call to the
          // handler. N.b. the first call the handler will be run
          // immediately, and the final call will always result in the
          // handler being called after the `wait` period elapses.
          // A slimmed down version of underscore's implementation.
          function throttle(func, wait) {
            var timeout = null;
            var previous = 0;

            function later() {
              previous = new Date().getTime();
              $interval.cancel(timeout);
              timeout = null;
              return func.call();
            }

            function throttled() {
              var now = new Date().getTime();
              var remaining = wait - (now - previous);
              if (remaining <= 0) {
                $interval.cancel(timeout);
                timeout = null;
                previous = now;
                func.call();
              } else if (!timeout) {
                timeout = $interval(later, remaining, 1);
              }
            }

            return throttled;
          }

          var handler = THROTTLE_MILLISECONDS !== null ? throttle(defaultHandler, THROTTLE_MILLISECONDS) : defaultHandler;

          function handleDestroy() {
            container.unbind('scroll', handler);
            if (unregisterEventListener !== null) {
              unregisterEventListener();
              unregisterEventListener = null;
            }
            if (checkInterval) {
              $interval.cancel(checkInterval);
            }
          }

          scope.$on('$destroy', handleDestroy);

          // infinite-scroll-distance specifies how close to the bottom of the page
          // the window is allowed to be before we trigger a new scroll. The value
          // provided is multiplied by the container height; for example, to load
          // more when the bottom of the page is less than 3 container heights away,
          // specify a value of 3. Defaults to 0.
          function handleInfiniteScrollDistance(v) {
            scrollDistance = parseFloat(v) || 0;
          }

          scope.$watch('infiniteScrollDistance', handleInfiniteScrollDistance);
          // If I don't explicitly call the handler here, tests fail. Don't know why yet.
          handleInfiniteScrollDistance(scope.infiniteScrollDistance);

          // infinite-scroll-disabled specifies a boolean that will keep the
          // infnite scroll function from being called; this is useful for
          // debouncing or throttling the function call. If an infinite
          // scroll is triggered but this value evaluates to true, then
          // once it switches back to false the infinite scroll function
          // will be triggered again.
          function handleInfiniteScrollDisabled(v) {
            scrollEnabled = !v;
            if (scrollEnabled && checkWhenEnabled) {
              checkWhenEnabled = false;
              handler();
            }
          }

          scope.$watch('infiniteScrollDisabled', handleInfiniteScrollDisabled);
          // If I don't explicitly call the handler here, tests fail. Don't know why yet.
          handleInfiniteScrollDisabled(scope.infiniteScrollDisabled);

          // use the bottom of the document instead of the element's bottom.
          // This useful when the element does not have a height due to its
          // children being absolute positioned.
          function handleInfiniteScrollUseDocumentBottom(v) {
            useDocumentBottom = v;
          }

          scope.$watch('infiniteScrollUseDocumentBottom', handleInfiniteScrollUseDocumentBottom);
          handleInfiniteScrollUseDocumentBottom(scope.infiniteScrollUseDocumentBottom);

          // infinite-scroll-container sets the container which we want to be
          // infinte scrolled, instead of the whole window. Must be an
          // Angular or jQuery element, or, if jQuery is loaded,
          // a jQuery selector as a string.
          function changeContainer(newContainer) {

            if (container !== null) {
              container.unbind('scroll', handler);
            }

            container = newContainer;
            if (newContainer !== null) {
              container.bind('scroll', handler);
            }
          }

          changeContainer(windowElement);

          if (scope.infiniteScrollListenForEvent) {
            unregisterEventListener = $rootScope.$on(scope.infiniteScrollListenForEvent, handler);
          }

          function handleInfiniteScrollContainer(newContainer) {
            // TODO: For some reason newContainer is sometimes null instead
            // of the empty array, which Angular is supposed to pass when the
            // element is not defined
            // (https://github.com/sroze/ngInfiniteScroll/pull/7#commitcomment-5748431).
            // So I leave both checks.
            if (!newContainer || newContainer.length === 0) {
              return;
            }

            var newerContainer = void 0;

            if (newContainer.nodeType && newContainer.nodeType === 1) {
              newerContainer = angular.element(newContainer);
            } else if (typeof newContainer.append === 'function') {
              newerContainer = angular.element(newContainer[newContainer.length - 1]);
            } else if (typeof newContainer === 'string') {
              newerContainer = angular.element(document.querySelector(newContainer));
            } else {
              newerContainer = newContainer;
            }

            if (newerContainer === null) {
              throw new Error('invalid pl-infinite-scroll-container attribute.');
            }
            changeContainer(newerContainer);
          }

          scope.$watch('infiniteScrollContainer', handleInfiniteScrollContainer);
          handleInfiniteScrollContainer(scope.infiniteScrollContainer || []);

          // infinite-scroll-parent establishes this element's parent as the
          // container infinitely scrolled instead of the whole window.
          if (attrs.plInfiniteScrollParent) {
            changeContainer(angular.element(elem.parent()));
          }

          // infinte-scoll-immediate-check sets whether or not run the
          // expression passed on infinite-scroll for the first time when the
          // directive first loads, before any actual scroll.
          if (attrs.plInfiniteScrollImmediateCheck !== null) {
            immediateCheck = scope.$eval(attrs.plInfiniteScrollImmediateCheck);
          }

          function intervalCheck() {
            if (immediateCheck) {
              handler();
            }
            return $interval.cancel(checkInterval);
          }

          checkInterval = $interval(intervalCheck);
          return checkInterval;
        }
      };
    }]);
})();

(function () {
  'use strict';

  angular.module('pl.inlineEdit', ['ngSanitize'])
    .constant('plInlineEditDefault', {
      labelset: '<i class="fa fa-check text-success" aria-hidden="true"></i>'
    })
    .component('plInlineEdit', {
      require: {
        ngModel: '^ngModel',
        plForm: '?^plForm',
        plGroup: '?^^plGroup'
      },
      bindings: {
        class: '@?',
        value: '=?ngModel',
        editMode: '=?',
        onValidate: '=?',
        onValidateTarget: '=?',
        type: '@?',
        editClass: '=?',
        properties: '<?'
      },
      templateUrl: '../source/pl-inline-edit.html',
      controller: /*@ngInject*/ ['$q', '$scope', '$filter', '$element', '$timeout', 'plInlineEditDefault', 'plFormat', 'plCompsService', 'KEYCODE', function ($q, $scope, $filter, $element, $timeout, plInlineEditDefault, plFormat, plCompsService, KEYCODE) {
        var ctrl = this;
        var originalRender = null;
        var defaultOptions = {};

        ctrl.format = angular.copy(plFormat.format);
        ctrl.name = null;
        ctrl.options = {};
        ctrl.edits = [];
        ctrl.editMode = !!ctrl.editMode;

        ctrl.$postLink = postLink;
        ctrl.$onChanges = onChanges;
        ctrl.$onDestroy = onDestroy;
        ctrl.addEdit = addEdit;
        ctrl.updateEdit = updateEdit;
        ctrl.removeEdit = removeEdit;
        ctrl.updateValue = updateValue;
        ctrl.openEdit = openEdit;
        ctrl.cancelEdit = cancelEdit;
        ctrl.closeEdit = closeEdit;
        ctrl.getValue = getValue;
        ctrl.showMask = showMask;
        ctrl.handleModeChange = handleModeChange;
        ctrl.valueChanged = valueChanged;

        /////////////

        function postLink() {
          originalRender = ctrl.ngModel.$render;
          ctrl.config = plInlineEditDefault;

          if (ctrl.plGroup) {
            ctrl.plGroup.addEdit(ctrl);
            if (ctrl.plGroup.properties) {
              _.merge(defaultOptions, ctrl.plGroup.properties);
            }
          }
          ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties);

          if (ctrl.options.format) {
            ctrl.format = _.merge({}, ctrl.format, ctrl.options.format);
          }

          ctrl.ngModel.$render = function () {
            ctrl.value = ctrl.ngModel.$viewValue;
            ctrl.oldValue = ctrl.ngModel.$viewValue;
          };
        }

        function onChanges(inlineEdit) {
          if (inlineEdit) {
            var inlineEditOptions = angular.copy(defaultOptions);
            if (ctrl.options) {
              _.merge(inlineEditOptions, ctrl.options);
            }
            if (inlineEdit.options) {
              _.merge(inlineEditOptions, inlineEdit.options.currentValue);
            }
            if (inlineEdit.properties) {
              _.merge(inlineEditOptions, inlineEdit.properties.currentValue);
            }
            if (ctrl.properties) {
              _.merge(inlineEditOptions, ctrl.properties);
            }

            for (var i = 0; i < ctrl.edits.length; i++) {
              var plEdit = ctrl.edits[i];
              if (plEdit) {
                plEdit.updateEdit(inlineEditOptions);
              }
            }
          }
        }

        function onDestroy() {
          if (ctrl.plGroup) {
            ctrl.plGroup.removeEdit(ctrl.name);
          }
        }

        function addEdit(plEdit) {
          plEdit.name = plCompsService.generateName(plEdit.name, 'plEdit');
          ctrl.edits.push(plEdit);
        }

        function updateEdit(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, properties, ctrl.properties);
            ctrl.$onChanges({options: {currentValue: ctrl.options}});
          }
        }

        function removeEdit(name) {
          for (var i = 0; i < ctrl.edits.length; i++) {
            if (ctrl.edits[i].name === name) {
              ctrl.edits.splice(i, 1);
              break;
            }
          }
        }

        function updateValue() {
          ctrl.ngModel.$setViewValue(ctrl.value);
          originalRender();
        }

        function openEdit() {
          ctrl.editMode = true;
          $timeout(function () {
            var input = $element.find('input');
            if (input.length) {
              input.focus();
            }
          });
        }

        function cancelEdit() {
          ctrl.editMode = false;
          ctrl.value = ctrl.oldValue;
          ctrl.updateValue();
        }

        function closeEdit() {
          var ret;
          if (angular.isFunction(ctrl.onValidate)) {
            ret = ctrl.onValidate(ctrl.value, ctrl.onValidateTarget);
            if (angular.isUndefined(ret)) {
              ret = true;
            }
          }
          else {
            ret = true;
          }

          $q.when(ret).then(
            function () {
              ctrl.editMode = false;
            },
            function () {
              ctrl.openEdit();
            }
          );
        }

        function getValue() {
          return plCompsService.prettyPrintValue(ctrl.value, ctrl.type, ctrl.format, ctrl.options);
        }

        function showMask(value) {
          if (ctrl.options.readonly) {
            return false;
          }
          if (angular.isUndefined(value) || value === null) {
            value = ctrl.getValue();
          }
          if (angular.isString(value)) {
            return value.length === 0;
          }
          return angular.isUndefined(value) || value === null;
        }

        function handleModeChange() {
          if (!ctrl.editMode) {
            ctrl.openEdit();
          } else {
            ctrl.closeEdit();
          }
        }

        function valueChanged(plEdit) {
          if (ctrl.plForm) {
            ctrl.plForm.valueChanged(plEdit);
          }
        }

        /////////////

        $scope.$watch(angular.bind(ctrl, function () {
          return ctrl.editMode;
        }), function (newVal) {
          $timeout(function () {
            var input = $element.find('input');
            var _fnInputEvent = function (event) {
              if (event.which === KEYCODE.ENTER) {
                $timeout(function () {
                  ctrl.closeEdit();
                });
              }
              else if (event.which === KEYCODE.ESC) {
                $timeout(function () {
                  ctrl.cancelEdit();
                });
              }
            };
            if (input.length) {
              newVal ? input.on('keyup', _fnInputEvent) : input.off('keyup', _fnInputEvent);
            }
          });
        });
      }]
    });
})();

(function () {
  'use strict';

  angular.module('pl.comps')
    .service('plKeyboard', /*@ngInject*/ ['$window', 'plFormat', 'KEYCODE', function ($window, plFormat, KEYCODE) {
      var defaultOptions = plFormat.format;
      var lastPressedKey = null;

      (function init() {
        angular.element('html,body').on('keyup', function (event) {
          lastPressedKey = event.which;
        });
      })();

      return {
        lastPressedKey: getLastPressedKey,
        numericOnly: numericOnly
      };

      /////////////

      function getLastPressedKey() {
        return lastPressedKey;
      }

      function numericOnly(event, options, successCallback, errorCallback) {
        var allowedKeys = [
          KEYCODE.ENTER,
          KEYCODE.BACKSPACE,
          KEYCODE.TAB,
          KEYCODE.ESC,
          KEYCODE.DELETE,
          KEYCODE.HOME,
          KEYCODE.END,
          KEYCODE.F5,
          KEYCODE.F11,
          KEYCODE.F12,
          KEYCODE.DASH,
          KEYCODE.SUBTRACT,
          KEYCODE.DECIMAL_POINT
        ];
        var index = -1;
        var target = angular.element(event.target);
        var viewValue = target.val();
        var cursorPosition = event.target.selectionStart;
        var hasSelection = $window.getSelection().toString();

        if (options) {
          options = _.merge({}, defaultOptions, options);
        }
        if (options.decimalsSeparatorCode === KEYCODE.DECIMAL_POINT) {
          allowedKeys.push(KEYCODE.PERIOD);
        }
        // Adding decimals separator to allowed keys
        allowedKeys.push(options.decimalsSeparatorCode);

        if ($.inArray(event.which, allowedKeys) !== -1 ||
          // Allow: Ctrl+A, Command+A
          (event.which === KEYCODE.A && (event.ctrlKey === true || event.metaKey === true)) ||
          // Allow: Ctrl+X, Command+X
          (event.which === KEYCODE.X && (event.ctrlKey === true || event.metaKey === true)) ||
          // Allow: Ctrl+C, Command+C
          (event.which === KEYCODE.C && (event.ctrlKey === true || event.metaKey === true)) ||
          // Allow: Ctrl+V, Command+V
          (event.which === KEYCODE.V && (event.ctrlKey === true || event.metaKey === true)) ||
          // Allow: home, end, left, right, down, up
          (event.which >= KEYCODE.END && event.which <= KEYCODE.DOWN)) {

          // If user tried to add decimals separator but decimals limit is falsy
          if (!options.decimalsLimit && (event.key === options.decimalsSeparator || event.which === options.decimalsSeparatorCode || event.which === KEYCODE.DECIMAL_POINT)) {
            event.preventDefault();
            return false;
          }

          // If user tried to add more than one decimals separator
          index = viewValue.indexOf(options.decimalsSeparator);
          if (index !== -1 && (event.key === options.decimalsSeparator || event.which === options.decimalsSeparatorCode || event.which === KEYCODE.DECIMAL_POINT) &&
            !hasSelection) {
            event.preventDefault();
            return false;
          }
          // Else if key pressed is decimal point, switch key to defined decimals separator
          else {
            if (event.which === KEYCODE.DECIMAL_POINT && event.key !== options.decimalsSeparator) {
              event.preventDefault();
              target.val(target.val() + options.decimalsSeparator);
              return true;
            }
          }

          // If user tried to add more than one dash
          index = viewValue.indexOf('-');
          if ((event.which === KEYCODE.DASH || event.which === KEYCODE.SUBTRACT) && ((cursorPosition > 0 || index !== -1) && !hasSelection || !options.allowNegative)) {
            event.preventDefault();
            return false;
          }

          // Let it happen, don't do anything or call success callback
          if (angular.isFunction(successCallback)) {
            return successCallback(event, options);
          }
          return true;
        }

        // Ensure that it is a number and stop the keypress
        if ((event.shiftKey || (event.which < KEYCODE._0 || event.which > KEYCODE._9)) && (event.which < KEYCODE.NUMPAD_0 || event.which > KEYCODE.NUMPAD_9)) {
          if (angular.isFunction(errorCallback)) {
            return errorCallback(event, options);
          }
          event.preventDefault();
          return false;
        }
        // If it is indeed is a number
        else {
          // Check if decimals length has reached it's maximum (only prevent if a selection isn't present)
          index = viewValue.indexOf(options.decimalsSeparator);
          if (index !== -1 && !hasSelection) {
            var decimalsValue = viewValue.substring(index + 1, viewValue.length);
            if (decimalsValue.length >= options.decimalsLimit && cursorPosition > index) {
              event.preventDefault();
              return false;
            }
          }
          // Success callback
          else if (angular.isFunction(successCallback)) {
            return successCallback(event, options);
          }
          return true;
        }
      }
    }])
    .directive('plNumericOnly', ['$parse', 'plKeyboard', 'plFormat', function ($parse, plKeyboard, plFormat) {
      return {
        restrict: 'A',
        link: function ($scope, $element, $attrs) {
          var defaultOptions = plFormat.format;
          var options = {};

          // Try parsing attribute
          try {
            var plNumericOnly = angular.fromJson($attrs.plNumericOnly);
            defaultOptions = _.merge({}, defaultOptions, $parse(plNumericOnly)($scope.parent));
          }
          catch (ignored) {
          }
          options = _.merge({}, defaultOptions, options);

          function keyDown(event) {
            return plKeyboard.numericOnly(event, options);
          }

          $element.on('keydown', keyDown);

          $scope.$on('$destroy', function () {
            $element.off('keydown', keyDown);
          });
        }
      };
    }])
    /**
     * @description
     * The plEvents directive allows you to specify custom behavior when
     * one of the assigned events is triggered.
     *
     * @param {expression} plEvents Expression to evaluate upon event trigger
     * @param {string} events Comma separated string with the desired events
     * @example
     *  <button pl-events="$ctrl.myFunc($event)" events="click,keyup"></button>
     */
    .directive('plEvents', ['$parse', function ($parse) {
      return {
        restrict: 'A',
        compile: function ($element, $attrs) {
          var fn = $parse($attrs.plEvents);
          var events = $attrs.events;
          return function link($scope, $element) {
            function fnEvent(event) {
              $scope.$apply(function () {
                fn($scope, {$event: event});
              });
            }

            if (events) {
              events = events.replace(/,/g, ' ');
              $element.on(events, fnEvent);
              $scope.$on('$destroy', function () {
                $element.off(events, fnEvent);
              });
            }
          };
        }
      };
    }]);
})();

/**
 * Created by pedro on 17/01/17.
 */
(function () {
  'use strict';

  angular.module('pl.comps')
    .provider('plLocale', function () {
      var dictionary = {
        en: {
          today: 'Today',
          day: 'Day',
          week: 'Week',
          month: 'Month',
          year: 'Year',
          months: {
            january: 'January',
            february: 'February',
            march: 'March',
            april: 'April',
            may: 'May',
            june: 'June',
            july: 'July',
            august: 'August',
            september: 'September',
            october: 'October',
            november: 'November',
            december: 'December'
          },
          weekdays: {
            sunday: 'Sunday',
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday'
          },
          autocomplete: {
            textSearching: 'searching...',
            textEmpty: 'no results',
            textNotFound: 'not found'
          },
          placeholders: {
            search: 'Filter menu...',
            tableGroupBy: 'Drag a column header here to group by that column'
          },
          btn: {
            goBack: 'Previous',
            goForward: 'Next',
            finalize: 'Finish',
            submit: 'Submit',
            search: 'Search',
            ok: 'OK',
            cancel: 'Cancel',
            apply: 'Apply',
            addFilter: 'Add filter'
          },
          text: {
            lines: 'Lines',
            close: 'Close',
            now: 'Now',
            clear: 'Clear',
            open: 'Open',
            initialize: 'Initializing',
            noFilters: 'No available filters',
            activeFilters: 'Active filters',
            clearFilters: 'Clear active filters',
            true: 'True',
            false: 'False'
          },
          messages: {
            switchRequiredInvalidMessage: 'At least one field must be active',
            pdfJsLoadError: 'Error reading the document',
            pdfJsNoDocument: 'No document loaded'
          },
          validators: {
            date: 'Invalid date',
            datetimelocal: 'Invalid date',
            email: 'Invalid email',
            max: 'This field can\'t have a value greater than {{max.value}}',
            maxlength: 'This field has a maximum length of {{maxlength.value}} characters',
            maxSelected: 'This field can not have more than {{maxselected.value}} selected element(s)',
            min: 'This field can\'t be less than {{min.value}}',
            minlength: 'This field has a minimum length of {{minlength.value}} characters',
            minSelected: 'This field must have at least {{minselected.value}} selected element(s)',
            month: 'Invalid month',
            number: 'Invalid number',
            pattern: 'Invalid field',
            required: 'This field is required',
            time: 'Invalid field',
            url: 'Invalid field',
            week: 'Invalid field'
          }
        },
        'pt-pt': {
          today: 'Hoje',
          day: 'Dia',
          week: 'Semana',
          month: 'Mês',
          year: 'Ano',
          months: {
            january: 'Janeiro',
            february: 'Fevereiro',
            march: 'Março',
            april: 'Abril',
            may: 'Maio',
            june: 'Junho',
            july: 'Julho',
            august: 'Agosto',
            september: 'Setembro',
            october: 'Outubro',
            november: 'Novembro',
            december: 'Dezembro'
          },
          weekdays: {
            sunday: 'Domingo',
            monday: 'Segunda-feira',
            tuesday: 'Terça-feira',
            wednesday: 'Quarta-feira',
            thursday: 'Quinta-feira',
            friday: 'Sexta-feira',
            saturday: 'Sábado'
          },
          autocomplete: {
            textSearching: 'a pesquisar...',
            textEmpty: 'sem resultados',
            textNotFound: 'não encontrado'
          },
          placeholders: {
            search: 'Filtrar menu...',
            tableGroupBy: 'Arraste uma coluna para esta zona para agrupar por essa coluna'
          },
          btn: {
            goBack: 'Retroceder',
            goForward: 'Avançar',
            finalize: 'Finalizar',
            submit: 'Submeter',
            search: 'Pesquisar',
            ok: 'OK',
            cancel: 'Cancelar',
            apply: 'Aplicar',
            addFilter: 'Adicionar filtro'
          },
          text: {
            lines: 'Linhas',
            close: 'Fechar',
            now: 'Agora',
            clear: 'Limpar',
            open: 'Abrir',
            initialize: 'A inicializar',
            noFilters: 'Sem filtros',
            activeFilters: 'Filtros ativos',
            clearFilters: 'Limpar filtros ativos',
            true: 'Verdadeiro',
            false: 'Falso'
          },
          messages: {
            switchRequiredInvalidMessage: 'É necessário ter pelo menos um campo ativo',
            pdfJsLoadError: 'Erro a ler o documento',
            pdfJsNoDocument: 'Sem documento'
          },
          validators: {
            date: 'Data inválida',
            datetimelocal: 'Data inválida',
            email: 'Email inválido',
            max: 'Este campo não pode ter um valor superior a {{max.value}}',
            maxlength: 'Este campo tem um tamanho máximo de {{maxlength.value}} caracteres',
            maxSelected: 'Este campo não pode ter mais de {{maxselected.value}} elemento(s) selecionados',
            min: 'Este campo não pode ter um valor inferior a {{min.value}}',
            minlength: 'Este campo tem um tamanho mínimo de {{minlength.value}} caracteres',
            minSelected: 'Este campo tem de ter pelo menos {{minselected.value}} elemento(s) selecionados',
            month: 'Mês inválido',
            number: 'Número inválido',
            pattern: 'Campo inválido',
            required: 'Este campo é obrigatório',
            time: 'Campo inválido',
            url: 'Campo inválido',
            week: 'Campo inválido'
          }
        }
      };

      var locales = {};
      var currentLocale = 'pt-pt';

      function addLocale(lang, locales) {
        if (!dictionary[lang]) {
          dictionary[lang] = _.merge({}, dictionary.en, locales);
        }
      }

      function setLocale(lang, locales) {
        dictionary[lang] = _.merge({}, dictionary.en, locales);
      }

      function applyLocale(locale) {
        if (angular.isDefined(dictionary[locale]) && dictionary[locale] !== null) {
          locales = dictionary[locale];
          currentLocale = locale;
          return true;
        }
        return false;
      }

      (function init() {
        applyLocale('pt-pt');
      })();

      return {
        setLocale: setLocale,
        addLocale: addLocale,
        applyLocale: applyLocale,
        $get: /*@ngInject*/ ['$rootScope', 'amMoment', function ($rootScope, amMoment) {
          return {
            setLocale: setLocale,
            addLocale: addLocale,
            applyLocale: function (locale) {
              if (applyLocale(locale)) {
                if (locale === 'pt-pt') {
                  amMoment.changeLocale('pt');
                }
                else {
                  amMoment.changeLocale(locale);
                }
                $rootScope.$broadcast('plLocale:appliedLocale', {lang: locale});
              }
            },
            locales: locales,
            locale: currentLocale
          };
        }]
      };
    });
})();

(function () {
  /*
   * Attaches input mask onto input element
   * based on
   * https://github.com/angular-ui/ui-mask
   * http://embed.plnkr.co/gE1WXaXsYI7zpWPkmvVS/preview
   */

  /*jshint -W016 */
  /*jshint -W121 */
  'use strict';

  angular.module('pl.mask', [])
    .value('plMaskConfig', {
      maskDefinitions: {
        '9': /\d/,
        'A': /[a-zA-Z]/,
        '*': /[a-zA-Z0-9]/,
        'D': '^(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])(19|20)\\d\\d$|^(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])(19|20)\\d$' +
        '|^(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])(19|20)$' +
        '|^(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[12]$' +
        '|^(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])$' +
        '|^(0[1-9]|1[012])([0-3])$' +
        '|^(0[1-9]|1[012])$' +
        '|^[01]$'
      },
      clearOnBlur: true,
      clearOnBlurPlaceholder: false,
      escChar: '\\',
      eventsToHandle: ['input', 'keyup', 'click', 'focus'],
      addDefaultPlaceholder: true,
      allowInvalidValue: true
    })
    .provider('plMaskConfig', function () {
      var options = {};

      this.maskDefinitions = function (maskDefinitions) {
        options.maskDefinitions = maskDefinitions;
        return options.maskDefinitions;
      };
      this.clearOnBlur = function (clearOnBlur) {
        options.clearOnBlur = clearOnBlur;
        return options.clearOnBlur;
      };
      this.clearOnBlurPlaceholder = function (clearOnBlurPlaceholder) {
        options.clearOnBlurPlaceholder = clearOnBlurPlaceholder;
        return options.clearOnBlurPlaceholder;
      };
      this.eventsToHandle = function (eventsToHandle) {
        options.eventsToHandle = eventsToHandle;
        return options.eventsToHandle;
      };
      this.addDefaultPlaceholder = function (addDefaultPlaceholder) {
        options.addDefaultPlaceholder = addDefaultPlaceholder;
        return options.addDefaultPlaceholder;
      };
      this.allowInvalidValue = function (allowInvalidValue) {
        options.allowInvalidValue = allowInvalidValue;
        return options.allowInvalidValue;
      };
      this.$get = ['uiMaskConfig', function (uiMaskConfig) {
        var tempOptions = uiMaskConfig;
        for (var prop in options) {
          if (angular.isObject(options[prop]) && !angular.isArray(options[prop])) {
            _.merge(tempOptions[prop], options[prop]);
          } else {
            tempOptions[prop] = options[prop];
          }
        }

        return tempOptions;
      }];
    })
    .directive('plMask', ['maskConfig', function (maskConfig) {
      function isFocused(elem) {
        return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
      }

      return {
        priority: 100,
        require: 'ngModel',
        restrict: 'A',
        compile: function uiMaskCompilingFunction() {
          var options = angular.copy(maskConfig);

          return function uiMaskLinkingFunction(scope, iElement, iAttrs, controller) {
            var maskProcessed = false, eventsBound = false,
              maskCaretMap, maskPatterns, maskPlaceholder, maskComponents,
              // Minimum required length of the value to be considered valid
              minRequiredLength,
              value, valueMasked, isValid,
              // Vars for initializing/uninitializing
              originalPlaceholder = iAttrs.placeholder,
              originalMaxlength = iAttrs.maxlength,
              // Vars used exclusively in eventHandler()
              oldValue, oldValueUnmasked, oldCaretPosition, oldSelectionLength,
              // Used for communicating if a backspace operation should be allowed between
              // keydownHandler and eventHandler
              preventBackspace;
            var linkOptions = {};

            var originalIsEmpty = controller.$isEmpty;
            controller.$isEmpty = function (value) {
              if (maskProcessed) {
                return originalIsEmpty(unmaskValue(value || ''));
              } else {
                return originalIsEmpty(value);
              }
            };

            function initialize(maskAttr) {
              if (!angular.isDefined(maskAttr)) {
                return uninitialize();
              }
              processRawMask(maskAttr);
              if (!maskProcessed) {
                return uninitialize();
              }
              initializeElement();
              bindEventListeners();
              return true;
            }

            function initPlaceholder(placeholderAttr) {
              if (!placeholderAttr) {
                return;
              }

              maskPlaceholder = placeholderAttr;

              // If the mask is processed, then we need to update the value
              // but don't set the value if there is nothing entered into the element
              // and there is a placeholder attribute on the element because that
              // will only set the value as the blank maskPlaceholder
              // and override the placeholder on the element
              if (maskProcessed && !(iElement.val().length === 0 && angular.isDefined(iAttrs.placeholder))) {
                iElement.val(maskValue(unmaskValue(iElement.val())));
              }
            }

            function initPlaceholderChar() {
              return initialize(iAttrs.uiMask);
            }

            var modelViewValue = false;
            iAttrs.$observe('modelViewValue', function (val) {
              if (val === 'true') {
                modelViewValue = true;
              }
            });

            iAttrs.$observe('allowInvalidValue', function (val) {
              linkOptions.allowInvalidValue = val === '' ? true : !!val;
              formatter(controller.$modelValue);
            });

            function formatter(fromModelValue) {
              if (!maskProcessed) {
                return fromModelValue;
              }
              value = unmaskValue(fromModelValue || '');
              isValid = validateValue(value);
              controller.$setValidity('mask', isValid);

              if (!value.length) return undefined;
              if (isValid || linkOptions.allowInvalidValue) {
                return maskValue(value);
              } else {
                return undefined;
              }
            }

            function parser(fromViewValue) {
              if (!maskProcessed) {
                return fromViewValue;
              }
              value = unmaskValue(fromViewValue || '');
              isValid = validateValue(value);
              // We have to set viewValue manually as the reformatting of the input
              // value performed by eventHandler() doesn't happen until after
              // this parser is called, which causes what the user sees in the input
              // to be out-of-sync with what the controller's $viewValue is set to.
              controller.$viewValue = value.length ? maskValue(value) : '';
              controller.$setValidity('mask', isValid);

              if (isValid || linkOptions.allowInvalidValue) {
                return modelViewValue ? controller.$viewValue : value;
              }
            }


            if (iAttrs.uiOptions) {
              linkOptions = scope.$eval('[' + iAttrs.uiOptions + ']');
              if (angular.isObject(linkOptions[0])) {
                // we can't use angular.copy nor _.merge, they lack the power to do a deep merge
                linkOptions = (function (original, current) {
                  for (var i in original) {
                    if (Object.prototype.hasOwnProperty.call(original, i)) {
                      if (current[i] === undefined) {
                        current[i] = angular.copy(original[i]);
                      } else {
                        if (angular.isObject(current[i]) && !angular.isArray(current[i])) {
                          current[i] = _.merge({}, original[i], current[i]);
                        }
                      }
                    }
                  }
                  return current;
                })(options, linkOptions[0]);
              } else {
                linkOptions = options;  //gotta be a better way to do this..
              }
            } else {
              linkOptions = options;
            }

            iAttrs.$observe('uiMask', initialize);
            if (angular.isDefined(iAttrs.uiMaskPlaceholder)) {
              iAttrs.$observe('uiMaskPlaceholder', initPlaceholder);
            }
            else {
              iAttrs.$observe('placeholder', initPlaceholder);
            }
            if (angular.isDefined(iAttrs.uiMaskPlaceholderChar)) {
              iAttrs.$observe('uiMaskPlaceholderChar', initPlaceholderChar);
            }

            controller.$formatters.unshift(formatter);
            controller.$parsers.unshift(parser);

            function uninitialize() {
              maskProcessed = false;
              unbindEventListeners();

              if (angular.isDefined(originalPlaceholder)) {
                iElement.attr('placeholder', originalPlaceholder);
              } else {
                iElement.removeAttr('placeholder');
              }

              if (angular.isDefined(originalMaxlength)) {
                iElement.attr('maxlength', originalMaxlength);
              } else {
                iElement.removeAttr('maxlength');
              }

              iElement.val(controller.$modelValue);
              controller.$viewValue = controller.$modelValue;
              return false;
            }

            function initializeElement() {
              value = oldValueUnmasked = unmaskValue(controller.$modelValue || '');
              valueMasked = oldValue = maskValue(value);
              isValid = validateValue(value);
              if (iAttrs.maxlength) { // Double maxlength to allow pasting new val at end of mask
                iElement.attr('maxlength', maskCaretMap[maskCaretMap.length - 1] * 2);
              }
              if (!originalPlaceholder && linkOptions.addDefaultPlaceholder) {
                iElement.attr('placeholder', maskPlaceholder);
              }
              var viewValue = controller.$modelValue;
              var idx = controller.$formatters.length;
              while (idx--) {
                viewValue = controller.$formatters[idx](viewValue);
              }
              controller.$viewValue = viewValue || '';
              controller.$render();
              // Not using $setViewValue so we don't clobber the model value and dirty the form
              // without any kind of user interaction.
            }

            function bindEventListeners() {
              if (eventsBound) {
                return;
              }
              iElement.bind('blur', blurHandler);
              iElement.bind('mousedown mouseup', mouseDownUpHandler);
              iElement.bind('keydown', keydownHandler);
              iElement.bind(linkOptions.eventsToHandle.join(' '), eventHandler);
              eventsBound = true;
            }

            function unbindEventListeners() {
              if (!eventsBound) {
                return;
              }
              iElement.unbind('blur', blurHandler);
              iElement.unbind('mousedown', mouseDownUpHandler);
              iElement.unbind('mouseup', mouseDownUpHandler);
              iElement.unbind('keydown', keydownHandler);
              iElement.unbind('input', eventHandler);
              iElement.unbind('keyup', eventHandler);
              iElement.unbind('click', eventHandler);
              iElement.unbind('focus', eventHandler);
              eventsBound = false;
            }

            function validateValue(value) {
              // Zero-length value validity is ngRequired's determination
              return value.length ? value.length >= minRequiredLength : true;
            }

            function unmaskValue(value) {
              var valueUnmasked = '',
                input = iElement[0],
                maskPatternsCopy = maskPatterns.slice(),
                selectionStart = oldCaretPosition,
                selectionEnd = selectionStart + getSelectionLength(input),
                valueOffset, valueDelta, tempValue = '';
              // Preprocess by stripping mask components from value
              value = value.toString();
              valueOffset = 0;
              valueDelta = value.length - maskPlaceholder.length;
              angular.forEach(maskComponents, function (component) {
                var position = component.position;
                //Only try and replace the component if the component position is not within the selected range
                //If component was in selected range then it was removed with the user input so no need to try and remove that component
                if (!(position >= selectionStart && position < selectionEnd)) {
                  if (position >= selectionStart) {
                    position += valueDelta;
                  }
                  if (value.substring(position, position + component.value.length) === component.value) {
                    tempValue += value.slice(valueOffset, position);// + value.slice(position + component.value.length);
                    valueOffset = position + component.value.length;
                  }
                }
              });
              value = tempValue + value.slice(valueOffset);
              angular.forEach(value.split(''), function (chr) {
                if (maskPatternsCopy.length && maskPatternsCopy[0].test(chr)) {
                  valueUnmasked += chr;
                  maskPatternsCopy.shift();
                }
              });

              return valueUnmasked;
            }

            function maskValue(unmaskedValue) {
              var valueMasked = '',
                maskCaretMapCopy = maskCaretMap.slice();

              angular.forEach(maskPlaceholder.split(''), function (chr, i) {
                if (unmaskedValue.length && i === maskCaretMapCopy[0]) {
                  valueMasked += unmaskedValue.charAt(0) || '_';
                  unmaskedValue = unmaskedValue.substr(1);
                  maskCaretMapCopy.shift();
                }
                else {
                  valueMasked += chr;
                }
              });
              return valueMasked;
            }

            function getPlaceholderChar(i) {
              var placeholder = angular.isDefined(iAttrs.uiMaskPlaceholder) ? iAttrs.uiMaskPlaceholder : iAttrs.placeholder,
                defaultPlaceholderChar;

              if (angular.isDefined(placeholder) && placeholder[i]) {
                return placeholder[i];
              } else {
                defaultPlaceholderChar = angular.isDefined(iAttrs.uiMaskPlaceholderChar) && iAttrs.uiMaskPlaceholderChar ? iAttrs.uiMaskPlaceholderChar : '_';
                return (defaultPlaceholderChar.toLowerCase() === 'space') ? ' ' : defaultPlaceholderChar[0];
              }
            }

            // Generate array of mask components that will be stripped from a masked value
            // before processing to prevent mask components from being added to the unmasked value.
            // E.g., a mask pattern of '+7 9999' won't have the 7 bleed into the unmasked value.
            function getMaskComponents() {
              var maskPlaceholderChars = maskPlaceholder.split(''),
                maskPlaceholderCopy, components;

              //maskCaretMap can have bad values if the input has the ui-mask attribute implemented as an obversable property, e.g. the demo page
              if (maskCaretMap && !isNaN(maskCaretMap[0])) {
                //Instead of trying to manipulate the RegEx based on the placeholder characters
                //we can simply replace the placeholder characters based on the already built
                //maskCaretMap to underscores and leave the original working RegEx to get the proper
                //mask components
                angular.forEach(maskCaretMap, function (value) {
                  maskPlaceholderChars[value] = '_';
                });
              }
              maskPlaceholderCopy = maskPlaceholderChars.join('');
              components = maskPlaceholderCopy.replace(/[_]+/g, '_').split('_');
              components = components.filter(function (s) {
                return s !== '';
              });

              // need a string search offset in cases where the mask contains multiple identical components
              // E.g., a mask of 99.99.99-999.99
              var offset = 0;
              return components.map(function (c) {
                var componentPosition = maskPlaceholderCopy.indexOf(c, offset);
                offset = componentPosition + 1;
                return {
                  value: c,
                  position: componentPosition
                };
              });
            }

            function processRawMask(mask) {
              var characterCount = 0;

              maskCaretMap = [];
              maskPatterns = [];
              maskPlaceholder = '';

              if (angular.isString(mask)) {
                minRequiredLength = 0;

                var isOptional = false,
                  numberOfOptionalCharacters = 0,
                  splitMask = mask.split('');

                var inEscape = false;
                angular.forEach(splitMask, function (chr, i) {
                  if (inEscape) {
                    inEscape = false;
                    maskPlaceholder += chr;
                    characterCount++;
                  }
                  else if (linkOptions.escChar === chr) {
                    inEscape = true;
                  }
                  else if (linkOptions.maskDefinitions[chr]) {
                    maskCaretMap.push(characterCount);

                    maskPlaceholder += getPlaceholderChar(i - numberOfOptionalCharacters);
                    maskPatterns.push(linkOptions.maskDefinitions[chr]);

                    characterCount++;
                    if (!isOptional) {
                      minRequiredLength++;
                    }

                    isOptional = false;
                  }
                  else if (chr === '?') {
                    isOptional = true;
                    numberOfOptionalCharacters++;
                  }
                  else {
                    maskPlaceholder += chr;
                    characterCount++;
                  }
                });
              }
              // Caret position immediately following last position is valid.
              maskCaretMap.push(maskCaretMap.slice().pop() + 1);

              maskComponents = getMaskComponents();
              maskProcessed = maskCaretMap.length > 1 ? true : false;
            }

            var prevValue = iElement.val();

            function blurHandler() {
              if (linkOptions.clearOnBlur || ((linkOptions.clearOnBlurPlaceholder) && (value.length === 0) && iAttrs.placeholder)) {
                oldCaretPosition = 0;
                oldSelectionLength = 0;
                if (!isValid || value.length === 0) {
                  valueMasked = '';
                  iElement.val('');
                  scope.$apply(function () {
                    //only $setViewValue when not $pristine to avoid changing $pristine state.
                    if (!controller.$pristine) {
                      controller.$setViewValue('');
                    }
                  });
                }
              }
              //Check for different value and trigger change.
              //Check for different value and trigger change.
              if (value !== prevValue) {
                // #157 Fix the bug from the trigger when backspacing exactly on the first letter (emptying the field)
                // and then blurring out.
                // Angular uses html element and calls setViewValue(element.value.trim()), setting it to the trimmed mask
                // when it should be empty
                var currentVal = iElement.val();
                var isTemporarilyEmpty = value === '' && currentVal && angular.isDefined(iAttrs.uiMaskPlaceholderChar) && iAttrs.uiMaskPlaceholderChar === 'space';
                if (isTemporarilyEmpty) {
                  iElement.val('');
                }
                triggerChangeEvent(iElement[0]);
                if (isTemporarilyEmpty) {
                  iElement.val(currentVal);
                }
              }
              prevValue = value;
            }

            function triggerChangeEvent(element) {
              var change;
              if (angular.isFunction(window.Event) && !element.fireEvent) {
                // modern browsers and Edge
                try {
                  change = new Event('change', {
                    view: window,
                    bubbles: true,
                    cancelable: false
                  });
                } catch (ex) {
                  //this is for certain mobile browsers that have the Event object
                  //but don't support the Event constructor #168
                  change = document.createEvent('HTMLEvents');
                  change.initEvent('change', false, true);
                } finally {
                  element.dispatchEvent(change);
                }
              } else if ('createEvent' in document) {
                // older browsers
                change = document.createEvent('HTMLEvents');
                change.initEvent('change', false, true);
                element.dispatchEvent(change);
              }
              else if (element.fireEvent) {
                // IE <= 11
                element.fireEvent('onchange');
              }
            }

            function mouseDownUpHandler(e) {
              if (e.type === 'mousedown') {
                iElement.bind('mouseout', mouseoutHandler);
              } else {
                iElement.unbind('mouseout', mouseoutHandler);
              }
            }

            iElement.bind('mousedown mouseup', mouseDownUpHandler);

            function mouseoutHandler() {
              /*jshint validthis: true */
              oldSelectionLength = getSelectionLength(this);
              iElement.unbind('mouseout', mouseoutHandler);
            }

            function keydownHandler(e) {
              /*jshint validthis: true */
              var isKeyBackspace = e.which === 8,
                caretPos = getCaretPosition(this) - 1 || 0, //value in keydown is pre change so bump caret position back to simulate post change
                isCtrlZ = e.which === 90 && e.ctrlKey; //ctrl+z pressed

              if (isKeyBackspace) {
                while (caretPos >= 0) {
                  if (isValidCaretPosition(caretPos)) {
                    //re-adjust the caret position.
                    //Increment to account for the initial decrement to simulate post change caret position
                    setCaretPosition(this, caretPos + 1);
                    break;
                  }
                  caretPos--;
                }
                preventBackspace = caretPos === -1;
              }

              if (isCtrlZ) {
                // prevent IE bug - value should be returned to initial state
                iElement.val('');
                e.preventDefault();
              }
            }

            function eventHandler(e) {
              /*jshint validthis: true */
              e = e || {};
              // Allows more efficient minification
              var eventWhich = e.which,
                eventType = e.type;

              // Prevent shift and ctrl from mucking with old values
              if (eventWhich === 16 || eventWhich === 91) {
                return;
              }

              var val = iElement.val(),
                valOld = oldValue,
                valMasked,
                valAltered = false,
                valUnmasked = unmaskValue(val),
                valUnmaskedOld = oldValueUnmasked,
                caretPos = getCaretPosition(this) || 0,
                caretPosOld = oldCaretPosition || 0,
                caretPosDelta = caretPos - caretPosOld,
                caretPosMin = maskCaretMap[0],
                caretPosMax = maskCaretMap[valUnmasked.length] || maskCaretMap.slice().shift(),
                selectionLenOld = oldSelectionLength || 0,
                isSelected = getSelectionLength(this) > 0,
                wasSelected = selectionLenOld > 0,
                // Case: Typing a character to overwrite a selection
                isAddition = (val.length > valOld.length) || (selectionLenOld && val.length > valOld.length - selectionLenOld),
                // Case: Delete and backspace behave identically on a selection
                isDeletion = (val.length < valOld.length) || (selectionLenOld && val.length === valOld.length - selectionLenOld),
                isSelection = (eventWhich >= 37 && eventWhich <= 40) && e.shiftKey, // Arrow key codes

                isKeyLeftArrow = eventWhich === 37,
                // Necessary due to "input" event not providing a key code
                isKeyBackspace = eventWhich === 8 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === -1)),
                isKeyDelete = eventWhich === 46 || (eventType !== 'keyup' && isDeletion && (caretPosDelta === 0) && !wasSelected),
                // Handles cases where caret is moved and placed in front of invalid maskCaretMap position. Logic below
                // ensures that, on click or leftward caret placement, caret is moved leftward until directly right of
                // non-mask character. Also applied to click since users are (arguably) more likely to backspace
                // a character when clicking within a filled input.
                caretBumpBack = (isKeyLeftArrow || isKeyBackspace || eventType === 'click') && caretPos > caretPosMin;

              oldSelectionLength = getSelectionLength(this);

              // These events don't require any action
              if (isSelection || (isSelected && (eventType === 'click' || eventType === 'keyup' || eventType === 'focus'))) {
                return;
              }

              if (isKeyBackspace && preventBackspace) {
                iElement.val(maskPlaceholder);
                // This shouldn't be needed but for some reason after aggressive backspacing the controller $viewValue is incorrect.
                // This keeps the $viewValue updated and correct.
                scope.$apply(function () {
                  controller.$setViewValue(''); // $setViewValue should be run in angular context, otherwise the changes will be invisible to angular and user code.
                });
                setCaretPosition(this, caretPosOld);
                return;
              }

              // Value Handling
              // ==============

              // User attempted to delete but raw value was unaffected--correct this grievous offense
              if ((eventType === 'input') && isDeletion && !wasSelected && valUnmasked === valUnmaskedOld) {
                while (isKeyBackspace && caretPos > caretPosMin && !isValidCaretPosition(caretPos)) {
                  caretPos--;
                }
                while (isKeyDelete && caretPos < caretPosMax && maskCaretMap.indexOf(caretPos) === -1) {
                  caretPos++;
                }
                var charIndex = maskCaretMap.indexOf(caretPos);
                // Strip out non-mask character that user would have deleted if mask hadn't been in the way.
                valUnmasked = valUnmasked.substring(0, charIndex) + valUnmasked.substring(charIndex + 1);

                // If value has not changed, don't want to call $setViewValue, may be caused by IE raising input event due to placeholder
                if (valUnmasked !== valUnmaskedOld)
                  valAltered = true;
              }

              // Update values
              valMasked = maskValue(valUnmasked);

              oldValue = valMasked;
              oldValueUnmasked = valUnmasked;

              //additional check to fix the problem where the viewValue is out of sync with the value of the element.
              //better fix for commit 2a83b5fb8312e71d220a497545f999fc82503bd9 (I think)
              if (!valAltered && val.length > valMasked.length)
                valAltered = true;

              iElement.val(valMasked);

              //we need this check.  What could happen if you don't have it is that you'll set the model value without the user
              //actually doing anything.  Meaning, things like pristine and touched will be set.
              if (valAltered) {
                scope.$apply(function () {
                  controller.$setViewValue(valMasked); // $setViewValue should be run in angular context, otherwise the changes will be invisible to angular and user code.
                });
              }

              // Caret Repositioning
              // ===================

              // Ensure that typing always places caret ahead of typed character in cases where the first char of
              // the input is a mask char and the caret is placed at the 0 position.
              if (isAddition && (caretPos <= caretPosMin)) {
                caretPos = caretPosMin + 1;
              }

              if (caretBumpBack) {
                caretPos--;
              }

              // Make sure caret is within min and max position limits
              caretPos = caretPos > caretPosMax ? caretPosMax : caretPos < caretPosMin ? caretPosMin : caretPos;

              // Scoot the caret back or forth until it's in a non-mask position and within min/max position limits
              while (!isValidCaretPosition(caretPos) && caretPos > caretPosMin && caretPos < caretPosMax) {
                caretPos += caretBumpBack ? -1 : 1;
              }

              if ((caretBumpBack && caretPos < caretPosMax) || (isAddition && !isValidCaretPosition(caretPosOld))) {
                caretPos++;
              }
              oldCaretPosition = caretPos;
              setCaretPosition(this, caretPos);
            }

            function isValidCaretPosition(pos) {
              return maskCaretMap.indexOf(pos) > -1;
            }

            function getCaretPosition(input) {
              if (!input)
                return 0;
              if (input.selectionStart !== undefined) {
                return input.selectionStart;
              } else if (document.selection) {
                if (isFocused(iElement[0])) {
                  // Curse you IE
                  input.focus();
                  var selection = document.selection.createRange();
                  selection.moveStart('character', input.value ? -input.value.length : 0);
                  return selection.text.length;
                }
              }
              return 0;
            }

            function setCaretPosition(input, pos) {
              if (!input)
                return 0;
              if (input.offsetWidth === 0 || input.offsetHeight === 0) {
                return; // Input's hidden
              }
              if (input.setSelectionRange) {
                if (isFocused(iElement[0])) {
                  input.focus();
                  input.setSelectionRange(pos, pos);
                }
              }
              else if (input.createTextRange) {
                // Curse you IE
                var range = input.createTextRange();
                range.collapse(true);
                range.moveEnd('character', pos);
                range.moveStart('character', pos);
                range.select();
              }
            }

            function getSelectionLength(input) {
              if (!input)
                return 0;
              if (input.selectionStart !== undefined) {
                return (input.selectionEnd - input.selectionStart);
              }
              if (window.getSelection) {
                return (window.getSelection().toString().length);
              }
              if (document.selection) {
                return (document.selection.createRange().text.length);
              }
              return 0;
            }

            // https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Array/indexOf
            if (!Array.prototype.indexOf) {
              Array.prototype.indexOf = function (searchElement /*, fromIndex */) {
                if (this === null) {
                  throw new TypeError();
                }
                var t = Object(this);
                var len = t.length >>> 0;
                if (len === 0) {
                  return -1;
                }
                var n = 0;
                if (arguments.length > 1) {
                  n = Number(arguments[1]);
                  if (n !== n) { // shortcut for verifying if it's NaN
                    n = 0;
                  } else if (n !== 0 && n !== Infinity && n !== -Infinity) {
                    n = (n > 0 || -1) * Math.floor(Math.abs(n));
                  }
                }
                if (n >= len) {
                  return -1;
                }
                var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
                for (; k < len; k++) {
                  if (k in t && t[k] === searchElement) {
                    return k;
                  }
                }
                return -1;
              };
            }

          };
        }
      };
    }
    ]);
})();

(function () {
  'use strict';

  angular.module('pl.edit')
    .component('plMessages', {
      require: {
        form: '?^form',
        plGroup: '?^plGroup',
        plEdit: '?^plEdit',
        plInlineEdit: '?^^plInlineEdit',
        plNavWizardStep: '?^^plNavWizardStep'
      },
      bindings: {
        target: '@',
        validate: '<',
        properties: '<?'
      },
      templateUrl: '../source/pl-messages.html',
      controller: /*@ngInject*/ ['$log', '$q', '$element', '$interpolate', 'plCompsService', 'plValidate', 'plTranslate', 'plLocale', function ($log, $q, $element, $interpolate, plCompsService, plValidate, plTranslate, plLocale) {
        var ctrl = this;
        var locales = plLocale.locales;
        var defaultOptions = {
          date: {value: null, message: locales.validators.date},
          datetimelocal: {value: null, message: locales.validators.datetimelocal},
          email: {value: null, message: locales.validators.email},
          max: {value: null, message: locales.validators.max},
          maxlength: {value: null, message: locales.validators.maxlength},
          maxselected: {value: null, message: locales.validators.maxSelected},
          min: {value: null, message: locales.validators.min},
          minlength: {value: null, message: locales.validators.minlength},
          minselected: {value: null, message: locales.validators.minSelected},
          month: {value: null, message: locales.validators.month},
          number: {value: null, message: locales.validators.number},
          pattern: {value: null, message: locales.validators.pattern},
          required: {value: false, message: locales.validators.required},
          time: {value: null, message: locales.validators.time},
          url: {value: null, message: locales.validators.url},
          week: {value: null, message: locales.validators.week},
          /* Not real validators, but are here to avoid errors */
          decimals: {value: null, message: ''}
        };
        var defaultValidators = angular.copy(defaultOptions);

        ctrl.options = {};
        ctrl.target = null;

        ctrl.$postLink = postLink;
        ctrl.$onChanges = onChanges;
        ctrl.handleValues = handleValues;
        ctrl.customValidators = customValidators;
        ctrl.updateValidator = updateValidator;
        ctrl.checkGroupError = checkGroupError;

        /////////////

        function postLink() {
          if (ctrl.plEdit) {
            if (!ctrl.target && ctrl.plEdit.name) {
              ctrl.target = ctrl.plEdit.name;
            }
            ctrl.plEdit.addValidator(ctrl);
            if (ctrl.plEdit.options && ctrl.plEdit.options.validators) {
              ctrl.options = _.merge({}, defaultOptions, ctrl.plEdit.options.validators);
            }
          }
          ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties);

          ctrl.target = ctrl.target || null;

          ctrl.customValidators();
          ctrl.handleValues();
        }

        function onChanges(messages) {
          if (messages) {
            ctrl.checkGroupError();
            if (messages.validate && !messages.validate.isFirstChange()) {
              ctrl.$postLink();
            }
          }
        }

        function handleValues() {
          angular.forEach(ctrl.options, function (option) {
            if (option) {
              if (!angular.isObject(option)) {
                option = {value: option};
              }
              option.error = plTranslate.translate($interpolate(option.message || '')(ctrl.options));
            }
          });
        }

        function customValidators() {
          // Adding custom validators to ngModel's validators
          var $input = $element.parent().find('input,select,textarea,.ui-select-container');
          var model = $input.controller('ngModel');
          if (!model) {
            return;
          }
          var validators = plValidate.getValidators();
          ctrl.options = _.merge({}, validators, ctrl.options);

          // Handling custom validators (including unregistered ones)
          plCompsService.debounce(function () {
            angular.forEach(ctrl.options, function (validator, property) {
              if (!defaultValidators[property]) {
                // If validator is not a promise
                if (!angular.isFunction(validator)) {
                  var data = angular.copy(validator);
                  validator = function () {
                    // Fix for when a non validator property is inherited
                    return data;
                  };
                }

                model.$asyncValidators[property] = function (modelValue) {
                  // Main validation object
                  return $q.when(validator()).then(function (response) {
                    ctrl.options[property] = response;
                    ctrl.handleValues();

                    if (ctrl.validate === false) {
                      return $q.resolve(true);
                    }
                    else {
                      // Validation function
                      try {
                        var promise = $q.when(response.validate(response.value, modelValue, model, $input));
                        if (!angular.isFunction(response.callback)) {
                          return promise.then(function (response) {
                            return response === true ? $q.resolve(true) : $q.reject(false);
                          });
                        }
                        // In case a need for manual response handling arises
                        else {
                          return response.callback(promise).then(
                            function (response) {
                              return $q.resolve(response);
                            },
                            function (error) {
                              return $q.reject(error);
                            }
                          );
                        }
                      }
                      catch (exception) {
                        $log.warn('An error was thrown while trying to validate the component `' + ctrl.target + '` with validation `' + property + '`.' +
                          ' Check the trace log for more information.');
                        $log.error(exception);
                        return $q.resolve(true);
                      }
                    }
                  });
                };
              }
            });
          }, 50, 'plMessagesCustomValidators' + ctrl.target);
        }

        function updateValidator(validators) {
          if (!ctrl.target) {
            return;
          }
          if (validators && validators !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, validators, ctrl.properties);
          }
          ctrl.customValidators();
          ctrl.handleValues();
        }

        function checkGroupError() {
          // This method is called by this directive's plEdit parent when $onCheck is called
          if (ctrl.target && ctrl.form && ctrl.form[ctrl.target] && ctrl.plGroup && ctrl.plGroup.options) {
            ctrl.plGroup.options.hasError = ctrl.form[ctrl.target].$invalid;
            if (ctrl.plGroup.options.hasError && ctrl.plNavWizardStep) {
              ctrl.plNavWizardStep.setComplete(false);
            }
          }
        }
      }]
    });
})();

/**
 * Created by pedro on 12/12/16.
 */
(function () {
  'use strict';

  angular.module('pl.multiselect', [])
    .component('plMultiselect', {
      require: {
        ngModel: 'ngModel',
        plForm: '?^plForm',
        plEdit: '?^plEdit'
      },
      bindings: {
        source: '<',
        name: '@?',
        template: '<?',
        key: '@?',
        onAllLeft: '&?',
        onAllRight: '&?',
        onSelectedLeft: '&?',
        onSelectedRight: '&?',
        callback: '<?',
        onChange: '&?',
        properties: '<?'
      },
      transclude: true,
      templateUrl: '../source/pl-multiselect.html',
      controller: /*@ngInject*/ ['$scope', '$element', '$interpolate', '$timeout', 'plCompsService', 'plTranslate', 'plLocale', function ($scope, $element, $interpolate, $timeout, plCompsService, plTranslate, plLocale) {
        var ctrl = this;
        var defaultOptions = {
          readonly: false,
          disabled: false,
          validate: true,
          leftCaption: '',
          rightCaption: '',
          validators: {
            minselected: {value: null},
            maxselected: {value: null},
            required: {value: false}
          },
          events: {
            allLeft: undefined,
            allRight: undefined,
            selectedLeft: undefined,
            selectedRight: undefined
          }
        };

        ctrl.value = [];
        ctrl.options = {};
        ctrl.search = plLocale.locales.btn.search;

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.render = render;
        ctrl.validators = validators;
        ctrl.validate = validate;
        ctrl.inList = inList;
        ctrl.find = find;
        ctrl.getKey = getKey;
        ctrl.isInModel = isInModel;
        ctrl.moveAll = moveAll;
        ctrl.move = move;
        ctrl.selectedRight = selectedRight;
        ctrl.allRight = allRight;
        ctrl.selectedLeft = selectedLeft;
        ctrl.allLeft = allLeft;
        ctrl.getRow = getRow;
        ctrl.getLeftCaption = getLeftCaption;
        ctrl.getRightCaption = getRightCaption;
        ctrl.updateComponent = updateComponent;

        ////////////

        function init() {
          if (ctrl.plEdit) {
            ctrl.plEdit.addComponent(ctrl);
            if (ctrl.plEdit.options) {
              _.merge(defaultOptions, ctrl.plEdit.options);
            }
          }
          else {
            ctrl.name = plCompsService.generateName(ctrl.name, 'plEdit');
          }
          ctrl.options = _.merge({}, defaultOptions, ctrl.properties);
          ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;

          ctrl.ngModel.$render = function () {
            var model = ctrl.ngModel.$viewValue;
            if (angular.isDefined(model) && model !== null && !angular.isArray(model)) {
              model = [model];
            }
            ctrl.value = model || [];

            if (!ctrl.source) {
              ctrl.source = [];
            }
            for (var i = 0; i < ctrl.source.length; i++) {
              if (ctrl.source[i] && ctrl.isInModel(ctrl.source[i]) !== -1) {
                ctrl.source.splice(i, 1);
                i = -1;
              }
            }

            // Set custom validators
            ctrl.validators();
          };

          // Set initial required if necessary
          if (ctrl.options.validate && ctrl.options.validators.required.value) {
            $timeout(function () {
              if (!ctrl.value || !ctrl.value.length) {
                var ngModel = $element.find('.pl-multiselect-validator').controller('ngModel');
                if (ngModel) {
                  ngModel.$setValidity('required', false);
                }
              }
            });
          }
        }

        function onChanges(plMultiselect) {
          if (plMultiselect) {
            if (plMultiselect.callback && angular.isObject(ctrl.callback)) {
              ctrl.callback.allLeft = allLeft;
              ctrl.callback.allRight = allRight;
            }
            if (plMultiselect.properties && !plMultiselect.properties.isFirstChange()) {
              ctrl.updateComponent(plMultiselect.properties.currentValue);
            }
            if (plMultiselect.source && !plMultiselect.source.isFirstChange()) {
              if (!ctrl.source) {
                ctrl.source = [];
              }
              for (var i = 0; i < ctrl.source.length; i++) {
                if (ctrl.isInModel(ctrl.source[i]) !== -1) {
                  ctrl.source.splice(i, 1);
                  i = -1;
                }
              }
            }
          }
        }

        function render() {
          ctrl.ngModel.$setViewValue(ctrl.value);
          ctrl.validate();
          if (angular.isFunction(ctrl.onChange)) {
            ctrl.onChange({model: ctrl.value});
          }
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.change)) {
            ctrl.options.events.change(ctrl.value);
          }
        }

        function validators() {
          var modelCtrl = $element.find('.pl-multiselect-validator').controller('ngModel');
          if (!modelCtrl) {
            return;
          }

          // Minimum selected
          if (ctrl.options.validate && ctrl.options.validators.minselected.value !== null) {
            modelCtrl.$validators.minselected = function (modelValue) {
              return angular.isDefined(modelValue) && modelValue !== null && modelValue.length >= ctrl.options.validators.minselected.value;
            };
          }
          else {
            modelCtrl.$validators.minselected = function () {
              return true;
            };
          }

          // Maximum selected
          if (ctrl.options.validate && ctrl.options.validators.maxselected.value !== null) {
            modelCtrl.$validators.maxselected = function (modelValue) {
              return angular.isDefined(modelValue) && modelValue !== null && modelValue.length <= ctrl.options.validators.maxselected.value;
            };
          }
          else {
            modelCtrl.$validators.maxselected = function () {
              return true;
            };
          }
        }

        function validate() {
          ctrl.ngModel.$validate();
          var validator = $element.find('.pl-multiselect-validator').controller('ngModel');
          if (validator) {
            validator.$setDirty();
            validator.$validate();
          }
        }

        function inList(list, item) {
          return ctrl.find(list, ctrl.getKey(item));
        }

        function find(list, key) {
          for (var i = 0; i < list.length; i++) {
            var a = ctrl.getKey(list[i]);
            if ('' + a === '' + key) {
              return i;
            }
          }
          return -1;
        }

        function getKey(item) {
          if (ctrl.key) {
            return item[ctrl.key];
          }
          else {
            return item;
          }
        }

        function isInModel(item) {
          return ctrl.inList(ctrl.value, item);
        }

        function moveAll(left, right) {
          if (!left || !left.length) {
            return;
          }
          for (var i = 0; i < left.length; i++) {
            right.push(left[i]);
          }
          while (left.length) {
            left.pop();
          }
          ctrl.render();
        }

        function move(left, items, right) {
          if (!left || !left.length || !items) {
            return;
          }
          for (var i = 0; i < items.length; i++) {
            var key = items[i];
            var idx = ctrl.find(left, key);
            if (idx !== -1) {
              var item = left[idx];
              right.push(item);
              left.splice(idx, 1);
            }
          }
          ctrl.render();
        }

        function selectedRight(item) {
          var items = ctrl.rights;
          if (item) {
            items = [item];
          }
          ctrl.move(ctrl.source, items, ctrl.value);
          $scope.$emit('selectedRight.pl-multiselect');
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.selectedRight)) {
            ctrl.options.events.selectedRight();
          }
          if (angular.isFunction(ctrl.onSelectedRight)) {
            ctrl.onSelectedRight({item: item, model: ctrl.value, source: ctrl.source});
          }
        }

        function allRight() {
          ctrl.moveAll(ctrl.source, ctrl.value);
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.allRight)) {
            ctrl.options.events.allRight();
          }
          if (angular.isFunction(ctrl.onAllRight)) {
            ctrl.onAllRight();
          }
        }

        function selectedLeft(item) {
          var items = ctrl.lefts;
          if (item) {
            items = [item];
          }
          ctrl.move(ctrl.value, items, ctrl.source);
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.selectedLeft)) {
            ctrl.options.events.selectedLeft();
          }
          if (angular.isFunction(ctrl.onSelectedLeft)) {
            ctrl.onSelectedLeft({item: item});
          }
        }

        function allLeft() {
          ctrl.moveAll(ctrl.value, ctrl.source);
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.allLeft)) {
            ctrl.options.events.allLeft();
          }
          if (angular.isFunction(ctrl.onAllLeft)) {
            ctrl.onAllLeft();
          }
        }

        function getRow(item) {
          if (ctrl.template) {
            return $interpolate(ctrl.template)(item);
          }
          else {
            return item;
          }
        }

        function getLeftCaption() {
          return plTranslate.translate(ctrl.options.leftCaption) || '';
        }

        function getRightCaption() {
          return plTranslate.translate(ctrl.options.rightCaption) || '';
        }

        function updateComponent(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties, properties);
            ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
            ctrl.validators();
          }
        }
      }]
    });
})();

(function () {
  'use strict';

  var sStep = 'step';

  angular.module('pl.comps')
    .component('plNavWizard', {
      require: {
        ngModel: '?ngModel',
        plForm: '?^^plForm'
      },
      bindings: {
        definition: '<',
        instanceId: '@?',
        callback: '<?',
        beforeStepChange: '&?',
        onStepChange: '&?',
        onFinalize: '&?',
        affix: '<?',
        hideFooter: '<?',
        properties: '<?'
      },
      transclude: true,
      templateUrl: '../source/pl-nav-wizard.html',
      controllerAs: '$ctrl',
      controller: /*ngInject*/ ['$location', '$q', '$scope', '$element', '$sce', '$document', 'plCompsService', 'plTranslate', function ($location, $q, $scope, $element, $sce, $document, plCompsService, plTranslate) {
        var ctrl = this;
        var selectorForm = 'form:visible,ng-form:visible';
        var defaultOptions = {
          useUrl: false,
          showActions: true
        };
        var DEFAULTS = {};

        ctrl.selected = null;
        ctrl.previouslySelected = null;
        ctrl.options = {};
        ctrl.promise = null;

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.$onDestroy = onDestroy;
        ctrl.handleChanges = handleChanges;
        ctrl.render = render;
        ctrl.setDefault = setDefault;
        ctrl.setStep = setStep;
        ctrl.validate = validate;
        ctrl.previousStep = previousStep;
        ctrl.nextStep = nextStep;
        ctrl.addStep = addStep;
        ctrl.isStepDisabled = isStepDisabled;
        ctrl.isActionDisabled = isActionDisabled;
        ctrl.animateCurrent = animateCurrent;
        ctrl.getTitle = getTitle;
        ctrl.getItem = getItem;
        ctrl.getItemSize = getItemSize;
        ctrl.calcSeparatorSize = calcSeparatorSize;
        ctrl.resize = resize;
        ctrl.getItemContent = getItemContent;
        ctrl.updateComponent = updateComponent;

        /////////////

        function init() {
          DEFAULTS.definition = {
            type: 'horizontal',
            items: [],
            caption: null,
            vertical: false,
            force: false
          };
          DEFAULTS.definitionItem = {
            id: undefined,
            caption: '',
            template: null,
            templateUrl: null,
            required: true,
            visible: true,
            valid: false,
            validator: undefined,
            complete: false,
            active: false
          };
          DEFAULTS.horizontal = {
            progressLine: '.pl-nav-wizard-progress-line',
            step: '.pl-nav-wizard-step',
            stepIcon: '.pl-nav-wizard-step-icon'
          };

          if (ctrl.plEdit) {
            ctrl.plEdit.addComponent(ctrl);
            if (ctrl.plEdit.options) {
              _.merge(defaultOptions, ctrl.plEdit.options);
            }
          }
          ctrl.handleChanges();

          ctrl.instanceId = ctrl.instanceId || '';
          if (ctrl.ngModel) {
            ctrl.ngModel.$render = function () {
              if (ctrl.definition && ctrl.definition.items.length && ctrl.ngModel.$modelValue) {
                ctrl.setStep(ctrl.ngModel.$modelValue);
                return;
              }
              ctrl.setDefault();
            };
          }
          else {
            ctrl.setDefault();
          }

          angular.element($document).on('resize', ctrl.resize);
          $scope.$on('$locationChanged', function (event, data) {
            var step = data.search[ctrl.instanceId + sStep];
            if (step) {
              ctrl.setStep(step);
            }
          });
        }

        function onChanges(plNavWizard) {
          if (plNavWizard) {
            ctrl.handleChanges();
          }
        }

        function onDestroy() {
          angular.element($document).off('resize', ctrl.resize);
        }

        function handleChanges() {
          if (!ctrl.definition) {
            return;
          }
          ctrl.options = _.merge({}, defaultOptions, ctrl.properties);
          if (ctrl.options.affix) {
            ctrl.affix = ctrl.options.affix;
          }

          // Definition
          var definition = _.merge({}, angular.copy(DEFAULTS.definition), ctrl.definition);
          _.merge(ctrl.definition, definition);
          if (ctrl.definition.type === 'vertical') {
            ctrl.definition.vertical = true;
          }

          // Definition items
          angular.forEach(ctrl.definition.items, function (step, index) {
            step = _.merge({}, angular.copy(DEFAULTS.definitionItem), step);
            if (!step.id) {
              step.id = index;
            }
            if (step.templateUrl && step.template) {
              delete step.template;
            }
            _.merge(ctrl.definition.items[index], step);
          });

          if (angular.isObject(ctrl.callback)) {
            ctrl.callback.previousStep = ctrl.previousStep;
            ctrl.callback.nextStep = ctrl.nextStep;
            ctrl.callback.setStep = ctrl.setStep;
          }

          for (var i = 0; i < ctrl.definition.items.length; i++) {
            var step = ctrl.definition.items[i];
            if (angular.isFunction(step.updateComponent)) {
              step.updateComponent(ctrl.options);
            }
          }
        }

        function render() {
          ctrl.selected.visited = true;
          if (ctrl.ngModel) {
            ctrl.ngModel.$setViewValue(ctrl.selected);
          }
          if (ctrl.options.useUrl && ctrl.selected) {
            $location.search(ctrl.instanceId + sStep, ctrl.selected.id);
          }
          if (angular.isFunction(ctrl.onStepChange)) {
            ctrl.onStepChange({currentStep: ctrl.selected, previousStep: ctrl.previouslySelected});
          }
        }

        function setDefault() {
          if (ctrl.definition && ctrl.definition.items.length) {
            var search = $location.search()[ctrl.instanceId + sStep];
            if (search) {
              ctrl.setStep(search);
            }
            else {
              ctrl.setStep(ctrl.definition.items[0]);
            }
          }
        }

        function setStep(step, force, evaluatedBeforeStepChange) {
          if (step === ctrl.selected || ctrl.options.disableNavigation) {
            return;
          }

          force = force || ctrl.definition.force;
          if (!angular.isObject(step)) {
            step = {id: step};
          }
          var index = ctrl.definition.items.findIndex(function (item) {
            return item.id === step.id;
          });
          if (index === -1) {
            return;
          }
          var previous;
          if (index > 0) {
            previous = _.findLast(ctrl.definition.items, function (step) {
              return step.visible;
            }, index - 1);
          }

          step = ctrl.definition.items[index];
          var promise = null;
          if (evaluatedBeforeStepChange !== true && angular.isFunction(ctrl.beforeStepChange)) {
            promise = ctrl.beforeStepChange({currentStep: ctrl.selected, previousStep: ctrl.previouslySelected, type: 'set', nextStep: step});
          }

          var deferred = $q.defer();
          $q.when(promise).then(
            function (response) {
              if (angular.isObject(response) && response.data) {
                response = response.data;
              }
              if (response !== false && step.visible && (!ctrl.selected || ctrl.selected !== step)) {
                $q.when(ctrl.validate(step, index, force)).then(
                  function (valid) {
                    if (valid === false || previous && !previous.visited && !force) {
                      ctrl.animateCurrent();
                      $q.when(ctrl.setStep(ctrl.definition.items[index - 1], force)).then(
                        function (response) {
                          deferred.resolve(response);
                        },
                        function (error) {
                          deferred.reject(error);
                        }
                      );
                    }
                    else {
                      if (ctrl.selected) {
                        ctrl.selected.active = false;
                      }
                      if (!step.visited) {
                        step.visited = true;
                      }
                      step.active = true;
                      ctrl.previouslySelected = ctrl.selected;
                      ctrl.selected = step;
                      ctrl.render();
                      deferred.resolve(true);
                    }
                  },
                  function () {
                    ctrl.animateCurrent();
                    $q.when(ctrl.setStep(ctrl.definition.items[index - 1], force)).then(
                      function (response) {
                        deferred.resolve(response);
                      },
                      function (error) {
                        deferred.reject(error);
                      }
                    );
                  }
                );
              }
              else {
                deferred.reject('canceled');
              }
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        }

        function validate(step, index, force) {
          // First must always by allowed
          if (index === 0) {
            return true;
          }
          var deferred = $q.defer();

          // Get previous (visible) step
          var previousStep = _.findLast(ctrl.definition.items, function (item) {
            return item.visible;
          }, index - 1);

          // Check if previous step is required
          if (previousStep.required && (!previousStep.complete || !previousStep.visited) && !force) {
            var form = $element.find('[data-item-id=' + previousStep.id + '] ' + selectorForm);
            if (form.length) {
              form = form.controller('form');
              previousStep.valid = form.$valid;
              previousStep.complete = (form.$submitted || !form.$pristine) && form.$valid;
              if (!previousStep.valid) {
                deferred.resolve(previousStep.valid);
                return deferred.promise;
              }
            }
            // If a custom validator is provided we call it
            if (angular.isFunction(previousStep.validator)) {
              var fn = null;
              if (!previousStep.manual) {
                fn = previousStep.validator(step, ctrl.selected, previousStep);
              }
              else {
                fn = previousStep.validator({toStep: step, currentStep: ctrl.selected, previousStep: previousStep});
              }
              ctrl.promise = $q.when(fn).then(
                function (value) {
                  if (angular.isDefined(value) && value !== null) {
                    previousStep.valid = value;
                    previousStep.complete = value;
                  }
                  else {
                    previousStep.valid = true;
                    previousStep.complete = true;
                  }
                  deferred.resolve(previousStep.valid);
                },
                function () {
                  previousStep.valid = false;
                  previousStep.complete = false;
                  deferred.resolve(false);
                }
              )['finally'](function () {
                ctrl.promise = null;
              });
              return deferred.promise;
            }
          }
          previousStep.valid = true;
          previousStep.complete = true;
          deferred.resolve(true);
          return deferred.promise;
        }

        function previousStep() {
          if (!ctrl.selected || ctrl.options.disablePreviousStep === false) {
            return;
          }
          var index = ctrl.definition.items.findIndex(function (item) {
            return item.id === ctrl.selected.id;
          });
          if (index === -1 || index === 0) {
            return;
          }

          var promise = null;
          if (angular.isFunction(ctrl.beforeStepChange)) {
            promise = ctrl.beforeStepChange({currentStep: ctrl.selected, previousStep: ctrl.previouslySelected, type: 'previous'});
          }

          var deferred = $q.defer();
          $q.when(promise).then(
            function (response) {
              if (response !== false) {
                var previousVisibleStep = _.findLast(ctrl.definition.items, function (step) {
                  return step.visible;
                }, index - 1);
                $q.when(ctrl.setStep(previousVisibleStep, null, true)).then(
                  function (response) {
                    deferred.resolve(response);
                  },
                  function (error) {
                    deferred.reject(error);
                  }
                );
              }
              deferred.reject(response);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        }

        function nextStep() {
          if (!ctrl.selected || ctrl.options.disableNextStep === false) {
            return;
          }
          var index = ctrl.definition.items.findIndex(function (item) {
            return item.id === ctrl.selected.id;
          });
          if (index === -1 || index === ctrl.definition.items.length - 1) {
            if (index === ctrl.definition.items.length - 1 && angular.isFunction(ctrl.onFinalize)) {
              return ctrl.onFinalize({currentStep: ctrl.selected, previousStep: ctrl.previouslySelected});
            }
            return;
          }
          var form = $element.find('[data-item-id=' + ctrl.definition.items[index].id + '] ' + selectorForm);
          if (form.length) {
            form = form.controller('form');
            if (form) {
              form.$setSubmitted();
            }
          }

          var promise = null;
          if (angular.isFunction(ctrl.beforeStepChange)) {
            promise = ctrl.beforeStepChange({currentStep: ctrl.selected, previousStep: ctrl.previouslySelected, type: 'next'});
          }

          var deferred = $q.defer();
          $q.when(promise).then(
            function (response) {
              if (response !== false) {
                var nextVisibleStep = _.find(ctrl.definition.items, function (step) {
                  return step.visible;
                }, index + 1);
                $q.when(ctrl.setStep(nextVisibleStep, null, true)).then(
                  function (response) {
                    deferred.resolve(response);
                  },
                  function (error) {
                    deferred.reject(error);
                  }
                );
              }
              deferred.reject(response);
            },
            function (error) {
              deferred.reject(error);
            }
          );
          return deferred.promise;
        }

        function addStep(step) {
          var formattedStep = _.merge({}, angular.copy(DEFAULTS.definitionItem), step);
          _.merge(step, formattedStep);

          step.manual = true;
          if (!angular.isObject(ctrl.definition)) {
            ctrl.definition = {};
          }
          if (!angular.isArray(ctrl.definition.items)) {
            ctrl.definition.items = [];
          }
          if (!step.id) {
            step.id = ctrl.definition.items.length;
          }
          if (step.templateUrl && step.template) {
            delete step.template;
          }
          if (ctrl.plForm && ctrl.plForm.properties && angular.isFunction(step.setOrientation)) {
            step.setOrientation(ctrl.plForm.properties.orientation);
          }
          ctrl.definition.items.push(step);

          if (ctrl.definition.items.length === 1) {
            ctrl.setStep(step);
          }
        }

        function isStepDisabled(step) {
          return ctrl.options.disableNavigation || step.disabled;
        }

        function isActionDisabled(type) {
          if (!ctrl.selected) {
            return false;
          }

          var item = -1;
          switch (type) {
            case 'prev':
              item = _.find(ctrl.definition.items, function (step) {
                return step.visible;
              });
              break;
            case 'next':
              item = _.findLast(ctrl.definition.items, function (step) {
                return step.visible;
              });
              break;
            default:
              return;
          }
          return ctrl.selected.id === item.id;
        }

        function animateCurrent() {
          plCompsService.debounce(function () {
            if (ctrl.selected) {
              var index = ctrl.definition.items.findIndex(function (item) {
                return item.id === ctrl.selected.id;
              });
              if (index !== -1) {
                index++;
                var element;
                if (!ctrl.options.vertical) {
                  index++;
                  element = $element.find('.pl-nav-wizard-step:nth-child(' + index + ')');
                }
                else {
                  element = $element.find('.nav-wizard-item:nth-child(' + index + ')');
                }
                element.animateWith('pl-animation-shake');
              }
            }
          }, 100, 'plNavWizardAnimateCurrent');
        }

        function getTitle(value) {
          return plTranslate.translate(value);
        }

        function getItem(index) {
          if (ctrl.definition && ctrl.definition.items && ctrl.definition.items.length) {
            if (index < 0) {
              index = ctrl.definition.items.length + index;
            }
            return ctrl.definition.items[index];
          }
          return undefined;
        }

        function getItemSize() {
          return (100 / ctrl.definition.items.length) + '%';
        }

        function calcSeparatorSize() {
          var progressLine = $element.find(DEFAULTS.horizontal.progressLine);
          if (progressLine && progressLine.length && ctrl.selected) {
            var stepIndex = angular.element(ctrl.selected.$element).index();
            var item = angular.element($element.find(DEFAULTS.horizontal.step).get(stepIndex));
            if (item && item.length) {
              return (item.offset().left - progressLine.offset().left) + (item.width() / 2);
            }
          }
          return 0;
        }

        function resize() {
          plCompsService.debounce(function () {
            $element.find(DEFAULTS.horizontal.progressLine).css('width', ctrl.calcSeparatorSize() + 'px');
          }, 100, 'plNavWizardCalcSeparatorSize');
        }

        function getItemContent(item) {
          var value = plTranslate.translate(item.caption);
          if (value.indexOf('{{') !== -1 && value.indexOf('}}') !== -1) {
            return $sce.parseAsHtml(value);
          }
          else {
            return $sce.trustAsHtml(value);
          }
        }

        function updateComponent(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties, properties);
            for (var i = 0; i < ctrl.definition.items.length; i++) {
              var item = ctrl.definition.items[i];
              if (angular.isFunction(item.updateComponent)) {
                item.updateComponent(properties);
              }
            }
          }
        }
      }]
    });
})();

(function () {
  'use strict';

  angular.module('pl.comps')
    .component('plNavWizardStep', {
      require: {
        plNavWizard: '?^^plNavWizard',
        plForm: '?^^plForm'
      },
      bindings: {
        caption: '@',
        name: '@?',
        icon: '@?',
        selected: '<?',
        properties: '<?',
        shouldAdd: '<?',
        template: '@?',
        templateUrl: '@?',
        required: '<?',
        visible: '<?',
        valid: '<?',
        validator: '&?',
        complete: '<?',
        hideFooter: '<?',
        hidePrevious: '<?',
        hideNext: '<?',
        hideFinalize: '<?',
        actions: '<?'
      },
      transclude: true,
      templateUrl: '../source/pl-nav-wizard-step.html',
      controllerAs: '$ctrl',
      controller: /*ngInject*/ ['$element', 'plLocale', 'plCompsService', function ($element, plLocale, plCompsService) {
        var ctrl = this;
        var orientation = plCompsService.config().plEditForm.orientation;
        var defaultOptions = {
          footerOffset: orientation  === 'horizontal' ? 'col-sm-offset-2' : ''
        };

        ctrl.locale = {};
        ctrl.options = {};

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.handleOptions = handleOptions;
        ctrl.setComplete = setComplete;
        ctrl.evaluateFooter = evaluateFooter;
        ctrl.setOrientation = setOrientation;
        ctrl.updateComponent = updateComponent;

        /////////////

        function init() {
          ctrl.locale = plLocale.locales;
          ctrl.handleOptions();
          if (angular.isUndefined(ctrl.shouldAdd) || ctrl.shouldAdd === null) {
            ctrl.shouldAdd = true;
          }
          if (ctrl.shouldAdd) {
            ctrl.plNavWizard.addStep(ctrl);
          }
        }

        function onChanges(plNavWizardStep) {
          if (plNavWizardStep) {
            ctrl.handleOptions();
          }
        }

        function handleOptions() {
          _.merge(ctrl, defaultOptions, ctrl.properties, {
            id: ctrl.name,
            caption: ctrl.caption,
            icon: ctrl.icon,
            active: ctrl.selected || false,
            $element: $element
          });
        }

        function setComplete(value) {
          ctrl.complete = value;
          if (!ctrl.complete) {
            ctrl.valid = false;
          }
        }

        function evaluateFooter(type) {
          if (!ctrl.plNavWizard) {
            return false;
          }
          var index;
          switch (type) {
            case 'previous':
              index = 0;
              break;
            case 'next':
              index = -1;
              break;
            default:
              return false;
          }
          return ctrl === ctrl.plNavWizard.getItem(index);
        }

        function setOrientation(orientation) {
          var css = '';
          switch (orientation) {
            case 'horizontal':
              css = ctrl.footerOffset;
              break;
            case 'vertical':
              css = '';
              break;
            default:
              ctrl.setOrientation(plCompsService.config().plEditForm.orientation);
              return;
          }
          ctrl.footerOffset = css;
        }

        function updateComponent(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties, properties);
          }
        }
      }]
    });
})();

(function () {
  // Based on http://codepen.io/m-e-conroy/pen/bcEsA
  'use strict';

  var plnavbarDirective = /*@ngInject*/  ['plNavbarService', '$document', function (plNavbarService, $document) {

    var controller = /*@ngInject*/ ['$scope', function ($scope) {
      var vm = this;
      var id = $scope.instanceId || '__default';

      plNavbarService.registerInstance(id, vm);

      vm.collapsed = false;
      vm.brand = $scope.brand;
      vm.subBrand = $scope.subBrand;
      vm.menus = $scope.menus;

      vm.toggleSidebar = function () {
        $scope.pageWrapper.toggleSidebar();
      };

      vm.isToogled = function () {
        return $scope.pageWrapper.toggle;
      };

      //=== Methods ===//

      vm.updateMenu = function (menu, id) {
        for (var i = 0; i < vm.menus.length; i++) {
          if (vm.menus[i].id === id) {
            vm.menus[i] = menu;
          }
        }
      };

      vm.hasMenus = function () {
        return (angular.isDefined(vm.menus));
      };

      vm.hasDropdownMenu = function (menu) {
        return (angular.isDefined(menu.menu) && angular.isArray(menu.menu));
      }; // end hasDropdownMenu

      vm.isDivider = function (item) {
        return (angular.isDefined(item.divider) && angular.equals(item.divider, true));
      }; // end isDivider


      vm.navAction = function (item, parent) {
        var handle = false;

        if (angular.isFunction(item.action)) {
          handle = item.action(item, parent);
        }

        if (!handle && angular.isFunction($scope.onItemClick)) {
          $scope.onItemClick(item, parent);
        }
      };

      // Object.defineProperty($scope, 'search', {
      //   get: function () {
      //     return $scope.searchObj.search;
      //   },
      //   set: function (newValue) {
      //     $scope.searchObj.search = newValue;
      //   },
      //   enumerable: true,
      //   configurable: true
      // });


      return vm;
    }];
    controller.$inject = ['$scope'];

    var link = function (scope, element, attrs, ctrl) {
      scope.pageWrapper = ctrl;
      scope.collapsed = true;
    };


    return {
      restrict: 'E',
      scope: {
        instanceId: '@?instanceId',
        brand: '=?',
        subBrand: '=?',
        menus: '=?',
        onItemClick: '=?',
        isItemActive: '=?'
      },
      templateUrl: '../source/pl-navbar.html',
      replace: true,
      transclude: {
        brandSlot: '?brand',
        subBrandSlot: '?subBrand'
      },
      require: '^^plPageWrapper',
      link: link,
      controller: controller,
      controllerAs: 'vm'
    };
  }];
  plnavbarDirective.$inject = ['plNavbarService', '$document'];

  var plnavbarService = function () {
    var that = this;
    var instances = [];
    that.getInstance = function (instanceId) {
      if (!that.isRegistered(instanceId)) {
        instances[instanceId] = {
          searchObj: {
            search: '',
            active: false,
            button: false
          }
        };
      }
      return instances[instanceId];
    };

    that.registerInstance = function (instanceId, scope) {
      var inst = that.getInstance(instanceId);

      if (angular.isDefined(inst.menus)) {
        scope.menus = inst.menus;
      }
      if (angular.isDefined(inst.options)) {
        scope.options = inst.options;
      }
      if (angular.isDefined(inst.searchObj)) {
        scope.searchObj = inst.searchObj;
      }

      instances[instanceId] = scope;
    };

    that.isRegistered = function (instanceId) {
      return angular.isDefined(instances[instanceId]);
    };

    that.getLastInstanceId = function () {
      return that.lastRegisteredInstance;
    };

    that.setMenu = function (instanceId, val, id) {
      var inst = that.getInstance(instanceId);
      if (angular.isUndefined(id)) {
        inst.menus = val;
      } else {
        inst.updateMenu(val, id);
      }
    };

    that.getMenu = function (instanceId) {
      var inst = that.getInstance(instanceId);
      return inst.menus;

    };

    that.setOptions = function (instanceId, options) {
      var inst = that.getInstance(instanceId);
      inst.options = options;
    };

    that.getSearch = function (instanceId) {
      var inst = that.getInstance(instanceId);
      return inst.searchObj;
    };


    return that;
  };


  function plNavBarProvider() {
    var translateFn;

    function setTranslateFn(fn) {
      translateFn = fn;
    }

    return {
      setTranslateFn: setTranslateFn,
      $get: function () {
        return {
          setTranslateFn: setTranslateFn,
          translate: function (value) {
            if (angular.isFunction(translateFn)) {
              return translateFn(value);
            }
            return value;
          }
        };
      }
    };
  }


  var plContainer = /*@ngInject*/ ['$log', function ($log) {
    return {
      restrict: 'E',
      transclude: true,
      //replace:true,
      require: '^plNavbar',
      template: '<div ng-transclude></div>'
    };
  }];
  plContainer.$inject = ['$log'];


  angular.module('pl.navbar', ['ngSanitize', 'LocalStorageModule', 'pl.translate'])
    .directive('plNavbar', plnavbarDirective)
    .directive('plContainer', plContainer)
    .service('plNavbarService', plnavbarService)
    .provider('plNavbarConfig', plNavBarProvider);

}());

/**
 * Created by pedro on 27/04/16.
 */
(function () {
  'use strict';

  angular.module('pl.comps')
    .directive('plNavigation', ['plCompsService', 'KEYCODE', function (plCompsService, KEYCODE) {
      return {
        restrict: 'A',
        scope: {
          stepOver: '<?',
          selector: '@?',
          parent: '@?'
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: ['$element', function ($element) {
          var ctrl = this;

          ctrl.elementsToSkip = [];

          ctrl.$onInit = init;
          ctrl.$onChanges = onChanges;
          ctrl.$onDestroy = onDestroy;
          ctrl.eventKeydown = eventKeydown;
          ctrl.shouldStepOver = shouldStepOver;

          /////////////

          function init() {
            if (ctrl.stepOver) {
              ctrl.elementsToSkip = plCompsService.parseExpressionToString(ctrl.stepOver).split(',');
            }
            $element.on('keydown', ctrl.eventKeydown);
          }

          function onChanges(plNavigation) {
            if (plNavigation && plNavigation.stepOver && !plNavigation.stepOver.isFirstChange()) {
              ctrl.elementsToSkip = plCompsService.parseExpressionToString(ctrl.stepOver).split(',');
            }
          }

          function onDestroy() {
            $element.off('keydown', ctrl.eventKeydown);
          }

          function eventKeydown(event) {
            var $active = angular.element('input:focus,select:focus,textarea:focus,button:focus', $element);
            var $next = null;
            var focusableQuery = 'input,select,textarea,button,input:disabled,select:disabled,textarea:disabled';
            var position = parseInt($active.closest(ctrl.selector).index()) + 1;

            switch (event.which) {
              case KEYCODE.LEFT:
                $next = findHorizontal($active, focusableQuery, 'prev');
                break;
              case KEYCODE.UP:
                $next = findVertical($active, focusableQuery, position, 'prev');
                break;
              case KEYCODE.RIGHT:
                $next = findHorizontal($active, focusableQuery, 'next');
                break;
              case KEYCODE.DOWN:
                $next = findVertical($active, focusableQuery, position, 'next');
                break;
            }

            if ($next && $next.length) {
              event.preventDefault();
              $next.focus();
              $next.select();
            }
          }

          function shouldStepOver(element) {
            if (ctrl.elementsToSkip.indexOf(element.attr('name')) !== -1) {
              for (var i = 0; i < ctrl.elementsToSkip.length; i++) {
                var $input = element.closest(ctrl.parent).find('input[name="' + ctrl.elementsToSkip[i] + '"]');
                if (!$input.length) {
                  throw new Error('Found an invalid element to skip with the name: ' + ctrl.elementsToSkip[i]);
                }
                if ($input.val().toString().trim() !== '') {
                  return true;
                }
              }
            }
            return false;
          }

          function findHorizontal($active, focusableQuery, type) {
            if (type !== 'prev' && type !== 'next') {
              return;
            }
            if (ctrl.selector) {
              $active = $active.closest(ctrl.selector);
            }
            var element = $active[type]().find(focusableQuery);
            while (element.is(':disabled') || !element.is(':visible') || ctrl.shouldStepOver(element)) {
              element = element.closest(ctrl.selector)[type]().find(focusableQuery);
              if ((element.is(':enabled') && element.is(':visible') || !element.length) && !ctrl.shouldStepOver(element)) {
                break;
              }
            }
            return element;
          }

          function findVertical($active, focusableQuery, position, type) {
            if (type !== 'prev' && type !== 'next') {
              return;
            }
            if (ctrl.parent) {
              $active = $active.closest(ctrl.parent);
            }
            var element = $active[type]().find(ctrl.selector + ':nth-child(' + position + ')').find(focusableQuery);
            while (element.is(':disabled') || !element.is(':visible') || ctrl.shouldStepOver(element)) {
              element = element.closest(ctrl.parent)[type]().find(ctrl.selector + ':nth-child(' + position + ')').find(focusableQuery);
              if ((element.is(':enabled') && element.is(':visible') || !element.length) && !ctrl.shouldStepOver(element)) {
                break;
              }
            }
            return element;
          }
        }]
      };
    }]);
})();

(function () {
  'use strict';

  angular.module('pl.edit')
    .component('plNavpill', {
      bindings: {
        name: '@',
        onSelect: '&?',
        callback: '<?'
      },
      transclude: true,
      templateUrl: '../source/pl-navpill.html',
      controller: ['$location', '$sce', '$scope', 'plTranslate', function ($location, $sce, $scope, plTranslate) {
        var ctrl = this;

        ctrl.panels = [];
        ctrl.activePanel = null;

        ctrl.$init = init;
        ctrl.addPanel = addPanel;
        ctrl.removePanel = removePanel;
        ctrl.selectPanel = selectPanel;
        ctrl.query = query;
        ctrl.getCaption = getCaption;
        ctrl.locationChanged = locationChanged;

        /////////////

        function init() {
          ctrl.lazyLoad = !!ctrl.lazyLoad;
          if (ctrl.name) {
            ctrl.activePanel = ctrl.query();
            ctrl.selectPanel(ctrl.activePanel);
          }
          if (angular.isObject(ctrl.callback)) {
            ctrl.callback.selectTab = ctrl.selectTab;
          }
          $scope.$on('$locationChanged', ctrl.locationChanged);
        }

        function addPanel(panel) {
          panel.id = panel.name || 'plNavpill' + ctrl.panels.length;
          panel._index = ctrl.panels.length;
          ctrl.panels.push(panel);

          if (ctrl.panels.length > 0 && !ctrl.activePanel) {
            ctrl.selectPanel(ctrl.panels[0].id);
          }
          else if (ctrl.activePanel) {
            if (panel.id === ctrl.activePanel.id) {
              ctrl.selectPanel(ctrl.activePanel.id);
            }
          }
        }

        function removePanel(panel) {
          if (!angular.isObject(panel)) {
            panel = {id: panel};
          }
          var panelIndex = ctrl.panels.findIndex(function (myPanel) {
            return myPanel.id === panel.id;
          });
          if (panelIndex !== -1) {
            if (panel === ctrl.activePanel && ctrl.panels.length > 1) {
              ctrl.selectPanel(ctrl.panels[0].id);
            }
            ctrl.panels.splice(panelIndex, 1);
            return true;
          }
          return false;
        }

        function selectPanel(id) {
          angular.forEach(ctrl.panels, function (panel) {
            panel.selected = panel.id === id;
            if (panel.selected) {
              ctrl.activePanel = panel;

              if (ctrl.name) {
                $location.search(ctrl.name, panel.id);
              }
              if (angular.isFunction(ctrl.onSelect)) {
                ctrl.onSelect({id: panel.id, panel: panel});
              }
            }
          });
        }

        function query() {
          var param = $location.search()[ctrl.name];
          return angular.isDefined(param) && param ? param : null;
        }

        function getCaption(caption) {
          return plTranslate.translate($sce.getTrustedHtml(caption));
        }

        function locationChanged(event, data) {
          var panel = data.search[ctrl.name];
          if (!panel) {
            return;
          }
          ctrl.selectPanel(panel);
        }
      }]
    })
    .component('plPanel', {
      require: {
        plNavpill: '^plNavpill'
      },
      bindings: {
        caption: '@',
        name: '@?',
        captionClass: '@?',
        selected: '<?',
        lazyLoad: '<?'
      },
      transclude: true,
      templateUrl: '../source/pl-navpill-panel.html',
      controller: /*@ngInject*/ function () {
        var ctrl = this;
        ctrl.id = null;

        ctrl.$onInit = init;
        ctrl.$onDestroy = onDestroy;

        /////////////

        function init() {
          ctrl.lazyLoad = !!ctrl.lazyLoad || ctrl.plNavpill.lazyLoad || false;
          if (ctrl.selected) {
            ctrl.plNavpill.activePanel = ctrl;
          }
          ctrl.plNavpill.addPanel(ctrl);
        }

        function onDestroy() {
          if (ctrl.plNavpill) {
            ctrl.plNavpill.removePanel(ctrl);
          }
        }
      }
    });
}());

/**
 * Created by pedro on 20/12/16.
 */
(function () {
  'use strict';

  var $ = angular.element;

  angular.module('pl.objecteditor', [])
    .directive('plObjectEditor', function () {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          object: '='
        },
        template: '<ul class="pl-object-editor">' +
        '<pl-object-property ng-repeat="key in keys" name="key" parent="object"></pl-object-property>' +
        '<li data-ng-show="exists" class="addSection"><button class="add">Add {{addSubject}}</button></li>' +
        '</ul>',
        link: {
          pre: function (scope, element) {

            scope.exists = typeof scope.object === 'object';

            scope.addSubject = angular.isArray(scope.object) ? 'Value' : 'Property';

            var $menu = $(document.getElementById('plobjecteditor-types-menu'));

            function bodyClick(e) {
              if ($menu.find($(e.target)).length === 0) {
                //$menu[0].style.display = 'none';
                $(document.body).unbind('click', bodyClick);
              }
            }

            // create menu
            if (!$menu.length) {
              $menu = $('<ul/>').attr('id', 'plobjecteditor-types-menu');
              $menu.append($('<li/>').data('type', 'object').text('Object'))
                .append($('<li/>').data('type', 'array').text('Array'))
                .append($('<li/>').data('type', 'string').text('String'))
                .append($('<li/>').data('type', 'number').text('Number'))
                .append($('<li/>').data('type', 'boolean').text('Boolean'));

              $(document.body).append($menu);

              $menu.on('click', function (e) {
                var val,
                  type = $(e.target).data('type');

                if (type === 'object') {
                  val = {};
                } else if (type === 'array') {
                  val = [];
                } else if (type === 'string') {
                  val = '';
                } else if (type === 'number') {
                  val = 0;
                } else if (type === 'boolean') {
                  val = false;
                }

                $menu[0].style.display = 'none';
                $(document.body).unbind('click', bodyClick);
                $menu.data('itemSelection')(val);
              });

            }

            $(element[0].querySelector('.add')).on('click', function () {

              //var $addButton = $(this);

              //show the menu

              var rect = this.getBoundingClientRect();
              $menu[0].style.top = rect.top + rect.height + 'px';
              $menu[0].style.left = rect.left + 'px';
              $menu[0].style.display = 'block';

              function itemSelected(val) {
                var newKeyName;

                if (angular.isArray(scope.object)) {
                  scope.object.push(val);
                } else {
                  newKeyName = prompt('Property Name');
                  if (newKeyName) {
                    scope.object[newKeyName] = val;
                  }
                }
                scope.objectChange();

                $menu.data('itemSelection', null);
              }

              $menu.data('itemSelection', itemSelected);
              $(document.body).bind('click', bodyClick);
              return false;
            });

            scope.$watch('object', function () {
              if (scope.object && typeof scope.object === 'object') {
                scope.keys = Object.keys(scope.object);
                scope.exists = typeof scope.object === 'object';
              }
            }, true);


            scope.objectChange = function () {

              scope.keys = Object.keys(scope.object);
              scope.$apply();
            };
          }
        }
      };
    })
    .directive('plObjectProperty', ['$compile', function ($compile) {

      return {
        restrict: 'E',
        replace: true,
        scope: {
          name: '=',
          parent: '='
        },
        template: '<li class="{{type}} {{expanedCollapsed}}">' +
        '<button name="delete" class="delete" title="Delete">' +
        '</button><button class="expandCollapse"></button>' +
        '<label>{{name}}:</label> {{start}} <span class="type {{type}} {{editingClass}}"></span></li>',
        link: {
          pre: function (scope, element, attrs) {
            var value,
              typeElement,
              type,
              editorHTML = '<pl-object-editor object="parent[name]"></pl-object-editor>',
              actionButtonHtml = '',
              inputHTML = '',
              isArray;

            function create() {
              var childElement;

              value = scope.parent[scope.name];
              type = typeof value;
              inputHTML = '';
              isArray = angular.isArray(value);

              if (value === null) {
                type = 'null';
              }

              scope.expanedCollapsed = 'expanded';
              scope.isContainer = type === 'object';
              scope.isPrimitive = !scope.isContainer || type === 'function';
              scope.isArray = isArray;
              scope.inputType = 'checkbox';
              scope.editingClass = '';
              scope.type = scope.isArray ? 'array' : type;

              if (scope.isPrimitive) {
                scope.textValue = value;
              }

              scope.prefix = '';
              scope.suffix = '';
              scope.start = '';

              if (type === 'object') {
                if (scope.isArray) {
                  scope.start = '[';
                } else {
                  scope.start = '{';
                }
              } else if (type === 'function') {
                scope.start = 'function () {...}';

              } else if (type === 'string') {
                scope.prefix = '';
                scope.suffix = '';
                scope.inputType = 'text';

              } else if (type === 'number') {
                scope.inputType = 'number';
              } else if (type === 'boolean') {
                scope.inputType = 'checkbox';
              }

              scope.showInput = function () {
                return scope.isPrimitive && (scope.editing || scope.inputType === 'checkbox');
              };

              typeElement = $(element[0].querySelector('.type'));
              typeElement[0].innerHTML = 0;

              if (scope.isPrimitive) {
                inputHTML = '<input type=' + scope.inputType + ' data-ng-model="parent[name]" ng-switch-case="isBoolean">';
              }

              actionButtonHtml = type === 'function' ? '<button class="run" title="run">Run</button> ' +
                '<button class="runWithParams" title="runWithParams">Run with arguments</button> ' : '<button class="duplicate" title="Duplicate">Duplicate</button>';

              typeElement.html('{{prefix}}' + inputHTML + '<span class="textValue">{{parent[name]}}</span>{{suffix}}</span>' + actionButtonHtml);

              $compile(typeElement.contents())(scope);


              $(element[0].querySelector('span.textValue, .duplicate')).unbind('click');
              element.find('input').unbind('blur');

              if (type === 'string' || type === 'number') {
                $(element[0].querySelector('span.textValue')).bind('click', function () {
                  scope.editing = true;
                  scope.editingClass = 'editing';
                  scope.$apply();
                });

                element.find('input').bind('blur', function () {
                  scope.editingClass = '';
                  scope.editing = false;
                  scope.$apply();
                });
              }

              $(element[0].querySelector('.duplicate')).bind('click', function () {

                var newKeyName;

                if (angular.isArray(scope.parent)) {
                  scope.parent.push(angular.copy(scope.parent[scope.name]));
                } else {
                  newKeyName = prompt('Property Name');
                  if (newKeyName) {
                    scope.parent[newKeyName] = angular.copy(scope.parent[scope.name]);
                  }
                }

                scope.$parent.objectChange();
              });


              $(element[0].querySelector('.run')).bind('click', function () {
                scope.parent[scope.name].call(scope.parent[scope.name]);
              });

              $(element[0].querySelector('.runWithParams')).bind('click', function () {
                var args = prompt('arguments (comma delimited)') || '';
                scope.parent[scope.name].apply(scope.parent[scope.name], args.split(','));
              });

              childElement = $(element[0].querySelector('ul.plobjecteditor'));
              if (childElement.length) {
                childElement.remove();
                $(element[0].querySelector('.end')).remove();
              }

              if (typeof value === 'object') {
                $compile(editorHTML)(scope, function (cloned, scope) {
                  element.append(cloned);
                  element.append($('<span/>').addClass('end').addClass(type).text(isArray ? ']' : '}'));
                });
              }
            }


            create();

            function expandCollapse() {
              if (scope.expanedCollapsed === 'expanded') {
                scope.expanedCollapsed = 'collapsed';
              } else {
                scope.expanedCollapsed = 'expanded';
              }

              scope.$apply();
            }

            $(element[0].querySelector('.expandCollapse')).bind('click', expandCollapse);
            element.find('label').eq(0).bind('dblclick', expandCollapse);


            scope.$watch('editing', function (isEditing) {
              if (isEditing) {
                setTimeout(function () {
                  element.find('input')[0].focus();
                  element.find('input')[0].select();
                }, 1);

              }
            });

            $(element[0].querySelector('.delete')).bind('click', function () {

              if (angular.isArray(scope.parent)) {
                scope.parent.splice(Number(scope.name), 1);
              } else {
                delete scope.parent[scope.name];
              }

              scope.$parent.objectChange();
            });

            scope.$watch('parent[name]', function (newVal) {
              var newType = typeof newVal,
                newIsArray = angular.isArray(newVal);

              if (newType !== type || newIsArray !== isArray) {
                create();
              }
            });
          }
        }
      };
    }]);
}());

/**
 * Created by Luis on 14/10/2016.
 */
(function () {
  'use strict';

  angular.module('pl.navbar')
    .component('plPageWrapper', {
      transclude: {
        'sidebar': '?sidebar',
        'navbar': '?navbar',
        'container': '?container'
      },
      templateUrl: '../source/pl-page-wrapper.html',
      controller: /*@ngInject*/ ['$scope', '$window', '$document', '$timeout', 'localStorageService', 'plCompsService', 'SCREENSIZES', function ($scope, $window, $document, $timeout, localStorageService, plCompsService, SCREENSIZES) {
        var ctrl = this;

        ctrl.toggle = true;

        ctrl.$onInit = init;
        ctrl.$onDestroy = onDestroy;
        ctrl.documentEvent = documentEvent;
        ctrl.toggleSidebar = toggleSidebar;
        ctrl.setLocalStorage = setLocalStorage;
        ctrl.isMobile = isMobile;

        /////////////

        function init() {
          ctrl.toggle = ctrl.isMobile() ? false : (localStorageService.get('toggleSideBar') || true);
          angular.element($window).on('resize', function () {
            plCompsService.debounce(function () {
              var newValue = $window.innerWidth;
              $scope.$apply(function () {
                ctrl.toggle = newValue >= SCREENSIZES.MD;
                ctrl.setLocalStorage();
              });
            }, 50, 'plPageWrapperResize');
          });
        }

        function onDestroy() {
          angular.element($window).off('resize');
          angular.element($document).off('click', ctrl.documentEvent);
        }

        function documentEvent(event) {
          if (!angular.element(event.target).closest('pl-sidebar #pl-sidebar-wrapper').length) {
            $scope.$apply(function () {
              ctrl.toggle = false;
              angular.element($document).off('click', ctrl.documentEvent);
            });
          }
          else {
            event.stopPropagation();
          }
        }

        function toggleSidebar() {
          ctrl.toggle = !ctrl.toggle;
          ctrl.setLocalStorage();

          // Clicked outside closes sidebar on mobile
          if (ctrl.isMobile() && ctrl.toggle === true) {
            $timeout(function () {
              angular.element($document).on('click', ctrl.documentEvent);
            }, 100);
          }
          else {
            angular.element($document).off('click', ctrl.documentEvent);
          }
        }

        function setLocalStorage() {
          localStorageService.set('toggleSideBar', ctrl.toggle);
        }

        function isMobile() {
          return plCompsService.isMobile();
        }

        /////////////

        $scope.$watch(angular.bind(ctrl, function () {
          return ctrl.toggle;
        }), function (newVal) {
          if (newVal === false) {
            angular.element($document).off('click', ctrl.documentEvent);
          }
        });
      }]
    });
})();

(function () {
  'use strict';

  var sPerPage = 'perpage';

  angular.module('pl.table', ['pl.transclude', 'pl.animation', 'pl.spinners', 'pl.translate'])
    .component('plPagination', {
      templateUrl: '../source/pl-pagination.html',
      bindings: {
        properties: '<',
        page: '<',
        total: '<',
        instanceId: '@?',
        onPageChange: '&?'
      },
      controller: /*@ngInject*/ ['$location', '$scope', 'plLocale', function ($location, $scope, plLocale) {
        var ctrl = this;
        var defaultOptions = {
          showPagination: true,
          directionLinks: true,
          boundaryLinks: false,
          pagesLength: 1,
          paginationRange: 10,
          perPage: 10,
          selectFirst: false,
          useUrl: false,
          lines: [10, 20, 25, 50]
        };
        ctrl.locales = plLocale.locales;
        ctrl.options = {};
        ctrl.lastPerPage = null;
        ctrl.locales = plLocale.locales;

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.handleChanges = handleChanges;
        ctrl.setCurrent = setCurrent;
        ctrl.perPageChanged = perPageChanged;
        ctrl.refresh = refresh;

        /////////////

        function calculatePageNumber(i, currentPage, paginationRange, totalPages) {
          var halfWay = Math.ceil(paginationRange / 2);
          if (i === paginationRange) {
            return totalPages;
          }
          else if (i === 1) {
            return i;
          }
          else if (paginationRange < totalPages) {
            if (totalPages - halfWay < currentPage) {
              return totalPages - paginationRange + i;
            }
            else if (halfWay < currentPage) {
              return currentPage - halfWay + i;
            }
            else {
              return i;
            }
          }
          else {
            return i;
          }
        }

        function generatePagesArray(currentPage, collectionLength, rowsPerPage, paginationRange) {
          var pages = [];
          var totalPages = Math.ceil(collectionLength / rowsPerPage);
          var halfWay = Math.ceil(paginationRange / 2);
          var position;

          if (currentPage <= halfWay) {
            position = 'start';
          }
          else if (totalPages - halfWay < currentPage) {
            position = 'end';
          }
          else {
            position = 'middle';
          }

          var ellipsesNeeded = paginationRange < totalPages;
          var i = 1;
          while (i <= totalPages && i <= paginationRange) {
            var pageNumber = calculatePageNumber(i, currentPage, paginationRange, totalPages);

            var openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'));
            var closingEllipsesNeeded = (i === paginationRange - 1 && (position === 'middle' || position === 'start'));
            if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
              pages.push('...');
            }
            else {
              pages.push(pageNumber);
            }
            i++;
          }
          return pages;
        }

        function init() {
          ctrl.page = ctrl.page || 1;
          ctrl.options = _.merge({}, defaultOptions, ctrl.properties);
          ctrl.handleChanges();

          $scope.$on('$locationChanged', function (event, data) {
            var search = data.search;
            var perPage = search[ctrl.instanceId + sPerPage];
            if (perPage && perPage !== ctrl.options.perPage) {
              ctrl.options.perPage = perPage;
              ctrl.perPageChanged();
            }
          });
        }

        function onChanges(plPagination) {
          if (plPagination) {
            if (plPagination.properties) {
              ctrl.$onInit();
            }
            if (plPagination.total) {
              ctrl.refresh();
            }
          }
        }

        function handleChanges() {
          if (angular.isString(ctrl.options.perPage)) {
            ctrl.options.perPage = parseInt(ctrl.options.perPage) || ctrl.options.lines[0];
            if (ctrl.options.useUrl) {
              $location.search(ctrl.instanceId + sPerPage, ctrl.options.perPage);
            }
          }
          ctrl.perPageChanged();
        }

        function setCurrent(page) {
          if (page >= 1 && page <= ctrl.totalPages) {
            ctrl.page = page;
            ctrl.refresh();
            if (angular.isFunction(ctrl.onPageChange)) {
              ctrl.onPageChange({page: page, perPage: ctrl.options.perPage});
            }
          }
        }

        function perPageChanged() {
          if (ctrl.lastPerPage === ctrl.options.perPage) {
            return;
          }
          ctrl.lastPerPage = ctrl.options.perPage;
          ctrl.setCurrent(ctrl.page);
          if (angular.isFunction(ctrl.options.onChange)) {
            ctrl.options.onChange('perPage', ctrl.options.perPage);
          }
        }

        function refresh() {
          ctrl.totalPages = Math.ceil(ctrl.total / ctrl.options.perPage);
          ctrl.pages = generatePagesArray(ctrl.page, ctrl.total, ctrl.options.perPage, ctrl.options.paginationRange);
        }
      }]
    });
})();

/**
 * Created by pedro on 04/01/17.
 */
(function () {
  'use strict';

  angular.module('pl.pdf', [])
    .provider('plPdf', function () {
      var errorHandler = fnErrorHandler;
      var provider = {
        errorHandler: function (error) {
          return errorHandler.call(this, error);
        },
        setErrorHandler: setErrorHandler,
        $get: $get
      };
      return provider;

      /////////////

      function fnErrorHandler(error) {
        if (angular.isObject(error)) {
          if (error.error) {
            error = error.error;
          }
          throw new Error(error.message);
        }
        else {
          throw new Error(error);
        }
      }

      function setErrorHandler(fn) {
        if (angular.isFunction(fn)) {
          errorHandler = fn;
        }
      }

      function $get() {
        var factory = angular.copy(provider);
        delete factory.$get;
        return factory;
      }
    })
    .directive('plPdf', /*@ngInject*/ ['$window', '$document', '$http', '$log', 'plToolbarService', '$timeout', '$q', 'plCompsService', 'plPdf', 'plLocale', function NgPdf($window, $document, $http, $log, plToolbarService, $timeout, $q, plCompsService, plPdf, plLocale) {
      var backingScale = function backingScale(canvas) {
        var ctx = canvas.getContext('2d');
        var dpr = $window.devicePixelRatio || 1;
        var bsr = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;

        return dpr / bsr;
      };

      var setCanvasDimensions = function setCanvasDimensions(canvas, w, h) {
        var ratio = backingScale(canvas);
        canvas.width = Math.floor(w * ratio);
        canvas.height = Math.floor(h * ratio);
        canvas.style.width = Math.floor(w) + 'px';
        canvas.style.height = Math.floor(h) + 'px';
        canvas.getContext('2d').setTransform(ratio, 0, 0, ratio, 0, 0);
        return canvas;
      };

      return {
        restrict: 'E',
        scope: {
          pdfUrl: '@',
          pdfUrlPreview: '@',
          source: '=?',
          toolbarId: '@?',
          filename: '@?',
          onError: '&?',
          promise: '=?'
        },
        templateUrl: '../source/pl-pdf.html',
        link: function link(scope, element, attrs) {
          scope.loading = null;
          scope.error = false;
          scope.errorMessage = plLocale.locales.messages.pdfJsLoadError;
          scope.onError = scope.onError || plPdf.errorHandler;
          scope.locales = plLocale.locales;
          var renderTask = null;
          var pdfLoaderTask = null;
          var url = attrs.pdfUrl;
          var urlPreview = attrs.pdfUrlPreview;
          var lasturl = null;
          var httpHeaders = scope.httpHeaders;
          var pdfDoc = null;
          var pageFit = true; //attrs.scale === 'page-fit' ;
          var scale = attrs.scale > 0 ? attrs.scale : 1;
          var canvasid = attrs.canvasid || 'pdf-canvas';
          var canvas = $document[0].getElementById(canvasid);
          var creds = attrs.usecredentials;
          var mnuZoom = {
            groupId: 'pl-pdf',
            id: 'pdfZoom',
            order: 300,
            type: 'dropdown',
            iconLeft: '',
            class: 'btn-primary',
            caption: 'Ajustar à página',
            menu: [
              {
                caption: 'Ajustar à página',
                click: function (mnu) {
                  scope.fit();
                  mnuZoom.caption = mnu.caption;
                }
              },
              {
                caption: '175%',
                click: function (mnu) {
                  scope.scale(1.75);
                  mnuZoom.caption = mnu.caption;
                }
              },
              {
                caption: '150%',
                click: function (mnu) {
                  scope.scale(1.5);
                  mnuZoom.caption = mnu.caption;
                }
              },
              {
                caption: '125%',
                click: function (mnu) {
                  scope.scale(1.25);
                  mnuZoom.caption = mnu.caption;
                }
              },
              {
                caption: '100%',
                click: function (mnu) {
                  scope.scale(1);
                  mnuZoom.caption = mnu.caption;
                }
              },
              {
                caption: '80%',
                click: function (mnu) {
                  scope.scale(0.8);
                  mnuZoom.caption = mnu.caption;
                }
              },
              {
                caption: '50%',
                click: function (mnu) {
                  scope.scale(0.5);
                  mnuZoom.caption = mnu.caption;
                }
              }
            ]
          };
          var mnuDownload = {
            groupId: 'pl-pdf',
            id: 'pdfDownload',
            order: 300,
            type: 'download',
            iconLeft: '<i class="fa fa-download fa-fw"></i>',
            class: 'btn-primary',
            caption: 'Transferir',
            download: {url: url, filename: scope.filename}
          };
          var ctx = canvas.getContext('2d');
          var windowEl = angular.element($window);

          element.css('display', 'block');

          windowEl.on('scroll', function () {
            scope.$apply(function () {
              scope.scroll = windowEl[0].scrollY;
            });
          });

          scope.page = {
            num: isFinite(attrs.page) ? parseInt(attrs.page) : 1,
            total: 0
          };

          scope.renderPage = function (num) {
            if (renderTask) {
              renderTask._internalRenderTask.cancel();
            }
            pdfDoc.getPage(num).then(function (page) {
              var viewport = void 0;
              var pageWidthScale = void 0;
              var renderContext = void 0;

              if (pageFit) {
                viewport = page.getViewport({scale: 1});
                var clientRect = element[0].getBoundingClientRect();
                pageWidthScale = clientRect.width / viewport.width;
                scale = pageWidthScale;
              }
              viewport = page.getViewport({scale: scale});

              setCanvasDimensions(canvas, viewport.width, viewport.height);

              renderContext = {
                canvasContext: ctx,
                viewport: viewport
              };

              renderTask = page.render(renderContext);

              renderTask.promise.then(function () {

                if (angular.isFunction(scope.onPageRender)) {
                  scope.onPageRender();
                }
              }).catch(function (reason) {
                $log.log(reason);
              });
            });
          };

          scope.goPrevious = function () {
            if (scope.page.num <= 1) {
              return;
            }
            scope.page.num = parseInt(scope.page.num) - 1;
            scope.pageNum = scope.page.num;
          };

          scope.goNext = function () {
            if (scope.page.num >= pdfDoc.numPages) {
              return;
            }
            scope.page.num = parseInt(scope.page.num) + 1;
            scope.pageNum = scope.page.num;
          };

          scope.scale = function (s) {
            pageFit = false;
            scale = s;
            scope.renderPage(scope.page.num);
            return scale;
          };

          scope.zoomIn = function () {
            pageFit = false;
            scale = parseFloat(scale) + 0.2;
            scope.renderPage(scope.page.num);
            return scale;
          };

          scope.zoomOut = function () {
            pageFit = false;
            scale = parseFloat(scale) - 0.2;
            scope.renderPage(scope.page.num);
            return scale;
          };

          scope.fit = function () {
            pageFit = true;
            scope.renderPage(scope.page.num);
          };

          scope.changePage = function () {
            scope.renderPage(scope.page.num);
          };

          scope.rotate = function () {

            if (canvas.getAttribute('class') === 'rotate0') {
              canvas.setAttribute('class', 'rotate90');
            } else if (canvas.getAttribute('class') === 'rotate90') {
              canvas.setAttribute('class', 'rotate180');
            } else if (canvas.getAttribute('class') === 'rotate180') {
              canvas.setAttribute('class', 'rotate270');
            } else {
              canvas.setAttribute('class', 'rotate0');
            }
          };

          scope.print = function () {
            var wnd = $window.open(scope.pdfUrl);
            $timeout(function () {
              wnd.print();
            }, 1000);
          };

          function clearCanvas() {
            if (ctx) {
              ctx.clearRect(0, 0, canvas.width, canvas.height);
            }
            if (pdfLoaderTask) {
              pdfLoaderTask.destroy().then()['finally'](function () {
                if (ctx) {
                  ctx.clearRect(0, 0, canvas.width, canvas.height);
                }
                scope.loading = $q.defer();
                scope.loading.reject();
                return scope.loading;
              });
            }
            if (renderTask) {
              renderTask._internalRenderTask.cancel();
            }
          }

          scope.isLoading = function () {
            if (scope.loading) {
              return scope.loading.promise;
            }
            else {
              return null;
            }
          };

          function renderPDF(aUrl) {
            var urlAux;
            if (!aUrl) {
              urlAux = url;
            } else {
              urlAux = aUrl;
            }

            if (lasturl === urlAux) return;
            lasturl = urlAux;

            scope.loading = $q.defer();
            scope.error = false;
            scope.errorMessage = plLocale.locales.messages.pdfJsLoadError;

            if (ctx) {
              StackBlur.canvasRGB(canvas, 0, 0, canvas.width, canvas.height, 4);
            }

            var params = {
              'url': urlAux,
              'withCredentials': creds
            };

            if (httpHeaders) {
              params.httpHeaders = httpHeaders;
            }

            if (urlAux && urlAux.length) {
              lasturl = urlAux;

              pdfLoaderTask = pdfjsLib.getDocument(params);
              pdfLoaderTask.onProgress = scope.onProgress;
              pdfLoaderTask.onPassword = scope.onPassword;
              pdfLoaderTask.promise.then(
                function (_pdfDoc) {
                  if (angular.isFunction(scope.onLoad)) {
                    scope.onLoad();
                  }

                  pdfDoc = _pdfDoc;
                  scope.renderPage(scope.page.num);

                  scope.$apply(function () {
                    scope.page.total = _pdfDoc.numPages;
                    scope.error = false;
                    scope.errorMessage = plLocale.locales.messages.pdfJsLoadError;
                  });
                  scope.loading.resolve();
                },
                function (error) {
                  if (error.headers && error.headers.hasOwnProperty('exception')) {
                    var exceptionJson = angular.fromJson(error.headers.exception);
                    if (exceptionJson.exception && exceptionJson.exception.message) {
                      scope.errorMessage = exceptionJson.exception.message;
                    }
                  }
                  scope.loading.reject(error);
                  scope.$apply(function () {
                    scope.error = true;
                  });
                  if (error) {
                    if (angular.isFunction(scope.onError)) {
                      scope.onError({error: error});
                    }
                  }
                }
              )['finally'](function () {
                scope.promise = null;
              });
              scope.promise = pdfLoaderTask.promise;
            }
            else {
              scope.loading.reject();
            }

            return scope.loading;
          }

          function loadPdf() {
            var urlAux;
            if (!urlPreview){
              urlAux = url;
            } else {
              urlAux = urlPreview;
            }

            if (lasturl === urlAux) {
              return;
            }
            mnuDownload.download.url = url;
            mnuDownload.download.filename = scope.filename;

            if (pdfLoaderTask) {
              pdfLoaderTask.destroy().then(function () {
                renderPDF(urlAux);
              });
            }
            else {
              renderPDF(urlAux);
            }
          }

          scope.$watch('page.num', function (newVal) {
            scope.page.num = parseInt(newVal);
            if (pdfDoc !== null) {
              scope.renderPage(scope.page.num);
            }
          });

          scope.$watch('pdfUrl', function (newVal) {
            if (newVal === '') {
              clearCanvas();
            }
            else {
              url = newVal;
              scope.page.num = 1;
              scope.pageNum = scope.page.num;
              loadPdf();
            }
          });

          function cleanup() {
            if (scope.toolbarId) {
              var toolbar = plToolbarService.getInstance(scope.toolbarId);
              if (!toolbar) return;

              toolbar.config.removeGroupId('pl-pdf');
            }
            windowEl.off('scroll');
            angular.element($window).off('resize');
          }

          if (scope.toolbarId) {
            var toolbar = plToolbarService.getInstance(scope.toolbarId);
            if (!toolbar) {
              return;
            }
            toolbar.config.removeGroupId('pl-pdf');

            toolbar.config.items.push(
              {
                groupId: 'pl-pdf',
                id: 'pdfNav',
                order: 300,
                type: 'button-group',
                items: [
                  {
                    groupId: 'pl-pdf',
                    id: 'pdfPrev',
                    order: 1,
                    type: 'button',
                    iconLeft: '<i class="fa fa-chevron-left fa-fw"></i>',
                    class: 'btn-primary',
                    caption: '',
                    click: scope.goPrevious
                  },
                  {
                    groupId: 'pl-pdf',
                    id: 'pdfNext',
                    order: 2,
                    type: 'button',
                    iconLeft: '<i class="fa fa-chevron-right fa-fw"></i>',
                    class: 'btn-primary',
                    caption: '',
                    click: scope.goNext
                  }
                ]
              },
              {
                groupId: 'pl-pdf',
                id: 'pdfPages',
                order: 300,
                type: 'page',
                iconLeft: '',
                class: 'btn-primary',
                caption: 'Páginas:',
                page: scope.page
              },
              mnuZoom,
              mnuDownload,
              {
                groupId: 'pl-pdf',
                id: 'pdfPrint',
                order: 300,
                type: 'button',
                iconLeft: '<i class="fa fa-print fa-fw"></i>',
                class: 'btn-primary',
                caption: 'Imprimir',
                click: scope.print
              }
            );
          }

          loadPdf();

          angular.element($window).on('resize', function () {
            plCompsService.debounce(function () {
              scope.renderPage(scope.page.num);
            }, 500, 'plPdf');
          });

          scope.$on('$destroy', function () {
            cleanup();
          });

          scope.source = {
            print: scope.print,
            fit: scope.fit,
            rotate: scope.rotate,
            zoomOut: scope.zoomOut,
            zoomIn: scope.zoomIn,
            goNext: scope.goNext,
            goPrevious: scope.goPrevious,
            goPage: scope.renderPage,
            scale: scope.scale,
            page: scope.page
          };
        }
      };
    }]);

})();

(function () {
  'use strict';

  angular.module('pl.comps')
    .component('plPivotTable', {
      require: {
        ngModel: '?ngModel'
      },
      bindings: {
        source: '<',
        definition: '<?',
        template: '<?',
        name: '@?',
        properties: '<?'
      },
      template: '<div class="table-responsive" ng-attr-name="{{$ctrl.name}}"></div>',
      controllerAs: '$ctrl',
      controller: /*ngInject*/['$window', '$scope', '$element', '$q', '$timeout', '$filter', 'plFormat', 'plLocale', 'plTranslate', 'plCompsService', function ($window, $scope, $element, $q, $timeout, $filter, plFormat, plLocale, plTranslate, plCompsService) {
        var ctrl = this;
        var DEFAULTS = {};
        var defaultOptions = {
          locale: plFormat.format.pivotTableLocale
        };
        var table = null;
        var events = [
          {selector: 'select', event: 'change'},
          {selector: 'input', event: 'keyup'},
          {selector: 'button[type="button"]', event: 'click'},
          {selector: 'button.pvtRowOrder', event: 'click'},
          {selector: 'button.pvtColOrder', event: 'click'},
          {selector: 'span.pvtTriangle', event: 'click'},
          {selector: '.pvtAxisContainer', event: 'sortupdate'}
        ];

        ctrl.name = '';
        ctrl.model = {};
        ctrl.source = [];
        ctrl.sourceMap = {};
        ctrl.options = {};

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.$onDestroy = onDestroy;
        ctrl.render = render;
        ctrl.handleBindings = handleBindings;
        ctrl.handleExtension = handleExtension;
        ctrl.renderTable = renderTable;
        ctrl.handleSource = handleSource;
        ctrl.normalizeData = normalizeData;
        ctrl.applyFilter = applyFilter;
        ctrl.extendDate = extendDate;
        ctrl.fixRowsCols = fixRowsCols;
        ctrl.retrieveData = retrieveData;
        ctrl.getSourceMapField = getSourceMapField;
        ctrl.tableEvents = tableEvents;
        ctrl.updateDefinition = updateDefinition;

        /////////////

        function init() {
          DEFAULTS.definition = {
            fields: [],
            pivot: {
              cols: [],
              rows: [],
              type: ''
            }
          };
          DEFAULTS.template = {
            cols: [],
            rows: [],
            type: ''
          };

          // ngModel can be either a javascript object or the raw string returned by retrieveData()
          if (ctrl.ngModel) {
            ctrl.ngModel.$render = function () {
              if (ctrl.ngModel.$viewValue) {
                var value = ctrl.ngModel.$viewValue;
                if (angular.isString(value)) {
                  value = angular.fromJson(value);
                }
                _.merge(ctrl.template, {
                  cols: value.cols || ctrl.template.cols || [],
                  rows: value.rows || ctrl.template.rows || [],
                  type: value.type || ctrl.template.type || ''
                });
                ctrl.handleBindings();
              }
            };
          }
          ctrl.handleBindings();
          $scope.$on('plLocale:appliedLocale', function () {
            defaultOptions.locale = plFormat.format.pivotTableLocale;
            ctrl.handleBindings();
          });
        }

        function onChanges(plPivotTable) {
          if (plPivotTable) {
            for (var change in plPivotTable) {
              if (plPivotTable.hasOwnProperty(change) && plPivotTable[change].isFirstChange()) {
                return;
              }
            }
            ctrl.handleBindings();
          }
        }

        function onDestroy() {
          angular.forEach(events, function (event) {
            if (event.element) {
              event.element.off(event.event, ctrl.render);
            }
          });
        }

        function render() {
          plCompsService.debounce(function () {
            var value = ctrl.retrieveData();
            if (value && ctrl.ngModel) {
              ctrl.ngModel.$setViewValue(value);
              ctrl.ngModel.$commitViewValue();
              ctrl.updateDefinition(value);
            }
          }, 100, 'plPivotTableRender' + ctrl.name);
        }

        function handleBindings() {
          ctrl.name = plCompsService.generateName(ctrl.name, 'plPivotTable');
          ctrl.definition = _.merge({}, DEFAULTS.definition, ctrl.definition);
          ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties);
          if (ctrl.options.locale === 'pt-pt') {
            ctrl.options.locale = 'pt';
          }
          ctrl.handleExtension();
          ctrl.renderTable();
        }

        function handleExtension() {
          if (!ctrl.template) {
            ctrl.template = {};
          }
          var template = angular.copy(ctrl.template) || {};
          _.merge(ctrl.template, DEFAULTS.template, ctrl.definition.pivot, template, {
            renderers: angular.extend({},
              angular.element.pivotUtilities.locales[ctrl.options.locale].renderers,
              angular.element.pivotUtilities.locales[ctrl.options.locale].export_renderers, // jshint ignore:line
              angular.element.pivotUtilities.locales[ctrl.options.locale].gchart_renderers, // jshint ignore:line
              angular.element.pivotUtilities.locales[ctrl.options.locale].plotly_renderers)// jshint ignore:line
          });
        }

        function renderTable() {
          var type = ctrl.template ? ctrl.template.type : '';
          ctrl.handleSource().then(function (source) {
            source = ctrl.normalizeData(source);
            var deferred = $timeout(function () {
              // Clean up if rendered previously
              if (table) {
                ctrl.$onDestroy();
                table.empty();
              }

              if (type !== 'ui') {
                $scope.$apply(function () {
                  table = $element.find('[name="' + ctrl.name + '"]').pivot(source, ctrl.template, ctrl.options.locale);
                });
              }
              else {
                $scope.$apply(function () {
                  table = $element.find('[name="' + ctrl.name + '"]').pivotUI(source, ctrl.template, true, ctrl.options.locale);
                });
              }
            });
            deferred.then(function () {
              $timeout(function () {
                ctrl.tableEvents();
                ctrl.render();
              });
            });
          });
        }

        function handleSource() {
          var deferred = $q.defer();

          if (angular.isFunction(ctrl.source)) {
            $q.when(ctrl.source).then(function (value) {
              deferred.resolve(value);
            });
          }
          else {
            deferred.resolve(ctrl.source);
          }

          return deferred.promise;
        }

        function normalizeData(source) {
          var result = [];
          angular.forEach(source, function (field) {
            angular.forEach(field, function (value, property) {
              var definition = ctrl.definition.fields.find(function (item) {
                // Separating pseudo fields
                var name = item.name;
                var separatorIndex = name.indexOf('.');
                if (separatorIndex !== -1) {
                  name = name.substring(0, separatorIndex);
                }
                return name === property;
              });
              if (definition) {
                if (definition.caption) {
                  var caption = plTranslate.translate(definition.caption);
                  ctrl.sourceMap[property] = caption;
                  field[caption] = value;
                  delete field[property];
                  property = caption;
                }
                if (definition.type) {
                  field[property] = ctrl.applyFilter(value, definition.type, property);
                }
              }
            });
            result.push(field);
          });
          ctrl.fixRowsCols();
          return result;
        }

        function applyFilter(value, filter, field) {
          if (filter === 'date' || filter === 'datetime' || filter === 'time') {
            // Check if value is in ISO format
            if (angular.isString(value) && !value.match(plFormat.format.isoRegex)) {
              var format = plFormat.format[filter];
              if (filter === 'date') {
                format = format.toUpperCase();
              }
              value = $filter('date')(plCompsService.normalizeDate(value, format).toDate(), plFormat.format[filter]);
            }
            else {
              value = $filter('date')(plCompsService.normalizeDate(value).toDate(), plFormat.format[filter]);
            }
            if (filter === 'date' || filter === 'datetime') {
              ctrl.extendDate(field, 'date');
            }
          }
          else if (filter === 'currency') {
            value = $filter('plNumber')(value);
            value += plFormat.format.currency;
          }
          else if (filter === 'number' || filter === 'float') {
            value = $filter('plNumber')(value);
            value += plFormat.format.currency;
          }
          return value;
        }

        function extendDate(field, type) {
          var locales = plLocale.locales;
          var derivedAttributes = {};
          var realField = ctrl.getSourceMapField(field);

          derivedAttributes[locales.day] = function (row) {
            var date = plCompsService.normalizeDate(row[field], plFormat.format[type].toUpperCase());
            return date.isValid() ? date.format('DD') : row[field];
          };
          derivedAttributes[locales.week] = function (row) {
            var date = plCompsService.normalizeDate(row[field], plFormat.format[type].toUpperCase());
            return date.isValid() ? date.format('WW') : row[field];
          };
          derivedAttributes[locales.month] = function (row) {
            var date = plCompsService.normalizeDate(row[field], plFormat.format[type].toUpperCase());
            var month = date.isValid() ? date.format('M') : row[field];
            switch (parseInt(month)) {
              case 1:
                return '01 - ' + locales.months.january;
              case 2:
                return '02 - ' + locales.months.february;
              case 3:
                return '03 - ' + locales.months.march;
              case 4:
                return '04 - ' + locales.months.april;
              case 5:
                return '05 - ' + locales.months.may;
              case 6:
                return '06 - ' + locales.months.june;
              case 7:
                return '07 - ' + locales.months.july;
              case 8:
                return '08 - ' + locales.months.august;
              case 9:
                return '09 - ' + locales.months.september;
              case 10:
                return '10 - ' + locales.months.october;
              case 11:
                return '11 - ' + locales.months.november;
              case 12:
                return '12 - ' + locales.months.december;
              default:
                return row[field];
            }
          };
          derivedAttributes[locales.year] = function (row) {
            var date = plCompsService.normalizeDate(row[field], plFormat.format[type].toUpperCase());
            return date.isValid() ? date.format('YYYY') : row[field];
          };

          // Mapping field's derived attributes to sourceMap
          angular.forEach(derivedAttributes, function (attribute, property) {
            var newProperty = property + ' (' + _.capitalize(field) + ')';
            derivedAttributes[newProperty] = attribute;
            delete derivedAttributes[property];

            if (realField) {
              var key = _.findKey(locales, function (locale) {
                return locale === property;
              });
              ctrl.sourceMap[realField + '.' + key] = newProperty;
            }
          });

          _.merge(ctrl.template, {derivedAttributes: derivedAttributes}, ctrl.template);
        }

        function fixRowsCols() {
          var toFix = ['cols', 'rows'];
          angular.forEach(toFix, function (item) {
            angular.forEach(ctrl.sourceMap, function (value, key) {
              var index = ctrl.template[item].indexOf(key);
              if (index !== -1) {
                ctrl.template[item][index] = value;
              }
            });
          });
        }

        function retrieveData() {
          if (!table) {
            return null;
          }

          var data = angular.toJson(table.data('pivotUIOptions'));
          if (!data) {
            return;
          }

          data = angular.fromJson(data);

          // Remove unnecessary properties
          delete data.aggregators;
          delete data.renderers;
          delete data.rendererOptions.localeStrings;
          delete data.localeStrings;

          // Parse rows/columns
          var properties = ['cols', 'rows'];
          angular.forEach(properties, function (property) {
            angular.forEach(data[property], function (element, index) {
              // Definition items
              var item = ctrl.getSourceMapField(element);
              if (item) {
                data[property][index] = item;
              }
            });
          });

          return angular.toJson(data);
        }

        function getSourceMapField(data) {
          for (var item in ctrl.sourceMap) {
            if (ctrl.sourceMap.hasOwnProperty(item) && data === ctrl.sourceMap[item]) {
              return item;
            }
          }
          return undefined;
        }

        function tableEvents() {
          if (!table) {
            return;
          }
          angular.forEach(events, function (event, i) {
            events[i].element = table.find(event.selector);
            events[i].element.on(event.event, ctrl.render);
          });
        }

        function updateDefinition(value) {
          value = angular.fromJson(value) || {};
          ctrl.template.cols = value.cols;
          ctrl.template.fields = value.fields || [];
          ctrl.template.rows = value.rows;
        }
      }]
    });
})();

/**
 * Created by pedro on 06/03/2017.
 */
(function () {
  'use strict';

  angular.module('pl.edit')
    .component('plProgress', {
      bindings: {
        value: '<',
        max: '<?',
        min: '<?'
      },
      transclude: true,
      templateUrl: '../source/pl-progress.html',
      controller: function () {
        var ctrl = this;

        ctrl.min = 0;
        ctrl.max = 100;

        ctrl.$onInit = init;

        /////////////

        function init() {
          ctrl.min = ctrl.min || 0;
          ctrl.max = ctrl.max || 100;
        }
      }
    });
})();

(function () {
  'use strict';

  angular.module('pl.promises', ['ngAnimate', 'pl.spinners'])
    .provider('plPromise', function () {
      var config = {
        templates: {
          promises: '<div class="pl-promise-spinner">' +
          '<div class="pl-spinner-3dots-bounce1"></div>' +
          '<div class="pl-spinner-3dots-bounce2"></div>' +
          '<div class="pl-spinner-3dots-bounce3"></div>' +
          '</div>',
          overlay: '<div class="pl-promise-overlay"></div>'
        },
        overlay: false,
        dim: false,
        priority: 0,
        disableBtn: true,
        disableSpin: false,
        btnLoadingClass: 'pl-promise-loading',
        btnDimClass: 'pl-promise-dim',
        addClassToCurrentBtnOnly: false,
        disableCurrentBtnOnly: false,
        minDuration: false,
        CLICK_EVENT: 'click',
        CLICK_ATTR: 'ngClick',
        SUBMIT_EVENT: 'submit',
        SUBMIT_ATTR: 'ngSubmit'
      };
      return {
        setConfig: mergeConfig,
        $get: function () {
          return {
            config: config
          };
        }
      };

      /////////////

      function mergeConfig(newConfig) {
        config = angular.extend({}, config, newConfig);
      }
    });
})();

(function () {
  'use strict';

  angular.module('pl.promises')
    .directive('plPromise', ['$log', '$parse', '$timeout', 'plPromise', 'plCompsService', function ($log, $parse, $timeout, plPromise, plCompsService) {
      var CLICK_EVENT = 'click';
      var CLICK_ATTR = 'ngClick';
      var SUBMIT_EVENT = 'submit';
      var SUBMIT_ATTR = 'ngSubmit';

      return {
        restrict: 'EA',
        priority: plPromise.config.priority,
        link: function ($scope, $element, $attrs) {
          var ctrl = $scope['plPromise' + plCompsService.generateUniqueID()] = {};
          var defaultConfig = plPromise.config;

          ctrl.config = angular.copy(defaultConfig);
          ctrl.promiseWatcher = null;
          ctrl.timeout = null;
          ctrl.timeoutDone = false;
          ctrl.promiseDone = false;

          ctrl.$onInit = init;
          ctrl.$onDestroy = onDestroy;
          ctrl.handleLoading = handleLoading;
          ctrl.handleLoadingFinished = handleLoadingFinished;
          ctrl.initPromiseWatcher = initPromiseWatcher;
          ctrl.getCallbacks = getCallbacks;
          ctrl.appendSpinnerTemplate = appendSpinnerTemplate;
          ctrl.addHandlersForCurrentBtnOnly = addHandlersForCurrentBtnOnly;
          ctrl.initHandlingOfViewFunctionsReturningAPromise = initHandlingOfViewFunctionsReturningAPromise;
          ctrl.getSubmitBtnChildren = getSubmitBtnChildren;
          ctrl.addClass = addClass;
          ctrl.removeClass = removeClass;

          ctrl.$onInit();

          /////////////

          function init() {
            ctrl.icon = $element;
            if ($element.is('pl-button')) {
              $element = $element.find('button');
            }
            if ($attrs.promiseBtnOptions) {
              ctrl.config = _.merge({}, defaultConfig, ctrl.config, $scope.$eval($attrs.promiseBtnOptions));
            }

            // Check if there is any value given via $attrs.plPromise
            if (!$attrs.plPromise) {
              // Handle ngClick function directly returning a promise
              if ($attrs.hasOwnProperty(CLICK_ATTR)) {
                ctrl.appendSpinnerTemplate($element);
                ctrl.addHandlersForCurrentBtnOnly($element);
                ctrl.initHandlingOfViewFunctionsReturningAPromise(CLICK_EVENT, CLICK_ATTR, $element);
              }
              // Handle ngSubmit function directly returning a promise
              else if ($attrs.hasOwnProperty(SUBMIT_ATTR)) {
                // Get child submits for form elements
                var btnElements = getSubmitBtnChildren($element);
                ctrl.appendSpinnerTemplate(btnElements);
                ctrl.addHandlersForCurrentBtnOnly(btnElements);
                ctrl.initHandlingOfViewFunctionsReturningAPromise(SUBMIT_EVENT, SUBMIT_ATTR, btnElements);
              }
            }
            // Handle promises passed via scope.plPromise
            else {
              ctrl.appendSpinnerTemplate($element);
              ctrl.addHandlersForCurrentBtnOnly($element);

              // Handle promise passed directly via attribute as variable
              ctrl.initPromiseWatcher(angular.bind(ctrl, function () {
                return $parse($attrs.plPromise)($scope);
              }), $element);
            }

            $attrs.$observe('promiseBtnOptions', function (interpolatedValue) {
              ctrl.config = _.merge({}, defaultConfig, ctrl.config, $scope.$eval(interpolatedValue));
            });
          }

          function onDestroy() {
            if (ctrl.timeout) {
              $timeout.cancel(ctrl.timeout);
            }
          }

          function handleLoading(btnElement) {
            $log.debug('promisse loading');
            if (ctrl.config.btnLoadingClass && !ctrl.config.addClassToCurrentBtnOnly) {
              ctrl.addClass();
            }
            if (ctrl.config.disableBtn && !ctrl.config.disableCurrentBtnOnly) {
              btnElement.attr('disabled', 'disabled');
            }
          }

          function handleLoadingFinished(btnElement) {
            $log.debug('promisse finished');
            if ((!ctrl.config.minDuration || ctrl.timeoutDone) && ctrl.promiseDone) {
              if (ctrl.config.btnLoadingClass) {
                ctrl.removeClass();
              }
              if (ctrl.config.disableBtn) {
                btnElement.removeAttr('disabled');
              }
            }
          }

          function initPromiseWatcher(watchExpressionForPromise, btnElement) {
            // Watch promise to resolve or fail
            $scope.$watch(watchExpressionForPromise, function (promise) {
              ctrl.timeoutDone = false;
              ctrl.promiseDone = false;

              // create ctrl.timeout if option is set
              if (ctrl.config.minDuration) {
                ctrl.timeout = $timeout(function () {
                  ctrl.timeoutDone = true;
                  ctrl.handleLoadingFinished(btnElement);
                }, ctrl.config.minDuration);
              }

              if (promise && (promise.then || promise.$promise)) {
                var fn = null;
                ctrl.handleLoading(btnElement);

                // For regular promises
                if (promise.then) {
                  fn = 'finally';
                }
                // For $resource
                if (promise.$promise) {
                  fn = '$promise';
                }

                promise[fn](function () {
                  ctrl.promiseDone = true;
                  ctrl.handleLoadingFinished(btnElement);
                });
              }
            });
          }

          function getCallbacks(expression) {
            // Split by ';' to get different functions if any
            return expression
              .split(';')
              .map(function (callback) {
                // Return getter function
                return $parse(callback);
              });
          }

          function appendSpinnerTemplate(btnElement) {
            var i = btnElement.find('i.fa-circle-o-notch,i.fa-cog,i.fa-refresh,i.fa-spinner');
            if (i.length && !ctrl.config.disableSpin) {
              if (i.hasClass('fa-spin')) {
                i.removeClass('fa-spin');
                ctrl.config.btnLoadingClass = 'fa-spin';
                ctrl.icon = i;
              }
            }
            else {
              btnElement.append(ctrl.config.templates.promises);
            }
            if (ctrl.config.overlay) {
              btnElement.append(ctrl.config.templates.overlay);
            }
          }

          function addHandlersForCurrentBtnOnly(btnElement) {
            // Handle current button only options via click
            if (ctrl.config.addClassToCurrentBtnOnly) {
              btnElement.on(CLICK_EVENT, function () {
                ctrl.addClass();
              });
            }
            if (ctrl.config.disableCurrentBtnOnly) {
              btnElement.on(CLICK_EVENT, function () {
                btnElement.attr('disabled', 'disabled');
              });
            }
          }

          function initHandlingOfViewFunctionsReturningAPromise(eventToHandle, attrToParse, btnElement) {
            /* We need to use evalAsync here, as otherwise the click or submit event
             * won't be ready to be replaced */
            $scope.$evalAsync(function () {
              var callbacks = ctrl.getCallbacks($attrs[attrToParse]);

              // Unbind original click event
              $element.off(eventToHandle);

              // Rebind, but this time watching it's return value
              $element.on(eventToHandle, function () {
                // Make sure we run the $digest cycle
                $scope.$apply(function () {
                  callbacks.forEach(function (callback) {
                    // Execute function on parent $scope as we're in an isolate $scope here
                    var promise = callback($scope, {$event: eventToHandle});
                    if (promise && angular.isFunction(promise.then)) {
                      promise.then();
                    }

                    // Only init watcher if not done before
                    if (!ctrl.promiseWatcher) {
                      ctrl.promiseWatcher = ctrl.initPromiseWatcher(function () {
                        return promise;
                      }, btnElement);
                    }
                  });
                });
              });
            });
          }

          function getSubmitBtnChildren(element) {
            var allButtonEls = element.find('button');
            var submitBtnEls = [];
            for (var i = 0; i < allButtonEls.length; i++) {
              var btnElement = allButtonEls[i];
              if (angular.element(btnElement).attr('type') === 'submit') {
                submitBtnEls.push(btnElement);
              }
            }
            return angular.element(submitBtnEls);
          }

          function addClass() {
            ctrl.icon.addClass(ctrl.config.btnLoadingClass);
            if (ctrl.config.dim) {
              ctrl.icon.addClass(ctrl.config.btnDimClass);
            }
          }

          function removeClass() {
            ctrl.icon.removeClass(ctrl.config.btnLoadingClass);
            if (ctrl.config.dim) {
              ctrl.icon.removeClass(ctrl.config.btnDimClass);
            }
          }
        }
      };
    }]);
})();

/**
 * Created by pedro on 18/11/16.
 */

(function () {
  'use strict';

  angular.module('pl.input', [])
    .component('plRowSelect', {
      require: {
        ngModel: '^ngModel',
        plForm: '?^plForm',
        plEdit: '?^plEdit'
      },
      bindings: {
        name: '@?',
        start: '@?',
        end: '@?',
        list: '<?',
        editClass: '<?',
        properties: '<?'
      },
      templateUrl: '../source/pl-rowselect.html',
      controller: /*@ngInject*/ ['$scope', '$location', '$attrs', function ($scope, $location, $attrs) {
        var ctrl = this;
        var defaultOptions = {
          start: 1,
          end: 5,
          validate: true,
          validators: {
            required: {value: false}
          }
        };
        var lastStart;
        var lastEnd;

        ctrl.options = {};

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.$onDestroy = onDestroy;
        ctrl.render = render;
        ctrl.buildList = buildList;
        ctrl.select = select;
        ctrl.isArray = isArray;
        ctrl.isObject = isObject;
        ctrl.updateComponent = updateComponent;

        /////////////

        function init() {
          if (!(ctrl.start && angular.isNumber(ctrl.start)) && !ctrl.isArray() && !ctrl.isObject()) {
            ctrl.start = defaultOptions.start;
            ctrl.list = undefined;

          }
          if (!(ctrl.end && angular.isNumber(ctrl.end)) && !ctrl.isArray() && !ctrl.isObject()) {
            ctrl.end = defaultOptions.end;
            ctrl.list = undefined;
          }
          if (!ctrl.editClass) {
            ctrl.editClass = {};
          }

          if (ctrl.plEdit) {
            ctrl.plEdit.addComponent(ctrl);
            if (ctrl.plEdit.options) {
              _.merge(defaultOptions, ctrl.plEdit.options);
            }
          }
          ctrl.options = _.merge({}, defaultOptions, ctrl.properties);
          ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;

          ctrl.buildList();

          ctrl.ngModel.$render = function () {
            ctrl.value = (ctrl.ngModel.$viewValue);
          };

          if ($attrs.name) {
            ctrl.select($location.search()[$attrs.name]);
          }

          if (ctrl.options.validate) {
            if (ctrl.options.validators.required.value === true) {
              ctrl.ngModel.$validators.required = function () {
                return angular.isDefined(ctrl.value) && ctrl.value !== null;
              };
            }
          }
        }

        function onChanges(values) {
          if (values) {
            if (values.end && values.end.currentValue === '') {
              ctrl.end = defaultOptions.end;
            }
            if (values.start && values.start.currentValue === '') {
              ctrl.start = defaultOptions.start;
            }
          }
          ctrl.buildList();
        }

        function onDestroy() {
          if (ctrl.plEdit) {
            ctrl.plEdit.removeComponent(ctrl.name);
          }
        }

        function render() {
          ctrl.ngModel.$setViewValue(ctrl.value);
          if (ctrl.plEdit) {
            ctrl.plEdit.valueChanged(ctrl);
          }
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.change)) {
            ctrl.options.events.change(ctrl, ctrl.plForm);
          }
          if ($attrs.name) $location.search($attrs.name, ctrl.value);
        }

        function buildList() {
          if (lastStart !== ctrl.start || lastEnd !== ctrl.end) {
            lastStart = ctrl.start;
            lastEnd = ctrl.end;
            ctrl.list = undefined;
          }

          if (!ctrl.list) {
            ctrl.list = [];
            for (var i = parseInt(ctrl.start); i <= ctrl.end; i++) {
              ctrl.list.push(i);
            }
          }
        }

        function select(item) {
          if (ctrl.options.readonly || ctrl.options.disabled) {
            return;
          }
          ctrl.value = item;
          ctrl.render();
        }

        function isArray() {
          return angular.isArray(ctrl.list);
        }

        function isObject() {
          return angular.isObject(ctrl.list);
        }

        function updateComponent(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties, properties);
            ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
          }
        }
      }]
    });
})();

(function () {
  'use strict';

  var controllerAs = '$ctrl';

  angular.module('pl.comps')
    .component('plSelect', {
      require: {
        ngModel: 'ngModel'
      },
      bindings: {
        source: '<',
        rowTemplate: '<?',
        output: '<?',
        name: '@?',
        multiple: '<?',
        ngDisabled: '<?',
        readonly: '<?',
        onChange: '&?',
        onSelect: '<?',
        groupBy: '<?',
        filterBy: '@?',
        placeholder: '@?',
        properties: '<?'
      },
      templateUrl: '../source/pl-select.html',
      controllerAs: controllerAs,
      controller: /*ngInject*/ ['$interpolate', '$timeout', '$element', 'plCompsService', 'plTranslate', function ($interpolate, $timeout, $element, plCompsService, plTranslate) {
        var ctrl = this;
        var defaultOptions = {
          readonly: false,
          disabled: false,
          validate: true,
          raw: false,
          forceFixEvents: false,
          validators: {
            required: {value: false}
          },
          events: {
            change: undefined,
            open: undefined
          }
        };

        ctrl.value = {};
        ctrl.setEvent = false;

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.$onDestroy = onDestroy;
        ctrl.handleOptions = handleOptions;
        ctrl.handleResize = handleResize;
        ctrl.render = render;
        ctrl.getRow = getRow;
        ctrl.getOutput = getOutput;
        ctrl.getFilter = getFilter;
        ctrl.fnOnChange = fnOnChange;
        ctrl.fnOnSelect = fnOnSelect;
        ctrl.fnOpen = fnOpen;
        ctrl.doFocus = doFocus;
        ctrl.updateComponent = updateComponent;

        /////////////

        function init() {
          if (ctrl.plEdit) {
            ctrl.plEdit.addComponent(ctrl);
            if (ctrl.plEdit.options) {
              _.merge(defaultOptions, ctrl.plEdit.options);
            }
          }
          ctrl.handleOptions();
          ctrl.ngModel.$render = function () {
            ctrl.value = ctrl.ngModel.$viewValue;
            ctrl.handleResize();
          };
          if (ctrl.multiple) {
            angular.element('window').on('resize', ctrl.handleResize);
          }
          if (ctrl.options.forceFixEvents) {
            $timeout(function () {
              $element.find('.ui-select-focusser').on('keydown focus', ctrl.doFocus);
            });
          }
        }

        function onChanges(plSelect) {
          if (plSelect && plSelect.properties && !plSelect.properties.isFirstChange()) {
            ctrl.handleOptions(plSelect.properties.currentValue);
          }
        }

        function onDestroy() {
          angular.element('window').off('resize', ctrl.handleResize);
          $element.find('.ui-select-focusser').off('keydown focus', ctrl.doFocus);
        }

        function handleOptions(properties) {
          properties = properties || ctrl.properties;
          if (!properties) {
            properties = {};
          }
          if (properties.select2) {
            _.merge(properties, properties.select2);
          }
          ctrl.options = _.merge({}, defaultOptions, properties);
          ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
          _.merge(ctrl, ctrl.options);
          if (!ctrl.multiple && !ctrl.options.multiple) {
            ctrl.options.raw = true;
          }
        }

        function handleResize() {
          if (ctrl.multiple) {
            plCompsService.debounce(function () {
              $timeout(function () {
                var $input = $element.find('.ui-select-search');
                if ($input.length) {
                  var $parent = $input.parent();
                  var $selectMatch = $parent.find('.ui-select-match');
                  var width = $parent.width() - $selectMatch.width();
                  $input.width(width - 10);
                }
              });
            }, 100, 'plSelectHandleResize');
          }
        }

        function render(value) {
          value = value || ctrl.value;
          ctrl.ngModel.$setViewValue(value);
          ctrl.handleResize();
        }

        function getRow(item) {
          if (!angular.isObject(item) || !ctrl.rowTemplate) {
            return item;
          }
          angular.forEach(item, function (propValue, propName) {
            if (angular.isString(propValue)) {
              item[propName] = plTranslate.translate(item[propName]);
            }
          });
          try {
            if (ctrl.rowTemplate.indexOf('{{') !== -1) {
              return $interpolate(ctrl.rowTemplate)(item);
            }
            else {
              return item[ctrl.rowTemplate];
            }
          }
          catch (e) {
            throw 'getRow' + e.stack;
          }
        }

        function getOutput(item) {
          if (!angular.isObject(item) || !ctrl.output) {
            return item;
          }
          try {
            if (ctrl.output.indexOf('{{') !== -1) {
              return $interpolate(ctrl.output)(item);
            }
            else {
              return item[ctrl.output];
            }
          }
          catch (e) {
            throw 'getOutput' + e.stack;
          }
        }

        function getFilter(search) {
          if (angular.isUndefined(ctrl.filterBy) || ctrl.filterBy === null) {
            return search;
          }
          if (angular.isString(ctrl.filterBy)) {
            var properties = ctrl.filterBy.split(',');
            var filter = {};
            for (var i = 0; i < properties.length; i++) {
              var property = properties[i];
              filter[property] = search;
            }
          }
          else if (angular.isFunction(ctrl.filterBy)) {
            return ctrl.filterBy;
          }
          else {
            return search;
          }
        }

        function fnOnChange(item, model) {
          ctrl.render();
          if (angular.isFunction(ctrl.onChange)) {
            ctrl.onChange({item: item, model: model, source: ctrl.source});
          }
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.change)) {
            ctrl.options.events.change(item, model, ctrl.source);
          }
        }

        function fnOnSelect(item, model) {
          ctrl.render();
          if (angular.isFunction(ctrl.onSelect)) {
            ctrl.onSelect(item, model, ctrl.source);
          }
        }

        function fnOpen(event) {
          var toggler = $element;
          if (ctrl.multiple === true) {
            toggler = toggler.find('input.ui-select-search');
          }
          else {
            toggler = toggler.find('.ui-select-toggle');
          }
          $timeout(function () {
            toggler.triggerHandler('click');
          });

          if (ctrl.options.events && angular.isFunction(ctrl.options.events.open)) {
            ctrl.options.events.open(ctrl.value, ctrl.source, event);
          }
        }

        function doFocus(event, prevent) {
          if (prevent) {
            return false;
          }
          var target;
          if (event) {
            target = angular.element(event.target.parentNode);
          }
          else {
            target = $element;
          }
          target = target.find('.ui-select-search');
          $timeout(function () {
            target.focus();
          });
        }

        function updateComponent(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.handleOptions(properties);
          }
        }
      }]
    })
    .directive('multipleChecker', ['$compile', function ($compile) {
      return {
        restrict: 'A',
        terminal: true,
        priority: 2000,
        compile: function (cElement) {
          cElement.removeAttr('multiple-checker');
          cElement.removeAttr('data-multiple-checker');
          return function postLink($scope, iElement) {
            if ($scope[controllerAs].multiple || $scope[controllerAs].properties && $scope[controllerAs].properties.multiple) {
              iElement[0].setAttribute('multiple', '');
              iElement.addClass('multiple');
            }
            else {
              iElement.removeClass('multiple');
            }
            $compile(iElement)($scope);
          };
        }
      };
    }]);
})();

(function () {
  'use strict';

  angular.module('pl.navbar')
    .component('plSidebar', {
      require: {
        plPageWrapper: '^^plPageWrapper'
      },
      transclude: {
        titleSlot: '?plSidebarTitle'
      },
      bindings: {
        menu: '<menus',
        onItemClick: '=?',
        isItemActive: '=?'
      },
      templateUrl: '../source/pl-sidebar.html',
      controllerAs: 'ctrl',
      controller: /*@ngInject*/ ['$scope', 'plLocale', 'plTranslate', 'KEYCODE', 'plCompsService', function ($scope, plLocale, plTranslate, KEYCODE, plCompsService) {
        var ctrl = this;

        ctrl.placeholder = plLocale.locales.placeholders.search;
        ctrl.title = '';
        ctrl.filterValue = '';
        ctrl.filterActive = false;
        ctrl.menusMap = [];
        ctrl.toShow = [];
        ctrl.previouslyOpen = [];

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.toggleSidebar = toggleSidebar;
        ctrl.getIcon = getIcon;
        ctrl.go = go;
        ctrl.jqueryScrollbarOptions = jqueryScrollbarOptions;
        ctrl.normalize = normalize;
        ctrl.normalizeSpecialChars = normalizeSpecialChars;
        ctrl.initMenu = initMenu;
        ctrl.initMenuItem = initMenuItem;
        ctrl.isActive = isActive;
        ctrl.doFilter = doFilter;
        ctrl.findMapValue = findMapValue;
        ctrl.isFiltered = isFiltered;
        ctrl.clearFilter = clearFilter;
        ctrl.filterKeyUp = filterKeyUp;

        /////////////

        function init() {
          ctrl.title = ctrl.title || 'Menu';
          ctrl.initMenu();

          $scope.$watch(angular.bind(ctrl, function () {
            return ctrl.menu;
          }), function () {
            ctrl.initMenu();
          });

          $scope.$on('plLocale:appliedLocale', function () {
            ctrl.placeholder = plLocale.locales.placeholders.search;
            ctrl.initMenu();
          });
        }

        function onChanges(plSidebar) {
          if (plSidebar && plSidebar.menu && !plSidebar.menu.isFirstChange()) {
            ctrl.initMenu();
          }
        }

        function toggleSidebar() {
          ctrl.plPageWrapper.toggleSidebar();
        }

        function getIcon(item) {
          return item.icon;
        }

        function go(item, parent) {
          if (!item.menu) {
            var handle = false;
            if (angular.isFunction(item.action)) {
              handle = item.action(item);
            }
            if (!handle && angular.isFunction(ctrl.onItemClick)) {
              ctrl.onItemClick(item);
            }
            if (ctrl.plPageWrapper.isMobile()) {
              ctrl.plPageWrapper.toggleSidebar();
            }
          }
          else {
            item.isOpened = !item.isOpened;
          }

          if (parent) {
            parent.isOpened = true;
          }
        }

        function jqueryScrollbarOptions(y, x) {
          if (y.scroll === y.maxScroll) {
            return true;
          }
        }

        function normalize(string) {
          return plCompsService.normalizeAccents(string);
        }

        function normalizeSpecialChars(string) {
          return string.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}\[\]\\\/]/gi, '');
        }

        function initMenu() {
          if (!ctrl.menu) {
            return;
          }
          ctrl.menusMap = [];
          for (var i = 0; i < ctrl.menu.length; i++) {
            var parentMenu = ctrl.menu[i];
            parentMenu.title = plTranslate.translate(parentMenu.title);
            parentMenu.filterValue = ctrl.normalize(parentMenu.title);
            if (parentMenu.suffix) {
              parentMenu.suffix = plTranslate.translate(parentMenu.suffix);
              parentMenu.filterValue += ctrl.normalize(parentMenu.suffix);
            }
            parentMenu.isOpened = ctrl.initMenuItem(parentMenu);
          }
        }

        function initMenuItem(item, parent) {
          var isActive = null;
          if (angular.isFunction(ctrl.isItemActive)) {
            isActive = ctrl.isItemActive(item, parent);
          }

          if (item.menu) {
            for (var i = 0; i < item.menu.length; i++) {
              var menu = item.menu[i];
              menu.title = plTranslate.translate(menu.title);
              if (!isActive) {
                isActive = ctrl.initMenuItem(menu, item);
              }
              if (item.filterValue) {
                var title = menu.title;
                if (menu.suffix) {
                  menu.suffix = plTranslate.translate(menu.suffix);
                  title += menu.suffix;
                }
                item.filterValue += '_' + ctrl.normalize(title);
              }
            }
          }
          else if (!parent) {
            item.filterValue += '_' + item.filterValue;
          }

          if (!parent) {
            ctrl.menusMap.push(item.filterValue);
          }

          return isActive;
        }

        function isActive(item, parent) {
          if (item.menu && item.isOpened) {
            return false;
          }

          var opened = null;
          if (angular.isFunction(ctrl.isItemActive)) {
            opened = ctrl.isItemActive(item, parent);
          }

          if (!opened && item.menu) {
            for (var i = 0; i < item.menu.length; i++) {
              opened = ctrl.isActive(item.menu[i], item);
              if (opened) {
                return opened;
              }
            }

          }
          return opened;
        }

        function doFilter() {
          if (!ctrl.filterValue) {
            return ctrl.clearFilter();
          }
          if (!ctrl.filterActive) {
            ctrl.previouslyOpen = [];
            for (var z = 0; z < ctrl.menu.length; z++) {
              if (ctrl.menu[z].isOpened) {
                ctrl.previouslyOpen.push(ctrl.menu[z].title);
              }
            }
          }

          var filterValues = ctrl.normalize(ctrl.filterValue).split(' ');
          ctrl.filterActive = true;
          ctrl.toShow = [];
          for (var i = 0; i < ctrl.menusMap.length; i++) {
            var map = ctrl.menusMap[i].split('_');
            for (var j = 1; j < map.length; j++) {
              var mapParentValue = map[0];
              var mapValue = map[j];
              var filterValueIndex = -1;

              var valid = true;
              for (var k = 0; k < filterValues.length; k++) {
                var filterValue = filterValues[k];
                filterValueIndex = ctrl.normalizeSpecialChars(mapValue).indexOf(filterValue);
                if (filterValueIndex === -1) {
                  if (mapParentValue.indexOf(filterValue) !== -1 && filterValues.length > 1) {
                    continue;
                  }
                  valid = false;
                  break;
                }

                // Removing found word from mapValue
                if (filterValues.length > 1 && mapValue.indexOf(' ') !== -1) {
                  mapValue = mapValue.split(' ');
                  var index = mapValue.findIndex(ctrl.findMapValue(filterValue));
                  if (index !== -1) {
                    mapValue.splice(index, 1);
                  }
                  mapValue = mapValue.join(' ');
                }
              }
              if (valid) {
                ctrl.toShow.push({
                  parent: mapParentValue,
                  value: map[j]
                });
              }
            }
          }
        }

        function findMapValue(filterValue) {
          return function (value) {
            return value.indexOf(filterValue) !== -1;
          };
        }

        function isFiltered(menu, parent) {
          if (!ctrl.filterActive) {
            return false;
          }
          var index = ctrl.toShow.findIndex(function (item) {
            var title = ctrl.normalize(menu.title);
            if (menu.suffix) {
              title += ctrl.normalize(menu.suffix);
            }

            if (!parent) {
              return item.value === title || item.parent === title;
            }
            else {
              return item.value === title && item.parent === ctrl.normalize(parent.title);
            }
          });

          if (index !== -1) {
            menu.isOpened = true;
          }

          return index === -1;
        }

        function clearFilter() {
          ctrl.filterValue = '';
          ctrl.filterActive = false;
          for (var i = 0; i < ctrl.menu.length; i++) {
            ctrl.menu[i].isOpened = ctrl.previouslyOpen.indexOf(ctrl.menu[i].title) !== -1;
          }
        }

        function filterKeyUp(event) {
          if (event.which === KEYCODE.ESC) {
            ctrl.clearFilter();
          }
        }
      }]
    });
})();

/**
 * Created by pedro on 18/10/16.
 */
(function () {
  'use strict';

  angular.module('pl.spinners', ['ngAnimate'])
    .directive('plSpinner', function () {
      return {
        restrict: 'E',
        transclude: true,
        controllerAs: 'vm',
        compile: function (element, attr) {
          if (attr.type === 'round') {
            element.append('<div class="pl-spinner-round"></div><div ng-transclude></div>');
          }
          else {
            element.append('<div class="pl-spinner-3dots">' +
              '<div class="pl-spinner-3dots-bounce1"></div>' +
              '<div class="pl-spinner-3dots-bounce2"></div>' +
              '<div class="pl-spinner-3dots-bounce3"></div>' +
              '</div>' +
              '<div ng-transclude></div>'
            );
          }
        }
      };
    });
})();

(function () {
  'use strict';

  var sPagina = 'pagina';
  var sOrdena = 'ordena';
  var sPesquisa = 'pesquisa';

  angular.module('pl.table')
    .component('headerActions', {
      require: {
        plTable: '^^plTable'
      },
      transclude: true,
      template: '<ng-transclude></ng-transclude>',
      controller: ['$attrs', function ($attrs) {
        var ctrl = this;

        ctrl.$onInit = init;

        function init() {
          ctrl.plTable.actionsAlign = $attrs.align || 'right';
        }
      }]
    })
    .component('itemActions', {
      require: {
        plTable: '^^plTable'
      },
      transclude: true,
      template: '<ng-transclude></ng-transclude>',
      controller: ['$attrs', function ($attrs) {
        var ctrl = this;

        ctrl.$onInit = init;

        function init() {
          ctrl.plTable.actionsAlign = $attrs.align || 'right';
        }
      }]
    })
    .component('plTable', {
      require: {
        plTable: '?^^plTable'
      },
      bindings: {
        instanceId: '@?',
        definition: '=',
        source: '=?',
        search: '=?',
        order: '=?',
        page: '=?',
        options: '=?',
        onSelect: '=?',
        onDetail: '=?',
        selected: '=?',
        callback: '=?',
        fields: '=?',
        tableClass: '@?',
        highlightFields: '@?',
        theme: '@?'
      },
      transclude: {
        headerActions: '?headerActions',
        itemDetail: '?itemDetail',
        itemActions: '?itemActions'
      },
      templateUrl: '../source/pl-table.html',
      controller: ['$rootScope', '$scope', '$element', '$q', '$filter', '$transclude', '$log', '$location', '$timeout', 'plCompsService', 'plLocale', 'plFormat', 'plTranslate', function ($rootScope, $scope, $element, $q, $filter, $transclude, $log, $location, $timeout, plCompsService, plLocale, plFormat, plTranslate) { // jshint ignore:line
        var ctrl = this;
        var defaultOptions = {
          perPage: 10,
          selectFirst: false,
          useUrl: true,
          actionCaption: '',
          border: false,
          tableClass: undefined,
          hasDetail: undefined,
          hasActions: undefined,
          hidePagination: false,
          suppressEmptyLines: false
        };

        ctrl.locales = plLocale.locales;
        ctrl.instanceId = '';
        ctrl.originalDefinition = {};
        ctrl.source = [];
        ctrl.search = '';
        ctrl.order = 'asc';
        ctrl.page = 1;
        ctrl.options = {};
        ctrl.selected = null;
        ctrl.callback = undefined;
        ctrl.lastSearch = null;
        ctrl.fields = '';
        ctrl.highlightFields = '';
        ctrl.format = {};
        ctrl.footerSource = [];
        ctrl.theme = '';

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.$onDestroy = onDestroy;
        ctrl.handleChanges = handleChanges;
        ctrl.setIsLoading = setIsLoading;
        ctrl.getField = getField;
        ctrl.initModelName = initModelName;
        ctrl.doSearch = doSearch;
        ctrl.loadPage = loadPage;
        ctrl.dataReceived = dataReceived;
        ctrl.validateDefinitions = validateDefinitions;
        ctrl.canSort = canSort;
        ctrl.sort = sort;
        ctrl.getCaption = getCaption;
        ctrl.isOrderAsc = isOrderAsc;
        ctrl.isOrderDesc = isOrderDesc;
        ctrl.fnOnDetail = fnOnDetail;
        ctrl.doSelected = doSelected;
        ctrl.getValue = getValue;
        ctrl.getRowClass = getRowClass;
        ctrl.getTdClass = getTdClass;
        ctrl.getActionCaption = getActionCaption;
        ctrl.getTdValSpanClass = getTdValSpanClass;

        /////////////

        function init() {
          ctrl.instanceId = ctrl.instanceId || '';
          ctrl.source = ctrl.source || [];
          ctrl.originalDefinition = angular.copy(ctrl.definition);
          ctrl.search = ctrl.search || '';
          ctrl.order = ctrl.order || 'asc';
          ctrl.page = ctrl.page || 1;
          ctrl.handleChanges();
          ctrl.onSelect = ctrl.onSelect || undefined;
          ctrl.selected = ctrl.selected || null;
          ctrl.callback = ctrl.callback || undefined;
          ctrl.fields = ctrl.fields || ctrl.definition.listFields || null;
          ctrl.highlightFields = ctrl.highlightFields ? ctrl.highlightFields.split(',') : null;
          ctrl.format = {
            date: plFormat.format.date,
            datetime: plFormat.format.datetime,
            time: plFormat.format.time
          };
          ctrl.footerSource = ctrl.footerSource || [];
          ctrl.theme = ctrl.theme || '';
          ctrl.setIsLoading(true);

          if (ctrl.fields && ctrl.definition) {
            var newFields = [];
            var fields = ctrl.fields.split(',');
            for (var i = 0; i < fields.length; i++) {
              var field = ctrl.getField(fields[i]);
              if (field) {
                newFields.push(field);
              }
            }
            ctrl.definition.fields = newFields;
          }

          ctrl.hasDetail = angular.isDefined(ctrl.options.hasDetail) ? ctrl.options.hasDetail && $transclude.isSlotFilled('itemDetail') : $transclude.isSlotFilled('itemDetail');
          ctrl.hasActions = angular.isDefined(ctrl.options.hasActions) ? ctrl.options.hasActions && $transclude.isSlotFilled('itemActions') : $transclude.isSlotFilled('itemActions');

          ctrl.data = {list: [], total: ctrl.options.perPage};
          if (!ctrl.options.suppressEmptyLines) {
            for (var j = 0; j < ctrl.options.perPage; j++) {
              ctrl.data.list.push({empty: true});
            }
          }

          $timeout(function () {
            if (ctrl.options.useUrl) {
              var s = $location.search();
              if ($rootScope.app && $rootScope.app.queryParams) {
                s = $rootScope.app.queryParams;
                if (!s.filter) {
                  $rootScope.app.queryParams = null;
                }
              }
              var page = s[ctrl.instanceId + sPagina];
              var order = s[ctrl.instanceId + sOrdena];
              var search = s[ctrl.instanceId + sPesquisa];

              if (angular.isDefined(page)) {
                ctrl.page = Number(page);
              }
              if (angular.isDefined(order)) {
                ctrl.order = order;
              }
              if (angular.isDefined(search)) {
                ctrl.search = search;
              }
            }
            if (angular.isUndefined(ctrl.page)) {
              ctrl.page = 1;
            }
            if (angular.isDefined(ctrl.definition)) {
              ctrl.order = ctrl.definition.order;
            }
          });

          if (angular.isObject(ctrl.callback)) {
            ctrl.callback.refresh = function () {
              return ctrl.doSearch(true);
            };
          }

          $scope.$watch(angular.bind(ctrl, function () {
            return ctrl.search;
          }), function () {
            ctrl.doSearch();
          });
          $scope.$on('$locationChanged', function (event, data) {
            var search = data.search;
            ctrl.page = search[ctrl.instanceId + sPagina] || ctrl.page;
            ctrl.order = search[ctrl.instanceId + sOrdena] || ctrl.order;
            ctrl.search = search[ctrl.instanceId + sPesquisa] || ctrl.search;
            ctrl.doSearch(true);
          });
        }

        function onChanges(plTable) {
          if (plTable) {
            ctrl.handleChanges();
          }
        }

        function onDestroy() {
          $timeout(function () {
            var queryParams = $location.search();
            if (queryParams && $rootScope.app && $rootScope.app.queryParams) {
              for (var param in queryParams) {
                if (queryParams.hasOwnProperty(param) && (param.indexOf('type') === -1 || queryParams[param].indexOf('detail') === -1)) {
                  $rootScope.app.queryParams = null;
                  return;
                }
              }
            }
          });
        }

        function handleChanges() {
          ctrl.options = _.merge({}, defaultOptions, ctrl.options);
          if (ctrl.tableClass) {
            if (angular.isString(ctrl.tableClass)) {
              ctrl.tableClass = ctrl.tableClass.split(' ');
            }
            if (!angular.isArray(ctrl.tableClass)) {
              if (ctrl.tableClass) {
                ctrl.tableClass = [ctrl.tableClass];
              }
              else {
                ctrl.tableClass = [];
              }
            }
          }
          else {
            ctrl.tableClass = [];
          }
          ctrl.tableClass = ctrl.tableClass.concat(['table', 'table-hover', 'table-condensed']).join(' ');
          ctrl.actionsAlign = ctrl.options.actionsAlign || 'right';
        }

        function setIsLoading(value) {
          ctrl.isLoading = value;
          if (value) {
            $element.addClass('loading');
          }
          else {
            $element.removeClass('loading');
          }
        }

        function getField(field) {
          field = field.trim().toUpperCase();
          for (var i = 0; i < ctrl.definition.fields.length; i++) {
            var definitionField = ctrl.definition.fields[i];
            if (field === definitionField.name.toUpperCase() && definitionField.visible !== false) {
              return ctrl.definition.fields[i];
            }
          }
          return null;
        }

        function initModelName(field) {
          var index = 0;
          if (!field.name || field.name.trim() === '') {
            throw new TypeError('Invalid field name');
          }
          if (field.name.indexOf('.') !== -1) {
            index = field.name.lastIndexOf('.') + 1;
          }
          field.modelName = field.name.substring(index, field.name.length);
          return field;
        }

        function doSearch(force) {
          return $timeout(function () {
            if (force || ctrl.lastSearch !== ctrl.search) {
              ctrl.lastSearch = ctrl.search && ctrl.search.trim() !== '' ? ctrl.search : null;
              if (ctrl.lastSearch !== null) {
                ctrl.page = 1;
              }
              return ctrl.loadPage(ctrl.page);
            }
          });
        }

        function loadPage(page, perPage) {
          if (angular.isUndefined(ctrl.source)) {
            $log.error('pl-table.source not defined!');
            ctrl.setIsLoading(false);
            return;
          }
          $timeout(function () {
            ctrl.page = page;
            ctrl.options.perPage = perPage || ctrl.options.perPage;
            ctrl.selected = null;
            ctrl.lastSearch = ctrl.search;
            ctrl.setIsLoading(true);

            if (ctrl.options.useUrl) {
              $location.search(ctrl.instanceId + sPagina, ctrl.page);
              $location.search(ctrl.instanceId + sOrdena, ctrl.order);
              $location.search(ctrl.instanceId + sPesquisa, ctrl.search);
            }

            if (angular.isObject(ctrl.source) && angular.isArray(ctrl.source.list)) {
              if (angular.isArray(ctrl.source.footer) && ctrl.source.footer.length) {
                ctrl.footerSource = ctrl.source.footer;
              }
              ctrl.source = ctrl.source.list;
            }
            if (angular.isArray(ctrl.source)) {
              ctrl.dataReceived(ctrl.source, page);
              return;
            }
            ctrl.doSelected(null);
            return $q.when(ctrl.source(ctrl.search, ctrl.order, ctrl.page, ctrl.options.perPage)).then(
              function (data) {
                ctrl.dataReceived(data, page);
              },
              function () {
                ctrl.setIsLoading(false);
              }
            );
          });
        }

        function dataReceived(data, page) {
          if (!data) {
            $log.warn('Cannot read property \'data\' of undefined');
            return;
          }
          ctrl.data = data;
          if (ctrl.data.data) {
            ctrl.data = data.data;
          }

          if (angular.isArray(ctrl.data)) {
            ctrl.validateDefinitions(ctrl.data);
            data = $filter('filter')(ctrl.data, ctrl.search);

            var reverse = false;
            var order = ctrl.order ? ctrl.order.split(' ') : null;
            if (order && order.length) {
              reverse = order.length > 1 ? order[1] === 'desc' : false;
              order = order[0];
              data = $filter('orderBy')(data, order, reverse);
            }

            ctrl.data = {
              total: data.length,
              list: data
            };

            var index = (page - 1) * ctrl.options.perPage;
            ctrl.data.list = ctrl.data.list.slice(index, index + ctrl.options.perPage);
          }
          else {
            if (angular.isArray(data.footer) && data.footer.length) {
              ctrl.footerSource = data.footer;
            }

            if (!ctrl.data.list) {
              $log.error('Source doesn\'t have list property');
              return;
            }
          }

          ctrl.validateDefinitions(ctrl.data.list);
          if (!ctrl.options.suppressEmptyLines) {
            for (var j = ctrl.data.list.length; j < ctrl.options.perPage; j++) {
              ctrl.data.list.push({empty: true});
            }
            if (ctrl.data.total < ctrl.options.perPage) {
              ctrl.data.total = ctrl.options.perPage;
            }
          }

          if (ctrl.options.selectFirst && ctrl.data.list.length > 0) {
            ctrl.doSelected(ctrl.data.list[0]);
          }
          if (angular.isObject(ctrl.callback) && angular.isFunction(ctrl.callback.dataReceived)) {
            $q.when(ctrl.callback.dataReceived(ctrl.data, page)).then()['finally'](function () {
              ctrl.setIsLoading(false);
            });
          }
          else {
            ctrl.setIsLoading(false);
          }
        }

        function validateDefinitions(data) {
          if (ctrl.definition && ctrl.definition.fields.length || !data || !data.length) {
            return;
          }
          ctrl.definition = {
            fields: []
          };

          data = data[0];
          for (var name in data) {
            if (data.hasOwnProperty(name) && name && !name.startsWith('$')) {
              ctrl.definition.fields.push({
                name: name
              });
            }
          }
        }

        function canSort(item) {
          return angular.isUndefined(item.canOrder) ? true : item.canOrder;
        }

        function sort(item) {
          $timeout(function () {
            if (ctrl.order === item.name) {
              ctrl.order += ' desc';
            }
            else {
              ctrl.order = item.name;
            }
            ctrl.loadPage(ctrl.page);
          });
        }

        function getCaption(item) {
          return item.caption || item.name;
        }

        function isOrderAsc(item) {
          return ctrl.order === item.name;
        }

        function isOrderDesc(item) {
          return ctrl.order === item.name + ' desc';
        }

        function fnOnDetail(item, prevent, event) {
          if (!ctrl.hasDetail || (item._hasDetail === false) || prevent) {
            return;
          }
          item._detailOpen = !item._detailOpen;
          if (angular.isFunction(ctrl.onDetail)) {
            ctrl.onDetail(item, event);
          }
        }

        function doSelected(item, td, prevent, event) {
          if (prevent) {
            return;
          }
          ctrl.selected = item;
          if (angular.isDefined(ctrl.onSelect) && item && !item.empty) {
            ctrl.onSelect(item, td, event);
          }
        }

        function getValue(item, field) {
          if (angular.isFunction(ctrl.definition.onGetFieldValue)) {
            var r1 = ctrl.definition.onGetFieldValue(field, item);
            if (angular.isDefined(r1)) {
              return r1;
            }
          }
          if (!angular.isObject(item)) {
            return '';
          }

          if (!field.modelName) {
            field = ctrl.initModelName(field);
          }
          var value = plCompsService.getPathValue(item, field.name)[field.modelName];
          if (angular.isUndefined(value) || value === null) {
            value = '';
          }

          if (field.select) {
            var key = field.select.valueProp || 'value';
            var label = field.select.labelProp || 'name';
            for (var i = 0; i < field.select.list.length; i++) {
              if (field.select.list[i][key] === value) {
                value = field.select.list[i][label];
                break;
              }
            }
          }

          // Should highlight field
          if (ctrl.highlightFields && ctrl.highlightFields.indexOf(field.name) === -1) {
            field.hightlight = false;
          }

          if (value === 0 && field.emptyIfZero) {
            value = null;
          }

          return plTranslate.translate(value);
        }

        function getRowClass(item, index) {
          if (item.rowClass) {
            if (angular.isFunction(item.rowClass)) {
              return item.rowClass(item, index);
            }
            else {
              return item.rowClass;
            }
          }
          else if (ctrl.definition.rowsClass) {
            return plCompsService.parseExpressionToString(ctrl.definition.rowsClass, [item, index]);
          }
        }

        function getTdClass(item, field, index) {
          var myClass = [];
          if (item && item.tdClass) {
            myClass = plCompsService.parseExpressionToString(item.tdClass);
          }
          else if (ctrl.definition.tdsClass) {
            if (angular.isFunction(ctrl.definition.tdsClass)) {
              myClass = ctrl.definition.tdsClass(item, index);
            }
            else {
              myClass = ctrl.definition.tdsClass;
            }
          }
          else if (field && field.tdClass) {
            myClass = field.tdClass;
          }

          if (angular.isString(myClass)) {
            myClass = myClass.split(' ');
          }
          if (ctrl.definition.fields.length && (field.align === 'right' || field.type === 'currency' || field.type === 'tax')) {
            myClass.push('text-right');
          }
          return myClass.join(' ');
        }

        function getTdValSpanClass(item, field) {

          if (angular.isUndefined(field.valSpanClass)) {
            return '';
          }

          if (angular.isFunction(field.valSpanClass)) {
            return field.valSpanClass(item, field);
          }

          return field.valSpanClass;
        }

        function getActionCaption() {

        }
      }]
    });
})();

/**
 * Created by pedro on 27/04/16.
 */
(function () {
  'use strict';

  angular.module('pl.comps')
    .directive('plTableNavigation', ['$timeout', '$q', 'plCompsService', 'KEYCODE', function ($timeout, $q, plCompsService, KEYCODE) {
      return {
        restrict: 'A',
        priority: 2,
        scope: {
          onLastCell: '&?',
          onCheckLine: '&?',
          onRemoveLine: '&?',
          stepOver: '<?'
        },
        bindToController: true,
        controllerAs: '$ctrl',
        controller: /*@ngInject*/ ['$element', function ($element) {
          var ctrl = this;

          ctrl.elementsToSkip = [];

          ctrl.$onInit = init;
          ctrl.$onChanges = onChanges;
          ctrl.$onDestroy = onDestroy;
          ctrl.eventKeydown = eventKeydown;
          ctrl.shouldStepOver = shouldStepOver;
          ctrl.checkLine = checkLine;
          ctrl.checkAddNew = checkAddNew;
          ctrl.isLineDisabled = isLineDisabled;

          /////////////

          function init() {
            if (ctrl.stepOver) {
              ctrl.elementsToSkip = plCompsService.parseExpressionToString(ctrl.stepOver).split(',');
            }
            $element.on('keydown', ctrl.eventKeydown);
          }

          function onChanges(plTableNavigation) {
            if (plTableNavigation && plTableNavigation.stepOver && !plTableNavigation.stepOver.isFirstChange()) {
              ctrl.elementsToSkip = plCompsService.parseExpressionToString(ctrl.stepOver).split(',');
            }
          }

          function onDestroy() {
            $element.off('keydown', ctrl.eventKeydown);
          }

          function eventKeydown(event) {
            var $table = $element;
            var $active = angular.element('input:focus,select:focus,textarea:focus', $table);
            var $next = null;
            var focusableQuery = 'input,select,textarea,input:disabled,select:disabled,textarea:disabled';
            var position = parseInt($active.closest('td').index()) + 1;

            switch (event.which) {
              case KEYCODE.ESC:
              case KEYCODE.LEFT:
                $next = findHorizontal($active, focusableQuery, 'prev');
                break;
              case KEYCODE.UP:
                $next = findVertical($active, focusableQuery, position, 'prev');
                break;
              case KEYCODE.RIGHT:
                $next = findHorizontal($active, focusableQuery, 'next');
                break;
              case KEYCODE.DOWN:
                $next = findVertical($active, focusableQuery, position, 'next');
                break;
              case KEYCODE.ENTER:
                $next = findHorizontal($active, focusableQuery, 'next', true);
                break;
            }

            if ($next && $next.length) {
              event.preventDefault();
              event.stopPropagation();
            }

            ctrl.checkLine($table, $active, $next, event).then(function (wasLineFoccused) {
              if ($next && $next.length && !wasLineFoccused) {
                $next.focus();
                $next.select();
              }
            });
          }

          function shouldStepOver(element) {
            if (ctrl.elementsToSkip.indexOf(element.attr('name')) !== -1) {
              for (var i = 0; i < ctrl.elementsToSkip.length; i++) {
                var $input = element.closest('tr').find('input[name="' + ctrl.elementsToSkip[i] + '"]');
                if (!$input.length) {
                  throw new Error('Found an invalid element to skip with the name: ' + ctrl.elementsToSkip[i]);
                }
                if ($input.val().toString().trim() !== '') {
                  return true;
                }
              }
            }
            return false;
          }

          function findHorizontal($active, focusableQuery, type, doSkip) {
            if (type !== 'prev' && type !== 'next') {
              return;
            }
            var element = $active.closest('td')[type]().find(focusableQuery);
            while (element.is(':disabled') || !element.is(':visible') || doSkip && ctrl.shouldStepOver(element)) {
              element = element.closest('td')[type]().find(focusableQuery);
              if ((element.is(':enabled') && element.is(':visible') || !element.length) && (!doSkip || !ctrl.shouldStepOver(element))) {
                break;
              }
            }
            return element;
          }

          function findVertical($active, focusableQuery, position, type, doSkip) {
            if (type !== 'prev' && type !== 'next') {
              return;
            }
            var element = $active.closest('tr')[type]().find('td:nth-child(' + position + ')').find(focusableQuery);
            while (element.is(':disabled') || !element.is(':visible') || doSkip && ctrl.shouldStepOver(element)) {
              element = element.closest('tr')[type]().find('td:nth-child(' + position + ')').find(focusableQuery);
              if ((element.is(':enabled') && element.is(':visible') || !element.length) && (!doSkip || !ctrl.shouldStepOver(element))) {
                break;
              }
            }
            return element;
          }

          function findNotSkipped($parent, query) {
            var $element = angular.element(query, $parent);
            var name = $element.attr('name');
            while (ctrl.elementsToSkip.indexOf(name) !== -1 || $element.is(':disabled')) {
              $element = $element.closest('td').prev('td').find('input');
              name = $element.attr('name');
              if (!$element.length) {
                break;
              }
            }
            return $element;
          }

          /**
           * @return {object} Promise This method and the ``onCheckLine()`` method should return
           *    a promise with a boolean value regarding whether a ``angular.element().focus()``
           *    method was called. This is to ensure the called focus isn't going to be overuled
           *    by the end of execution of ``eventKeydown()`` method.
           */
          function checkLine($table, $active, $next, event) {
            var deferred = $q.defer();
            if (angular.isFunction(ctrl.onCheckLine)) {
              event.stopPropagation();
              $q.when(ctrl.onCheckLine({event: event, next: plCompsService.getNodePath($next)})).then(function (checkLineValue) {
                ctrl.checkAddNew(checkLineValue, $table, $active, $next, event).then(function (checkAddNewValue) {
                  deferred.resolve(checkAddNewValue || checkLineValue);
                });
              });
            }
            else {
              ctrl.checkAddNew(false, $table, $active, $next, event).then(function (value) {
                deferred.resolve(value);
              });
            }
            return deferred.promise;
          }

          function checkAddNew(checkLineValue, $table, $active, $next, event) {
            var deferred = $q.defer();
            var valid = false;

            // On key down or enter
            if (event.which === KEYCODE.DOWN || event.which === KEYCODE.ENTER) {
              var $lastRow = $table.find('tr:last');

              // If last line is disabled we must go back until an enabled one is found
              if (ctrl.isLineDisabled($lastRow)) {
                while (true) {
                  $lastRow = $lastRow.prev('tr');
                  if (!ctrl.isLineDisabled($lastRow) || !$lastRow.length) {
                    break;
                  }
                }
              }

              // Find last input not disabled or skipped
              var $lastElement = $lastRow.find('input:last');
              var $lastNotSkippedElement = findNotSkipped($lastRow, 'input:last');

              /* Call onLastCell in case one of the two following scenarios are true:
               *   - ENTER key was pressed and the currently active input is the last horizontal one;
               *   - DOWN key was pressed and the currently active input is part of the last enabled row.
               * NOTE: ``event.stopPropagation()`` must be called in order to disable plFormNavigate behavior
               */
              if (event.which === KEYCODE.ENTER && ($lastElement.is($active) || $lastNotSkippedElement.is($active)) ||
                event.which === KEYCODE.DOWN && $lastRow.is($active.closest('tr'))) {
                event.stopPropagation();

                // Execute add new line
                if (angular.isFunction(ctrl.onLastCell)) {
                  valid = true;
                  $q.when(ctrl.onLastCell({event: event, next: plCompsService.getNodePath($next)})).then(function (value) {
                    if (!value) {
                      event.preventDefault();
                      event.stopPropagation();
                      deferred.resolve(true);
                      // To focus newly created element, use plAutofocus directive
                    }
                    else {
                      deferred.resolve(value || checkLineValue);
                    }
                  });
                }
              }
              else if (event.which === KEYCODE.ENTER && !$next.length) {
                var $row = $active.closest('tr');
                while (true) {
                  $row = $row.next('tr');
                  if (!ctrl.isLineDisabled($row) || !$row.length) {
                    break;
                  }
                }
                if ($row.length) {
                  $row.find('td').first().find('input').focus();
                  valid = true;
                  deferred.resolve(checkLineValue || true);
                }
              }
            }
            // On key up calls onRemoveLine
            else if (event.which === KEYCODE.UP) {
              if (angular.isFunction(ctrl.onRemoveLine)) {
                $q.when(ctrl.onRemoveLine({event: event, next: plCompsService.getNodePath($next)})).then()['finally'](function () {
                  deferred.resolve(false);
                });
              }
            }
            if (!valid) {
              deferred.resolve(checkLineValue || false);
            }

            return deferred.promise;
          }

          function isLineDisabled($row) {
            var inputs = $row.find('input');
            return inputs.length === $row.find('input:disabled').length;
          }
        }]
      };
    }]);
})();

(function () {
  // Based on http://codepen.io/m-e-conroy/pen/bcEsA
  'use strict';

  angular.module('pl.edit')
    .component('plTabs', {
      bindings: {
        name: '@?',
        justified: '<?',
        stacked: '<?',
        pills: '<?',
        onSelect: '&?',
        lazyLoad: '<?',
        theme: '@?',
        callback: '<?'
      },
      transclude: true,
      templateUrl: '../source/pl-tabs.html',
      controller: ['$sce', '$location', '$scope', 'plTranslate', 'plCompsService', function ($sce, $location, $scope, plTranslate, plCompsService) {
        var ctrl = this;

        ctrl.id = 0;
        ctrl.tabs = [];
        ctrl.activeTab = null;
        ctrl.theme = '';

        ctrl.$onInit = init;
        ctrl.query = query;
        ctrl.getCaption = getCaption;
        ctrl.selectTab = selectTab;
        ctrl.addTab = addTab;
        ctrl.removeTab = removeTab;
        ctrl.locationChanged = locationChanged;
        ctrl.isMobile = isMobile;
        ctrl.getTabsClass = getTabsClass;

        /////////////

        function init() {
          ctrl.lazyLoad = !!ctrl.lazyLoad;
          if (ctrl.name) {
            ctrl.activeTab = ctrl.query();
            ctrl.selectTab(ctrl.activeTab);
          }
          if (angular.isObject(ctrl.callback)) {
            ctrl.callback.selectTab = ctrl.selectTab;
          }
          $scope.$on('$locationChanged', ctrl.locationChanged);
        }

        function query() {
          var param = $location.search()[ctrl.name];
          return angular.isDefined(param) && param ? param : null;
        }

        function getCaption(caption) {
          return plTranslate.translate($sce.getTrustedHtml(caption));
        }

        function selectTab(id) {
          angular.forEach(ctrl.tabs, function (tab) {
            tab.selected = tab.id === id;
            if (tab.selected) {
              ctrl.activeTab = tab;

              if (ctrl.name) {
                $location.search(ctrl.name, tab.id);
              }
              if (angular.isFunction(ctrl.onSelect)) {
                ctrl.onSelect({id: tab.id, tab: tab});
              }
            }
          });
        }

        function addTab(tab) {
          tab.id = tab.name || 'plTabs' + ctrl.tabs.length;
          ctrl.tabs.push(tab);
          if (ctrl.tabs.length > 0 && !ctrl.activeTab) {
            ctrl.selectTab(ctrl.tabs[0].id);
          }
          else if (ctrl.activeTab) {
            if (tab.id === ctrl.activeTab.id) {
              ctrl.selectTab(ctrl.activeTab.id);
            }
          }
        }

        function removeTab(tab) {
          if (!angular.isObject(tab)) {
            tab = {id: tab};
          }
          var tabIndex = ctrl.tabs.findIndex(function (myTab) {
            return myTab.id === tab.id;
          });
          if (tabIndex !== -1) {
            if (tab === ctrl.activeTab && ctrl.tabs.length > 1) {
              ctrl.selectTab(ctrl.tabs[0].id);
            }
            ctrl.tabs.splice(tabIndex, 1);
            return true;
          }
          return false;
        }

        function locationChanged(event, data) {
          var tab = data.search[ctrl.name];
          if (!tab) {
            return;
          }
          ctrl.selectTab(tab);
        }

        function isMobile() {
          return plCompsService.isMobile();
        }

        function getTabsClass() {
          return ctrl.pills === true ? 'nav-pills' : 'nav-tabs';
        }
      }]
    })
    .component('plTab', {
      require: {
        plTabs: '^plTabs'
      },
      bindings: {
        caption: '@',
        name: '@?',
        selected: '<?',
        lazyLoad: '<?'
      },
      transclude: true,
      templateUrl: '../source/pl-tab.html',
      controller: function () {
        var ctrl = this;

        ctrl.$onInit = init;
        ctrl.$onDestroy = onDestroy;

        /////////////

        function init() {
          ctrl.lazyLoad = !!ctrl.lazyLoad || ctrl.plTabs.lazyLoad || false;
          if (ctrl.selected) {
            ctrl.plTabs.activeTab = ctrl;
          }
          ctrl.plTabs.addTab(ctrl);
        }

        function onDestroy() {
          if (ctrl.plTabs) {
            ctrl.plTabs.removeTab(ctrl);
          }
        }
      }
    });
})();

/**
 * Created by pedro on 18/11/16.
 */

(function () {
  'use strict';

  // baseado em:
  // http://alistapart.com/article/expanding-text-areas-made-elegant
  // and
  // https://docs.angularjs.org/api/ng/type/ngModel.NgModelController
  angular.module('pl.textarea', [])
    .directive('plTextArea', ['$timeout', function ($timeout) {
      return {
        restrict: 'E',
        require: '?ngModel',
        scope: {
          ngFocusOn: '='
        },
        template: '<div class="pl-textarea active"><pre ng-class="class"><span></span><br></pre><textarea ng-class="class"></textarea></div>',
        link: function (scope, element, attrs, ngModel) {
          var area = element.find('textarea')[0];
          var span = element.find('span')[0];
          scope.class = attrs.class;
          element.removeClass(scope.class);

          // Specify how UI should be updated
          ngModel.$render = function () {
            area.value = (ngModel.$viewValue || '');
            span.textContent = area.value;
          };


          function read() {
            span.textContent = area.value;
            ngModel.$setViewValue(area.value);
          }


          if (area.addEventListener) {
            area.addEventListener('input', function () {
              span.textContent = area.value;
              scope.$evalAsync(read);
            }, false);

          } else if (area.attachEvent) {
            // IE8 compatibility
            area.attachEvent('onpropertychange', function () {
              span.innerText = area.value;
              scope.$evalAsync(read);
            });
          }

          scope.$watch('ngFocusOn', function (newVal) {
            if (newVal && newVal === true) {
              $timeout(function () {
                element.find('textarea').focus();
              });
            }
          });

          read(); // initialize
        }
      };
    }]);
})();

/**
 /**
 * Created by pedro on 02/05/16.
 */
(function () {
  'use strict';

  angular.module('pl.timepicker', ['pl.edit'])
    .component('plTimepicker', {
      require: {
        ngModel: 'ngModel',
        plForm: '?^plForm',
        plGroup: '?^plGroup',
        plEdit: '?^plEdit'
      },
      bindings: {
        name: '@?',
        format: '@?',
        viewFormat: '@?',
        properties: '<?'
      },
      templateUrl: '../source/pl-timepicker.html',
      controller: /*@ngInject*/ ['$scope', '$element', '$timeout', '$document', 'plFormat', 'plCompsService', 'plLocale', 'KEYCODE', function ($scope, $element, $timeout, $document, plFormat, plCompsService, plLocale, KEYCODE) {
        var ctrl = this;
        var defaultOptions = {
          readonly: false,
          disabled: false,
          disallowInput: false,
          validate: true,
          validators: {
            required: {value: false}
          },
          events: {
            blur: undefined,
            focus: undefined,
            change: undefined,
            keydown: undefined,
            keypress: undefined,
            keyup: undefined,
            mousedown: undefined,
            mouseenter: undefined,
            mouseleave: undefined,
            mousemove: undefined,
            mouseover: undefined,
            mouseup: undefined
          }
        };

        ctrl.locales = plLocale.locales;
        ctrl.format = plFormat.format;
        ctrl.timerOpened = false;
        ctrl.viewValue = null;
        ctrl.timeValue = null;
        ctrl.timeInputs = angular.element();

        ctrl.$onInit = init;
        ctrl.$onDestroy = onDestroy;
        ctrl.updateComponent = updateComponent;
        ctrl.render = render;
        ctrl.showTimer = showTimer;
        ctrl.closeTimer = closeTimer;
        ctrl.toggleTimer = toggleTimer;
        ctrl.viewChange = viewChange;
        ctrl.valueChange = valueChange;
        ctrl.onMouseEnter = onMouseEnter;
        ctrl.onMouseLeave = onMouseLeave;
        ctrl.onBlur = onBlur;
        ctrl.clearClick = clearClick;
        ctrl.nowClick = nowClick;
        ctrl.fnClickDocument = fnClickDocument;
        ctrl.fnClickElement = fnClickElement;
        ctrl.handleEvents = handleEvents;
        ctrl.clearEvents = clearEvents;
        ctrl.keyup = keyup;
        ctrl.setViewValue = setViewValue;

        /////////////

        function init() {
          ctrl.viewFormat = ctrl.viewFormat || plFormat.format.time;
          ctrl.placeholder = ctrl.placeholder || ctrl.viewFormat;

          if (ctrl.plEdit) {
            ctrl.plEdit.addComponent(ctrl);
            if (ctrl.plEdit.options) {
              _.merge(defaultOptions, ctrl.plEdit.options);
            }
          }
          ctrl.options = _.merge({}, defaultOptions, ctrl.properties);
          ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
          _.merge(ctrl, ctrl.options);
          _.merge(ctrl.component, ctrl.options);

          ctrl.ngModel.$render = function () {
            var newValue = ctrl.ngModel.$viewValue;
            if (newValue) {
              var momentObj = plCompsService.normalizeDate(newValue);
              momentObj.milliseconds(0);
              var date = momentObj.toDate();
              ctrl.setViewValue(date);
              ctrl.timeValue = date;
            }
          };

          $timeout(function () {
            ctrl.timeInputs = $element.find('.pl-timepicker .uib-timepicker input');
            ctrl.timeInputs.on('keyup', ctrl.keyup);
          });

          ctrl.handleEvents();
        }

        function onDestroy() {
          if (ctrl.plEdit) {
            ctrl.plEdit.removeComponent(ctrl.name);
          }

          // Removes binds
          ctrl.clearEvents();
          ctrl.timeInputs.off('keyup', ctrl.keyup);
        }

        function updateComponent(properties) {
          if (properties && properties !== ctrl.options) {
            ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties, properties);
            ctrl.options.validate = ctrl.options.readonly === false && ctrl.options.disabled === false;
          }
        }

        function render(value) {
          var momentObj = plCompsService.normalizeDate(value);
          if (momentObj.isValid()) {
            momentObj.milliseconds(0);
            ctrl.ngModel.$setViewValue(momentObj.toISOString());
          }
        }

        function showTimer() {
          if (ctrl.timerOpened || ctrl.options.disabled || ctrl.options.readonly) {
            return;
          }
          ctrl.timerOpened = true;
          ctrl.handleEvents();
        }

        function closeTimer() {
          if (!ctrl.timerOpened) {
            return;
          }
          ctrl.timerOpened = false;
          ctrl.clearEvents();
        }

        function toggleTimer() {
          if (ctrl.options.disabled || ctrl.options.readonly) {
            return;
          }
          ctrl.timerOpened = !ctrl.timerOpened;
          if (ctrl.timerOpened) {
            ctrl.handleEvents();
          }
          else {
            ctrl.clearEvents();
          }
        }

        function viewChange(value) {
          var momentObj = moment.utc(value, [
            ctrl.format.time,
            'HH:mm:ss',
            'HH:mm',
            'HH',
            'HHmmss',
            'HHmm',
            'HH'
          ]);
          if (momentObj.isValid()) {
            momentObj = plCompsService.normalizeDate(momentObj);
            ctrl.timeValue = momentObj.toDate();
            ctrl.render(momentObj);
          }
        }

        function valueChange() {
          var momentObj = plCompsService.normalizeDate(ctrl.timeValue);
          if (momentObj.isValid()) {
            momentObj.millisecond(0);
            ctrl.setViewValue(momentObj);
            ctrl.render(ctrl.timeValue);
          }
          if (ctrl.plEdit) {
            ctrl.plEdit.valueChanged(ctrl);
          }
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.change)) {
            ctrl.options.events.change(momentObj.toISOString(), ctrl, ctrl.plForm);
          }
        }

        function onMouseEnter() {
          ctrl.isMouseIn = true;
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.mouseenter)) {
            ctrl.options.events.mouseenter(ctrl.viewValue, event);
          }
        }

        function onMouseLeave() {
          ctrl.isMouseIn = false;
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.mouseleave)) {
            ctrl.options.events.mouseleave(ctrl.viewValue, event);
          }
        }

        function onBlur(event) {
          if (!ctrl.isMouseIn) {
            ctrl.valueChange();
            ctrl.closeTimer();
          }
          if (ctrl.options.events && angular.isFunction(ctrl.options.events.blur)) {
            ctrl.options.events.blur(ctrl.viewValue, event);
          }
        }

        function clearClick() {
          ctrl.setViewValue('');
          ctrl.timeValue = '';
          ctrl.ngModel.$setViewValue('');
        }

        function nowClick() {
          var momentObj = plCompsService.normalizeDate();
          if (momentObj.isValid()) {
            momentObj.millisecond(0);
            ctrl.setViewValue(momentObj);
            ctrl.timeValue = momentObj.toDate();
            ctrl.valueChange();
          }
        }

        function fnClickDocument() {
          $scope.$apply(ctrl.closeTimer);
        }

        function fnClickElement(event) {
          event.stopPropagation();
        }

        function handleEvents() {
          $timeout(function () {
            // Click anywhere but the element: closes timer
            angular.element($document).on('click', ctrl.fnClickDocument);

            // Click these elements: timer stays open
            $element.find('div.pl-timepicker, a.btnShowTimer').on('click', ctrl.fnClickElement);
          });
        }

        function clearEvents() {
          angular.element($document).off('click', ctrl.fnClickDocument);
          $element.find('div.pl-timepicker, a.btnShowTimer').off('click', ctrl.fnClickElement);
        }

        function keyup(event) {
          var rawElement = event.target;
          var element = angular.element(rawElement);
          var next = null;

          if (event.which === KEYCODE.ENTER) {
            next = element.closest('td').next('td').next('td').find('input');
            if (next.length) {
              next.focus();
            }
            else {
              $element.find('.pl-timepicker-close').focus();
            }
          }
          else {
            var input;
            if (event.which === KEYCODE.LEFT && rawElement.selectionStart === 0) {
              input = element.closest('td').prev('td').prev('td').find('input');
            }
            if (event.which === KEYCODE.RIGHT && rawElement.selectionStart === element.val().length) {
              input = element.closest('td').next('td').next('td').find('input');
            }
            if (input && input.length) {
              input.focus();
              input[0].selectionStart = input.val().length;
            }
          }
        }

        function setViewValue(date) {
          if (date) {
            date = plCompsService.normalizeDate(date);
            ctrl.viewValue = date.format(ctrl.format.time);
          }
          else {
            ctrl.viewValue = '';
          }
        }
      }]
    });
})();

(function () {
  // Based on http://codepen.io/m-e-conroy/pen/bcEsA
  'use strict';

  angular.module('pl.toolbar', ['ngSanitize', 'ui.bootstrap', 'pl.translate'])
    .component('plToolbar', {
      bindings: {
        config: '=?',
        instanceId: '@?',
        collapseOnMobile: '<?',
        popupOrientation: '@?'
      },
      transclude: true,
      templateUrl: '../source/pl-toolbar.html',
      controller: /*@ngInject*/ ['plToolbarService', 'plCompsService', function (plToolbarService, plCompsService) {
        var ctrl = this;

        ctrl.id = '';
        ctrl.config = {};
        ctrl.isCollapsed = false;
        ctrl.lastSize = -1;
        ctrl.cachedTitleItem = null;

        ctrl.$onInit = init;
        ctrl.isVisible = isVisible;
        ctrl.isCollapseVisible = isCollapseVisible;
        ctrl.getTabIndex = getTabIndex;
        ctrl.doClick = doClick;
        ctrl.isTypeExcluded = isTypeExcluded;
        ctrl.getPopupOrientationClass = getPopupOrientationClass;
        ctrl.isMobile = plCompsService.isMobile;

        /////////////

        function init() {
          ctrl.id = ctrl.instanceId || '__default';
          ctrl.popupOrientation = ctrl.popupOrientation || 'down';
          ctrl.config = plToolbarService.registerInstance(ctrl, ctrl.config).config;
          ctrl.translate = ctrl.config.translate;
        }

        function isVisible(item) {
          if (!item.hasOwnProperty('visible') || item.visible) {
            if (angular.isFunction(item.visible)) {
              return item.visible();
            }
            else {
              return true;
            }
          }
        }

        function isCollapseVisible() {
          var visible = false;
          var itemTitle = ctrl.config.items.find(function (item) {
            return item.type === 'title';
          });
          var itemSearch = ctrl.config.items.find(function (item) {
            return item.type === 'search' && ctrl.config.search.active;
          });
          var length = ctrl.config.items.filter(function (item) {
            if (item.type === 'search') {
              return item.visible !== false && ctrl.config.search.active;
            }
            return item.visible !== false;
          }).length;
          if (itemTitle && itemSearch) {
            visible = length > 2;
          }
          else if (itemTitle || itemSearch) {
            visible = length > 1;
          }
          return ctrl.collapseOnMobile === true && ctrl.isMobile() && visible;
        }

        function getTabIndex(item) {
          var itemClass = item.class || '';
          return itemClass.toString().toLowerCase().indexOf('divider') !== -1 || item.type === 'divider' || item.role === 'separator' ? -1 : 0;
        }

        function doClick(item, event) {
          if (angular.isFunction(item.click)) {
            return item.click(item, event);
          }
        }

        function isTypeExcluded(type) {
          return type === 'title' || type === 'html' || type === 'search';
        }

        function getPopupOrientationClass(){
          return ctrl.popupOrientation === 'up' ? 'dropup' : '';
        }

      }]
    });
})();

(function () {
  // Based on http://codepen.io/m-e-conroy/pen/bcEsA
  'use strict';

  angular.module('pl.toolbar')
    .service('plToolbarService', ['plCompsService', function (plCompsService) {
      var defaultConfig = {
        search: {
          active: true,
          placeholder: '',
          button: true
        },
        items: []
      };
      var instances = [];
      var service = {
        getInstance: getInstance,
        isRegistered: isRegistered,
        registerInstance: registerInstance
      };
      return service;

      /////////////

      function getInstance(instanceId, config) {
        if (!service.isRegistered(instanceId)) {
          config = _.merge({}, defaultConfig, config);
          var instance = {config: config};

          instance.config.find = function (id) {
            var index = instance.config.findIndex(id);
            if (index > -1) {
              return instance.config.items[index];
            }
            return null;
          };

          instance.config.findIndex = function (id) {
            for (var i = 0; i < config.items.length; i++) {
              if (id === config.items[i].id || id === config.items[i]) {
                return i;
              }
            }
            return -1;
          };

          instance.config.removeButton = function (id) {
            var idx = instance.config.findIndex(id);
            if (idx > -1) {
              instance.config.items.splice(idx, 1);
            }
          };

          instance.config.removeGroupId = function (id) {
            for (var i = 0; i < config.items.length; i++) {
              if (id === config.items[i].groupId) {
                config.items.splice(i, 1);
                i--;
              }
            }
          };

          instance.config.translate = function (value) {
            return value;
          };

          instance.config.addButton = function (btn) {
            if (btn.id) {
              for (var i = 0; i < instance.config.items.length; i++) {
                if (instance.config.items[i].id === btn.id) {
                  instance.config.items[i] = btn;
                  return;
                }
              }
            }
            else {
              btn.id = plCompsService.generateName(btn.id, 'plToolbarItem');
            }
            instance.config.items.push(btn);
          };

          instances[instanceId] = instance;
        }

        return instances[instanceId];
      }

      function isRegistered(instanceId) {
        return angular.isDefined(instances[instanceId]);
      }

      function registerInstance(instance, config) {
        return service.getInstance(instance.id, config);
      }
    }]);
})();

(function () {
  'use strict';

  var needsWrapping = ['button'];

  angular.module('pl.comps')
    .directive('plTooltip', ['$compile', '$parse', function ($compile, $parse) {
      return {
        restrict: 'A',
        terminal: true,
        priority: 1202,
        compile: function (tElement, tAttrs) {
          var attributes = tAttrs.plTooltip;
          if (!attributes) {
            return;
          }
          tElement.removeAttr('pl-tooltip');
          tElement.removeAttr('data-pl-tooltip');

          for (var i = 0; i < needsWrapping.length; i++) {
            var type = needsWrapping[i];
            if (tElement.is(type)) {
              tElement.wrap('<div class="pl-tooltip"></div>').parent().append('<div class="tooltip-delegator"></div>');
              tElement = tElement.parent();
              break;
            }
          }

          return function postLink($scope, $element, $attrs, ctrl, transclude) {
            var tooltipTypes = [
              {uibtooltip: 'uib-tooltip', property: 'text', evaluated: true},
              {uibtooltip: 'uib-tooltip-html', property: 'html'},
              {uibtooltip: 'uib-tooltip-template', property: 'template'}
            ];

            var tooltipProperties = [
              {uibtooltip: 'tooltip-animation', property: 'animation', default: true},
              {uibtooltip: 'tooltip-append-to-body', property: 'appendToBody', default: false},
              {uibtooltip: 'tooltip-class', property: 'class'},
              {uibtooltip: 'tooltip-enable', property: 'enable', default: true},
              {uibtooltip: 'tooltip-is-open', property: 'isOpen', default: false},
              {uibtooltip: 'tooltip-placement', property: 'placement', evaluated: true},
              {uibtooltip: 'tooltip-popup-close-delay', property: 'popupCloseDelay'},
              {uibtooltip: 'tooltip-popup-delay', property: 'popupDelay'},
              {uibtooltip: 'tooltip-trigger', property: 'trigger', default: 'mouseenter'}
            ];

            var model = $parse(attributes)($scope);
            if (model) {
              // Tooltip can only have one of these
              for (var i = 0; i < tooltipTypes.length; i++) {
                var type = tooltipTypes[i];
                if (model[type.property]) {
                  var attr = attributes + '.' + type.property;
                  if (type.evaluated) {
                    attr = '{{' + attr + '}}';
                  }
                  $element.attr(type.uibtooltip, attr);
                  break;
                }
              }

              angular.forEach(tooltipProperties, function (attribute) {
                var value = model[attribute.property];
                var attr = attributes + '.' + attribute.property;

                if (angular.isUndefined(value) || value === null) {
                  model[attribute.property] = attribute.default;
                }
                if (attribute.evaluated) {
                  attr = '{{' + attr + '}}';
                }
                $element.attr(attribute.uibtooltip, attr);
              });
            }

            $compile($element, transclude)($scope);
          };
        }
      };
    }]);
})();

/**
 * Created by pedro on 16/09/16.
 */

(function () {
  'use strict';
  angular.module('pl.transclude', [])

    .config(['$provide', function ($provide) {
      $provide.decorator('ngTranscludeDirective', ['$delegate', function ($delegate) {
        // Remove the original directive
        $delegate.shift();
        return $delegate;
      }]);
    }])

    .directive('ngTransclude', ['$compile', function ($compile) {
      return {
        restrict: 'EAC',
        compile: function (tElement) {
          return function postLink($scope, $element, $attrs, controller, $transclude) {
            if (!$transclude) {
              throw angular.$$minErr('ngTransclude')('orphan',
                'Illegal use of ngTransclude directive in the template! ' +
                'No parent directive that requires a transclusion found. ' +
                'Element: {0}', $element[0]);
            }

            var iScopeType = $attrs.ngTranscludeType || 'sibling';
            var slotName = $attrs.ngTransclude;

            switch (iScopeType) {
              case 'sibling':
                $transclude(function (clone) {
                  if (clone.length) {
                    $element.empty();
                    $element.append(clone);
                  }
                }, null, slotName);
                break;
              case 'parent':
                $transclude($scope, function (clone) {
                  if (clone.length) {
                    $element.empty();
                    $element.append(clone);
                  }
                }, null, slotName);
                break;
              case 'child':
                var iChildScope = $scope.$new();
                iChildScope.main = $scope.$new(false, $scope);
                $transclude(iChildScope, function (clone) {
                  if (clone.length) {
                    $element.empty();
                    $element.append(clone);
                    $element.on('$destroy', function () {
                      iChildScope.$destroy();
                    });
                  }
                }, null, slotName);
                break;
            }
          };
        }
      };
    }]);

})();

/**
 * Created by pedro on 18/10/16.
 */
(function () {
  'use strict';

  angular.module('pl.translate', [])
    .provider('plTranslate', function () {
      var translateFn;

      function setTranslateFn(fn) {
        if (angular.isFunction(fn)) {
          translateFn = fn;
        }
      }

      function translate(value, parameters) {
        if (angular.isFunction(translateFn)) {
          return translateFn.apply(this, arguments); // jshint ignore:line
        }
        return value;
      }

      return {
        setTranslateFn: setTranslateFn,
        translate: translate,
        $get: function () {
          return {
            setTranslateFn: setTranslateFn,
            /**
             * @param {string} value
             * @param {...*} [parameters] Any number of arguments to pass to translation function
             * @return {string|object} translation
             */
            translate: translate
          };
        }
      };
    })
    .filter('pltranslate', ['plTranslate', function (plTranslate) {
      return function (value) {
        return plTranslate.translate(value);
      };
    }])
    .directive('plTranslate', ['plTranslate', function (plTranslate) {
      return {
        restrict: 'A',
        scope: {
          plTranslate: '@'
        },
        link: function ($scope, $element) {
          if ($scope.plTranslate && $scope.plTranslate.trim() !== '') {
            $element.html(plTranslate.translate($scope.plTranslate));
          }
        }
      };
    }]);
}());

/**
 * Created by pedro on 17/01/17.
 */
(function () {
  'use strict';

  angular.module('pl.upload', ['ngFileUpload'])
    .component('plUpload', {
      bindings: {
        files: '<?',
        data: '<?',
        placeHolder: '@?',
        url: '<',
        pattern: '<?',
        callback: '<?',
        onUpload: '&?',
        onUploadFinish: '&?',
        properties: '<?'
      },
      templateUrl: '../source/pl-upload.html',
      controller: ['$log', 'Upload', 'plLocale', function ($log, Upload, plLocale) {
        var ctrl = this;
        var defaultOptions = {
          multiple: false,
          dragdrop: true
        };

        ctrl.isUploading = false;
        ctrl.imagesExt = ['jpeg', 'jpg', 'png', 'bmp', 'gif'];
        ctrl.files = [];
        ctrl.image = {};
        ctrl.options = {};
        ctrl.promise = null;
        ctrl.locales = plLocale.locales;

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;
        ctrl.drop = drop;
        ctrl.uploadFiles = uploadFiles;
        ctrl.remove = remove;
        ctrl.removeAll = removeAll;
        ctrl.add = add;
        ctrl.send = send;
        ctrl.isImage = isImage;
        ctrl.getImageFor = getImageFor;

        /////////////

        function init() {
          ctrl.options = _.merge({}, ctrl.options, defaultOptions, ctrl.properties);
          if (!ctrl.placeHolder) {
            ctrl.placeHolder = 'Arraste um ficheiro para aqui';
          }
          if (angular.isObject(ctrl.callback)) {
            ctrl.callback.send = ctrl.send;
            ctrl.callback.uploadService = Upload;
          }
        }

        function onChanges(plUpload) {
          if (plUpload) {
            if (plUpload.properties && !plUpload.properties.isFirstChange()) {
              ctrl.options = _.merge({}, ctrl.options, defaultOptions, plUpload.properties.currentValue);
            }
          }
        }

        function drop(index, $files) {
          ctrl.files[index] = $files[0];
        }

        function uploadFiles($files) {
          if (!ctrl.properties.multiple) {
            ctrl.files = [];
          }
          // $files: an array of files selected, each file has name, size, and type.
          for (var i = 0; i < $files.length; i++) {
            ctrl.files.push($files[i]);
          }
        }

        function remove(index) {
          ctrl.files.splice(index, 1);
        }

        function removeAll() {
          ctrl.files = [];
        }

        function add(files) {
          for (var file in files) {
            if (files.hasOwnProperty(file) && file) {
              ctrl.files.push(file);
            }
          }
        }

        function send(obj) {
          if (!obj) {
            obj = {
              url: ctrl.url, //'http://localhost:9001/api/v1/empresas/imagem', // data: obj.data {},
              file: ctrl.files, // or list of files ($files) for html5 only,
              fields: ctrl.data // extra data that may be passed to the request, such as json
            };
          }
          else {
            obj.url = obj.url || ctrl.url;
            obj.file = obj.files || obj.file || ctrl.files;
            obj.fields = obj.data || obj.fields || ctrl.data;
          }

          if (obj.fields && !angular.isString(obj.fields)) {
            obj.fields = {data: angular.toJson(obj.fields)};
          }

          ctrl.isUploading = true;
          ctrl.progress = 0;
          var promise = Upload.upload(obj).progress(function (evt) {
            ctrl.progress = parseInt(100.0 * evt.loaded / evt.total);
          });
          ctrl.promise = promise;
          promise.then(
            function (response) {
              if (angular.isFunction(ctrl.onUploadFinish)) {
                ctrl.onUploadFinish({config: obj, response: response});
              }
            },
            function (error) {
              if (angular.isFunction(ctrl.onUploadFinish)) {
                ctrl.onUploadFinish({config: obj, response: error});
              }
            }
          )['finally'](function () {
            ctrl.isUploading = false;
            ctrl.promise = null;
          });

          if (angular.isFunction(ctrl.onUpload)) {
            ctrl.onUpload({config: obj, promise: promise});
          }

          return promise;
        }

        function isImage(file) {
          var ext = file.name.split('.').pop();
          var extFile = String.prototype.toLowerCase.apply(ext);
          return ctrl.imagesExt.indexOf(extFile) > 0;
        }

        function getImageFor(file) {
          var ext = file.name.split('.').pop();
          var extFile = String.prototype.toLowerCase.apply(ext);

          if (extFile === 'pdf') {
            return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAAN2AAADdgF91YLMAAAAGXRFWHRTb2Z0d2FyZQB3d3' +
              'cuaW5rc2NhcGUub3Jnm+48GgAAAdFQTFRF////4uXn8VZC4uXn4uXn4uXn8VZC4uXn4uXnwMbL4uXn8VZC8VZC4uXnsLe9srm/tbvBvsTJv8XKyc7SytHYzNLYzNPZzNPazdHV0tje1tvf29/' +
              'h4OPl4aKc4uXn5NbW7G5f7Ih87Wtb8GJQ8GRS8VZC8VdD8VhE8VlF8VlG8VpG8VtH8VtI8VxJ8l5L8l9M8mBN8mFO8mJP8mNQ8mNR8mVS82lX82pY82tZ82ta82xa825d829d83Fg83Jh83Rj' +
              '9HVl9HZm9Hpq9Hts9Hxs9H1u9H5u9H5v9YFy9YJ09YN09YR19YV39Yd59Yh69Yl79Yp99Yt99ox/9o6A9o6B9pCD9pOG9pSI9paJ9paK95mN95qO95uP956S956T96CV96GW96SZ+Kab+Kec+' +
              'Kqg+bGo+bKp+bOr+bWt+buz+r+4+sO8+sW++sW/+sa/+sfB+8rE+83H+87I+9HL+9PO+9XQ/NXQ/NfT/NnU/NvW/NzY/N3Y/N/b/ODc/OHd/eHe/eLe/ePg/eTh/ebj/ebk/ejl/ern/ero/e' +
              'zq/u7s/vDu/vHv/vLw/vLx/vPy/vTy/vTz/vX0/vj3/vj4//n4//r5//r6//v7//z7//7+////6Yan7AAAAA50Uk5TAAEaJG5+prK0wObm6vXU4MSnAAADiElEQVR42u3baVfTQBQGYJaWYpG' +
              'qLLIHUKYFQcUFFBfcNxAVEXcFBQVcse5SFUVREEVFseTXmmmatmmH1uTemfFD3k/cSU7mKZmbA+mZrKw0yXV7vIrNrMgCJ9tVqNiPDyzIzlcg8YEFLgUIAApyC8EAmMCtwAEggQcDABF4UQAA' +
              'gYIDsC/AAtgWoAHsCvAANgWIAHsCTIAtASrAjgAXYEOADLAuwAZYFqADrArwARYFHADWBDwAlgRcAFYEfAAWBFDAaqgACijyAQVQQLEPKIACqlYBBVCAUu6DCcAAZQ1MAAco5aC7gABQqoqL7' +
              'HejgpTKEnaEAZYTiAMsIxAIYAtEApgCoQCWQCyAIRAMSBWIBqQIhAOSBeIBSQIJALNABsAkkAJIFMgBJAgkAeICWYCYQBrAEMgDRAUSAbpAJiAikAqgArkATSAZoFTKBigO4D8E5OQVEE5pqK' +
              '/NDMhZSThmfW1GQB7hmvqMgAK+gIaMAMI5DsABOAAHYAOwoe+qnrN7G+Oj/h0dkbQ3J53euLMjls0YgO0zaix/xrZGR3umY4PzT663xU+/MRc/XQ0HN8IBg2pivpzRP/+UaXSuxzi7bdF0QL0' +
              'IB4yar/hzNx1sMQ+qS7eb9LMPJR3owgF8HKMJfqeXfOE3AG9fagn91md6zALMDvtxAPf1H1sf0queMgAH9EW3fyhMq3MxwGKLET/GIkwAkKZ3WjFsBmg5QtfpdHMMgNuGiQByWSvGUwDkKC1v' +
              'igAc1IoPqQAS1MoJEYA+rXjKAHTT/vALADzSihEGoJ3Wu4wu+BRN8DgywD9ML3+eAfD/iraHuQ0XtiEBQgM0t0KRj9fKADTRTjyZ+iA6TdCfhEvHCAPQSev2FMDzADogPEhYgAta+cPognBvN' +
              'PvQFmEszzoJCxB4T5/RHNtwapRmqHePMZgEoM8n9YqI5wAbcI0uwcmAJEBH/3jk7nQT4YCvs1rmo6vjDuEFGNEueZcJSGyOAcINcMJYX6a8Ns3/+bAxvmVBVV8h/1U8OnOvNWWwa8KY/Nvkg/' +
              '5N8QOXQm+6nH9MHIADcAAgAOcXlXWyX9XWSH5Zva5U6uv6uprSEstfWJTgpkw2oEIyYG21VEBZRbXzrZkDcAAOwDrAy3d+L/ctnxni4b7pNUPc3Lf9pk9hLveNz+nj4r/1O23ys/lvfk/3+3f' +
              '90/zA7f/L9p/Hbbr/fwHUnx9+J46GvgAAAABJRU5ErkJggg==';
          }
          else if (extFile === 'doc' || extFile === 'docx') {
            return 'data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC' +
              '4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0' +
              'iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxl' +
              'LWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij4KPHBhdGggc3R5bGU9ImZpbGw6I0UyRTVFNzsiI' +
              'GQ9Ik0xMjgsMGMtMTcuNiwwLTMyLDE0LjQtMzIsMzJ2NDQ4YzAsMTcuNiwxNC40LDMyLDMyLDMyaDMyMGMxNy42LDAsMzItMTQuNCwzMi0zMlYxMjhMMzUyLDBIMTI4eiIvPgo8cGF0aCBzdH' +
              'lsZT0iZmlsbDojQjBCN0JEOyIgZD0iTTM4NCwxMjhoOTZMMzUyLDB2OTZDMzUyLDExMy42LDM2Ni40LDEyOCwzODQsMTI4eiIvPgo8cG9seWdvbiBzdHlsZT0iZmlsbDojQ0FEMUQ4OyIgcG9' +
              'pbnRzPSI0ODAsMjI0IDM4NCwxMjggNDgwLDEyOCAiLz4KPHBhdGggc3R5bGU9ImZpbGw6IzUwQkVFODsiIGQ9Ik00MTYsNDE2YzAsOC44LTcuMiwxNi0xNiwxNkg0OGMtOC44LDAtMTYtNy4y' +
              'LTE2LTE2VjI1NmMwLTguOCw3LjItMTYsMTYtMTZoMzUyYzguOCwwLDE2LDcuMiwxNiwxNiAgVjQxNnoiLz4KPGc+Cgk8cGF0aCBzdHlsZT0iZmlsbDojRkZGRkZGOyIgZD0iTTkyLjU3NiwzO' +
              'DRjLTQuMjI0LDAtOC44MzItMi4zMi04LjgzMi03LjkzNnYtNzIuNjU2YzAtNC42MDgsNC42MDgtNy45MzYsOC44MzItNy45MzZoMjkuMjk2ICAgYzU4LjQ2NCwwLDU3LjE2OCw4OC41MjgsMS' +
              '4xMzYsODguNTI4SDkyLjU3NnogTTEwMC42NCwzMTEuMDcydjU3LjMxMmgyMS4yMzJjMzQuNTQ0LDAsMzYuMDY0LTU3LjMxMiwwLTU3LjMxMkgxMDAuNjR6Ii8+Cgk8cGF0aCBzdHlsZT0iZml' +
              'sbDojRkZGRkZGOyIgZD0iTTIyOCwzODUuMjhjLTIzLjY2NCwxLjAyNC00OC4yNC0xNC43Mi00OC4yNC00Ni4wNjRjMC0zMS40NzIsMjQuNTYtNDYuOTQ0LDQ4LjI0LTQ2Ljk0NCAgIGMyMi4z' +
              'ODQsMS4xMzYsNDUuNzkyLDE2LjYyNCw0NS43OTIsNDYuOTQ0QzI3My43OTIsMzY5LjU1MiwyNTAuMzg0LDM4NS4yOCwyMjgsMzg1LjI4eiBNMjI2LjU5MiwzMDguOTEyICAgYy0xNC4zMzYsM' +
              'C0yOS45MzYsMTAuMTEyLTI5LjkzNiwzMC4zMmMwLDIwLjA5NiwxNS42MTYsMzAuMzM2LDI5LjkzNiwzMC4zMzZjMTQuNzIsMCwzMC40NDgtMTAuMjQsMzAuNDQ4LTMwLjMzNiAgIEMyNTcuMD' +
              'QsMzE5LjAwOCwyNDEuMzEyLDMwOC45MTIsMjI2LjU5MiwzMDguOTEyeiIvPgoJPHBhdGggc3R5bGU9ImZpbGw6I0ZGRkZGRjsiIGQ9Ik0yODguODQ4LDMzOS4wODhjMC0yNC42ODgsMTUuNDg' +
              '4LTQ1LjkyLDQ0LjkxMi00NS45MmMxMS4xMzYsMCwxOS45NjgsMy4zMjgsMjkuMjk2LDExLjM5MiAgIGMzLjQ1NiwzLjE4NCwzLjg0LDguODE2LDAuMzg0LDEyLjRjLTMuNDU2LDMuMDU2LTgu' +
              'NzA0LDIuNjg4LTExLjc3Ni0wLjM4NGMtNS4yMzItNS41MDQtMTAuNjA4LTcuMDI0LTE3LjkwNC03LjAyNCAgIGMtMTkuNjk2LDAtMjkuMTUyLDEzLjk1Mi0yOS4xNTIsMjkuNTUyYzAsMTUuO' +
              'DcyLDkuMzI4LDMwLjQ0OCwyOS4xNTIsMzAuNDQ4YzcuMjk2LDAsMTQuMDgtMi45NiwxOS45NjgtOC4xOTIgICBjMy45NTItMy4wNzIsOS40NTYtMS41NTIsMTEuNzYsMS41MzZjMi4wNDgsMi' +
              '44MTYsMy4wNTYsNy41NTItMS40MDgsMTIuMDE2Yy04Ljk2LDguMzM2LTE5LjY5NiwxMC0zMC4zMzYsMTAgICBDMzAyLjgsMzg0LjkxMiwyODguODQ4LDM2My43NzYsMjg4Ljg0OCwzMzkuMDg' +
              '4eiIvPgo8L2c+CjxwYXRoIHN0eWxlPSJmaWxsOiNDQUQxRDg7IiBkPSJNNDAwLDQzMkg5NnYxNmgzMDRjOC44LDAsMTYtNy4yLDE2LTE2di0xNkM0MTYsNDI0LjgsNDA4LjgsNDMyLDQwMCw0' +
              'MzJ6Ii8+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnP' +
              'go8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=';
          }
          if (extFile === 'xls' || extFile === 'xlsx' || extFile === 'csv') {
            return 'data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuM' +
              'C4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz' +
              '0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxl' +
              'LWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij4KPHBhdGggc3R5bGU9ImZpbGw6I0UyRTVFNzsiIG' +
              'Q9Ik0xMjgsMGMtMTcuNiwwLTMyLDE0LjQtMzIsMzJ2NDQ4YzAsMTcuNiwxNC40LDMyLDMyLDMyaDMyMGMxNy42LDAsMzItMTQuNCwzMi0zMlYxMjhMMzUyLDBIMTI4eiIvPgo8cGF0aCBzdHls' +
              'ZT0iZmlsbDojQjBCN0JEOyIgZD0iTTM4NCwxMjhoOTZMMzUyLDB2OTZDMzUyLDExMy42LDM2Ni40LDEyOCwzODQsMTI4eiIvPgo8cG9seWdvbiBzdHlsZT0iZmlsbDojQ0FEMUQ4OyIgcG9pbn' +
              'RzPSI0ODAsMjI0IDM4NCwxMjggNDgwLDEyOCAiLz4KPHBhdGggc3R5bGU9ImZpbGw6Izg0QkQ1QTsiIGQ9Ik00MTYsNDE2YzAsOC44LTcuMiwxNi0xNiwxNkg0OGMtOC44LDAtMTYtNy4yLTE2' +
              'LTE2VjI1NmMwLTguOCw3LjItMTYsMTYtMTZoMzUyYzguOCwwLDE2LDcuMiwxNiwxNiAgVjQxNnoiLz4KPGc+Cgk8cGF0aCBzdHlsZT0iZmlsbDojRkZGRkZGOyIgZD0iTTE0NC4zMzYsMzI2Lj' +
              'E5MmwyMi4yNTYtMjcuODg4YzYuNjU2LTguNzA0LDE5LjU4NCwyLjQxNiwxMi4yODgsMTAuNzM2ICAgYy03LjY2NCw5LjA4OC0xNS43MjgsMTguOTQ0LTIzLjQwOCwyOS4wNGwyNi4wOTYsMzIu' +
              'NDk2YzcuMDQsOS42LTcuMDI0LDE4LjgtMTMuOTM2LDkuMzI4bC0yMy41NTItMzAuMTkybC0yMy4xNTIsMzAuODQ4ICAgYy02LjUyOCw5LjMyOC0yMC45OTItMS4xNTItMTMuNjk2LTkuODU2bD' +
              'I1LjcxMi0zMi42MjRjLTguMDY0LTEwLjExMi0xNS44NzItMTkuOTUyLTIzLjY2NC0yOS4wNCAgIGMtOC4wNDgtOS42LDYuOTEyLTE5LjQ0LDEyLjgtMTAuNDY0TDE0NC4zMzYsMzI2LjE5Mnoi' +
              'Lz4KCTxwYXRoIHN0eWxlPSJmaWxsOiNGRkZGRkY7IiBkPSJNMTk3LjM2LDMwMy4xNTJjMC00LjIyNCwzLjU4NC03LjgwOCw4LjA2NC03LjgwOGM0LjA5NiwwLDcuNTUyLDMuNiw3LjU1Miw3Lj' +
              'gwOHY2NC4wOTZoMzQuOCAgIGMxMi41MjgsMCwxMi44LDE2Ljc1MiwwLDE2Ljc1MkgyMDUuNDRjLTQuNDgsMC04LjA2NC0zLjE4NC04LjA2NC03Ljc5MnYtNzMuMDU2SDE5Ny4zNnoiLz4KCTxw' +
              'YXRoIHN0eWxlPSJmaWxsOiNGRkZGRkY7IiBkPSJNMjcyLjAzMiwzMTQuNjcyYzIuOTQ0LTI0LjgzMiw0MC40MTYtMjkuMjk2LDU4LjA4LTE1LjcyOGM4LjcwNCw3LjAyNC0wLjUxMiwxOC4xNi' +
              '04LjE5MiwxMi41MjggICBjLTkuNDcyLTYtMzAuOTYtOC44MTYtMzMuNjQ4LDQuNDY0Yy0zLjQ1NiwyMC45OTIsNTIuMTkyLDguOTc2LDUxLjI5Niw0My4wMDhjLTAuODk2LDMyLjQ5Ni00Ny45' +
              'NjgsMzMuMjQ4LTY1LjYzMiwxOC42NzIgICBjLTQuMjQtMy40NTYtNC4wOTYtOS4wNzItMS43OTItMTIuNTQ0YzMuMzI4LTMuMzEyLDcuMDI0LTQuNDY0LDExLjM5Mi0wLjg4YzEwLjQ4LDcuMT' +
              'UyLDM3LjQ4OCwxMi41MjgsMzkuMzkyLTUuNjQ4ICAgQzMyMS4yOCwzMzkuNjMyLDI2OC4wNjQsMzUxLjAwOCwyNzIuMDMyLDMxNC42NzJ6Ii8+CjwvZz4KPHBhdGggc3R5bGU9ImZpbGw6I0NB' +
              'RDFEODsiIGQ9Ik00MDAsNDMySDk2djE2aDMwNGM4LjgsMCwxNi03LjIsMTYtMTZ2LTE2QzQxNiw0MjQuOCw0MDguOCw0MzIsNDAwLDQzMnoiLz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz' +
              '4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4K' +
              'PC9zdmc+Cg==';
          }
          if (extFile === 'xml') {
            return 'data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4' +
              'wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaH' +
              'R0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY' +
              '2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij4KPHBhdGggc3R5bGU9ImZpbGw6I0UyRTVFNzsiIGQ9Ik0x' +
              'MjgsMGMtMTcuNiwwLTMyLDE0LjQtMzIsMzJ2NDQ4YzAsMTcuNiwxNC40LDMyLDMyLDMyaDMyMGMxNy42LDAsMzItMTQuNCwzMi0zMlYxMjhMMzUyLDBIMTI4eiIvPgo8cGF0aCBzdHlsZT0iZml' +
              'sbDojQjBCN0JEOyIgZD0iTTM4NCwxMjhoOTZMMzUyLDB2OTZDMzUyLDExMy42LDM2Ni40LDEyOCwzODQsMTI4eiIvPgo8cG9seWdvbiBzdHlsZT0iZmlsbDojQ0FEMUQ4OyIgcG9pbnRzPSI0OD' +
              'AsMjI0IDM4NCwxMjggNDgwLDEyOCAiLz4KPHBhdGggc3R5bGU9ImZpbGw6IzUwQkVFODsiIGQ9Ik00MTYsNDE2YzAsOC44LTcuMiwxNi0xNiwxNkg0OGMtOC44LDAtMTYtNy4yLTE2LTE2VjI1N' +
              'mMwLTguOCw3LjItMTYsMTYtMTZoMzUyYzguOCwwLDE2LDcuMiwxNiwxNiAgVjQxNnoiLz4KPGc+Cgk8cGF0aCBzdHlsZT0iZmlsbDojRkZGRkZGOyIgZD0iTTEzMS4yOCwzMjYuMTc2bDIyLjI3' +
              'Mi0yNy44ODhjNi42NC04LjY4OCwxOS41NjgsMi40MzIsMTIuMjg4LDEwLjc1MiAgIGMtNy42NjQsOS4wODgtMTUuNzI4LDE4Ljk0NC0yMy40MjQsMjkuMDI0bDI2LjExMiwzMi40OTZjNy4wMjQ' +
              'sOS42LTcuMDQsMTguODE2LTEzLjk1Miw5LjM0NGwtMjMuNTM2LTMwLjE5MmwtMjMuMTUyLDMwLjgzMiAgIGMtNi41MjgsOS4zMjgtMjAuOTkyLTEuMTUyLTEzLjY4LTkuODU2bDI1LjcxMi0zMi' +
              ' 42MjRjLTguMDY0LTEwLjA5Ni0xNS44NzItMTkuOTM2LTIzLjY2NC0yOS4wMjQgICBjLTguMDY0LTkuNiw2LjkxMi0xOS40NCwxMi43ODQtMTAuNDhMMTMxLjI4LDMyNi4xNzZ6Ii8+Cgk8cGF0' +
              'aCBzdHlsZT0iZmlsbDojRkZGRkZGOyIgZD0iTTIwMS4yNjQsMzI3Ljg0djQ3LjMyOGMwLDUuNjQ4LTQuNjA4LDguODMyLTkuMiw4LjgzMmMtNC4wOTYsMC03LjY4LTMuMTg0LTcuNjgtOC44MzJ' +
              '2LTcyLjAxNiAgIGMwLTYuNjU2LDUuNjQ4LTguODQ4LDcuNjgtOC44NDhjMy42OTYsMCw1Ljg3MiwyLjE5Miw4LjA0OCw0LjYyNGwyOC4xNiwzNy45ODRsMjkuMTUyLTM5LjQwOGM0LjI0LTUuMj' +
              'MyLDE0LjU5Mi0zLjIsMTQuNTkyLDUuNjQ4ICAgdjcyLjAxNmMwLDUuNjQ4LTMuNTg0LDguODMyLTcuNjY0LDguODMyYy00LjYwOCwwLTguMTkyLTMuMTg0LTguMTkyLTguODMyVjMyNy44NGwtM' +
              'jEuMjQ4LDI2Ljg2NCAgIGMtNC41OTIsNS42NDgtMTAuMzUyLDUuNjQ4LTE0LjU3NiwwTDIwMS4yNjQsMzI3Ljg0eiIvPgoJPHBhdGggc3R5bGU9ImZpbGw6I0ZGRkZGRjsiIGQ9Ik0yOTQuMjg4' +
              'LDMwMy4xNTJjMC00LjIyNCwzLjU4NC03LjgwOCw4LjA2NC03LjgwOGM0LjA5NiwwLDcuNTUyLDMuNiw3LjU1Miw3LjgwOHY2NC4wOTZoMzQuOCAgIGMxMi41MjgsMCwxMi44LDE2Ljc1MiwwLDE' +
              '2Ljc1MmgtNDIuMzM2Yy00LjQ4LDAtOC4wNjQtMy4xODQtOC4wNjQtNy44MDh2LTczLjA0SDI5NC4yODh6Ii8+CjwvZz4KPHBhdGggc3R5bGU9ImZpbGw6I0NBRDFEODsiIGQ9Ik00MDAsNDMySD' +
              'k2djE2aDMwNGM4LjgsMCwxNi03LjIsMTYtMTZ2LTE2QzQxNiw0MjQuOCw0MDguOCw0MzIsNDAwLDQzMnoiLz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KP' +
              'Gc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==';
          }
          return 'data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b' +
            '3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4' +
            'bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5' +
            'hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4Ij4KPHBhdGggc3R5bGU9ImZpbGw6I0RCRTlGRD' +
            'siIGQ9Ik0zODkuNjYyLDY2LjQ2MUgxMjIuMzM4Yy0yNy42MzksMC01MC4xMjMsMjIuNDg0LTUwLjEyMyw1MC4xMjN2MzQ1LjI5MyAgYzAsMjcuNjM5LDIyLjQ4NCw1MC4xMjMsNTAuMTIzLDUwL' +
            'jEyM2gyNjcuMzIzYzI3LjYzOSwwLDUwLjEyMy0yMi40ODQsNTAuMTIzLTUwLjEyM1YxMTYuNTg0ICBDNDM5Ljc4NSw4OC45NDUsNDE3LjMwMSw2Ni40NjEsMzg5LjY2Miw2Ni40NjF6Ii8+Cjxw' +
            'YXRoIHN0eWxlPSJmaWxsOiNDNURDRkQ7IiBkPSJNMzg5LjY2Miw2Ni40NjFIMjU2VjUxMmgxMzMuNjYyYzI3LjYzOSwwLDUwLjEyMy0yMi40ODQsNTAuMTIzLTUwLjEyM1YxMTYuNTg0ICBDNDM' +
            '5Ljc4NSw4OC45NDUsNDE3LjMwMSw2Ni40NjEsMzg5LjY2Miw2Ni40NjF6Ii8+CjxwYXRoIHN0eWxlPSJmaWxsOiM2QkJBRTI7IiBkPSJNMjg5LjQxNiwyNDQuNjc3aC02Ni44MzFjLTkuMjI0LD' +
            'AtMTYuNzA4LTcuNDc4LTE2LjcwOC0xNi43MDh2LTYxLjI2MmgtNTAuMTIzICBjLTYuMzMxLDAtMTIuMTE4LTMuNTczLTE0Ljk0Ni05LjIzNWMtMi44MjgtNS42NjItMi4yMTktMTIuNDMzLDEuN' +
            'Tc3LTE3LjQ5NkwyNDIuNjMyLDYuMzE1YzYuMzA5LTguNDIsMjAuNDI4LTguNDIsMjYuNzM3LDAgIGwxMDAuMjQ2LDEzMy42NjJjMy43OTYsNS4wNjQsNC40MDUsMTEuODM1LDEuNTc3LDE3LjQ5' +
            'NmMtMi44MjgsNS42NjItOC42MTUsOS4yMzUtMTQuOTQ2LDkuMjM1aC01MC4xMjN2NjEuMjYyICBDMzA2LjEyMywyMzcuMTk5LDI5OC42MzksMjQ0LjY3NywyODkuNDE2LDI0NC42Nzd6Ii8+Cjx' +
            'wYXRoIHN0eWxlPSJmaWxsOiM4QTkxOTk7IiBkPSJNMzU2LjI0NiwzMTEuNTA4aC0yNy4xMjhjLTkuMjI0LDAtMTYuNzA4LTcuNDc4LTE2LjcwOC0xNi43MDhjMC05LjIyOSw3LjQ4NC0xNi43MD' +
            'gsMTYuNzA4LTE2LjcwOCAgaDI3LjEyOGM5LjIyNCwwLDE2LjcwOCw3LjQ3OCwxNi43MDgsMTYuNzA4QzM3Mi45NTQsMzA0LjAyOSwzNjUuNDcsMzExLjUwOCwzNTYuMjQ2LDMxMS41MDh6Ii8+C' +
            'jxnPgoJPHBhdGggc3R5bGU9ImZpbGw6I0ExQUFCMzsiIGQ9Ik0yNjIuMjg4LDMxMS41MDhIMTU1Ljc1NGMtOS4yMjQsMC0xNi43MDgtNy40NzgtMTYuNzA4LTE2LjcwOGMwLTkuMjI5LDcuNDg0' +
            'LTE2LjcwOCwxNi43MDgtMTYuNzA4ICAgaDEwNi41MzRjOS4yMjQsMCwxNi43MDgsNy40NzgsMTYuNzA4LDE2LjcwOEMyNzguOTk2LDMwNC4wMjksMjcxLjUxMiwzMTEuNTA4LDI2Mi4yODgsMzE' +
            'xLjUwOHoiLz4KCTxwYXRoIHN0eWxlPSJmaWxsOiNBMUFBQjM7IiBkPSJNMzU2LjI0NiwzNzguMzM5SDE1NS43NTRjLTkuMjI0LDAtMTYuNzA4LTcuNDc4LTE2LjcwOC0xNi43MDhjMC05LjIyOS' +
            'w3LjQ4NC0xNi43MDgsMTYuNzA4LTE2LjcwOCAgIGgyMDAuNDkzYzkuMjI0LDAsMTYuNzA4LDcuNDc4LDE2LjcwOCwxNi43MDhDMzcyLjk1NCwzNzAuODYsMzY1LjQ3LDM3OC4zMzksMzU2LjI0N' +
            'iwzNzguMzM5eiIvPgoJPHBhdGggc3R5bGU9ImZpbGw6I0ExQUFCMzsiIGQ9Ik0zNTYuMjQ2LDQ0NS4xNjlIMTU1Ljc1NGMtOS4yMjQsMC0xNi43MDgtNy40NzgtMTYuNzA4LTE2LjcwOGMwLTku' +
            'MjI5LDcuNDg0LTE2LjcwOCwxNi43MDgtMTYuNzA4ICAgaDIwMC40OTNjOS4yMjQsMCwxNi43MDgsNy40NzgsMTYuNzA4LDE2LjcwOEMzNzIuOTU0LDQzNy42OTEsMzY1LjQ3LDQ0NS4xNjksMzU' +
            '2LjI0Niw0NDUuMTY5eiIvPgo8L2c+CjxnPgoJPHBhdGggc3R5bGU9ImZpbGw6IzhBOTE5OTsiIGQ9Ik0zNTYuMjQ2LDQxMS43NTRIMjU2djMzLjQxNWgxMDAuMjQ2YzkuMjI0LDAsMTYuNzA4LT' +
            'cuNDc4LDE2LjcwOC0xNi43MDggICBDMzcyLjk1NCw0MTkuMjMyLDM2NS40Nyw0MTEuNzU0LDM1Ni4yNDYsNDExLjc1NHoiLz4KCTxwYXRoIHN0eWxlPSJmaWxsOiM4QTkxOTk7IiBkPSJNMzU2L' +
            'jI0NiwzNDQuOTIzSDI1NnYzMy40MTVoMTAwLjI0NmM5LjIyNCwwLDE2LjcwOC03LjQ3OCwxNi43MDgtMTYuNzA4ICAgQzM3Mi45NTQsMzUyLjQwMiwzNjUuNDcsMzQ0LjkyMywzNTYuMjQ2LDM0' +
            'NC45MjN6Ii8+CjwvZz4KPHBhdGggc3R5bGU9ImZpbGw6I0E5QjBCNzsiIGQ9Ik0yNjIuMjg4LDI3OC4wOTJIMjU2djMzLjQxNWg2LjI4OGM5LjIyNCwwLDE2LjcwOC03LjQ3OCwxNi43MDgtMTY' +
            'uNzA4ICBDMjc4Ljk5NiwyODUuNTcxLDI3MS41MTIsMjc4LjA5MiwyNjIuMjg4LDI3OC4wOTJ6Ii8+CjxwYXRoIHN0eWxlPSJmaWxsOiM2MEFFRDU7IiBkPSJNMjg5LjQxNiwyNDQuNjc3YzkuMj' +
            'I0LDAsMTYuNzA4LTcuNDc4LDE2LjcwOC0xNi43MDh2LTYxLjI2Mmg1MC4xMjMgIGM2LjMzMSwwLDEyLjExOC0zLjU3MywxNC45NDYtOS4yMzVjMi44MjgtNS42NjIsMi4yMTktMTIuNDMzLTEuN' +
            'Tc3LTE3LjQ5NkwyNjkuMzY5LDYuMzE1QzI2Ni4yMTQsMi4xMDUsMjYxLjEwNywwLDI1NiwwdjI0NC42NzcgIEgyODkuNDE2eiIvPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9n' +
            'Pgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K';
        }

      }]
    });
})();

/**
 * Created by Bruno Ferreira on 13/11/17.
 */
(function () {
  'use strict';

  /**
   * Custom validators are loaded by plMessages in order to avoid ``angular.element``
   * not found issues
   */

  angular.module('pl.comps')
    .config(['plValidateProvider', function (plValidateProvider) {
      // Equals validator
      plValidateProvider.register('equals', {
        value: null,
        message: 'Este campo deve ser igual ao campo {{equals.value}}',
        validate: function (name, ngModel) {
          if (!name || !ngModel) {
            return true;
          }

          var value = this.value = name;
          var element = angular.element('input[name="' + value + '"]');
          if (!element || element.length !== 1) {
            throw new TypeError('Element to compare not found or target name attribute is not unique');
          }

          ngModel = ngModel.$modelValue || ngModel;
          var elementModel = element.controller('ngModel');
          return ngModel === elementModel.$modelValue;
        }
      });
    }])
    .directive('plValidate', function () {
      return {
        restrict: 'A',
        require: {
          'ngModel': 'ngModel'
        },
        bindings: {
          plValidate: '@',
          validationTarget: '@',
          validationOptions: '<?'
        },
        controller: /*@ngInject*/ ['plValidate', function (plValidate) {
          var ctrl = this;

          ctrl.validators = plValidate.getValidators();

          ctrl.init = init;

          ctrl.init();

          /////////////

          function init() {
            if (ctrl.ngModel && ctrl.validators[ctrl.plValidate]) {
              ctrl.ngModel.$validators[ctrl.plValidate] = function (modelValue) {
                var validator = angular.copy(ctrl.validators[ctrl.plValidate]);
                _.merge(validator, ctrl.validationOptions);
                return validator.validate(ctrl.validationTarget, modelValue);
              };
            }
          }
        }]
      };
    });
})();

/**
 * Created by Bruno Ferreira on 13/11/17.
 */
(function () {
  'use strict';

  angular.module('pl.edit')
    .provider('plValidate', function () {
      var validators = {};
      var maps = {};

      function register(name, validator) {
        if (!name || !validator || !angular.isObject(validator)) {
          throw new TypeError('Invalid custom validation register');
        }
        validators[name] = validator;
      }

      function getValidator(name) {
        var r = validators[name];
        if (!r) {
          r = maps[name];
          r = validators[r];
        }
        return r ? r : null;
      }

      function getValidators() {
        return validators;
      }

      function map(type, alias) {
        maps[alias] = type;
      }

      return {
        register: register,
        map: map,
        $get: function () {
          return {
            register: register,
            map: map,
            getValidator: getValidator,
            getValidators: getValidators
          };
        }
      };
    });
})();
